// This file is auto-generated by @hey-api/openapi-ts

export type AccountDetails = {
  defaultClusterArchitecture?:
    | ("distributed" | "hybrid" | "centralized")
    | null;
  defaultOperationalHours?: OperationalHoursResponseDto;
  id: number;
  name: string;
  createdAt: Date;
  logoImage: string;
  timezone?: string;
  defaultClusterId?: number;
  defaultClusterName?: string;
  currency?: string;
  accountReportUrl?: string;
  showAccountReport?: boolean;
  showEnvReport?: boolean;
  status?: string;
  enableSiteSpecificPricing?: boolean;
  autoSampleSessionsEnabled?: boolean;
  /**
   * Device tags that name a camera model, most significant first (ID-6991).
   */
  cameraTypeTagIds?: Array<number>;
  bigQuerySqlCompanionEnabled?: boolean;
  autoSampleSessionsPercentage?: number;
  nonScanDailyCapacityThreshold?: number;
  retentionMonths?: number;
};

export enum defaultClusterArchitecture {
  DISTRIBUTED = "distributed",
  HYBRID = "hybrid",
  CENTRALIZED = "centralized",
}

export type AccountDetailsDto = {
  id: number;
  name: string;
  companyName: {
    [key: string]: unknown;
  } | null;
  logoImage: {
    [key: string]: unknown;
  } | null;
  isActive: {
    [key: string]: unknown;
  } | null;
  currency: {
    [key: string]: unknown;
  } | null;
  timezone: {
    [key: string]: unknown;
  } | null;
  status: {
    [key: string]: unknown;
  } | null;
  alertsEnabled: {
    [key: string]: unknown;
  } | null;
  defaultClusterArchitecture: ("distributed" | "hybrid" | "centralized") | null;
  defaultCluster: MinimalEntityDto | null;
  accountReportUrl: {
    [key: string]: unknown;
  } | null;
  showEnvReport: {
    [key: string]: unknown;
  } | null;
  showAccountReport: {
    [key: string]: unknown;
  } | null;
  maxAgentVersion: {
    [key: string]: unknown;
  } | null;
  enableSiteSpecificPricing: boolean;
  autoSampleSessionsEnabled: boolean;
  autoSampleSessionsPercentage: {
    [key: string]: unknown;
  } | null;
  nonScanDailyCapacityThreshold: {
    [key: string]: unknown;
  } | null;
  retentionMonths: number;
  cameraTypeTagIds: Array<number>;
  defaultOperationalHours: OperationalHoursResponseDto | null;
  token: string;
};

export enum AccountOrderEnum {
  NAME = "name",
}

export type AccountOrderEnumSortOption = {
  field: AccountOrderEnum;
  dir?: "asc" | "desc";
};

export enum dir {
  ASC = "asc",
  DESC = "desc",
}

export type AccountSummaryClusterDto = {
  id: number;
  name: string;
};

export type AccountSummaryDto = {
  id: number;
  name: string;
  isActive: boolean;
  defaultClusterArchitecture: ("distributed" | "hybrid" | "centralized") | null;
  defaultCluster: AccountSummaryClusterDto | null;
  currency: string;
  enableSiteSpecificPricing: boolean;
};

export type AccountSwitchDto = {
  accountId: number;
};

export type AddSampleRequestDto = {
  label: string;
  labelTrigger: string;
  captureTrigger: string;
  family: string;
  category: string;
  groupId: string;
  imgSource: string;
  image: string;
  deviceId: number;
};

export type AddSamplesFromFilterDto = {
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  deviceIds?: Array<number>;
  storageDeviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  siteGroupIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  timeField?: "createdAt" | "addedAt";
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  modelIds?: Array<number>;
  result?: Array<TransactionResultEnum>;
  labels?: Array<string>;
  predictions?: Array<string>;
  families?: Array<string>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  taggedByIds?: Array<number>;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  dataType?: Array<string>;
  datasetId?: number;
  fromDate?: Date;
  toDate?: Date;
  onlyWithPrediction?: boolean;
  showNonScans?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  family?: string;
  fuzzy?: boolean;
  matchStrength?: string;
  sessionId?: Array<string>;
  showOnlyWithImages?: boolean;
  copyTagging?: boolean;
  copyPredictions?: boolean;
  allowDuplicates?: boolean;
};

export enum timeField {
  CREATED_AT = "createdAt",
  ADDED_AT = "addedAt",
}

export enum state {
  EXISTING = "existing",
  DELETED = "deleted",
  OVERRIDDEN = "overridden",
  EVICTED = "evicted",
  REPORTED_ONLY = "reported_only",
  MISSING = "missing",
}

export enum tagsMatch {
  ANY = "any",
  EXACT = "exact",
  ALL = "all",
  NONE = "none",
}

export enum devicesTagsMatch {
  ANY = "any",
  EXACT = "exact",
  ALL = "all",
  NONE = "none",
}

export type AddSessionsFromFilterDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  storageDeviceIds?: Array<number>;
  storage?:
    | "any"
    | "backend"
    | "cluster"
    | "edge"
    | "device"
    | "recorded"
    | "none";
  timeField?: "createdAt" | "session";
  sessionIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  tagIds?: Array<number>;
  sessionTagIds?: Array<number>;
  sessionsTagsMatch?: "any" | "exact" | "all" | "none";
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  assigneeIds?: Array<number>;
  assigneeMatch?: "any" | "none";
  alertType?: Array<"non-scan" | "non-match" | "left-in-cart">;
  labels?: Array<string>;
  datasetId?: number;
  from?: Date;
  to?: Date;
  sessionId?: Array<string>;
  onlyNonScans?: boolean;
  onlyStored?: boolean;
  headBlurred?: boolean;
  assistantId?: string;
  shopperId?: string;
  includeJsonSamples?: boolean;
  copyTagging?: boolean;
  copyPredictions?: boolean;
  allowDuplicates?: boolean;
};

export enum storage {
  ANY = "any",
  BACKEND = "backend",
  CLUSTER = "cluster",
  EDGE = "edge",
  DEVICE = "device",
  RECORDED = "recorded",
  NONE = "none",
}

export enum timeField2 {
  CREATED_AT = "createdAt",
  SESSION = "session",
}

export enum sessionsTagsMatch {
  ANY = "any",
  EXACT = "exact",
  ALL = "all",
  NONE = "none",
}

export enum assigneeMatch {
  ANY = "any",
  NONE = "none",
}

export type AdminUpdateUserDto = {
  firstName?: string;
  lastName?: string;
  defaultAccount?: number;
  profileImg?: Blob | File;
  id: number;
  email?: string;
  company?: string;
  role?:
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate";
  isActive?: boolean;
  lastConnected?: Date;
};

export enum role {
  VIEWER = "Viewer",
  ANNOTATOR = "Annotator",
  TECH = "Tech",
  OWNER = "Owner",
  MLOPS = "MLOps",
  SITE_MANAGER = "SiteManager",
  ANNOTATOR_MANAGER = "AnnotatorManager",
  EDGIFY_CANDIDATE = "EdgifyCandidate",
}

export type AffectedEntityDto = {
  /**
   * Parent region name, on a sub-region entry. Null on a region entry.
   */
  region?: string | null;
  id: number;
  name: string;
};

export type AffectedSiteDto = {
  /**
   * Region the site is assigned to, by name.
   */
  region?: string | null;
  /**
   * Sub-region the site is assigned to, by name.
   */
  subRegion?: string | null;
  id: number;
  name: string;
};

export type AgentDeploymentDto = {
  state:
    | "pending"
    | "downloading"
    | "installing"
    | "error"
    | "cancelled"
    | "deployed"
    | "removed";
  agentVersion: string;
  error?: string;
  createdAt: Date;
  updatedAt: Date;
};

export enum state2 {
  PENDING = "pending",
  DOWNLOADING = "downloading",
  INSTALLING = "installing",
  ERROR = "error",
  CANCELLED = "cancelled",
  DEPLOYED = "deployed",
  REMOVED = "removed",
}

/**
 * Agent Mode - in silent mode, alerts are not sent to the client, and predictions are not returned
 */
export enum AgentModeEnum {
  SILENT = "silent",
  ACTIVE = "active",
}

export enum AlertAction {
  ALERT = "Alert",
  RESOLVE = "Resolve",
}

export type AlertChannelDto = {
  id: number;
  alertChannelType: string;
  name: string | null;
  isGlobal: boolean;
  url: string;
  configurationInfo: {
    [key: string]: unknown;
  };
};

export type AlertChannelsResponseDto = {
  alertsEnabled: boolean;
  configuredAlertChannels: Array<ConfiguredAlertChannelDto>;
};

export enum AlertChannelType {
  JIRA = "JIRA",
  EMAIL = "email",
  SLACK = "slack",
  WEBHOOK = "webhook",
}

export type AlertDeliveryDto = {
  id: number;
  eventId: string;
  alertType:
    | "DeviceDown"
    | "ServerDown"
    | "CameraDown"
    | "HighResourceUsage"
    | "LookupTableDisabled"
    | "DeployedModelFailure"
    | "RegisterDisabledDeviceAttempt"
    | "RegisterDuplicateDeviceAttempt"
    | "TrainingFailed"
    | "NonScanDetectorDown"
    | "OnScreenAppDown"
    | "ZebraAdapterDown"
    | "AgentPortClash"
    | "LockedSamplesAboveThreshold"
    | "FailedToStoreSampleLackOfStorage"
    | "BlackScreenImageDetected"
    | "LocalStorageAlmostFull"
    | "AgentDoesNotReachEdgibox"
    | "VideoUploadError"
    | "ImageUploadError"
    | "PredictorDisabled"
    | "NonScanDetectorRepeatedFpsDrops"
    | "ModelBelowKpiThreshold"
    | "TrainingWarnings"
    | "LookupTableMismatch"
    | "MetricThresholdBreach"
    | "ServiceDown"
    | "DataCompletenessBelowThreshold"
    | "DeviceDownEscalated"
    | "ServerDownEscalated"
    | "CameraDownEscalated"
    | "HighResourceUsageEscalated"
    | "LookupTableDisabledEscalated"
    | "DeployedModelFailureEscalated"
    | "NonScanDetectorDownEscalated"
    | "OnScreenAppDownEscalated"
    | "ZebraAdapterDownEscalated"
    | "AgentPortClashEscalated"
    | "LockedSamplesAboveThresholdEscalated"
    | "FailedToStoreSampleLackOfStorageEscalated"
    | "BlackScreenImageDetectedEscalated"
    | "LocalStorageAlmostFullEscalated"
    | "AgentDoesNotReachEdgiboxEscalated"
    | "VideoUploadErrorEscalated"
    | "ImageUploadErrorEscalated"
    | "PredictorDisabledEscalated"
    | "NonScanDetectorRepeatedFpsDropsEscalated";
  status: "Open" | "Closed";
  attempt: number;
  success: boolean;
  httpStatus: number | null;
  error: string | null;
  requestPayload: {
    [key: string]: unknown;
  };
  responseBody: {
    [key: string]: unknown;
  };
  deviceId: number | null;
  deviceName: string | null;
  createdAt: Date;
};

export enum alertType {
  DEVICE_DOWN = "DeviceDown",
  SERVER_DOWN = "ServerDown",
  CAMERA_DOWN = "CameraDown",
  HIGH_RESOURCE_USAGE = "HighResourceUsage",
  LOOKUP_TABLE_DISABLED = "LookupTableDisabled",
  DEPLOYED_MODEL_FAILURE = "DeployedModelFailure",
  REGISTER_DISABLED_DEVICE_ATTEMPT = "RegisterDisabledDeviceAttempt",
  REGISTER_DUPLICATE_DEVICE_ATTEMPT = "RegisterDuplicateDeviceAttempt",
  TRAINING_FAILED = "TrainingFailed",
  NON_SCAN_DETECTOR_DOWN = "NonScanDetectorDown",
  ON_SCREEN_APP_DOWN = "OnScreenAppDown",
  ZEBRA_ADAPTER_DOWN = "ZebraAdapterDown",
  AGENT_PORT_CLASH = "AgentPortClash",
  LOCKED_SAMPLES_ABOVE_THRESHOLD = "LockedSamplesAboveThreshold",
  FAILED_TO_STORE_SAMPLE_LACK_OF_STORAGE = "FailedToStoreSampleLackOfStorage",
  BLACK_SCREEN_IMAGE_DETECTED = "BlackScreenImageDetected",
  LOCAL_STORAGE_ALMOST_FULL = "LocalStorageAlmostFull",
  AGENT_DOES_NOT_REACH_EDGIBOX = "AgentDoesNotReachEdgibox",
  VIDEO_UPLOAD_ERROR = "VideoUploadError",
  IMAGE_UPLOAD_ERROR = "ImageUploadError",
  PREDICTOR_DISABLED = "PredictorDisabled",
  NON_SCAN_DETECTOR_REPEATED_FPS_DROPS = "NonScanDetectorRepeatedFpsDrops",
  MODEL_BELOW_KPI_THRESHOLD = "ModelBelowKpiThreshold",
  TRAINING_WARNINGS = "TrainingWarnings",
  LOOKUP_TABLE_MISMATCH = "LookupTableMismatch",
  METRIC_THRESHOLD_BREACH = "MetricThresholdBreach",
  SERVICE_DOWN = "ServiceDown",
  DATA_COMPLETENESS_BELOW_THRESHOLD = "DataCompletenessBelowThreshold",
  DEVICE_DOWN_ESCALATED = "DeviceDownEscalated",
  SERVER_DOWN_ESCALATED = "ServerDownEscalated",
  CAMERA_DOWN_ESCALATED = "CameraDownEscalated",
  HIGH_RESOURCE_USAGE_ESCALATED = "HighResourceUsageEscalated",
  LOOKUP_TABLE_DISABLED_ESCALATED = "LookupTableDisabledEscalated",
  DEPLOYED_MODEL_FAILURE_ESCALATED = "DeployedModelFailureEscalated",
  NON_SCAN_DETECTOR_DOWN_ESCALATED = "NonScanDetectorDownEscalated",
  ON_SCREEN_APP_DOWN_ESCALATED = "OnScreenAppDownEscalated",
  ZEBRA_ADAPTER_DOWN_ESCALATED = "ZebraAdapterDownEscalated",
  AGENT_PORT_CLASH_ESCALATED = "AgentPortClashEscalated",
  LOCKED_SAMPLES_ABOVE_THRESHOLD_ESCALATED = "LockedSamplesAboveThresholdEscalated",
  FAILED_TO_STORE_SAMPLE_LACK_OF_STORAGE_ESCALATED = "FailedToStoreSampleLackOfStorageEscalated",
  BLACK_SCREEN_IMAGE_DETECTED_ESCALATED = "BlackScreenImageDetectedEscalated",
  LOCAL_STORAGE_ALMOST_FULL_ESCALATED = "LocalStorageAlmostFullEscalated",
  AGENT_DOES_NOT_REACH_EDGIBOX_ESCALATED = "AgentDoesNotReachEdgiboxEscalated",
  VIDEO_UPLOAD_ERROR_ESCALATED = "VideoUploadErrorEscalated",
  IMAGE_UPLOAD_ERROR_ESCALATED = "ImageUploadErrorEscalated",
  PREDICTOR_DISABLED_ESCALATED = "PredictorDisabledEscalated",
  NON_SCAN_DETECTOR_REPEATED_FPS_DROPS_ESCALATED = "NonScanDetectorRepeatedFpsDropsEscalated",
}

export enum status {
  OPEN = "Open",
  CLOSED = "Closed",
}

export type AlertDetailsDto = {
  alertType:
    | "DeviceDown"
    | "ServerDown"
    | "CameraDown"
    | "HighResourceUsage"
    | "LookupTableDisabled"
    | "DeployedModelFailure"
    | "RegisterDisabledDeviceAttempt"
    | "RegisterDuplicateDeviceAttempt"
    | "TrainingFailed"
    | "NonScanDetectorDown"
    | "OnScreenAppDown"
    | "ZebraAdapterDown"
    | "AgentPortClash"
    | "LockedSamplesAboveThreshold"
    | "FailedToStoreSampleLackOfStorage"
    | "BlackScreenImageDetected"
    | "LocalStorageAlmostFull"
    | "AgentDoesNotReachEdgibox"
    | "VideoUploadError"
    | "ImageUploadError"
    | "PredictorDisabled"
    | "NonScanDetectorRepeatedFpsDrops"
    | "ModelBelowKpiThreshold"
    | "TrainingWarnings"
    | "LookupTableMismatch"
    | "MetricThresholdBreach"
    | "ServiceDown"
    | "DataCompletenessBelowThreshold"
    | "DeviceDownEscalated"
    | "ServerDownEscalated"
    | "CameraDownEscalated"
    | "HighResourceUsageEscalated"
    | "LookupTableDisabledEscalated"
    | "DeployedModelFailureEscalated"
    | "NonScanDetectorDownEscalated"
    | "OnScreenAppDownEscalated"
    | "ZebraAdapterDownEscalated"
    | "AgentPortClashEscalated"
    | "LockedSamplesAboveThresholdEscalated"
    | "FailedToStoreSampleLackOfStorageEscalated"
    | "BlackScreenImageDetectedEscalated"
    | "LocalStorageAlmostFullEscalated"
    | "AgentDoesNotReachEdgiboxEscalated"
    | "VideoUploadErrorEscalated"
    | "ImageUploadErrorEscalated"
    | "PredictorDisabledEscalated"
    | "NonScanDetectorRepeatedFpsDropsEscalated";
  handling: string;
  alertIntervalUnits: "minutes" | "hours";
  enabled: boolean;
  priority: AlertPriority;
  severity: AlertSeverity;
  id: number;
  title: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
  allowThreshold: boolean;
  allowOperationalHours: boolean;
  allowInterval: boolean;
  escalatedSpecId: number | null;
  parentSpecId: number | null;
  escalation: AlertEscalationSummaryDto | null;
  occurrenceThreshold?: number;
  timeWindowSec?: number;
  alertInterval?: number;
  useOperationalHours?: boolean;
  subscriptions: Array<AlertSubscriptionItemDto>;
  availableChannels: Array<AlertChannelDto>;
  disabledDevices: Array<DisabledDeviceDto>;
};

export enum alertIntervalUnits {
  MINUTES = "minutes",
  HOURS = "hours",
}

export type AlertEscalationChannelDto = {
  channelType: AlertChannelType;
  alertChannelId: number;
  channelName: string;
  isGlobal: boolean;
};

export type AlertEscalationChannelOptionDto = {
  channelType: AlertChannelType;
  alertChannelId: number;
  channelName: string;
  isGlobal: boolean;
  isSubscribed: boolean;
};

export type AlertEscalationResponseDto = {
  escalatedAlertType: AlertType;
  activeScope: AlertEscalationScope | null;
  priority: AlertPriority;
  parentPriority: AlertPriority;
  allowedPriorities: Array<AlertPriority>;
  escalatedSpecId: number;
  rules: Array<AlertEscalationRuleDto>;
  useOperationalHours: boolean;
  channels: Array<AlertEscalationChannelOptionDto>;
};

export type AlertEscalationRuleDto = {
  scope: AlertEscalationScope;
  thresholdType: AlertEscalationThresholdType;
  thresholdValue: number;
  timeWindowSec: number;
  isEnabled: boolean;
};

export enum AlertEscalationScope {
  SITE = "Site",
  ACCOUNT = "Account",
}

export type AlertEscalationSummaryDto = {
  priority: AlertPriority;
  rules: Array<AlertEscalationRuleDto>;
  enabled: boolean;
  channels: Array<AlertEscalationChannelDto>;
  channelCount: number;
};

export enum AlertEscalationThresholdType {
  COUNT = "Count",
  PERCENT = "Percent",
}

export enum AlertPriority {
  MINOR = "Minor",
  NORMAL = "Normal",
  URGENT = "Urgent",
  BLOCKER = "Blocker",
}

export enum AlertSeverity {
  LOW = "Low",
  MEDIUM = "Medium",
  HIGH = "High",
}

export enum AlertSpecsOrderEnum {
  ALERT_TYPE = "alertType",
  PRIORITY = "priority",
  SEVERITY = "severity",
}

export type AlertSpecsOrderEnumSortOption = {
  field: AlertSpecsOrderEnum;
  dir?: "asc" | "desc";
};

export type AlertSubscriptionItemDto = {
  id: number | null;
  alertChannelId: number;
  channelName: string;
  name: string | null;
  channelType: "email" | "JIRA" | "slack" | "webhook";
  isEnabled: boolean;
  isGlobal: boolean;
};

export enum channelType {
  EMAIL = "email",
  JIRA = "JIRA",
  SLACK = "slack",
  WEBHOOK = "webhook",
}

export enum AlertType {
  DEVICE_DOWN = "DeviceDown",
  SERVER_DOWN = "ServerDown",
  CAMERA_DOWN = "CameraDown",
  HIGH_RESOURCE_USAGE = "HighResourceUsage",
  LOOKUP_TABLE_DISABLED = "LookupTableDisabled",
  DEPLOYED_MODEL_FAILURE = "DeployedModelFailure",
  REGISTER_DISABLED_DEVICE_ATTEMPT = "RegisterDisabledDeviceAttempt",
  REGISTER_DUPLICATE_DEVICE_ATTEMPT = "RegisterDuplicateDeviceAttempt",
  TRAINING_FAILED = "TrainingFailed",
  NON_SCAN_DETECTOR_DOWN = "NonScanDetectorDown",
  ON_SCREEN_APP_DOWN = "OnScreenAppDown",
  ZEBRA_ADAPTER_DOWN = "ZebraAdapterDown",
  AGENT_PORT_CLASH = "AgentPortClash",
  LOCKED_SAMPLES_ABOVE_THRESHOLD = "LockedSamplesAboveThreshold",
  FAILED_TO_STORE_SAMPLE_LACK_OF_STORAGE = "FailedToStoreSampleLackOfStorage",
  BLACK_SCREEN_IMAGE_DETECTED = "BlackScreenImageDetected",
  LOCAL_STORAGE_ALMOST_FULL = "LocalStorageAlmostFull",
  AGENT_DOES_NOT_REACH_EDGIBOX = "AgentDoesNotReachEdgibox",
  VIDEO_UPLOAD_ERROR = "VideoUploadError",
  IMAGE_UPLOAD_ERROR = "ImageUploadError",
  PREDICTOR_DISABLED = "PredictorDisabled",
  NON_SCAN_DETECTOR_REPEATED_FPS_DROPS = "NonScanDetectorRepeatedFpsDrops",
  MODEL_BELOW_KPI_THRESHOLD = "ModelBelowKpiThreshold",
  TRAINING_WARNINGS = "TrainingWarnings",
  LOOKUP_TABLE_MISMATCH = "LookupTableMismatch",
  METRIC_THRESHOLD_BREACH = "MetricThresholdBreach",
  SERVICE_DOWN = "ServiceDown",
  DATA_COMPLETENESS_BELOW_THRESHOLD = "DataCompletenessBelowThreshold",
  DEVICE_DOWN_ESCALATED = "DeviceDownEscalated",
  SERVER_DOWN_ESCALATED = "ServerDownEscalated",
  CAMERA_DOWN_ESCALATED = "CameraDownEscalated",
  HIGH_RESOURCE_USAGE_ESCALATED = "HighResourceUsageEscalated",
  LOOKUP_TABLE_DISABLED_ESCALATED = "LookupTableDisabledEscalated",
  DEPLOYED_MODEL_FAILURE_ESCALATED = "DeployedModelFailureEscalated",
  NON_SCAN_DETECTOR_DOWN_ESCALATED = "NonScanDetectorDownEscalated",
  ON_SCREEN_APP_DOWN_ESCALATED = "OnScreenAppDownEscalated",
  ZEBRA_ADAPTER_DOWN_ESCALATED = "ZebraAdapterDownEscalated",
  AGENT_PORT_CLASH_ESCALATED = "AgentPortClashEscalated",
  LOCKED_SAMPLES_ABOVE_THRESHOLD_ESCALATED = "LockedSamplesAboveThresholdEscalated",
  FAILED_TO_STORE_SAMPLE_LACK_OF_STORAGE_ESCALATED = "FailedToStoreSampleLackOfStorageEscalated",
  BLACK_SCREEN_IMAGE_DETECTED_ESCALATED = "BlackScreenImageDetectedEscalated",
  LOCAL_STORAGE_ALMOST_FULL_ESCALATED = "LocalStorageAlmostFullEscalated",
  AGENT_DOES_NOT_REACH_EDGIBOX_ESCALATED = "AgentDoesNotReachEdgiboxEscalated",
  VIDEO_UPLOAD_ERROR_ESCALATED = "VideoUploadErrorEscalated",
  IMAGE_UPLOAD_ERROR_ESCALATED = "ImageUploadErrorEscalated",
  PREDICTOR_DISABLED_ESCALATED = "PredictorDisabledEscalated",
  NON_SCAN_DETECTOR_REPEATED_FPS_DROPS_ESCALATED = "NonScanDetectorRepeatedFpsDropsEscalated",
}

export type AnalyzeDatasetDto = {
  file: Blob | File;
};

export type AssignGroupSampleTagsDto = {
  sampleUuid?: string;
  groupId?: string;
  sessionId?: string;
  referencedSampleUuid?: string;
  tags: Array<SampleTagAssignDto>;
};

export type AssignGroupSampleTagsResponseDto = {
  sampleIds: Array<number>;
  createdTags?: Array<SampleTagDto>;
};

export type AssignSampleTagsDto = {
  taggedIds?: Array<number>;
  sampleUuids?: Array<string>;
  referencedSampleUuid?: string;
  tags: Array<SampleTagAssignDto>;
};

export type AssignSampleTagsResponseDto = {
  taggedIds: Array<number>;
  missingSampleIds?: Array<number>;
  missingSampleUuids?: Array<string>;
  createdTags?: Array<SampleTagDto>;
};

export type AssignSitesDto = {
  userId: number;
  siteIds: Array<number>;
};

export type AssignTagsDto = {
  elementIds: Array<{
    [key: string]: unknown;
  }>;
  tags: Array<string>;
};

export type AssignTagsResponseDto = {
  createdTagIds?: Array<number>;
  foundElementsIds: Array<{
    [key: string]: unknown;
  }>;
  missingElements: Array<{
    [key: string]: unknown;
  }>;
};

export type AuthenticationFieldsDto = {
  username?: string;
  password?: string;
  token?: string;
  url?: string;
};

export type BboxDto = {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
};

export type BlurProgressDto = {
  /**
   * Which operation this is about. Missing on agents that predate the split - such a report is
   * always an upload, and carries only the upload fields. Use `isBlurProgress`/`progressOperation`
   * rather than reading this directly.
   */
  operation?: "upload" | "blur";
  /**
   * Size of the video being blurred - what an estimate is built from before the detector reports one.
   */
  videoSize?: number;
  videoSeconds?: number;
  currentFrame?: number;
  sourceTotalFrames?: number;
  totalFrames?: number;
  totalFramesWithHeads?: number;
  totalProcessingSec?: number;
  /**
   * Agent-side status string; empty before anything started.
   */
  status?: string;
  sessionId?: string;
  filename?: string;
  running?: boolean;
  /**
   * 0..1 of the item - bytes written for an upload, frames read for a blur. 0 until it can place itself.
   */
  percent?: number;
  remainingSeconds?: number;
  durationMs?: number;
  startTime?: Date;
  endTime?: Date;
  lastError?: string;
};

/**
 * Which operation this is about. Missing on agents that predate the split - such a report is
 * always an upload, and carries only the upload fields. Use `isBlurProgress`/`progressOperation`
 * rather than reading this directly.
 */
export enum operation {
  UPLOAD = "upload",
  BLUR = "blur",
}

export type BulkAccountsQueryDto = {
  accountIds?: Array<number>;
  name?: string;
  /**
   * Filter by active status. Defaults to true when omitted.
   */
  isActive?: boolean;
};

export enum BulkAlertAction {
  RESOLVE = "Resolve",
}

export type BulkCatalogItemsQueryDto = {
  plus?: Array<string>;
  itemIds?: Array<number>;
  priceBy?: "weight" | "quantity";
  price?: Decimal2;
  families?: Array<string>;
  sortBy?: Array<CatalogItemsSummaryOrderEnumSortOption>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  siteId?: number;
  groupId?: number;
  search?: string;
  exact?: boolean;
  name?: string;
  englishName?: string;
  outOfScope?: boolean;
};

export enum priceBy {
  WEIGHT = "weight",
  QUANTITY = "quantity",
}

export type BulkClustersQueryDto = {
  clusterIds?: Array<number>;
  sortBy?: Array<ClusterSummariesOrderEnumSortOption>;
  name?: string;
};

export type BulkDevicesQueryDto = {
  deviceIds?: Array<number>;
  state?: Array<QueryDeviceState>;
  excludeClusterIds?: Array<number>;
  siteIds?: Array<number>;
  excludeSiteIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  /**
   * Filter by one or more video states
   */
  videoState?: Array<
    "Unknown" | "Disabled" | "Disconnected" | "Down" | "OK" | "All"
  >;
  name?: string;
  agentVersion?: string;
  os?: string;
  cpu?: string;
  modelName?: string;
  localIp?: string;
  lastPing?: Date;
  clusterId?: number;
  siteId?: number;
  configLocked?: boolean;
};

export type BulkJobsQueryDto = {
  state?:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  name?: string;
  from?: Date;
  to?: Date;
  jobIds?: Array<number>;
};

export enum state3 {
  PENDING = "pending",
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
  CANCELLED = "cancelled",
  CANCELLING = "cancelling",
  SUSPENDED = "suspended",
  ABORTED = "aborted",
}

export type BulkManagedAlertsQueryDto = {
  priority?: Array<AlertPriority>;
  severity?: Array<AlertSeverity>;
  eventIds?: Array<string>;
  status?: Array<"Open" | "Closed">;
  deviceIds?: Array<number>;
  alertTypes?: Array<
    | "DeviceDown"
    | "ServerDown"
    | "CameraDown"
    | "HighResourceUsage"
    | "LookupTableDisabled"
    | "DeployedModelFailure"
    | "RegisterDisabledDeviceAttempt"
    | "RegisterDuplicateDeviceAttempt"
    | "TrainingFailed"
    | "NonScanDetectorDown"
    | "OnScreenAppDown"
    | "ZebraAdapterDown"
    | "AgentPortClash"
    | "LockedSamplesAboveThreshold"
    | "FailedToStoreSampleLackOfStorage"
    | "BlackScreenImageDetected"
    | "LocalStorageAlmostFull"
    | "AgentDoesNotReachEdgibox"
    | "VideoUploadError"
    | "ImageUploadError"
    | "PredictorDisabled"
    | "NonScanDetectorRepeatedFpsDrops"
    | "ModelBelowKpiThreshold"
    | "TrainingWarnings"
    | "LookupTableMismatch"
    | "MetricThresholdBreach"
    | "ServiceDown"
    | "DataCompletenessBelowThreshold"
    | "DeviceDownEscalated"
    | "ServerDownEscalated"
    | "CameraDownEscalated"
    | "HighResourceUsageEscalated"
    | "LookupTableDisabledEscalated"
    | "DeployedModelFailureEscalated"
    | "NonScanDetectorDownEscalated"
    | "OnScreenAppDownEscalated"
    | "ZebraAdapterDownEscalated"
    | "AgentPortClashEscalated"
    | "LockedSamplesAboveThresholdEscalated"
    | "FailedToStoreSampleLackOfStorageEscalated"
    | "BlackScreenImageDetectedEscalated"
    | "LocalStorageAlmostFullEscalated"
    | "AgentDoesNotReachEdgiboxEscalated"
    | "VideoUploadErrorEscalated"
    | "ImageUploadErrorEscalated"
    | "PredictorDisabledEscalated"
    | "NonScanDetectorRepeatedFpsDropsEscalated"
  >;
  name?: string;
  alertKey?: string;
  escalated?: boolean;
  fromDate?: Date;
  toDate?: Date;
};

export type BulkRegionRowsQueryDto = {
  /**
   * Case-insensitive substring match on the region name
   */
  region?: string;
  /**
   * Case-insensitive substring match on the sub-region name
   */
  subRegion?: string;
  regionIds?: Array<number>;
  subRegionIds?: Array<number>;
  /**
   * When true, list INACTIVE rows instead of active ones. Omitted or false = active only.
   */
  showInactive?: boolean;
};

export type BulkSamplesQueryDto = {
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  deviceIds?: Array<number>;
  storageDeviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  siteGroupIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  timeField?: "createdAt" | "addedAt";
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  modelIds?: Array<number>;
  result?: Array<TransactionResultEnum>;
  labels?: Array<string>;
  predictions?: Array<string>;
  families?: Array<string>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  taggedByIds?: Array<number>;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  dataType?: Array<string>;
  datasetId?: number;
  fromDate?: Date;
  toDate?: Date;
  onlyWithPrediction?: boolean;
  showNonScans?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  family?: string;
  fuzzy?: boolean;
  matchStrength?: string;
  sessionId?: Array<string>;
  showOnlyWithImages?: boolean;
};

export type BulkScheduledJobsQueryDto = {
  name?: string;
  from?: Date;
  to?: Date;
  scheduledJobIds?: Array<number>;
};

export type BulkScheduledTrainingsDto = {
  query: BulkScheduledTrainingsQueryDto;
};

export type BulkScheduledTrainingsQueryDto = {
  scheduledTrainingIds?: Array<number>;
};

export type BulkSessionsQueryDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  storageDeviceIds?: Array<number>;
  storage?:
    | "any"
    | "backend"
    | "cluster"
    | "edge"
    | "device"
    | "recorded"
    | "none";
  timeField?: "createdAt" | "session";
  sessionIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  tagIds?: Array<number>;
  sessionTagIds?: Array<number>;
  sessionsTagsMatch?: "any" | "exact" | "all" | "none";
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  assigneeIds?: Array<number>;
  assigneeMatch?: "any" | "none";
  alertType?: Array<"non-scan" | "non-match" | "left-in-cart">;
  labels?: Array<string>;
  datasetId?: number;
  from?: Date;
  to?: Date;
  sessionId?: Array<string>;
  onlyNonScans?: boolean;
  onlyStored?: boolean;
  headBlurred?: boolean;
  assistantId?: string;
  shopperId?: string;
};

export type BulkSiteGroupsQueryDto = {
  siteGroupIds?: Array<number>;
  name?: string;
};

export type BulkSitesQueryDto = {
  siteIds?: Array<number>;
  groupId?: number;
  excludeGroupIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  name?: string;
};

export type BulkTrainingsDto = {
  query: BulkTrainingsQueryDto;
};

export type BulkTrainingsQueryDto = {
  state?: Array<TrainingState>;
  name?: string;
  createdSince?: Date;
  from?: Date;
  to?: Date;
  isVisible?: boolean;
  trainingIds?: Array<number>;
};

export type BulkUpdateSiteGroupLabelsDto = {
  labels: Array<LabelUpdate>;
  schedule?: ScheduleJobScheduleDto;
  /**
   * Custom job name. Overrides the auto-generated name.
   */
  name?: string;
  /**
   * Only meaningful when `schedule` is set: apply labels to the DB immediately and only defer device notification.
   */
  immediateApply?: boolean;
};

export type BulkUpsertSiteGroupsOperationalHoursDto = {
  schedule: Array<CreateOperationalHoursEntryDto>;
  query: BulkSiteGroupsQueryDto;
  enabled: boolean;
  timezone: string;
};

export type BulkUpsertSitesOperationalHoursDto = {
  schedule: Array<CreateOperationalHoursEntryDto>;
  query: BulkSitesQueryDto;
  enabled: boolean;
  timezone: string;
};

export type BulkUsersQueryDto = {
  userIds?: Array<number>;
  roles?: Array<
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
  >;
  excludeRoles?: Array<
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
  >;
  id?: number;
  firstName?: string;
  lastName?: string;
  company?: string;
};

export type CameraCalibrationDataWithNameDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  name?: string;
  description?: string;
  predictorDeviceId: number;
  family?: string;
};

export type CameraCalibrationDeviceResultDto = {
  result?: "calibrated" | "uncalibrated" | "unknown" | "unrelated" | "failure";
  state?: CameraCalibrationStateEnum;
  startTime?: Date;
  captureTime?: Date;
  updateTime?: Date;
  name?: string;
  prediction?: PredictResponseDto;
  sampleId?: string;
  total?: number;
  done?: number;
  failures?: number;
  failure?: ErrorDto;
};

export enum result {
  CALIBRATED = "calibrated",
  UNCALIBRATED = "uncalibrated",
  UNKNOWN = "unknown",
  UNRELATED = "unrelated",
  FAILURE = "failure",
}

export type CameraCalibrationJobDataDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  predictorDeviceId: number;
  family?: string;
};

export type CameraCalibrationJobDeviceDto = {
  participation: CameraCalibrationJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type CameraCalibrationJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: CameraCalibrationJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: CameraCalibrationDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum CameraCalibrationJobDeviceStateDto {
  CAPTURING = "capturing",
  PREDICTING = "predicting",
  STORING = "storing",
  DONE = "done",
  FAILED = "failed",
}

export type CameraCalibrationJobDto = {
  id: number;
  name?: string;
  result: CameraCalibrationJobResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: CameraCalibrationJobDataDto;
  info?: CameraCalibrationJobInfoDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<CameraCalibrationJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type CameraCalibrationJobInfoDto = {
  predictor?: PredictorInfoDto;
};

export type CameraCalibrationJobResultDto = {
  failure?: ErrorDto;
  devices?: {
    total?: number;
    stateCounts?: {
      capturing?: number;
      predicting?: number;
      storing?: number;
      done?: number;
      failed?: number;
    };
    states?: {
      capturing?: Array<number>;
      predicting?: Array<number>;
      storing?: Array<number>;
      done?: Array<number>;
      failed?: Array<number>;
    };
  };
};

export type CameraCalibrationJobSummaryDto = {
  id: number;
  name?: string;
  result: CameraCalibrationJobResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: CameraCalibrationJobDataDto;
  info?: CameraCalibrationJobInfoDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type CameraCalibrationScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: CameraCalibrationJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  info?: CameraCalibrationJobInfoDto;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type CameraCalibrationScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: CameraCalibrationJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  info?: CameraCalibrationJobInfoDto;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type CameraCalibrationScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: CameraCalibrationJobDataDto;
};

export enum CameraCalibrationStateEnum {
  CAPTURING = "capturing",
  PREDICTING = "predicting",
  STORING = "storing",
  DONE = "done",
  FAILED = "failed",
}

export type CameraCalibrationUpdateJobDto = {
  name?: string;
  description?: string;
};

export type CameraCalibrationUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: CameraCalibrationJobDataDto;
};

export type CancelConfigDeploymentDto = {
  deploymentId: number;
};

export type CancelPendingUploadsDto = {
  /**
   * Set to true to cancel all rows matching the supplied pending-row filters (and optional exclusions)
   */
  allFiltered?: boolean;
  /**
   * Pending-row UUID filter for all-filtered cancellation
   */
  uuid?: string;
  /**
   * Explicit pending row IDs to cancel
   */
  ids?: Array<number>;
  /**
   * Explicit pending sample UUIDs to cancel
   */
  uuids?: Array<string>;
  excludedIds?: Array<number>;
  excludedUuids?: Array<string>;
  operationIds?: Array<number>;
  actions?: Array<PendingActionEnum>;
  deviceIds?: Array<number>;
  ownedByMe?: boolean;
  from?: Date;
  to?: Date;
};

export type CandidateImagesDto = {
  clientImageUrl?: string;
  serverImageUrl?: string;
};

export type CapacityTaggingAlertDto = {
  accountId: number;
  windowFrom: Date;
  windowTo: Date;
  thresholdPercent: number;
  actualPercent: number;
  completeness: CapacityTaggingCompletenessDto;
};

export type CapacityTaggingCompletenessDto = {
  alertedSessions: number;
  withVideo: number;
  /**
   * Overall completeness percent (0-100)
   */
  percent: number;
  /**
   * Threshold percent the run was gated on (null when the gate is disabled)
   */
  thresholdPercent: {
    [key: string]: unknown;
  } | null;
  /**
   * Whether the window passed the completeness gate
   */
  passesThreshold: boolean;
  perStore: Array<CapacityTaggingStoreCompletenessDto>;
};

export type CapacityTaggingDataWithNameDto = {
  /**
   * Explicit window start (manual runs)
   */
  fromDate?: Date;
  /**
   * Explicit window end (manual runs)
   */
  toDate?: Date;
  /**
   * Relative look-back window in days, resolved at run time (recurring/interval runs)
   */
  lookbackDays?: number;
  /**
   * Enable the data-completeness threshold gate
   */
  completenessThresholdEnabled?: boolean;
  /**
   * Minimum percent of the window's alerted sessions that must have video uploaded; below it the run alerts instead of dispatching
   */
  completenessThresholdPercent?: number;
  /**
   * Daily review capacity (sessions/day) handed to the component as its review budget; defaults to the account's nonScanDailyCapacityThreshold setting, then 600
   */
  capacity?: number;
  /**
   * Superseded by tags; still honored for schedules persisted before multi-tag support
   * @deprecated
   */
  tagName?: string;
  /**
   * Session tags applied to the selected sessions (missing tags are auto-created). Takes precedence over the deprecated tagName.
   */
  tags?: Array<string>;
  /**
   * Target sessions per Cloud Run task shard of the scoring execution (default 1k)
   */
  sessionsPerBatch?: number;
  name?: string;
  description?: string;
};

export type CapacityTaggingJobDataDto = {
  /**
   * Explicit window start (manual runs)
   */
  fromDate?: Date;
  /**
   * Explicit window end (manual runs)
   */
  toDate?: Date;
  /**
   * Relative look-back window in days, resolved at run time (recurring/interval runs)
   */
  lookbackDays?: number;
  /**
   * Enable the data-completeness threshold gate
   */
  completenessThresholdEnabled?: boolean;
  /**
   * Minimum percent of the window's alerted sessions that must have video uploaded; below it the run alerts instead of dispatching
   */
  completenessThresholdPercent?: number;
  /**
   * Daily review capacity (sessions/day) handed to the component as its review budget; defaults to the account's nonScanDailyCapacityThreshold setting, then 600
   */
  capacity?: number;
  /**
   * Superseded by tags; still honored for schedules persisted before multi-tag support
   * @deprecated
   */
  tagName?: string;
  /**
   * Session tags applied to the selected sessions (missing tags are auto-created). Takes precedence over the deprecated tagName.
   */
  tags?: Array<string>;
  /**
   * Target sessions per Cloud Run task shard of the scoring execution (default 1k)
   */
  sessionsPerBatch?: number;
};

export type CapacityTaggingJobDto = {
  id: number;
  name?: string;
  result: CapacityTaggingResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: CapacityTaggingJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<JobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type CapacityTaggingJobSummaryDto = {
  id: number;
  name?: string;
  result: CapacityTaggingResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: CapacityTaggingJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type CapacityTaggingPreCheckRequestDto = {
  fromDate?: Date;
  toDate?: Date;
  lookbackDays?: number;
  completenessThresholdEnabled?: boolean;
  completenessThresholdPercent?: number;
};

export type CapacityTaggingPreCheckResponseDto = {
  /**
   * Resolved window start
   */
  windowFrom: Date;
  /**
   * Resolved window end
   */
  windowTo: Date;
  /**
   * Alerted sessions in the window
   */
  alertedSessions: number;
  /**
   * Eligible sessions the run would process (video uploaded, not already dispatched)
   */
  wouldProcess: number;
  completeness: CapacityTaggingCompletenessDto;
};

export type CapacityTaggingPrepareCacheProgressDto = {
  /**
   * Cloud Run task count of the scoring execution
   */
  batchesTotal: number;
  /**
   * Tasks not yet terminal
   */
  batchesRunning: number;
  /**
   * Tasks succeeded
   */
  batchesDone: number;
  /**
   * Tasks failed or cancelled
   */
  batchesFailed: number;
  /**
   * Sessions processed (task-proportional estimate while running)
   */
  sessionsProcessed: number;
  /**
   * Sessions in the scoring input CSV
   */
  sessionsTotal: number;
};

export type CapacityTaggingResultDto = {
  /**
   * Sessions processed (drives the jobs-list progress bar)
   */
  done?: number;
  /**
   * Sessions to process (eligible sessions collected)
   */
  total?: number;
  /**
   * Always 0 on success — a failed scoring execution fails the whole run
   */
  failures?: number;
  /**
   * Alerted sessions eligible for processing (video uploaded, not already dispatched)
   */
  sessionsCollected?: number;
  sessionsProcessed?: number;
  completeness?: CapacityTaggingCompletenessDto;
  /**
   * GCS path of the uploaded input CSV (single file per run)
   */
  csvFiles?: Array<string>;
  prepareCache?: CapacityTaggingPrepareCacheProgressDto;
  /**
   * Sessions selected by the sample step
   */
  sampledSessionCount?: number;
  /**
   * Daily review capacity handed to the component for this run (sessions/day): the job's capacity, else the account's nonScanDailyCapacityThreshold, else 600
   */
  capacityApplied?: number;
  /**
   * GCS path of the per-run component config carrying that capacity as the review budget (passed to sample --config)
   */
  sampleConfigPath?: string;
  /**
   * Sessions excluded because no site resolves for them (blank Site ID is a hard input error for the component)
   */
  sessionsSkippedNoSite?: number;
  /**
   * Per-business-date sample outcomes
   */
  sampleDates?: Array<CapacityTaggingSampleDateDto>;
  /**
   * Per-date score run-summary counts read from the component’s handoff dirs (best effort)
   */
  scoreSummaries?: Array<CapacityTaggingScoreDateSummaryDto>;
  /**
   * Sessions actually tagged with the run tags
   */
  sessionsTagged?: number;
  /**
   * Session tags applied to the selected sessions
   */
  tags?: Array<string>;
  /**
   * Superseded by tags; mirrors tags[0]
   * @deprecated
   */
  tagName?: string;
  /**
   * Dedup marker tag applied on dispatch
   */
  dispatchTag?: string;
  /**
   * True when the run was skipped by the data-completeness threshold gate
   */
  skippedByThreshold?: boolean;
  /**
   * Alert recorded when the completeness gate failed
   */
  alert?: CapacityTaggingAlertDto;
  /**
   * Resolved window start
   */
  windowFrom?: Date;
  /**
   * Resolved window end
   */
  windowTo?: Date;
};

export type CapacityTaggingSampleDateDto = {
  /**
   * Business date the sample run decided (YYYY-MM-DD, store-local)
   */
  date: string;
  /**
   * Sessions selected for review on this date (union of the date’s selection files)
   */
  selectedCount: number;
  /**
   * Cells (stores) decided for this date
   */
  cellsDecided?: number;
  /**
   * Cells left waiting (coverage below the component’s gate)
   */
  cellsWaiting?: number;
  /**
   * Store ids of the waiting cells
   */
  waitingStores?: Array<string>;
  /**
   * True when the sample run was skipped: scoring produced no predictions for this date
   */
  skippedNoPredictions?: boolean;
};

export type CapacityTaggingScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: CapacityTaggingJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type CapacityTaggingScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: CapacityTaggingJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type CapacityTaggingScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: CapacityTaggingJobDataDto;
};

export type CapacityTaggingScoreDateSummaryDto = {
  /**
   * Business date (YYYY-MM-DD, store-local)
   */
  date: string;
  /**
   * Whether a score run summary was found in the date’s handoff dir
   */
  summaryFound: boolean;
  sessionsScored?: number;
  sessionsFailed?: number;
};

export type CapacityTaggingStoreCompletenessDto = {
  siteId?: {
    [key: string]: unknown;
  } | null;
  siteName?: {
    [key: string]: unknown;
  } | null;
  /**
   * Alerted sessions in the window for this store
   */
  alerted: number;
  /**
   * Alerted sessions with video uploaded
   */
  withVideo: number;
  /**
   * withVideo / alerted, percent (0-100)
   */
  percent: number;
};

export type CapacityTaggingUpdateJobDto = {
  name?: string;
  description?: string;
};

export type CapacityTaggingUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: CapacityTaggingJobDataDto;
};

export type CaptureAndPredictRequestDto = {
  role?: string;
  family?: string;
  captureTrigger?: string;
  thumbnail?: GetThumbnailRequestDto;
  crop?: boolean;
};

export type CaptureAndPredictResponseDto = {
  sampleId: string;
  duration: number;
  predictedAt: Date;
  capturedAt: Date;
  modelId: number;
  certain: boolean;
  predictions: Array<PredictionOption>;
  image: string;
};

export type CaptureAndPredictResponseTranslatedDto = {
  sampleId: string;
  duration: number;
  predictedAt: Date;
  capturedAt: Date;
  modelId: number;
  certain: boolean;
  image: string;
  predictions: Array<PredictionOptionTranslated>;
};

export type CaptureRequestDto = {
  thumbnail?: GetThumbnailRequestDto;
  crop?: boolean;
};

export type CatalogItemDetailsDto = {
  priceBy?: "weight" | "quantity";
  price?: string | number;
  siteGroupLabels?: Array<SiteGroupLabel>;
  id?: number;
  plu?: string;
  name?: string;
  englishName?: string;
  family?: string;
  outOfScope?: boolean;
  tags: Array<Tag>;
  createdAt?: Date;
  updatedAt?: Date;
  updatedBy?: string;
  repImgUrl?: string;
};

export type CatalogItemLabelDto = {
  catalogItemId: number;
  plu: string;
  catalogItemName: string;
  labelInGroup: string;
  updatedAt: Date;
  updatedBy?: string;
};

export type CatalogItemLabelsDto = {
  baseLabel: string;
  name: string;
  siteGroupLabels: Array<SiteGroupLabelDto>;
};

export type CatalogItemSitePricesDto = {
  basePrice?: string | number;
  priceBy?: "weight" | "quantity";
  sitePrices: Array<SitePriceDto>;
  plu: string;
};

export enum CatalogItemsSummaryOrderEnum {
  NAME = "name",
  ENGLISH_NAME = "englishName",
  PLU = "plu",
  FAMILY = "family",
}

export type CatalogItemsSummaryOrderEnumSortOption = {
  field: CatalogItemsSummaryOrderEnum;
  dir?: "asc" | "desc";
};

export type CatalogLabelQueryDto = {
  siteId?: number;
  groupId?: number;
};

export type CatalogMinimalItemDto = {
  id: number;
  plu: string;
  name: string;
};

export type CatalogUploadDataWithNameDto = {
  /**
   * CSV upload jobs only
   */
  gcsFilePath?: string;
  siteIds?: Array<number>;
  /**
   * For CSV uploads: the target site groups. For label jobs: the single site group being updated.
   */
  groupIds?: Array<number>;
  siteNames?: Array<string>;
  siteGroupNames?: Array<string>;
  /**
   * CSV upload jobs only
   */
  uploadMode?: "full" | "partial";
  /**
   * Site group label bulk-update jobs only. Presence of this field is the job-kind discriminator.
   */
  labels?: Array<LabelUpdate>;
  /**
   * True when the DB was updated immediately (Paths A/B); false when the full job runs on schedule (Path C).
   */
  immediateApply?: boolean;
  name?: string;
  description?: string;
};

/**
 * CSV upload jobs only
 */
export enum uploadMode {
  FULL = "full",
  PARTIAL = "partial",
}

export type CatalogUploadDeviceResultDto = {
  state?: CatalogUploadDeviceStateEnum;
  done?: boolean;
  failed?: boolean;
  pending?: boolean;
  cancelled?: boolean;
  startTime?: Date;
  updateTime?: Date;
  failure?: ErrorDto;
};

export enum CatalogUploadDeviceStateEnum {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
  PENDING = "pending",
  CANCELLED = "cancelled",
}

export type CatalogUploadJobDataDto = {
  /**
   * CSV upload jobs only
   */
  gcsFilePath?: string;
  siteIds?: Array<number>;
  /**
   * For CSV uploads: the target site groups. For label jobs: the single site group being updated.
   */
  groupIds?: Array<number>;
  siteNames?: Array<string>;
  siteGroupNames?: Array<string>;
  /**
   * CSV upload jobs only
   */
  uploadMode?: "full" | "partial";
  /**
   * Site group label bulk-update jobs only. Presence of this field is the job-kind discriminator.
   */
  labels?: Array<LabelUpdate>;
  /**
   * True when the DB was updated immediately (Paths A/B); false when the full job runs on schedule (Path C).
   */
  immediateApply?: boolean;
};

export type CatalogUploadJobDeviceDto = {
  participation: CatalogUploadJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type CatalogUploadJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: CatalogUploadJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: CatalogUploadDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum CatalogUploadJobDeviceStateDto {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
  PENDING = "pending",
  CANCELLED = "cancelled",
}

export type CatalogUploadJobDto = {
  id: number;
  name?: string;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: CatalogUploadJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<CatalogUploadJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type CatalogUploadJobSummaryDto = {
  id: number;
  name?: string;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: CatalogUploadJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type CatalogUploadScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: CatalogUploadJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type CatalogUploadScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: CatalogUploadJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type CatalogUploadScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: CatalogUploadJobDataDto;
};

export type CatalogUploadUpdateJobDto = {
  name?: string;
  description?: string;
};

export type CatalogUploadUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: CatalogUploadJobDataDto;
};

export type ChatMessageDto = {
  role: "user" | "assistant";
  content: string;
};

export enum role2 {
  USER = "user",
  ASSISTANT = "assistant",
}

export type ChatRequestDto = {
  /**
   * Optional per-conversation UUID, generated by the client and reused for every turn of one conversation. Groups the turns into one conversation in the chat log; a fresh one is generated server-side when omitted.
   */
  sessionId?: string;
  messages: Array<ChatMessageDto>;
  /**
   * Model override for this chat. Requires the caller to hold `mcp.advancedUse`; silently ignored for callers who don't. Defaults to Sonnet 4.6.
   */
  model?: "claude-sonnet-4-6" | "claude-sonnet-5" | "claude-haiku-4-5";
  /**
   * Extended-thinking / effort rung for this chat. Requires the caller to hold `mcp.advancedUse`; silently ignored otherwise. Defaults to Off.
   */
  reasoning?: "off" | "low" | "medium" | "high";
};

/**
 * Model override for this chat. Requires the caller to hold `mcp.advancedUse`; silently ignored for callers who don't. Defaults to Sonnet 4.6.
 */
export enum model {
  CLAUDE_SONNET_4_6 = "claude-sonnet-4-6",
  CLAUDE_SONNET_5 = "claude-sonnet-5",
  CLAUDE_HAIKU_4_5 = "claude-haiku-4-5",
}

/**
 * Extended-thinking / effort rung for this chat. Requires the caller to hold `mcp.advancedUse`; silently ignored otherwise. Defaults to Off.
 */
export enum reasoning {
  OFF = "off",
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
}

export enum ChatTurnOrderEnum {
  CREATED_AT = "createdAt",
  LATENCY_MS = "latencyMs",
}

export type ChatTurnOrderEnumSortOption = {
  field: ChatTurnOrderEnum;
  dir?: "asc" | "desc";
};

export type ChatTurnResponseDto = {
  outcome: ReportsCompanionChatOutcome;
  id: number;
  sessionId: string;
  accountId: number;
  accountName: string;
  userId: number | null;
  /**
   * Snapshot taken when the turn ran.
   */
  userName: string;
  /**
   * Snapshot taken when the turn ran.
   */
  userRole: string;
  question: string;
  answer: string | null;
  executedSql: Array<string>;
  refusalReason: string | null;
  errorMessage: string | null;
  model: string;
  reasoning: string;
  inputTokens: number;
  outputTokens: number;
  iterations: number;
  latencyMs: number;
  createdAt: Date;
};

export type CheckDuplicateLabelResponseDto = {
  /**
   * Whether a duplicate label exists in the site group
   */
  isDuplicate: boolean;
};

export type CheckUserDto = {
  role:
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
    | "SuperAdmin";
  email: string;
};

export enum role3 {
  VIEWER = "Viewer",
  ANNOTATOR = "Annotator",
  TECH = "Tech",
  OWNER = "Owner",
  MLOPS = "MLOps",
  SITE_MANAGER = "SiteManager",
  ANNOTATOR_MANAGER = "AnnotatorManager",
  EDGIFY_CANDIDATE = "EdgifyCandidate",
  SUPER_ADMIN = "SuperAdmin",
}

export type ClusterDetailsDto = {
  serverDevice: MinimalDeviceDto;
  architecture: "distributed" | "hybrid" | "centralized";
  devices: Array<ClusterDeviceDto>;
  id: number;
  name: string;
  labelWithLeastSamples: string;
  totalSamples: number;
  totalLabels: number;
  clusterModelDeployment?: {
    model: MinimalEntityDto;
    createdAt: Date;
  };
  createdAt: Date;
  updatedAt: Date;
  activationTime?: Date;
  tags: Array<Tag>;
};

export enum architecture {
  DISTRIBUTED = "distributed",
  HYBRID = "hybrid",
  CENTRALIZED = "centralized",
}

export type ClusterDeviceDto = {
  labelsDistribution?: LabelsDistributionDto;
  state?: "deploying" | "ready" | "disconnected" | "disabled" | "down";
  localIp?: string;
  webGrpcPort?: string;
  webServerPort?: string;
  httpPort?: string;
  httpsPort?: string;
  agentVersion?: string;
  name: string;
  id: number;
};

export enum state4 {
  DEPLOYING = "deploying",
  READY = "ready",
  DISCONNECTED = "disconnected",
  DISABLED = "disabled",
  DOWN = "down",
}

export type ClusterInfoDto = {
  id: number;
  name: string;
  architecture: "distributed" | "hybrid" | "centralized";
  server?: ClusterServerDto;
};

export type ClusterModelDeploymentDto = {
  cluster: MinimalEntityDto;
  /**
   * Whether the cluster's in-site collaborator runs this model, which follows the cluster's
   * architecture and the collaborator choice the deployment recorded: a centralized cluster's
   * collaborator always does, a hybrid one's only when the deployment asked for it. Null when the
   * cluster has no collaborator at all, as every distributed cluster does.
   */
  collaboratorTargeted: boolean | null;
  updatedAt: Date;
};

export enum ClusterModelDeploymentsOrderEnum {
  NAME = "name",
  CREATED_AT = "createdAt",
}

export type ClusterModelDeploymentsOrderEnumSortOption = {
  field: ClusterModelDeploymentsOrderEnum;
  dir?: "asc" | "desc";
};

export type ClustersConfigDeploymentBulkDto = {
  deviceConfig: PartialDeviceConfigDto;
  query: BulkClustersQueryDto;
  schedule?: ScheduleJobScheduleDto;
  name?: string;
  description?: string;
  isPartial: boolean;
  originalDeviceId?: number;
  dontCleanDangerousConfigParams?: boolean;
};

export type ClusterServerDto = {
  id: number;
  name: string;
  port: string;
  reverse_proxy_port: string;
  http_port: string;
  https_port: string;
  ip: string;
  local_ip: string;
};

export type ClustersModelDeploymentBulkDto = {
  query: BulkClustersQueryDto;
  schedule?: ScheduleJobScheduleDto;
  /**
   * Also deploy to each selected cluster's in-site collaborator. Absent means false.
   */
  includeCollaboratorDevices?: boolean;
  modelId: number;
  role?:
    | "predictor"
    | "nonScanDetector"
    | "objectDetector"
    | "similarityFilter";
};

export enum role4 {
  PREDICTOR = "predictor",
  NON_SCAN_DETECTOR = "nonScanDetector",
  OBJECT_DETECTOR = "objectDetector",
  SIMILARITY_FILTER = "similarityFilter",
}

export enum ClusterSummariesOrderEnum {
  NAME = "name",
  LAST_PING = "lastPing",
}

export type ClusterSummariesOrderEnumSortOption = {
  field: ClusterSummariesOrderEnum;
  dir?: "asc" | "desc";
};

export type ClusterSummaryDto = {
  id: number;
  name: string;
  lastPing: Date;
  readyDevices: Array<MinimalEntityDto>;
  offlineDevices: Array<MinimalEntityDto>;
  collaborator: MinimalEntityDto;
  /**
   * Decides which of the cluster's devices run a deployed model, so the UI can say the same.
   */
  architecture: "distributed" | "hybrid" | "centralized";
  models: Array<MinimalEntityDto>;
  clusterModelDeployment?: {
    model: MinimalEntityDto;
  };
  tags: Array<Tag>;
};

export type ClusterUploadPreviewRowDto = {
  name: string;
  architecture?: "distributed" | "hybrid" | "centralized";
  server?: string;
  tags: Array<string>;
  status: "new" | "existing" | "error";
  /**
   * Warning messages (e.g. server device not found)
   */
  warnings: Array<string>;
  /**
   * Error message when status is error
   */
  error?: string;
};

export enum status2 {
  NEW = "new",
  EXISTING = "existing",
  ERROR = "error",
}

export type ClusterUploadResponseDto = {
  /**
   * Whether this response is from a dry run (preview) or an actual apply
   */
  dryRun: boolean;
  results: Array<ClusterUploadPreviewRowDto>;
  totalNew: number;
  totalExisting: number;
  totalErrors: number;
  /**
   * Fatal error that prevents the entire upload from proceeding
   */
  fatalError?: string;
};

export type ConfidenceStatsMetricDto = {
  data: {
    per_class_stats_dict?: {
      [key: string]: {
        recall?: {
          top_1?: number;
          top_2?: number;
          top_3?: number;
        };
        "n samples"?: number;
        n_samples?: number;
        precision?: {
          top_1?: number;
          top_2?: number;
          top_3?: number;
        };
        "class_prediction rate"?: number;
        class_prediction_rate?: number;
      };
    };
    filtering?: {
      final_message?: string;
      certain_rate?: number;
      certain_precision?: number;
      "top-1_recall"?: number;
      "top-1_precision"?: number;
      "top-1_pred_rate"?: number;
      "top-2_recall"?: number;
      "top-2_precision"?: number;
      "top-2_pred_rate"?: number;
      "top-3_recall"?: number;
      "top-3_precision"?: number;
      "top-3_pred_rate"?: number;
    };
  };
  createdAt: Date;
  uuid?: string | null;
};

export type ConfigAgentDto = {
  /**
   * The agent version - actually hard-coded during the build (using a build command parameter)
   */
  version: string;
  /**
   * Enable gRPC-Web server (used to communicate with JS clients such as setup-ui and data collector)
   */
  web_grpc_enable?: boolean;
  /**
   * The port used for gGRPC-Web
   */
  web_grpc_port?: number;
  /**
   * The max msg size of a gRPC msg (depends on the number of images in data stream)
   */
  max_msg_size: number;
  /**
   * The gRPC port
   */
  grpc_port: number;
  /**
   * The port for the web server used for displaying the docs, the samples, the setup-ui, and the data-collector
   */
  web_server_port?: number;
  /**
   * The port for the gRPC reverse proxy (=REST interface), or 0 for disabled
   */
  reverse_proxy_server_port?: number;
  /**
   * The port for the http rest, or 0 for disabled
   */
  http_port?: number;
  /**
   * The port for the https rest, or 0 for disabled
   */
  https_port: number;
  /**
   * Ping period to the cluster server in seconds
   */
  grpc_ping_period?: number;
  /**
   * 'Ping period to the cluster server in seconds',
   */
  cluster_server_ping_period?: number;
  /**
   * The network mode for the worker and collaborator containers
   */
  network_mode: string;
  /**
   * the root directory used to serving docs (under /docs*), samples (/samples*), setup-ui (*), and data-collector (/data-collector*) via HTTP
   */
  static_files_directory: string;
  /**
   * disable GRPC, enable only REST
   */
  rest_only?: boolean;
  /**
   * Ping period to the client app in seconds, 0 for disabled
   */
  client_app_ping_period?: number;
  /**
   * Agent Mode - in silent mode, alerts are not sent to the client, and predictions are not returned
   */
  mode?: AgentModeEnum;
  /**
   * when running a service container (training, non-scan..) use this folder for mapping to container, overridden by container_name
   */
  external_path?: string;
  /**
   * when agent is running inside of a docker container - specify the agent's container name here, used for mapping folders to service containers (training, non-scan..)
   */
  container_name?: string;
  /**
   * When false, public APIs listen on 127.0.0.1 (requests from localhost only) instead of 0.0.0.0, unless network_mode is bridge. Default is true (accessible from any network interface).
   */
  allow_remote_access?: boolean;
  /**
   * Maximum number of failed authentication attempts allowed per IP address before blocking. Default is 5. Set to 0 to disable blocking.
   */
  max_auth_retries?: number;
  /**
   * Time window in seconds for counting failed authentication attempts. Failed attempts outside this window are not counted. Default is 300 seconds (5 minutes).
   */
  auth_retry_window_sec?: number;
  /**
   * Duration in seconds to block an IP address after exceeding max authentication retries. Default is 3600 seconds (1 hour).
   */
  auth_block_duration_sec?: number;
  /**
   * Serve the agent swagger UI
   */
  show_swagger?: boolean;
  /**
   * Serve the agent UI (setup-ui / data-collector)
   */
  show_agent_ui?: boolean;
  tls?: ConfigAgentTlsDto;
  repository_url?: string;
  start_session_on_capture?: boolean;
};

export type ConfigAgentTlsDto = {
  /**
   * Auto-generate a self-signed CA and server certificate on startup
   */
  generate_ca: boolean;
  /**
   * Server private key file path
   */
  server_key?:
    | string
    | {
        path: string;
        content: string;
      };
  /**
   * Server certificate file path
   */
  server_cert?:
    | string
    | {
        path: string;
        content: string;
      };
};

export type ConfigAnalyticsDto = {
  /**
   * Time, in seconds, between /predictions and /ground_truths POST requests  - or 0, to disable updates (v1.17+)
   */
  update_period: number;
  /**
   * Max number of items (predictions / ground-truths) to buffer in memory - or 0 to disable the buffer (v1.17+)
   */
  containers_size: number;
  /**
   * Max number of items (predictions / ground-truths) per notification - Min 1
   */
  max_items_per_notification: number;
};

export type ConfigApiDto = {
  /**
   * The edgify backend's root URL
   */
  backend_url: string;
  base_url?: string;
  /**
   * The device's token, generated on the control panel or via automatic device registration
   */
  token?: string;
  /**
   * The account's token, used for automatic device registration (can't be left empty if token is also empty)
   */
  account_token?: string;
  /**
   * Timeout, in seconds, for app-server requests
   */
  timeout: number;
  /**
   * Root URL for downloading component installers
   */
  download_url?: string;
  /**
   * Timeout, in seconds, for app-server download requests (model downloads)
   */
  download_timeout?: number;
  /**
   * Timeout, in seconds, for uploading logs to the backend
   */
  upload_timeout?: number;
  /**
   * Video upload speed limit, in Mbps, 0 for no limit
   */
  max_video_upload_speed_mbps?: number;
  /**
   * URL of a proxy server for communicating with the app-server (both HTTP and websockets)
   */
  proxy: string;
  /**
   * The address for communicating with the appserver via websockets.
   */
  websocket_endpoint?: string;
  /**
   * wss (secure websockets) or ws (non-secure)
   */
  websocket_protocol?: string;
  /**
   * The URL path for starting a websocket connection
   */
  websocket_path?: string;
  /**
   * time, in seconds, between reconnection attempts
   */
  websocket_reconnect_period: number;
  /**
   * time, in seconds, between empty ping messages sent to the app-server in order to keep the channel open
   */
  websocket_ping_period: number;
  /**
   * To overcome agent-to-backend disconnections, we may have to resort to restarting the agent. This is done after a minimal period
   * of disconnection, which is defined by this value. If the restart doesn't fix the connection, subsequent restarts will occur
   * according to the exponential-backoff formula: backoff-minutes(i) = min(backoff_multiplier * 2^i, max_backoff)
   */
  restart_on_disconnect_backoff_multiplier?: number;
  /**
   * The maximal backoff for restarting the agent on disconnections - see above
   */
  restart_on_disconnect_max_backoff?: number;
  skip_ssl_verify: boolean;
  /**
   * URL of a proxy server for communicating with different agents
   */
  remote_proxy: string;
  /**
   * interval in seconds to sync clock with backend
   */
  clock_sync_period: number;
  /**
   * min threshold time difference with backend that requires time adjustment, -1 will clear time adjustment
   */
  clock_sync_threshold_seconds: number;
  agent_download_timeout?: number;
  remote_timeout: number;
};

export type ConfigDatabaseDto = {
  /**
   * path to the database file
   */
  Path?: string;
  /**
   * path to the database file
   */
  path?: string;
  /**
   * Database optimization period in minutes
   */
  optimize_period_minutes?: number;
};

export type ConfigDataManagerDto = {
  /**
   * path to the images folder (the samples "buffer")
   */
  path: string;
  /**
   * The size of the samples buffer (in bytes)
   */
  size: number;
  /**
   * What percent of the buffer to use for storing new samples arriving during training
   */
  training_buffer_percentage: number;
  /**
   * Store samples only when recording?
   */
  store_only_during_recording?: boolean;
  /**
   * Seconds between data buffer analytics (/device_data_stream) updates
   */
  backend_update_period: number;
  /**
   * Seconds between data buffer syncing samples with cluster collaborator, 0 - manually sync samples to edgibox
   */
  remote_sync_period?: number;
  /**
   * The delay, in seconds, between each sample sent to the collaborator
   */
  remote_sync_delay_between_samples?: number;
  /**
   * Minimum number of samples required per label, 0 to disable
   */
  minimum_samples_per_label?: number;
  /**
   * Upload samples to the cluster automatically
   */
  auto_upload?: boolean;
  /**
   * Delete samples from the device once auto uploaded
   */
  auto_upload_delete?: boolean;
  tls?: ConfigDataManagerTlsDto;
};

export type ConfigDataManagerTlsDto = {
  /**
   * Skip server certificate verification
   */
  insecure_skip_verify: boolean;
  /**
   * Minimum TLS version
   */
  min_version: TlsMinVersionEnum;
  /**
   * CA certificate
   */
  ca_cert?:
    | string
    | {
        path: string;
        content: string;
      };
};

export type ConfigDeviceManagerDto = {
  /**
   * IP of this device, or “auto” if it should be determined automatically
   */
  local_ip: string;
  /**
   * Seconds between sending STATUS_UPDATE websocket messages to the app-server
   */
  state_update_period: number;
  /**
   * Seconds between sending UPDATE_RESOURCES websocket messages to the app-server
   */
  resources_update_period: number;
  /**
   * Folder to share files (e.g. training config YAML) with the worker docker
   */
  worker_shared_folder: string;
  /**
   * Folder to store deployed model files
   */
  models_folder: string;
  /**
   * OAUTH2 token for accessing the docker registry
   */
  registry_access_token?: string;
};

export type ConfigIssuesPublishDto = {
  /**
   * Enable / disable publishing of issues when added to the queue
   */
  enabled: boolean;
  /**
   * The protocol used for publishing
   */
  protocol: IssuePublishProtocol;
  /**
   * URL to publish to (broker, server, etc - depending on the protocol)
   */
  url: string;
  /**
   * Topic to publish to
   */
  topic: string;
  /**
   * Broker / server authentication user name
   */
  username: string;
  /**
   * Broker / server authentication password
   */
  password: string;
  /**
   * Reconnect period in seconds
   */
  reconnect_period: number;
  /**
   * MQTT QoS
   */
  qos: QoS;
  /**
   * Key/value pairs of fields to publish along with any issue - can be nested. Key names should be in snake_case instead of camelCase, and will be converted automatically
   */
  payload?: {
    [key: string]: unknown;
  };
  /**
   * Thumbnails configuration
   */
  thumbnails?: PublishThumbnailsConfigDto;
};

export type ConfigIssuesQueueDto = {
  /**
   * If true, add issues to the queue only in a session (between StartCustomerSession and StopCustomerSession), otherwise - always
   */
  in_session_only: boolean;
  /**
   * Insertion policy for issues in the queue
   */
  insertion_policy: IssueQueueInsertionPolicy;
  /**
   * If true, add "ticketSwitch" alerts in case of a mismatch between the sample's label and the prediction
   */
  add_match_alerts: boolean;
  /**
   * Optional configuration for publishing issues added to the queue
   */
  publish?: ConfigIssuesPublishDto;
};

export type ConfigLoggerDto = {
  /**
   * Log level: -1- trace, 0- debug, 1- info, 2-warn, 3-error, 4-fatal, 5-panic
   */
  log_level: number;
  /**
   * Write logs to console
   */
  console_logging_enabled: boolean;
  /**
   * Write logs to files
   */
  file_logging_enabled: boolean;
  /**
   * path to rolling logs directory    (can be empty if file logging is disabled)
   */
  directory: string;
  /**
   * base name of the rolling logs file     (can be empty if file logging is disabled)
   */
  filename: string;
  /**
   * the max size in MB of the each log file     (can be 0 if file logging is disabled)
   */
  max_file_size: number;
  /**
   * the max number of log files to keep - or 0 to avoid deleting backups
   */
  max_backups: number;
  /**
   * the max age in days to keep a logfile     (can be 0 if file logging is disabled)
   */
  max_age: number;
  /**
   * the minimum log level to send to the backend. -1 value disables sending entirely.
   */
  emitted_log_level?: number;
  /**
   * Timeout in seconds for re-emitting recurring logs
   */
  reemit_timeout_seconds?: number;
};

export type ConfigMotionDetectorDto = {
  /**
   * enable motion detector
   */
  enabled: boolean;
  /**
   * PredictionModelConfig
   */
  default_model: PredictionModelConfig;
  /**
   * ModelConfigDto
   */
  filtering_model: ModelConfigDto;
  /**
   * RegionOfInterest
   */
  region_of_interest: OldRegionOfInterestDto;
  /**
   * filtering_model_threshold
   */
  filtering_model_threshold: number;
  /**
   * filtering_model_threshold_gt
   */
  filtering_model_threshold_gt: number;
  /**
   * frame rate for motion detection (should be lower or equal to the video frame rate)
   */
  target_frame_rate: number;
  /**
   * sensitivity threshold
   */
  sensitivity_threshold_percent: number;
  /**
   * pixel_threshold
   */
  pixel_threshold: number;
  /**
   * static_duration_ms
   */
  static_duration_ms: number;
  /**
   * initial_noise_duration_ms
   */
  initial_noise_duration_ms: number;
  /**
   * after_last_gt_duration_ms
   */
  after_last_gt_duration_ms: number;
  /**
   * how many sample images to store per second
   */
  sample_images_per_second: number;
};

export type ConfigMqttDto = {
  /**
   * Enable MQTT
   */
  enabled: boolean;
  /**
   * MQTT Broker URL
   */
  url: string;
  /**
   * Publish topic
   */
  publish_topic: string;
  /**
   * Dedicated topic for left-in-cart responses, empty disables publishing them
   */
  left_in_cart_publish_topic?: string;
  /**
   * Subscribe topic
   */
  subscribe_topic: string;
  /**
   * MQTT username
   */
  username: string;
  /**
   * MQTT password
   */
  password: string;
  /**
   * Reconnect period
   */
  reconnect_period: number;
  /**
   * MQTT QoS
   */
  qos: QoS;
  /**
   * Key/value pairs of fields to publish along with any issue - can be nested. Key names should be in snake_case instead of camelCase, and will be converted automatically
   */
  payload?: {
    [key: string]: unknown;
  };
  /**
   * Publish retries
   */
  publish_retries: number;
  tls?: ConfigMqttTlsDto;
};

export type ConfigMqttTlsDto = {
  /**
   * CA certificate
   */
  ca_cert?:
    | string
    | {
        path: string;
        content: string;
      };
  /**
   * Client certificate for mTLS
   */
  client_cert?:
    | string
    | {
        path: string;
        content: string;
      };
  /**
   * Client private key for mTLS
   */
  client_key?:
    | string
    | {
        path: string;
        content: string;
      };
  /**
   * Skip server certificate verification (insecure, testing only)
   */
  insecure_skip_verify: boolean;
  /**
   * SNI server name override
   */
  server_name?: string;
  /**
   * Minimum TLS version
   */
  min_version: TlsMinVersionEnum;
};

export type ConfigNonScanDetectorDto = {
  /**
   * enable non-scan detector
   */
  enabled: boolean;
  /**
   * send alert images
   */
  send_images?: boolean;
  /**
   * send alert clip
   */
  send_clip?: boolean;
  /**
   * Region Of Interest A
   */
  region_of_interest_a?: RegionOfInterestDto;
  /**
   * Region Of Interest of scale
   */
  roi_scale?: RegionOfInterestDto;
  /**
   * Region Of Interest B
   */
  region_of_interest_b?: RegionOfInterestDto;
  /**
   * Region Of Interest of checkout
   */
  roi_checkout?: RegionOfInterestDto;
  /**
   * how many sample images to store per second
   */
  sample_images_per_second?: number;
  /**
   * Non-scan frame rate
   */
  frame_rate?: string | number;
  /**
   * Non-scan on screen app frame skip - increase to reduce memory consumption
   */
  return_skip_frames?: number;
  /**
   * should non scan save frames for on-screen app
   */
  save_return_frames?: boolean;
  /**
   * hardware accel for non scan object detector model
   */
  hardware?: ModelHardwareEnum;
  /**
   * How many frames to store per second when there is a non-scan
   */
  store_fps?: number;
  /**
   * onnx execution provider
   */
  onnx_execution_provider?: string;
  /**
   * onnx device type
   */
  onnx_device_type?: string;
  /**
   * onnx precision
   */
  onnx_precision?: string;
  /**
   * onnx runtime path
   */
  onnx_runtime_path?: string;
  /**
   * how many frames to skip
   */
  frames_skip?: number;
  /**
   * polling frequency
   */
  polling_frequency?: number;
  /**
   * output frame width
   */
  output_frame_width?: number;
  /**
   * output frame height
   */
  output_frame_height?: number;
  /**
   * get motions on gt only
   */
  get_motions_on_gt?: boolean;
  /**
   * video source
   */
  video_source?: string;
  /**
   * Non-scan detector server config
   */
  server: NonScanDetectorServiceConfig;
  /**
   * Non-scan detector service config
   */
  service: NonScanDetectorServiceConfig;
  /**
   * Non-scan rules
   */
  rules?: ConfigNonScanRulesDto;
  /**
   * Non-scan tracker
   */
  tracker?: ConfigNonScanTrackerDto;
  /**
   * Non-scan similarity filter
   */
  similarity_filter?: ConfigNonScanSimilarityFilterDto;
  /**
   * Precision level for non scan detector
   */
  precision_level?: NonScanPrecisionLevelEnum;
  /**
   * Number of frames in alert
   */
  num_frames_in_alert?: number;
  /**
   * Width of the alert image
   */
  alert_width?: number;
  /**
   * Height of the alert image
   */
  alert_height?: number;
  /**
   * Inference hardware used by the non scan detector
   */
  inference_hardware?: NonScanInferenceHardwareEnum;
  /**
   * TPU mode for non-scan detector (std or max)
   */
  tpu_mode?: "std" | "max";
  /**
   * Print debug-level logs
   */
  log_debug?: boolean;
  /**
   * Print trace-level logs (finer than log_debug, overrides it). Non-scan detector 0.5.3+
   */
  log_trace?: boolean;
  /**
   * For each session, save a video with object detection bounding boxes for debugging purposes
   */
  visualize?: boolean;
  /**
   * The folder in which to save the visualized videos
   */
  visualize_folder?: string;
  /**
   * Enable left-in-cart detection
   */
  enable_left_in_cart?: boolean;
  /**
   * Timeout in seconds for detect-cart-loss API call
   */
  detect_cart_loss_timeout_seconds?: number;
  /**
   * Timeout in seconds for detect-cart-loss API call
   */
  left_in_cart_timeout_seconds?: number;
  /**
   * Silence alerts before intervention
   */
  silence_before_intervention?: boolean;
  /**
   * Left-in-cart detection mode (silent or active)
   */
  left_in_cart_mode?: "silent" | "active";
  /**
   * Left-in-cart on end session call (if integration is not implemented)
   */
  left_in_cart_on_end_session?: boolean;
  /**
   * Enable head blurring (faces are blurred in recorded videos and data samples)
   */
  enable_head_blurring?: boolean;
  /**
   * The shape used for masking the detected heads
   */
  head_blurring_shape?: HeadBlurringShapeEnum;
  /**
   * Automatically trigger the head-blurring job on session stop
   */
  auto_blur?: boolean;
  /**
   * Timeout in seconds for a head-blurring API call
   */
  head_blur_timeout_seconds?: number;
  /**
   * Attempt to blur heads on sample requests, instead of rejecting a sample that is not blurred yet
   */
  head_blur_on_get_sample?: boolean;
  /**
   * Sleep between frames to reduce CPU usage
   */
  sleep_between_frames?: boolean;
  /**
   * Buffer size for non-scan detector
   */
  buffer_size?: number;
  /**
   * Maximum latency in seconds for non-scan detector processing
   */
  max_latency_sec?: number;
  /**
   * Working directory for non-scan detector
   */
  work_dir?: string;
  /**
   * FPS drop alert configuration
   */
  dropped_frames_alert?: NonScanAlertDroppedFramesConfigDto;
};

/**
 * TPU mode for non-scan detector (std or max)
 */
export enum tpu_mode {
  STD = "std",
  MAX = "max",
}

/**
 * Left-in-cart detection mode (silent or active)
 */
export enum left_in_cart_mode {
  SILENT = "silent",
  ACTIVE = "active",
}

export type ConfigNonScanRulesDto = {
  scale_iou_threshold: number;
  checkout_iou_threshold: number;
  gt_frame_tolerance: number;
};

export type ConfigNonScanSimilarityFilterDto = {
  similarity_threshold: number;
  gt_detection_min_confidence: number;
  gt_detection_min_iou: number;
  /**
   * hardware accel for similarity filter
   */
  hardware?: ModelHardwareEnum;
  enable?: boolean;
};

export type ConfigNonScanTrackerDto = {
  min_updates_use_prediction: number;
  max_predicts_without_update: number;
  iou_threshold: number;
  confidence_threshold: number;
  /**
   * algorithm for non scan tracker
   */
  tracker_type?: NonScanTrackerTypeEnum;
};

export type ConfigOnScreenAppDto = {
  /**
   * The server's port
   */
  port: number;
  /**
   * The server's host name
   */
  host: string;
  /**
   * The server's docker image.
   */
  image: string;
  /**
   * service docker network mode
   */
  network_mode: string;
  /**
   * protocol to use for the service
   */
  protocol: ProtocolEnum;
  /**
   * service docker privileged flag
   */
  privileged: boolean;
  /**
   * service executable folder / path
   */
  path: string;
  /**
   * service docker image override
   */
  env_image_override?: string;
  /**
   * timeout in seconds for service to respond after service startup
   */
  init_timeout: number;
  /**
   * timeout in seconds for service to respond to requests from agent
   */
  timeout: number;
  /**
   * folder to store logs of service running in docker
   */
  logs_folder: string;
  /**
   * pull the service docker image when the agent starts it: false/""/off - never, true/once/first/on - when the image is missing, always - on every boot
   */
  auto_pull?: boolean | "" | "off" | "once" | "always" | "first" | "on";
  /**
   * on-screen-app show powered by edgify trademark or not
   */
  show_powered_by_edgify: boolean;
  /**
   * on-screen-app ignore unhandled alert if user continues to next item
   */
  close_on_scan: boolean;
  /**
   * on-screen-app combine alert-non-scan and alert-non-match alert message display
   */
  merge_event_types: boolean;
  /**
   * on-screen-app show help page
   */
  show_help: boolean;
  /**
   * on-screen-app run with dev tools
   */
  dev_tools: boolean;
  /**
   * on-screen-app max json request size
   */
  max_request_size?: string;
  /**
   * on-screen-app log level
   */
  log_level: OnScreenAppLogLevelEnum;
  /**
   * on-screen-app docker config.json stroage (and any additional future files for on-screen-app)
   */
  shared_path: string;
  /**
   * Show predictions in on-screen app
   */
  show_predictions?: boolean;
  /**
   * Report sample updates to on-screen app
   */
  report_samples?: boolean;
  /**
   * Report predictions to on-screen app
   */
  report_predictions?: boolean;
  /**
   * Agent connection configuration for on-screen-app
   */
  agent?: ExternalServiceAgentConfigDto;
  theme: string;
  enabled: boolean;
};

export type ConfigPredictorDto = {
  /**
   * path to the default model file (.onnx) - the model will be deployed when no model is deployed
   */
  default_model_path: string;
  /**
   * path to the default model config file (.yml)
   */
  default_model_config_path: string;
  /**
   * default model id - or 0 to avoid installing a default model
   */
  default_model_id: number;
  /**
   * path to the filtering model file (.onnx)
   */
  filtering_model_path: string;
  /**
   * path to the filtering model config file (.yml)
   */
  filtering_model_config_path: string;
  /**
   * filtering model id
   */
  filtering_model_id: number;
  /**
   * hardware accel for classifier filtering model
   */
  filtering_model_hardware?: ModelHardwareEnum;
  /**
   * send is_certain for auto-buy
   */
  certainty_enabled: boolean;
  /**
   * Minimal score for is_certain in a case 1 label is returned - or -1 to derive this automatically
   */
  top1_high_certainty_threshold: number;
  /**
   * Minimal score to include a label in the prediction or -1 to derive this automatically
   */
  min_confidence_per_prediction: number;
  /**
   * Minimal sum of scores of all returned labels (otherwise unknown) or -1 to derive this automatically
   */
  min_confidence_sum: number;
  /**
   * Maximum number of predicted classes to show in the results - or 0 to derive this automatically
   */
  number_of_classes_to_show: number;
  /**
   * path to the lookup table that converts from SKU to name
   */
  lookup_table_path?: string;
  /**
   * array of classes that trigger a prediction retry
   */
  retry_items: Array<string>;
  /**
   * milliseconds from the first prediction, during which prediction should be retried until the predicted result is no longer part of the retry_items
   */
  retry_period: number;
  /**
   * should predictor ignore family field when making prediction
   */
  ignore_family: boolean;
  /**
   * assign default family when predictions are done without family
   */
  default_family: string;
  /**
   * Return the match strength on PUT sample requests
   */
  return_match_strength?: boolean;
  match_alert_threshold: number;
  match_alert_threshold_unknown: number;
  /**
   * TPU Inference Service (used for tflite models only)
   */
  tpu_inference_server: TpuInferenceServerConfig;
  /**
   * hardware accel for classifier model
   */
  hardware?: ModelHardwareEnum;
  match_alert_unknowns: boolean;
  match_enable_unknown: boolean;
};

export type ConfigPublishDto = {
  /**
   * If true, add issues to the queue only in a session (between StartCustomerSession and StopCustomerSession), otherwise - always
   */
  in_session_only: boolean;
  /**
   * If true, add "ticketSwitch" alerts in case of a mismatch between the sample's label and the prediction
   */
  add_match_alerts: boolean;
  /**
   * Thumbnails configuration
   */
  thumbnails?: PublishThumbnailsConfigDto;
  /**
   * If true, send webhook alerts for left-in-cart detections
   */
  alert_left_in_cart?: boolean;
  /**
   * If true, send the prediction event on every capture - the predict webhook and the PREDICTION_RESPONSE MQTT message. Alerts are unaffected. Default is false
   */
  send_predictions?: boolean;
  /**
   * If true, send the sample webhook when a sample is stored. Applies to every publisher, while Webhooks.report_samples turns the same event off for the webhooks target alone. Default is true
   */
  send_samples?: boolean;
};

export type ConfigResourceMonitoringDto = {
  /**
   * Enable resource monitoring and threshold based alerts
   */
  enabled: boolean;
  /**
   * Monitoring interval in milliseconds
   */
  monitoring_interval_milliseconds: number;
  device_alerts: ServiceResourceAlertsConfigDto;
  agent_alerts: ServiceResourceAlertsConfigDto;
  non_scan_detector_alerts: ServiceResourceAlertsConfigDto;
};

export type ConfigTrainingDto = {
  /**
   * Enable GPU in worker docker
   */
  worker_gpu_enabled: boolean;
};

export type ConfiguredAlertChannelDto = {
  id: number;
  channelType: "email" | "JIRA" | "slack" | "webhook";
  name: string | null;
  username: string;
  url: string;
  configurationInfo: {
    [key: string]: unknown;
  };
  isGlobal: boolean;
};

export type ConfigVideoRecordingDto = {
  /**
   * enable/disable video recording of sessions
   */
  enabled: boolean;
  /**
   * folder for storing video recordings
   */
  folder: string;
  /**
   * max folder size in MiB, after which videos will not be stored
   */
  max_folder_size: number;
  /**
   * duration since last client action, after which session should stop (fail safe for StopCostumerSession no called)
   */
  max_video_inactivity_seconds: number;
  /**
   * additional duration to record after session ends
   */
  post_session_recording_seconds?: number;
  /**
   * encoding format for video
   */
  encoding?: VideoRecordingEncodingEnum;
  /**
   * switch backend for video encoding
   */
  type?: VideoRecordingTypeEnum;
  /**
   * choose hardware acceleration, defaults to cpu
   */
  hardware?: VideoRecordingHardwareEnum;
  /**
   * choose hardware acceleration for format conversion, defaults to cpu
   */
  convert_hardware?: VideoRecordingHardwareEnum;
  /**
   * the format the cpu turns the frames into for a hardware encoder's converter - "BGRx", "BGRA", "RGBA", "NV12"; empty is BGRx
   */
  convert_format?: string;
  /**
   * framerate for video recording, -1 will use VideoSource.frame_rate
   */
  frame_rate?: string | number;
  /**
   * GStreamer pipeline for video recording, supports templates
   */
  pipeline?: string;
  /**
   * video encoding bitrate in bits/sec
   */
  bitrate?: number;
  /**
   * auto upload video to designated cluster | backend
   */
  auto_upload?: boolean;
  /**
   * cleaning behaviour for video recordings once capacity is reached, "" | "fifo" - delete oldest videos once capacity is reached, "off" - will stop recording / not allow uploads when capacity is reached
   */
  clean_strategy?: VideoRecordingCleanStrategyEnum;
  /**
   * The percentage of sessions to record
   */
  recorded_sessions_percentage?: number;
  /**
   * video recording ext - mp4,mkv,webm - leaving this empty will decide preffered based on encoding
   */
  container?: VideoRecordingContainerEnum;
  /**
   * record video using non scan detecotr (if non scan detector is enabled)
   */
  non_scan_recording?: boolean;
  /**
   * List of labels/patterns for which videos should be kept regardless of recorded_sessions_percentage
   */
  keep_videos_with_labels?: Array<string>;
  /**
   * Keep videos when there is a non-match alert
   */
  keep_videos_with_non_match?: boolean;
};

export type ConfigVideoStreamDto = {
  /**
   * Enable the video device
   */
  enabled: boolean;
  /**
   * Device name used to identify the video device. Will attempt to use device matching this name.
   */
  device_name?: string;
  /**
   * On laptops, 0 is the built-in camera. USB cameras come after in arbitrary order.
   */
  device_id: number;
  /**
   * A URL, file, or GStreamer pipeline used to capture pictures instead of the device defined by device_id. Used for an IP camera in RTSP protocol
   */
  external_camera_source: string;
  /**
   * camera type: "" - usb, or external when external_camera_source is set; zebra - the zebra adapter camera (source composed from the ZebraAdapter config)
   */
  camera_type?: VideoStreamCameraTypeEnum;
  /**
   * send auth headers to client (https only, bearer <TOKEN>)
   */
  auth?: boolean;
  /**
   * capture mode
   */
  capture_mode: VideoStreamCaptureModeEnum;
  /**
   * video stream encoding "" | "raw" | "jpeg" | "h264" | "h265" | "mjpeg" - "" - empty is auto - (raw for webcam, dynamic decoding for rtsp)
   */
  encoding?: VideoStreamEncoding;
  /**
   * video stream format - when using raw encoding and need to pick camera color format
   */
  format?: VideoStreamFormatEnum;
  /**
   * Frame width
   */
  frame_width: number;
  /**
   * Frame height
   */
  frame_height: number;
  /**
   * Video device’s FPS
   */
  frame_rate: string | number;
  /**
   * Should we crop the images according to the top-left, bottom-right coordinates given below
   */
  crop_enable: boolean;
  /**
   * Crop rectangle’s left X coordinate (or 0 if disabled)
   */
  crop_x1: number;
  /**
   * Crop rectangle’s top Y coordinate (or 0 if disabled)
   */
  crop_y1: number;
  /**
   * Crop rectangle’s right X coordinate (or 0 if disabled)
   */
  crop_x2: number;
  /**
   * Crop rectangle’s bottom Y coordinate (or 0 if disabled)
   */
  crop_y2: number;
  /**
   * Delay before capturing the image (for cases the IP camera’s video stream is delayed)
   */
  image_delay_milliseconds: number;
  /**
   * Detect black images on capture, and try to reconnect the camera if one happens
   */
  reconnect_on_black_screen: boolean;
  /**
   * set absolute focus on camera, auto focus should be off, -1 does not apply
   */
  focus_absolute?: number;
  /**
   * enable/disable auto focus, "" does not apply, "on" enable, "off" disable
   */
  auto_focus?: OnOffEnum;
  /**
   * enable/disable auto exposure, "" does not apply, "on" enable, "off" disable
   */
  auto_exposure?: OnOffEnum;
  /**
   * enable/disable auto white balance, "" does not apply, "on" enable, "off" disable
   */
  auto_white_balance?: OnOffEnum;
  /**
   * Controls the camera exposure level. Keep empty to use the default value. Not supported by all cameras.
   */
  exposure?: number;
  /**
   * Adjusts the overall image brightness. Keep empty to use the default value. Not supported by all cameras.
   */
  brightness?: number;
  /**
   * Controls the image contrast between light and dark areas. Keep empty to use the default value. Not supported by all cameras.
   */
  contrast?: number;
  /**
   * Affects the intensity of colors in the image. Keep empty to use the default value. Not supported by all cameras.
   */
  saturation?: number;
  /**
   * Controls the image sharpness or crispness. Keep empty to use the default value. Not supported by all cameras.
   */
  sharpness?: number;
  /**
   * Adjusts the overall image color hue. Keep empty to use the default value. Not supported by all cameras.
   */
  hue?: number;
  /**
   * Corrects the image brightness based on lighting conditions. Keep empty to use the default value. Not supported by all cameras.
   */
  gamma?: number;
  /**
   * Amplifies the camera signal for low-light conditions. Keep empty to use the default value. Not supported by all cameras.
   */
  gain?: number;
  /**
   * Compensates for uneven backlight in the scene. Keep empty to use the default value. Not supported by all cameras.
   */
  backlight_compensation?: number;
  /**
   * Sets the camera ISO speed, which affects image sensitivity. Keep empty to use the default value. Not supported by all cameras.
   */
  iso_speed?: number;
  /**
   * Sets the white balance based on a specific color temperature value. Keep empty to use the default value. Not supported by all cameras.
   */
  white_balance_temperature?: number;
  /**
   * Controls the camera zoom level. Keep empty to use the default value. Not supported by all cameras.
   */
  zoom?: number;
  /**
   * Controls the camera iris level, affecting aperture size. Keep empty to use the default value. Not supported by all cameras.
   */
  iris?: number;
  /**
   * Controls the horizontal camera orientation. Keep empty to use the default value. Not supported by all cameras.
   */
  pan?: number;
  /**
   * Controls the vertical camera orientation. Keep empty to use the default value. Not supported by all cameras.
   */
  tilt?: number;
  /**
   * Controls the camera roll rotation. Keep empty to use the default value. Not supported by all cameras.
   */
  roll?: number;
  /**
   * enable mjpeg when capturing video from camera (should allow higher frame rates, based on camera)
   */
  enable_mjpeg?: boolean;
  /**
   * switch backend for video capture
   */
  type?: VideoStreamTypeEnum;
  /**
   * GStreamer pipeline for video capture, supports templates
   */
  pipeline?: string;
  /**
   * choose hardware acceleration, defaults to cpu
   */
  hardware?: VideoStreamHardwareEnum;
  /**
   * choose hardware acceleration for format conversion, defaults to cpu
   */
  convert_hardware?: VideoStreamHardwareEnum;
  /**
   * gstreamer raw format a hardware conversion writes on the way to BGR - "BGRx", "BGRA", "RGBA", "NV12"; empty is BGRx
   */
  convert_format?: string;
  /**
   * Key/value of controls to set on camera, currently only works on linux, possible key/values depend on camera
   */
  camera_controls?: {
    [key: string]: unknown;
  };
  /**
   * Minimal framerate threshold - 0 will be auto, -1 disabled
   */
  min_frame_rate_threshold?: number;
  /**
   * Adapt frame rate early before streaming/recording, 0 to disable
   */
  adapt_frame_rate?: number;
  /**
   * Adapt frame width early before streaming/recording, 0 to disable
   */
  adapt_width?: number;
  /**
   * Adapt frame height early before streaming/recording, 0 to disable
   */
  adapt_height?: number;
  /**
   * Timeout in seconds for capture operations, 0 to disable
   */
  capture_timeout?: number;
  /**
   * RTSP protocol(s) to use for RTSP streams (for allowed values see gstreamer's rtspsrc protocols property)
   */
  rtsp_protocols?: string;
  /**
   * Streaming video to an external process
   */
  streaming?: StreamingConfig;
  /**
   * ROI used for predictor, affects capture / capture-and-predict calls
   */
  roi_predictor?: ROIPredictorDto;
  /**
   * choose source plugin, used for different camera interfaces
   */
  source_plugin?: VideoStreamSourcePluginEnum;
  /**
   * Enable video rotation
   */
  rotation_enabled?: boolean;
  /**
   * Video rotation offset in degrees (0, 90, 180, 270)
   */
  rotation_offset?: 0 | 90 | 180 | 270;
  /**
   * Number of frames to grab from camera buffer
   */
  frames_to_grab?: number;
  /**
   * Use read instead of grab for camera capture
   */
  use_read_instead_of_grab?: boolean;
  /**
   * Number of samples to save
   */
  number_of_samples_to_save?: number;
};

/**
 * Video rotation offset in degrees (0, 90, 180, 270)
 */
export enum rotation_offset {
  "_0" = 0,
  "_90" = 90,
  "_180" = 180,
  "_270" = 270,
}

export type ConfigWebhooksDto = {
  /**
   * enable webhooks
   */
  enabled: boolean;
  /**
   * webhooks base url
   */
  url: string;
  /**
   * Enable authentication for webhooks
   */
  auth?: boolean;
  /**
   * Timeout in seconds for webhook requests
   */
  timeout?: number;
  /**
   * Report sample updates via webhooks
   */
  report_samples?: boolean;
  /**
   * Report predictions via webhooks
   */
  report_predictions?: boolean;
};

export type ConfigZebraAdapterDto = {
  /**
   * The server's port
   */
  port: number;
  /**
   * The server's host name
   */
  host: string;
  /**
   * The server's docker image.
   */
  image: string;
  /**
   * service docker network mode
   */
  network_mode: string;
  /**
   * protocol to use for the service
   */
  protocol: ProtocolEnum;
  /**
   * service docker privileged flag
   */
  privileged: boolean;
  /**
   * service executable folder / path
   */
  path: string;
  /**
   * service docker image override
   */
  env_image_override?: string;
  /**
   * timeout in seconds for service to respond after service startup
   */
  init_timeout: number;
  /**
   * timeout in seconds for service to respond to requests from agent
   */
  timeout: number;
  /**
   * folder to store logs of service running in docker
   */
  logs_folder: string;
  /**
   * pull the service docker image when the agent starts it: false/""/off - never, true/once/first/on - when the image is missing, always - on every boot
   */
  auto_pull?: boolean | "" | "off" | "once" | "always" | "first" | "on";
  /**
   * shared path for zebra adapter
   */
  shared_path: string;
  /**
   * zebra adapter log level
   */
  log_level: ZebraAdapterLogLevelEnum;
  /**
   * turn on light on capture
   */
  light_on_capture: boolean;
  /**
   * rootless docker: use the device mirrors from mirror_folder instead of the host devices
   */
  rootless?: boolean;
  /**
   * folder of device mirrors (videoX, bus_usb_Y_Z), "" -> /data/docker/dev, "-"/"none" -> disabled
   */
  mirror_folder?: string;
  /**
   * barcode agent configuration
   */
  barcode_agent: ZebraAdapterAgentConfigDto;
  /**
   * produce agent configuration
   */
  produce_agent: ZebraAdapterAgentConfigDto;
  enabled: boolean;
};

export type ConfusionMatrixMetricDto = {
  data: {
    [key: string]: {
      [key: string]: number;
    };
  };
  createdAt: Date;
  uuid?: string | null;
};

export type ContactUsDto = {
  userName: string;
  userEmail?: string;
  account: string;
  subject: string;
  additionalInput: string;
};

export type CreateAccountDto = {
  logoImage?: Blob | File;
  defaultClusterArchitecture?:
    | ("distributed" | "hybrid" | "centralized")
    | null;
  timezone?: string;
  name: string;
  companyName?: string;
};

export type CreateAlertChannelDto = {
  channelType: "email" | "JIRA" | "slack" | "webhook";
  name?: string;
  editsViaPatch?: boolean;
  authenticationInfo: AuthenticationFieldsDto;
  configurationInfo?: {
    [key: string]: unknown;
  };
};

export type CreateCatalogItemDto = {
  priceBy?: "weight" | "quantity";
  price?: Decimal2;
  name?: string;
  englishName?: string;
  family?: string;
  outOfScope?: boolean;
  /**
   * Tags to add. A new item starts with exactly these; an item brought back keeps the tags it had and gains these.
   * No tag is removed.
   */
  tags?: Array<Tag>;
};

export type CreateCheckpointDto = {
  checkpoint: string;
  index: string;
};

export type CreateClusterDto = {
  architecture: "distributed" | "hybrid" | "centralized";
  name: string;
  serverDeviceId?: number;
  deviceIds: Array<number>;
};

export type CreateDashboardAlertDto = {
  errorMessages: string;
  stackTrace: string;
  fullStoryUrl?: string;
};

export type CreateDatasetDto = {
  name: string;
  deviceIds: Array<number>;
};

export type CreateDatasetFromTempDto = {
  /**
   * Temporary analysis session ID
   */
  tempId: string;
  /**
   * Dataset name
   */
  name: string;
  /**
   * Dataset description
   */
  description?: string;
};

export type CreatedCatalogItemDto = {
  priceBy?: "weight" | "quantity";
  price?: string | number;
  siteGroupLabels?: Array<SiteGroupLabel>;
  id?: number;
  plu?: string;
  name?: string;
  englishName?: string;
  family?: string;
  outOfScope?: boolean;
  tags: Array<Tag>;
  createdAt?: Date;
  updatedAt?: Date;
  updatedBy?: string;
  repImgUrl?: string;
  /**
   * Whether the label belonged to a removed item, which this brought back instead of creating a new one.
   */
  restored: boolean;
  /**
   * What the removed item had before it was brought back: the values the fields left out kept, and the tags it already
   * had. Only on a restore.
   */
  previous?: CatalogItemDetailsDto;
};

export type CreateDeviceDto = {
  name: string;
  description?: string;
};

export type CreateDomainAuthSettingDto = {
  domain: string;
  strategy: "magicLink" | "oidc";
  defaultAccountId: number;
  company: string;
  params?: OidcParamsDto;
};

export enum strategy {
  MAGIC_LINK = "magicLink",
  OIDC = "oidc",
}

export type CreateEmptyDatasetDto = {
  name: string;
  description?: string;
};

export type CreateFeedbackDto = {
  attachments?: Array<Blob | File>;
  category: string;
  description: string;
  importance: string;
  attachmentUrls?: Array<string>;
};

export type CreateLookupTableDto = {
  file?: Blob | File;
  name: string;
  siteIds?: Array<number>;
};

export type CreateMetricAlertDto = {
  priority?: AlertPriority;
  severity?: AlertSeverity;
  name: string;
  reportId: number;
  questionId: number;
  dashcardId: number;
  questionName: string;
  filterScope: string;
  operator: "BelowThreshold" | "AboveThreshold";
  thresholdValue: number;
  schedule: string;
  timezone?: string;
  channelIds: Array<number>;
};

export enum operator {
  BELOW_THRESHOLD = "BelowThreshold",
  ABOVE_THRESHOLD = "AboveThreshold",
}

export type CreateNotificationDto = {
  /**
   * Short title shown in the banner header
   */
  title: string;
  /**
   * Full body text of the notification banner
   */
  message: string;
  /**
   * Category of the notification (affects banner color and icon)
   */
  type:
    | "ScheduledMaintenance"
    | "IncidentOutage"
    | "IssueResolved"
    | "GeneralInformation";
  /**
   * When the event starts (e.g. start of maintenance window). Providing this sets status to Scheduled.
   */
  startsAt?: Date;
  /**
   * When the event ends. The banner is automatically archived after this time.
   */
  endsAt?: Date;
  /**
   * How many hours before startsAt to make the notification active (start showing it). 0 means activate exactly at startsAt.
   */
  notifyBeforeHours?: number;
  /**
   * Account IDs that should see this banner. Omit or pass an empty array to show to all accounts.
   */
  targetAccountIds?: Array<number>;
  /**
   * Save as Draft instead of publishing. When false (default): no startsAt → Active immediately, startsAt set → Scheduled.
   */
  saveAsDraft?: boolean;
};

/**
 * Category of the notification (affects banner color and icon)
 */
export enum type {
  SCHEDULED_MAINTENANCE = "ScheduledMaintenance",
  INCIDENT_OUTAGE = "IncidentOutage",
  ISSUE_RESOLVED = "IssueResolved",
  GENERAL_INFORMATION = "GeneralInformation",
}

export type CreateOperationalHoursDto = {
  schedule: Array<CreateOperationalHoursEntryDto>;
  enabled: boolean;
  timezone: string;
};

export type CreateOperationalHoursEntryDto = {
  dayOfWeek:
    | "Monday"
    | "Tuesday"
    | "Wednesday"
    | "Thursday"
    | "Friday"
    | "Saturday"
    | "Sunday";
  startTime: string;
  endTime: string;
  enabled: boolean;
};

export enum dayOfWeek {
  MONDAY = "Monday",
  TUESDAY = "Tuesday",
  WEDNESDAY = "Wednesday",
  THURSDAY = "Thursday",
  FRIDAY = "Friday",
  SATURDAY = "Saturday",
  SUNDAY = "Sunday",
}

export type CreateRegionDto = {
  /**
   * Attach to this existing region. Mutually exclusive with regionName.
   */
  regionId?: number;
  /**
   * Create (or reactivate) a region with this name. Mutually exclusive with regionId.
   */
  regionName?: string;
  /**
   * Optionally create a sub-region under the region above.
   */
  subRegionName?: string;
};

export type CreateRegionResponseDto = {
  region: MinimalEntityDto;
  subRegion?: MinimalEntityDto | null;
};

export type CreateReportDto = {
  name: string;
  description?: string;
  url: string;
};

export type CreateSampleTagDto = {
  name: string;
};

export type CreateScheduledTrainingDto = {
  /**
   * Omit to use the account default, then false.
   */
  autoDeploy?: boolean;
  /**
   * Worker container image URL. Omit to use the account's default training-job settings, else the newest edgify-worker version this account has deployed -- resolved when the training is created rather than snapshotted here, so a schedule follows the fleet instead of freezing a version.
   */
  clientImageUrl?: string;
  /**
   * Collaborator container image URL. Same defaulting as `clientImageUrl`.
   */
  serverImageUrl?: string;
  /**
   * Training configuration YAML. Omit to use the account's default configuration, or send an empty string to run with the worker's built-in classifier defaults.
   */
  config?: string;
  /**
   * Weekdays the training runs on, evaluated in the account timezone. Null (or omitted) means no weekday restriction: the recurrence simply repeats every `recurring` days. A list must name between 1 and 7 days -- an empty list is rejected rather than silently read as unrestricted, since `null` is the one spelling of that.
   */
  recurringDays?: Array<
    | "Monday"
    | "Tuesday"
    | "Wednesday"
    | "Thursday"
    | "Friday"
    | "Saturday"
    | "Sunday"
  > | null;
  recurring: number;
  scheduledFor?: Date;
  name: string;
  description?: string;
  clusterIds: Array<number>;
  serverDeviceId?: number;
  inputModelId?: number;
  isTrainingWindow?: boolean;
  windowEnd?: Date;
  windowStart?: Date;
};

export type CreateSiteDto = {
  name: string;
  deviceIds: Array<number>;
};

export type CreateSiteGroupDto = {
  name: string;
  siteIds?: Array<number>;
};

export type CreateSlackAlertChannelDto = {
  channelId: string;
  alertChannelId?: number;
  name?: string;
  editsViaPatch?: boolean;
};

export type CreateTagsDto = {
  tags: Array<string>;
};

export type CreateTrainingDto = {
  /**
   * Omit to use the account default, then false.
   */
  autoDeploy?: boolean;
  /**
   * Worker container image URL. Omit to use the account's default training-job settings, else the newest edgify-worker version this account has deployed -- resolved when the training is created rather than snapshotted here, so a schedule follows the fleet instead of freezing a version.
   */
  clientImageUrl?: string;
  /**
   * Collaborator container image URL. Same defaulting as `clientImageUrl`.
   */
  serverImageUrl?: string;
  /**
   * Training configuration YAML. Omit to use the account's default configuration, or send an empty string to run with the worker's built-in classifier defaults.
   */
  config?: string;
  name: string;
  description?: string;
  clusterIds: Array<number>;
  serverDeviceId?: number;
  inputModelId?: number;
  isTrainingWindow?: boolean;
  windowEnd?: Date;
  windowStart?: Date;
};

export type CreateUserClientDto = {
  email: string;
  firstName: string;
  lastName: string;
  company: string;
  profileImg?: Blob | File;
  role:
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
    | "SuperAdmin";
  profileImgUrl?: string;
};

export type CreateUserResponseDto = {
  id: number;
  failedRecipients: Array<string>;
};

export type DangerousConfigDto = {
  /**
   * The dangerous config fields - use with caution
   */
  fields: DeviceConfigDangerousFields;
};

export type DashboardMetadataResponseDto = {
  questions: Array<MetabaseQuestion>;
  filters: Array<MetabaseFilter>;
};

export type DataReportMetricDto = {
  data: {
    val?: {
      [key: string]: {
        "0"?: number;
      };
    };
    train?: {
      [key: string]: {
        "0"?: number;
      };
    };
  };
  createdAt: Date;
  uuid?: string | null;
};

export type DatasetDetailsDto = {
  devices: Array<DatasetDeviceDto>;
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
};

export type DatasetDeviceDto = {
  labelsDistribution: LabelsDistributionDto;
  name: string;
  id: number;
};

export type DatasetJobHistoryEntryDto = {
  jobId: number;
  state:
    | "pending"
    | "running"
    | "cancelling"
    | "done"
    | "failed"
    | "cancelled"
    | "suspended"
    | "aborted";
  done?: number;
  total?: number;
  failures?: number;
  transferred?: number;
  missing?: number;
  resumable?: boolean;
  startTime?: Date;
  endTime?: Date;
  kind:
    | "import"
    | "importSessions"
    | "importSamples"
    | "addSamples"
    | "addSessions"
    | "retryMissingSamples"
    | "retryMissingSessions"
    | "recalculateAnalytics";
};

export enum kind {
  IMPORT = "import",
  IMPORT_SESSIONS = "importSessions",
  IMPORT_SAMPLES = "importSamples",
  ADD_SAMPLES = "addSamples",
  ADD_SESSIONS = "addSessions",
  RETRY_MISSING_SAMPLES = "retryMissingSamples",
  RETRY_MISSING_SESSIONS = "retryMissingSessions",
  RECALCULATE_ANALYTICS = "recalculateAnalytics",
}

export type DatasetJobStatusDto = {
  jobId: number;
  state:
    | "pending"
    | "running"
    | "cancelling"
    | "done"
    | "failed"
    | "cancelled"
    | "suspended"
    | "aborted";
  done?: number;
  total?: number;
  failures?: number;
  transferred?: number;
  missing?: number;
  resumable?: boolean;
  startTime?: Date;
  endTime?: Date;
};

export type DatasetMinimalDto = {
  id: number;
  uuid: string;
  name: string;
};

export type DataStreamDto = {
  labels_distribution: {
    opened: {
      [key: string]: number;
    };
    closed: {
      [key: string]: number;
    };
  };
  used_space: number;
  number_of_samples: number;
};

export type Decimal2 = {
  [key: string]: unknown;
};

export type DeleteJobsBulkDto = {
  query: BulkJobsQueryDto;
};

export type DeleteSamplesDataWithNameDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  name?: string;
  description?: string;
  query?: GetSamplesQueryRequestDto;
};

export type DeleteSamplesDeviceResultDto = {
  state?: DeleteSamplesDeviceStateEnum;
  startTime?: Date;
  updateTime?: Date;
  remaining?: number;
  failures?: number;
  done?: number;
  total?: number;
  failure?: ErrorDto;
  skipped?: number;
  skippedItems?: Array<SkippedForDatasetsDto>;
};

export enum DeleteSamplesDeviceStateEnum {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type DeleteSamplesJobDataDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  query?: GetSamplesQueryRequestDto;
};

export type DeleteSamplesJobDetailsDto = {
  total?: number;
  done?: number;
  remaining?: number;
};

export type DeleteSamplesJobDeviceDto = {
  participation: DeleteSamplesJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type DeleteSamplesJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: DeleteSamplesJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: DeleteSamplesDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum DeleteSamplesJobDeviceStateDto {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type DeleteSamplesJobDto = {
  id: number;
  name?: string;
  result: DeleteSamplesJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: DeleteSamplesJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<DeleteSamplesJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type DeleteSamplesJobSummaryDto = {
  id: number;
  name?: string;
  result: DeleteSamplesJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: DeleteSamplesJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type DeleteSamplesScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: DeleteSamplesJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type DeleteSamplesScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: DeleteSamplesJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type DeleteSamplesScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: DeleteSamplesJobDataDto;
};

export type DeleteSamplesUpdateJobDto = {
  name?: string;
  description?: string;
};

export type DeleteSamplesUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: DeleteSamplesJobDataDto;
};

export type DeleteScheduledJobsBulkDto = {
  query: BulkScheduledJobsQueryDto;
};

export type DeleteSiteDeviceDto = {
  deviceId: number;
};

export type DeleteUsersBulkDto = {
  query: BulkUsersQueryDto;
};

export type DeleteVideosDataWithNameDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  name?: string;
  description?: string;
  query?: GetSessionsRequestDto;
};

export type DeleteVideosDeviceResultDto = {
  state?: DeleteVideosDeviceStateEnum;
  startTime?: Date;
  updateTime?: Date;
  remaining?: number;
  failures?: number;
  done?: number;
  total?: number;
  failure?: ErrorDto;
  skipped?: number;
  skippedItems?: Array<SkippedForDatasetsDto>;
};

export enum DeleteVideosDeviceStateEnum {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type DeleteVideosJobDataDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  query?: GetSessionsRequestDto;
};

export type DeleteVideosJobDetailsDto = {
  total?: number;
  done?: number;
  remaining?: number;
};

export type DeleteVideosJobDeviceDto = {
  participation: DeleteVideosJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type DeleteVideosJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: DeleteVideosJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: DeleteVideosDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum DeleteVideosJobDeviceStateDto {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type DeleteVideosJobDto = {
  id: number;
  name?: string;
  result: DeleteVideosJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: DeleteVideosJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<DeleteVideosJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type DeleteVideosJobSummaryDto = {
  id: number;
  name?: string;
  result: DeleteVideosJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: DeleteVideosJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type DeleteVideosScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: DeleteVideosJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type DeleteVideosScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: DeleteVideosJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type DeleteVideosScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: DeleteVideosJobDataDto;
};

export type DeleteVideosUpdateJobDto = {
  name?: string;
  description?: string;
};

export type DeleteVideosUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: DeleteVideosJobDataDto;
};

export type DeployAgentVersionRequestDto = {
  version: string;
};

export type DeployComponentsDataWithNameDto = {
  devicesQuery?: BulkDevicesQueryDto;
  sitesQuery?: BulkSitesQueryDto;
  clustersQuery?: BulkClustersQueryDto;
  component: string;
  version: string;
  type?: string;
  name?: string;
  description?: string;
};

export type DeployComponentsDeviceResultDto = {
  state?: DeployComponentsDeviceStateEnum;
  startTime?: Date;
  updateTime?: Date;
  name?: string;
  failed?: boolean;
  done?: boolean;
  failure?: ErrorDto;
};

export enum DeployComponentsDeviceStateEnum {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type DeployComponentsJobDataDto = {
  devicesQuery?: BulkDevicesQueryDto;
  sitesQuery?: BulkSitesQueryDto;
  clustersQuery?: BulkClustersQueryDto;
  component: string;
  version: string;
  type?: string;
};

export type DeployComponentsJobDetailsDto = {
  devices: {
    [key: string]: DeployComponentsDeviceResultDto;
  };
  total?: number;
  done?: number;
  failures?: number;
};

export type DeployComponentsJobDeviceDto = {
  participation: DeployComponentsJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type DeployComponentsJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: DeployComponentsJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: DeployComponentsDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum DeployComponentsJobDeviceStateDto {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type DeployComponentsJobDto = {
  id: number;
  name?: string;
  result: DeployComponentsJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: DeployComponentsJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<DeployComponentsJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type DeployComponentsJobSummaryDto = {
  id: number;
  name?: string;
  result: DeployComponentsJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: DeployComponentsJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type DeployComponentsScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: DeployComponentsJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type DeployComponentsScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: DeployComponentsJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type DeployComponentsScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: DeployComponentsJobDataDto;
};

export type DeployComponentsUpdateJobDto = {
  name?: string;
  description?: string;
};

export type DeployComponentsUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: DeployComponentsJobDataDto;
};

export type DeployModelDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  role?: string;
  includeCollaboratorDevices?: boolean;
};

export type DeployModelResponseDto = {
  successes: number;
  failures: number;
};

export type DeployServiceVersionDto = {
  serviceName:
    | "edgify-non-scan-detector"
    | "edgify-worker"
    | "edgify-on-screen-app"
    | "edgify-zebra-adapter"
    | "edgify-agent"
    | "edgify-model";
  schedule?: ScheduleJobScheduleDto;
  version: string;
  type?: string;
};

export enum serviceName {
  EDGIFY_NON_SCAN_DETECTOR = "edgify-non-scan-detector",
  EDGIFY_WORKER = "edgify-worker",
  EDGIFY_ON_SCREEN_APP = "edgify-on-screen-app",
  EDGIFY_ZEBRA_ADAPTER = "edgify-zebra-adapter",
  EDGIFY_AGENT = "edgify-agent",
  EDGIFY_MODEL = "edgify-model",
}

export type DetailedReportDto = {
  id: number;
  name: string;
  description?: string;
  url: string;
  createdAt: Date;
  user: ReportUserDto;
  isEnvReport: boolean;
  isEnabled: boolean;
  showCustomReportSubscription: boolean;
  filters?: {
    [key: string]: unknown;
  };
  signedUrl: string;
  subscriptions: Array<ReportSubscriptionDto>;
};

export type DeviceAlertsStatusDto = {
  totalDevices: number;
  alerts: Array<DeviceAlertStatusItemDto>;
};

export type DeviceAlertsStatusRequestDto = {
  query: BulkDevicesQueryDto;
};

export type DeviceAlertStateDto = {
  alertType:
    | "DeviceDown"
    | "ServerDown"
    | "CameraDown"
    | "HighResourceUsage"
    | "LookupTableDisabled"
    | "DeployedModelFailure"
    | "RegisterDisabledDeviceAttempt"
    | "RegisterDuplicateDeviceAttempt"
    | "TrainingFailed"
    | "NonScanDetectorDown"
    | "OnScreenAppDown"
    | "ZebraAdapterDown"
    | "AgentPortClash"
    | "LockedSamplesAboveThreshold"
    | "FailedToStoreSampleLackOfStorage"
    | "BlackScreenImageDetected"
    | "LocalStorageAlmostFull"
    | "AgentDoesNotReachEdgibox"
    | "VideoUploadError"
    | "ImageUploadError"
    | "PredictorDisabled"
    | "NonScanDetectorRepeatedFpsDrops"
    | "ModelBelowKpiThreshold"
    | "TrainingWarnings"
    | "LookupTableMismatch"
    | "MetricThresholdBreach"
    | "ServiceDown"
    | "DataCompletenessBelowThreshold"
    | "DeviceDownEscalated"
    | "ServerDownEscalated"
    | "CameraDownEscalated"
    | "HighResourceUsageEscalated"
    | "LookupTableDisabledEscalated"
    | "DeployedModelFailureEscalated"
    | "NonScanDetectorDownEscalated"
    | "OnScreenAppDownEscalated"
    | "ZebraAdapterDownEscalated"
    | "AgentPortClashEscalated"
    | "LockedSamplesAboveThresholdEscalated"
    | "FailedToStoreSampleLackOfStorageEscalated"
    | "BlackScreenImageDetectedEscalated"
    | "LocalStorageAlmostFullEscalated"
    | "AgentDoesNotReachEdgiboxEscalated"
    | "VideoUploadErrorEscalated"
    | "ImageUploadErrorEscalated"
    | "PredictorDisabledEscalated"
    | "NonScanDetectorRepeatedFpsDropsEscalated";
  enabled: boolean;
};

export type DeviceAlertStatusItemDto = {
  alertType:
    | "DeviceDown"
    | "ServerDown"
    | "CameraDown"
    | "HighResourceUsage"
    | "LookupTableDisabled"
    | "DeployedModelFailure"
    | "RegisterDisabledDeviceAttempt"
    | "RegisterDuplicateDeviceAttempt"
    | "TrainingFailed"
    | "NonScanDetectorDown"
    | "OnScreenAppDown"
    | "ZebraAdapterDown"
    | "AgentPortClash"
    | "LockedSamplesAboveThreshold"
    | "FailedToStoreSampleLackOfStorage"
    | "BlackScreenImageDetected"
    | "LocalStorageAlmostFull"
    | "AgentDoesNotReachEdgibox"
    | "VideoUploadError"
    | "ImageUploadError"
    | "PredictorDisabled"
    | "NonScanDetectorRepeatedFpsDrops"
    | "ModelBelowKpiThreshold"
    | "TrainingWarnings"
    | "LookupTableMismatch"
    | "MetricThresholdBreach"
    | "ServiceDown"
    | "DataCompletenessBelowThreshold"
    | "DeviceDownEscalated"
    | "ServerDownEscalated"
    | "CameraDownEscalated"
    | "HighResourceUsageEscalated"
    | "LookupTableDisabledEscalated"
    | "DeployedModelFailureEscalated"
    | "NonScanDetectorDownEscalated"
    | "OnScreenAppDownEscalated"
    | "ZebraAdapterDownEscalated"
    | "AgentPortClashEscalated"
    | "LockedSamplesAboveThresholdEscalated"
    | "FailedToStoreSampleLackOfStorageEscalated"
    | "BlackScreenImageDetectedEscalated"
    | "LocalStorageAlmostFullEscalated"
    | "AgentDoesNotReachEdgiboxEscalated"
    | "VideoUploadErrorEscalated"
    | "ImageUploadErrorEscalated"
    | "PredictorDisabledEscalated"
    | "NonScanDetectorRepeatedFpsDropsEscalated";
  disabledCount: number;
  enabledCount: number;
};

/**
 * The dangerous config fields - use with caution
 */
export enum DeviceConfigDangerousFields {
  NON_SCAN_DETECTOR_ROI_CHECKOUT = "NonScanDetector.roi_checkout",
  NON_SCAN_DETECTOR_ROI_SCALE = "NonScanDetector.roi_scale",
  VIDEO_STREAM_ROI_PREDICTOR = "VideoStream.roi_predictor",
  VIDEO_STREAM_CROP_ENABLE = "VideoStream.crop_enable",
  VIDEO_STREAM_CROP_X1 = "VideoStream.crop_x1",
  VIDEO_STREAM_CROP_X2 = "VideoStream.crop_x2",
  VIDEO_STREAM_CROP_Y1 = "VideoStream.crop_y1",
  VIDEO_STREAM_CROP_Y2 = "VideoStream.crop_y2",
}

export type DeviceConfigDeploymentDto = {
  id: number;
  name?: string;
  description?: string;
  deviceConfig: PartialDeviceConfigDto;
  isPartial: boolean;
  state:
    | "applied"
    | "partiallyApplied"
    | "noChanges"
    | "pending"
    | "cancelled"
    | "failed"
    | "validating"
    | "scheduled"
    | "fromAgent";
  createdAt: Date;
  updatedAt: Date;
  notAppliedChanges?: PartialDeviceConfigDto;
  originalDeviceConfig?: PartialDeviceConfigDto;
  originalDeviceId?: number;
  deployedBy: string;
};

export enum state5 {
  APPLIED = "applied",
  PARTIALLY_APPLIED = "partiallyApplied",
  NO_CHANGES = "noChanges",
  PENDING = "pending",
  CANCELLED = "cancelled",
  FAILED = "failed",
  VALIDATING = "validating",
  SCHEDULED = "scheduled",
  FROM_AGENT = "fromAgent",
}

export type DeviceConfigDto = {
  Agent: ConfigAgentDto;
  Api: ConfigApiDto;
  Analytics: ConfigAnalyticsDto;
  VideoStream: ConfigVideoStreamDto;
  Database: ConfigDatabaseDto;
  DataManager: ConfigDataManagerDto;
  Predictor: ConfigPredictorDto;
  NonScanDetector: ConfigNonScanDetectorDto;
  OnScreenApp: ConfigOnScreenAppDto;
  ZebraAdapter: ConfigZebraAdapterDto;
  MotionDetector: ConfigMotionDetectorDto;
  DeviceManager: ConfigDeviceManagerDto;
  ResourceMonitoring?: ConfigResourceMonitoringDto;
  Logger: ConfigLoggerDto;
  Training: ConfigTrainingDto;
  VideoRecording: ConfigVideoRecordingDto;
  IssuesQueue: ConfigIssuesQueueDto;
  Publish: ConfigPublishDto;
  Webhooks: ConfigWebhooksDto;
  Mqtt: ConfigMqttDto;
};

export type DeviceDetailsCharacteristicDto = {
  cpu: string;
  gpu: string;
  ram: string;
  disk: string;
  os?: string;
  platform?: string;
  platformFamily?: string;
  platformVersion?: string;
  kernelArch?: string;
  kernelVersion?: string;
};

export type DeviceDetailsClusterDto = {
  id: number;
  name: string;
  architecture: string;
  serverDeviceId: number;
};

export type DeviceDetailsDataStreamDto = {
  capacity: number;
  usedSpace: number;
  labelsDistribution?: LabelsDistributionDto;
};

export type DeviceDetailsDeployedModelDto = {
  id: number;
  name: string;
  updatedAt: Date;
  role: string;
  type: string;
};

export type DeviceDetailsDto = {
  state: "deploying" | "ready" | "disconnected" | "disabled" | "down";
  cameraState: "Unknown" | "Disabled" | "Disconnected" | "Down" | "OK";
  clientAppMode?: ("active" | "silent") | null;
  id: number;
  name: string;
  description: string | null;
  createdAt: Date;
  updatedAt: Date;
  ip: string | null;
  localIp: string | null;
  clusterId: number | null;
  lastPing: Date | null;
  port: string | null;
  agentVersion: string | null;
  webGrpcPort: string | null;
  webServerPort: string | null;
  httpPort: string | null;
  httpsPort: string | null;
  calibrated: boolean | null;
  calibrationSampleId: string | null;
  cluster: DeviceDetailsClusterDto | null;
  site: DeviceDetailsSiteDto | null;
  characteristics: DeviceDetailsCharacteristicDto;
  dataStream: DeviceDetailsDataStreamDto;
  deployedModel: DeviceDetailsDeployedModelDto | null;
  modelDeployments: Array<DeviceDetailsDeployedModelDto> | null;
  serviceDeployments: {
    [key: string]: Array<unknown>;
  };
  lastPredictionTime: Date;
  activationTime: Date;
  firstConnectedAt: Date;
  connectedSince: Date;
  agentDeploymentTime: Date;
  configLocked: boolean;
  lastCameraPing: Date;
  sampleBufferStatus: {
    [key: string]: unknown;
  };
  videoBufferStatus: {
    [key: string]: unknown;
  };
  servicesStatus: {
    [key: string]: unknown;
  };
  tags: Array<Tag>;
  alertsEnabled: boolean;
};

export enum cameraState {
  UNKNOWN = "Unknown",
  DISABLED = "Disabled",
  DISCONNECTED = "Disconnected",
  DOWN = "Down",
  OK = "OK",
}

export enum clientAppMode {
  ACTIVE = "active",
  SILENT = "silent",
}

export type DeviceDetailsSiteDto = {
  id: number;
  name: string;
};

export type DeviceEventDto = {
  uuid: string;
  createdAt: Date;
  addedAt: Date;
  data?: {
    [key: string]: unknown;
  };
  device?: MinimalEntityDto;
  logMessage: string;
  logLevel: string;
  errorMessage: string;
};

export enum DeviceEventsOrderEnum {
  CREATED_AT = "createdAt",
  ADDED_AT = "addedAt",
  NAME = "name",
}

export type DeviceEventsOrderEnumSortOption = {
  field: DeviceEventsOrderEnum;
  dir?: "asc" | "desc";
};

export type DeviceJobStatusUpdateDto = {
  [key: string]: unknown;
};

export enum DeviceOrderEnum {
  STATE = "state",
  SITE = "site",
  NAME = "name",
  LAST_PING = "lastPing",
  LOCAL_IP = "localIp",
  ID = "id",
}

export type DeviceOrderEnumSortOption = {
  field: DeviceOrderEnum;
  dir?: "asc" | "desc";
};

export type DeviceRestartDataWithNameDto = {
  devicesQuery: BulkDevicesQueryDto;
  restartAgent?: boolean;
  /**
   * Reserved for future NS restart support
   */
  restartNS?: boolean;
  /**
   * Reserved for future jobs restart support
   */
  restartJobs?: boolean;
  name?: string;
  description?: string;
};

export type DeviceRestartJobDataDto = {
  devicesQuery: BulkDevicesQueryDto;
  restartAgent?: boolean;
  /**
   * Reserved for future NS restart support
   */
  restartNS?: boolean;
  /**
   * Reserved for future jobs restart support
   */
  restartJobs?: boolean;
};

export type DeviceRestartJobDeviceDto = {
  participation: DeviceRestartJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type DeviceRestartJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: DeviceRestartJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: DeployComponentsDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum DeviceRestartJobDeviceStateDto {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type DeviceRestartJobDto = {
  id: number;
  name?: string;
  result: DeployComponentsJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: DeviceRestartJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<DeviceRestartJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type DeviceRestartJobSummaryDto = {
  id: number;
  name?: string;
  result: DeployComponentsJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: DeviceRestartJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type DeviceRestartScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: DeviceRestartJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type DeviceRestartScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: DeviceRestartJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type DeviceRestartScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: DeviceRestartJobDataDto;
};

export type DeviceRestartUpdateJobDto = {
  name?: string;
  description?: string;
};

export type DeviceRestartUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: DeviceRestartJobDataDto;
};

export enum DeviceRoleEnum {
  EDGE = "edge",
  CLUSTER = "cluster",
}

export type DeviceSampleDto = {
  sampleId: string;
  groupId: string;
  label: string;
  size: number;
  opened: boolean;
  pendingRemoteAction?: string;
  datasetType: string;
  imgSource: string;
  labelTrigger: string;
  captureTrigger: string;
  deviceId: number;
  family: string;
  category: string;
  sessionId: string;
  createdAt: Date;
  capturedAt?: Date;
  predictedAt?: Date;
  addedAt?: Date;
  matchStrength?: string;
  barcode?: string;
  price?: string;
  weight?: string;
  name?: string;
  dataType?: string;
  uploadedCluster?: boolean;
  uploadedBackend?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
};

export type DevicesConfigDeploymentBulkDto = {
  deviceConfig: PartialDeviceConfigDto;
  query: BulkDevicesQueryDto;
  schedule?: ScheduleJobScheduleDto;
  name?: string;
  description?: string;
  isPartial: boolean;
  originalDeviceId?: number;
  dontCleanDangerousConfigParams?: boolean;
};

export type DevicesConfigLockBulkDto = {
  query: BulkDevicesQueryDto;
  configLocked: boolean;
};

export type DeviceSessionDto = {
  sessionId: string;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  path?: string;
  size?: number;
  codec?: string;
  width?: number;
  height?: number;
  fps?: number;
  bitrate?: number;
  deviceId?: number;
  startCause?: string;
  stopCause?: string;
  uploadedBackend?: boolean;
  uploadedCluster?: boolean;
  headBlurred?: boolean;
  nonScanModelId?: number;
  predictorModelId?: number;
  nonScanPrecisionLevel?: string;
  agentAlertMode?: string;
  clientAppMode?: string;
};

export type DevicesModelDeploymentBulkDto = {
  query: BulkDevicesQueryDto;
  schedule?: ScheduleJobScheduleDto;
  modelId: number;
  role?:
    | "predictor"
    | "nonScanDetector"
    | "objectDetector"
    | "similarityFilter";
};

export type DevicesRestartBulkDto = {
  query: BulkDevicesQueryDto;
  restartAgent?: boolean;
  /**
   * Accepted for future NS restart support
   */
  restartNS?: boolean;
  /**
   * Accepted for future jobs restart support
   */
  restartJobs?: boolean;
  schedule?: ScheduleJobScheduleDto;
};

export type DevicesServiceVersionDeploymentBulkDto = {
  serviceName:
    | "edgify-non-scan-detector"
    | "edgify-worker"
    | "edgify-on-screen-app"
    | "edgify-zebra-adapter"
    | "edgify-agent"
    | "edgify-model";
  schedule?: ScheduleJobScheduleDto;
  query: BulkDevicesQueryDto;
  version: string;
  type?: string;
};

export type DevicesStateCountsDto = {
  counts: {
    [key: string]: number;
  };
  total: number;
};

export type DeviceSummaryClusterDto = {
  id: number;
  name: string;
};

export type DeviceSummaryDto = {
  state: "deploying" | "ready" | "disconnected" | "disabled" | "down";
  cameraState: "Unknown" | "Disabled" | "Disconnected" | "Down" | "OK";
  id: number;
  name: string;
  agentVersion: string;
  lastPing: Date;
  localIp: string;
  token: string;
  configLocked: boolean;
  cluster: DeviceSummaryClusterDto;
  site: DeviceSummarySiteDto;
  characteristics: {
    os: string;
  };
  deployedModel: DeviceSummaryModelDto;
  deployedModels: Array<DeviceSummaryModelExtendedDto>;
  numberOfSamples: number;
  sampleBufferStatus: {
    [key: string]: unknown;
  };
  videoBufferStatus: {
    [key: string]: unknown;
  };
  servicesStatus: {
    [key: string]: unknown;
  };
  tags: Array<Tag>;
  alertsEnabled: boolean;
};

export type DeviceSummaryModelDto = {
  id: number;
  name: string;
};

export type DeviceSummaryModelExtendedDto = {
  state:
    | "pending"
    | "cancelled"
    | "installing"
    | "failed"
    | "running"
    | "stopped";
  role: string;
  updatedAt: Date;
  id: number;
  name: string;
};

export enum state6 {
  PENDING = "pending",
  CANCELLED = "cancelled",
  INSTALLING = "installing",
  FAILED = "failed",
  RUNNING = "running",
  STOPPED = "stopped",
}

export type DeviceSummarySiteDto = {
  id: number;
  name: string;
};

export type DeviceUploadPreviewRowDto = {
  name: string;
  cluster?: string;
  site?: string;
  activationTime?: Date;
  tags: Array<string>;
  status: "new" | "existing" | "error";
  /**
   * Warning messages (e.g. cluster/site not found)
   */
  warnings: Array<string>;
  /**
   * Error message when status is error
   */
  error?: string;
};

export type DeviceUploadResponseDto = {
  /**
   * Whether this response is from a dry run (preview) or an actual apply
   */
  dryRun: boolean;
  results: Array<DeviceUploadPreviewRowDto>;
  totalNew: number;
  totalExisting: number;
  totalErrors: number;
  /**
   * Fatal error that prevents the entire upload from proceeding
   */
  fatalError?: string;
};

export type DeviceWithActivation = {
  name: string;
  id: number;
  activationTime: Date;
};

export type DeviceWithStateDto = {
  state: "deploying" | "ready" | "disconnected" | "disabled" | "down";
  /**
   * Which device requests the agent understands. Only selected where a caller needs it.
   */
  agentVersion?: string;
  name: string;
  id: number;
};

export type DisabledDeviceDto = {
  deviceId: number;
  deviceName: string;
  suppressedUntil: Date | null;
};

export type DisableDeviceAlertsDto = {
  deviceIds: Array<number>;
  suppressedUntil?: Date | null;
};

export type DomainAuthSettingResponseDto = {
  domain: string;
  strategy: "magicLink" | "oidc";
  defaultAccountId: number;
  company: string;
};

export type DownloadCatalogItemsRequestDto = {
  query: ExportCatalogItemsQueryDto;
};

export type DownloadClusterSummariesRequestDto = {
  query: ExportClusterSummariesDto;
};

export type DownloadDeviceSummariesRequestDto = {
  query: ExportDeviceSummariesDto;
};

export type DownloadManagedAlertsRequestDto = {
  query: ExportManagedAlertsDto;
};

export type DownloadRegionsRequestDto = {
  query: BulkRegionRowsQueryDto;
};

export type DownloadSiteSummariesRequestDto = {
  query: ExportSiteSummariesDto;
};

export type DownloadSubscriptionSendHistoryRequestDto = {
  query: ExportSubscriptionSendHistoryDto;
};

export type DownloadUsersRequestDto = {
  query: ExportUsersDto;
};

export type EligibilityResponseDto = {
  /**
   * True when the account has a ready, environment-matched tenant.
   */
  ready: boolean;
  /**
   * Present only when `ready` is false. `missing_llm_key` is a deployment-wide misconfiguration (REPORTS_COMPANION_LLM_API_KEY unset); the other reasons match the chat endpoint's per-account refusal taxonomy.
   */
  reason?:
    | "not_entitled"
    | "not_ready"
    | "incomplete_provisioning"
    | "env_mismatch"
    | "missing_llm_key";
  /**
   * Backend-authored English fallback explanation. The frontend prefers a per-reason translation when it recognises `reason`; this is what the panel renders when it does not (e.g. a reason the backend added after the deployed frontend was built). Safe to render as-is.
   */
  message?: string;
  /**
   * Only set when `reason === "not_ready"`: the current provisioning status from `account_bigquery_provisioning`. Interpolated into the `not_ready` translation on the frontend so the user can see how far along setup is (e.g. "awaitingPropagation").
   */
  status?: string;
  /**
   * True when the caller holds `mcp.advancedUse` (SuperAdmin auto). Frontend uses this to gate the model + reasoning-level controls in the chat header; regular MCP users never see them.
   */
  advancedControlsEnabled: boolean;
};

/**
 * Present only when `ready` is false. `missing_llm_key` is a deployment-wide misconfiguration (REPORTS_COMPANION_LLM_API_KEY unset); the other reasons match the chat endpoint's per-account refusal taxonomy.
 */
export enum reason {
  NOT_ENTITLED = "not_entitled",
  NOT_READY = "not_ready",
  INCOMPLETE_PROVISIONING = "incomplete_provisioning",
  ENV_MISMATCH = "env_mismatch",
  MISSING_LLM_KEY = "missing_llm_key",
}

export type EmailReportsDataWithNameDto = {
  name?: string;
  description?: string;
  mailingList: Array<string>;
  internalMailingList?: Array<string>;
  approvers?: Array<string>;
  reportUrl: string;
  reportName: string;
  reportId?: number;
  addAttachments?: boolean;
  fileType?: string;
  selectedQuestions?: Array<MetabaseQuestion>;
  customReportQuestions?: Array<MetabaseQuestion>;
  summaryTable?: MetabaseQuestion;
  summaryText?: string;
  subject?: string;
  isCustomReport?: boolean;
};

export type EmailReportsJobDataDto = {
  mailingList: Array<string>;
  internalMailingList?: Array<string>;
  approvers?: Array<string>;
  reportUrl: string;
  reportName: string;
  reportId?: number;
  addAttachments?: boolean;
  fileType?: string;
  selectedQuestions?: Array<MetabaseQuestion>;
  customReportQuestions?: Array<MetabaseQuestion>;
  summaryTable?: MetabaseQuestion;
  summaryText?: string;
  subject?: string;
  isCustomReport?: boolean;
};

export type EmailReportsJobDto = {
  id: number;
  name?: string;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: EmailReportsJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<JobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type EmailReportsJobSummaryDto = {
  id: number;
  name?: string;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: EmailReportsJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type EmailReportsScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: EmailReportsJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type EmailReportsScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: EmailReportsJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type EmailReportsScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: EmailReportsJobDataDto;
};

export type EmailReportsUpdateJobDto = {
  name?: string;
  description?: string;
};

export type EmailReportsUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: EmailReportsJobDataDto;
};

export type EmailSendOutcomeDto = {
  failedRecipients: Array<string>;
};

export type EmitTestAlertDto = {
  alertType: AlertType;
  /**
   * Optional device id to use for test-alert context enrichment
   */
  deviceId?: number;
  alertAction: "Alert" | "Resolve";
};

export enum alertAction {
  ALERT = "Alert",
  RESOLVE = "Resolve",
}

export type EnableDeviceAlertsDto = {
  deviceIds: Array<number>;
};

export type EntityIdDto = {
  id: number;
};

export type EpochDetailsDto = {
  trainingLoss: number;
  validationLoss: number;
  trainingAccuracy: number;
  validationAccuracy: number;
  createdAt: Date;
};

export type EpochMetricsMetricDto = {
  data: {
    [key: string]: Array<number>;
  };
  createdAt: Date;
  uuid?: string | null;
};

export type ErrorDto = {
  name?: string;
  message: string;
};

export type ExportCatalogItemsQueryDto = {
  plus?: Array<string>;
  itemIds?: Array<number>;
  priceBy?: "weight" | "quantity";
  price?: Decimal2;
  families?: Array<string>;
  sortBy?: Array<CatalogItemsSummaryOrderEnumSortOption>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  siteId?: number;
  groupId?: number;
  /**
   * Backend-only row cap override. Not exposed in the UI; omit to use the default.
   */
  maxRows?: number;
  search?: string;
  exact?: boolean;
  name?: string;
  englishName?: string;
  outOfScope?: boolean;
};

export type ExportClusterSummariesDto = {
  clusterIds?: Array<number>;
  sortBy?: Array<ClusterSummariesOrderEnumSortOption>;
  /**
   * Backend-only row cap override. Not exposed in the UI; omit to use the default.
   */
  maxRows?: number;
  name?: string;
};

export type ExportDeviceSummariesDto = {
  deviceIds?: Array<number>;
  state?: Array<QueryDeviceState>;
  excludeClusterIds?: Array<number>;
  siteIds?: Array<number>;
  excludeSiteIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  /**
   * Filter by one or more video states
   */
  videoState?: Array<
    "Unknown" | "Disabled" | "Disconnected" | "Down" | "OK" | "All"
  >;
  /**
   * Backend-only row cap override. Not exposed in the UI; omit to use the default.
   */
  maxRows?: number;
  name?: string;
  agentVersion?: string;
  os?: string;
  cpu?: string;
  modelName?: string;
  localIp?: string;
  lastPing?: Date;
  clusterId?: number;
  siteId?: number;
  configLocked?: boolean;
};

export type ExportManagedAlertsDto = {
  priority?: Array<AlertPriority>;
  severity?: Array<AlertSeverity>;
  /**
   * Backend-only row cap override. Not exposed in the UI; omit to use the default.
   */
  maxRows?: number;
  eventIds?: Array<string>;
  status?: Array<"Open" | "Closed">;
  deviceIds?: Array<number>;
  alertTypes?: Array<
    | "DeviceDown"
    | "ServerDown"
    | "CameraDown"
    | "HighResourceUsage"
    | "LookupTableDisabled"
    | "DeployedModelFailure"
    | "RegisterDisabledDeviceAttempt"
    | "RegisterDuplicateDeviceAttempt"
    | "TrainingFailed"
    | "NonScanDetectorDown"
    | "OnScreenAppDown"
    | "ZebraAdapterDown"
    | "AgentPortClash"
    | "LockedSamplesAboveThreshold"
    | "FailedToStoreSampleLackOfStorage"
    | "BlackScreenImageDetected"
    | "LocalStorageAlmostFull"
    | "AgentDoesNotReachEdgibox"
    | "VideoUploadError"
    | "ImageUploadError"
    | "PredictorDisabled"
    | "NonScanDetectorRepeatedFpsDrops"
    | "ModelBelowKpiThreshold"
    | "TrainingWarnings"
    | "LookupTableMismatch"
    | "MetricThresholdBreach"
    | "ServiceDown"
    | "DataCompletenessBelowThreshold"
    | "DeviceDownEscalated"
    | "ServerDownEscalated"
    | "CameraDownEscalated"
    | "HighResourceUsageEscalated"
    | "LookupTableDisabledEscalated"
    | "DeployedModelFailureEscalated"
    | "NonScanDetectorDownEscalated"
    | "OnScreenAppDownEscalated"
    | "ZebraAdapterDownEscalated"
    | "AgentPortClashEscalated"
    | "LockedSamplesAboveThresholdEscalated"
    | "FailedToStoreSampleLackOfStorageEscalated"
    | "BlackScreenImageDetectedEscalated"
    | "LocalStorageAlmostFullEscalated"
    | "AgentDoesNotReachEdgiboxEscalated"
    | "VideoUploadErrorEscalated"
    | "ImageUploadErrorEscalated"
    | "PredictorDisabledEscalated"
    | "NonScanDetectorRepeatedFpsDropsEscalated"
  >;
  name?: string;
  alertKey?: string;
  escalated?: boolean;
  fromDate?: Date;
  toDate?: Date;
};

export type ExportSiteSummariesDto = {
  siteIds?: Array<number>;
  groupId?: number;
  excludeGroupIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  /**
   * Backend-only row cap override. Not exposed in the UI; omit to use the default.
   */
  maxRows?: number;
  name?: string;
};

export type ExportSubscriptionSendHistoryDto = {
  subscriptionId: number;
  maxRows?: number;
  since?: Date;
  until?: Date;
  outcomes?: Array<
    | "rejected"
    | "failed"
    | "sent"
    | "waitingApproval"
    | "approvalExpired"
    | "notSent"
    | "inProgress"
  >;
};

export type ExportUsersDto = {
  roles?: Array<
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
  >;
  excludeRoles?: Array<
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
  >;
  /**
   * Backend-only row cap override. Not exposed in the UI; omit to use the default.
   */
  maxRows?: number;
  id?: number;
  firstName?: string;
  lastName?: string;
  company?: string;
};

export type ExternalServiceAgentConfigDto = {
  /**
   * agent host for external service to connect to
   */
  host: string;
  /**
   * agent port for external service to connect to
   */
  port: number;
  /**
   * use https for agent connection
   */
  https: boolean;
  /**
   * skip ssl verification for agent connection
   */
  skip_ssl_verify: boolean;
};

export type FailedRecipientDto = {
  address: string;
  reason: string;
};

export type FloatingUserDetails = {
  [key: string]: unknown;
};

export type FloatingUserDetailsDto = {
  user: FloatingUserDetails;
};

export type FullUserDetailsDto = {
  role: Role;
  user: UserDetails;
  account: AccountDetails;
  isActive: boolean;
};

export type GeneratePdfDto = {
  urlParameters: string;
};

export type GetCertValidityResponseDto = {
  field: string;
  path: string;
  subject: string;
  issuer: string;
  not_before: string;
  not_after: string;
  days_remaining: number;
  is_expired: boolean;
};

export type GetConfigFileResponseDto = {
  content: string;
};

export type GetSamplesQueryRequestDto = {
  sampleId?: Array<string>;
  groupId?: Array<string>;
  deviceId?: Array<number>;
  label?: Array<string>;
  labelTrigger?: Array<string>;
  captureTrigger?: Array<string>;
  family?: Array<string>;
  category?: Array<string>;
  imgSource?: Array<string>;
  datasetType?: Array<string>;
  dataType?: Array<string>;
  opened?: boolean;
  pendingRemoteAction?: string;
  from?: Date;
  to?: Date;
  timeField?: string;
  page?: number;
  limit?: number;
  orderBy?: string;
  direction?: string;
  uploadedBackend?: boolean;
  uploadedCluster?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
};

export type GetSamplesQueryResponseDto = {
  results: Array<DeviceSampleDto>;
  total: number;
  perPage: number;
  page: number;
  lastPage: number;
};

export type GetSessionsRequestDto = {
  sessionId?: Array<string>;
  deviceId?: Array<number>;
  uploadedBackend?: boolean;
  uploadedCluster?: boolean;
  shouldUpload?: boolean;
  headBlurred?: boolean;
  from?: Date;
  to?: Date;
  timeField?: string;
  page?: number;
  limit?: number;
  order?: string;
  direction?: string;
};

export type GetSessionsResponseDto = {
  results: Array<DeviceSessionDto>;
  total: number;
  perPage: number;
  page: number;
  lastPage: number;
};

export type GetThumbnailRequestDto = {
  width?: number;
  height?: number;
  expand?: boolean;
};

/**
 * Which GPU to enable in the service docker
 */
export enum GpuTypeEnum {
  DISABLED = "disabled",
  NVIDIA = "nvidia",
  INTEL = "intel",
}

export type GroundTruthPredictionDto = {
  predictions: Array<PredictionEntryDto>;
  device?: MinimalEntityDto;
  model?: MinimalEntityDto;
  loss?: Decimal2;
  editedLoss?: Decimal2;
  id: number;
  createdAt: Date;
  predictedAt: Date;
  capturedAt: Date;
  updatedAt: Date;
  captureDuration?: number;
  captureTrigger: string;
  certain: boolean;
  family?: string;
  sessionId: string;
  interactionStartTime?: Date;
  transactionDuration?: number;
  isActive?: boolean;
  result?: string;
  certainty?: number;
  inModel?: boolean;
  modelGroup?: string;
  modelFamily?: string;
};

export type GroupedManagedAlertDto = {
  priority: AlertPriority | null;
  severity: AlertSeverity | null;
  eventId: string;
  status: "Open" | "Closed";
  title: string;
  createdAt: Date;
  updatedAt: Date;
  alertCount: number;
  relatedAlerts: Array<ManagedAlertListItemDto>;
};

export type HeadBlurImageRequestDto = {
  image: string;
};

export type HeadBlurImageResponseDto = {
  image: string;
  /**
   * omitted when the detector did not report on this image
   */
  headsFound?: boolean;
  /**
   * how long the blur call took, in milliseconds
   */
  duration: number;
};

export type HeadBlurImagesArgsDto = {
  query?: GetSamplesQueryRequestDto;
  name?: string;
  force?: boolean;
  context?: {
    [key: string]: unknown;
  };
};

export type HeadBlurImagesDataWithNameDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  architecture?: Array<"distributed" | "hybrid" | "centralized">;
  query?: GetSamplesQueryRequestDto;
  name?: string;
  description?: string;
  /**
   * re-blur even if the target is already marked headBlurred
   */
  force?: boolean;
};

export type HeadBlurImagesDeviceResultDto = {
  lastStart?: Date;
  lastProgress?: Date;
  _meta?: HeadBlurImagesStateDto;
  failure?: ErrorDto;
  retries?: number;
  wasRunning?: boolean;
  remaining?: number;
};

export type HeadBlurImagesJobDataDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  architecture?: Array<"distributed" | "hybrid" | "centralized">;
  query?: GetSamplesQueryRequestDto;
  /**
   * re-blur even if the target is already marked headBlurred
   */
  force?: boolean;
};

export type HeadBlurImagesJobDeviceDto = {
  participation: HeadBlurImagesJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type HeadBlurImagesJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: HeadBlurImagesJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: HeadBlurImagesDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum HeadBlurImagesJobDeviceStateDto {
  PENDING = "pending",
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
  CANCELLED = "cancelled",
  ABORTED = "aborted",
  STOPPED = "stopped",
}

export type HeadBlurImagesJobDto = {
  id: number;
  name?: string;
  result: HeadBlurImagesJobResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: HeadBlurImagesJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<HeadBlurImagesJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type HeadBlurImagesJobResultDto = {
  failure?: ErrorDto;
  devices?: {
    total?: number;
    stateCounts?: {
      pending?: number;
      running?: number;
      done?: number;
      failed?: number;
      cancelled?: number;
      aborted?: number;
      stopped?: number;
    };
    states?: {
      pending?: Array<number>;
      running?: Array<number>;
      done?: Array<number>;
      failed?: Array<number>;
      cancelled?: Array<number>;
      aborted?: Array<number>;
      stopped?: Array<number>;
    };
  };
};

export type HeadBlurImagesJobSummaryDto = {
  id: number;
  name?: string;
  result: HeadBlurImagesJobResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: HeadBlurImagesJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type HeadBlurImagesScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: HeadBlurImagesJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type HeadBlurImagesScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: HeadBlurImagesJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type HeadBlurImagesScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: HeadBlurImagesJobDataDto;
};

export type HeadBlurImagesStateDto = {
  args?: HeadBlurImagesArgsDto;
  /**
   * UUID, unique per run
   */
  id?: string;
  /**
   * Optional label; multiple runs can share a name
   */
  name?: string;
  /**
   * True if this is the most recent run for the given name
   */
  latest?: boolean;
  /**
   * ISO date string when blurring started
   */
  startTime?: string;
  /**
   * ISO date string when blurring ended; omitted if still running
   */
  endTime?: string;
  running: boolean;
  total: number;
  remaining: number;
  done: number;
  lastError?: {
    [key: string]: unknown;
  };
  failures?: number;
  skipped?: number;
  progress?: BlurProgressDto;
};

export type HeadBlurImagesUpdateJobDto = {
  name?: string;
  description?: string;
};

export type HeadBlurImagesUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: HeadBlurImagesJobDataDto;
};

/**
 * The shape used for masking the detected heads
 */
export enum HeadBlurringShapeEnum {
  OCTAGON7 = "octagon7",
  RECTANGLE = "rectangle",
}

export type HeadBlurVideosArgsDto = {
  query?: GetSessionsRequestDto;
  name?: string;
  force?: boolean;
  context?: {
    [key: string]: unknown;
  };
};

export type HeadBlurVideosDataWithNameDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  architecture?: Array<"distributed" | "hybrid" | "centralized">;
  query?: GetSessionsRequestDto;
  name?: string;
  description?: string;
  /**
   * re-blur even if the target is already marked headBlurred
   */
  force?: boolean;
};

export type HeadBlurVideosDeviceResultDto = {
  lastStart?: Date;
  lastProgress?: Date;
  _meta?: HeadBlurVideosStateDto;
  failure?: ErrorDto;
  retries?: number;
  wasRunning?: boolean;
  remaining?: number;
};

export type HeadBlurVideosJobDataDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  architecture?: Array<"distributed" | "hybrid" | "centralized">;
  query?: GetSessionsRequestDto;
  /**
   * re-blur even if the target is already marked headBlurred
   */
  force?: boolean;
};

export type HeadBlurVideosJobDeviceDto = {
  participation: HeadBlurVideosJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type HeadBlurVideosJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: HeadBlurVideosJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: HeadBlurVideosDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum HeadBlurVideosJobDeviceStateDto {
  PENDING = "pending",
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
  CANCELLED = "cancelled",
  ABORTED = "aborted",
  STOPPED = "stopped",
}

export type HeadBlurVideosJobDto = {
  id: number;
  name?: string;
  result: HeadBlurVideosJobResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: HeadBlurVideosJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<HeadBlurVideosJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type HeadBlurVideosJobResultDto = {
  failure?: ErrorDto;
  devices?: {
    total?: number;
    stateCounts?: {
      pending?: number;
      running?: number;
      done?: number;
      failed?: number;
      cancelled?: number;
      aborted?: number;
      stopped?: number;
    };
    states?: {
      pending?: Array<number>;
      running?: Array<number>;
      done?: Array<number>;
      failed?: Array<number>;
      cancelled?: Array<number>;
      aborted?: Array<number>;
      stopped?: Array<number>;
    };
  };
};

export type HeadBlurVideosJobSummaryDto = {
  id: number;
  name?: string;
  result: HeadBlurVideosJobResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: HeadBlurVideosJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type HeadBlurVideosScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: HeadBlurVideosJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type HeadBlurVideosScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: HeadBlurVideosJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type HeadBlurVideosScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: HeadBlurVideosJobDataDto;
};

export type HeadBlurVideosStateDto = {
  args?: HeadBlurVideosArgsDto;
  /**
   * UUID, unique per run
   */
  id?: string;
  /**
   * Optional label; multiple runs can share a name
   */
  name?: string;
  /**
   * True if this is the most recent run for the given name
   */
  latest?: boolean;
  /**
   * ISO date string when blurring started
   */
  startTime?: string;
  /**
   * ISO date string when blurring ended; omitted if still running
   */
  endTime?: string;
  running: boolean;
  total: number;
  remaining: number;
  done: number;
  lastError?: {
    [key: string]: unknown;
  };
  failures?: number;
  skipped?: number;
  progress?: BlurProgressDto;
};

export type HeadBlurVideosUpdateJobDto = {
  name?: string;
  description?: string;
};

export type HeadBlurVideosUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: HeadBlurVideosJobDataDto;
};

export type InactivateRowsBulkDto = {
  /**
   * Defaults to TRUE. A preview reports exactly what would be inactivated and commits nothing.
   */
  dryRun?: boolean;
  query: BulkRegionRowsQueryDto;
};

export type InactivateRowsResultDto = {
  /**
   * Whether this was a preview (nothing committed) or a real inactivation.
   */
  dryRun: boolean;
  /**
   * True only when rows were actually inactivated. Always false for a preview.
   */
  applied: boolean;
  /**
   * Regions inactivated, or that would be -- the region-only rows of the selection.
   */
  regionsInactivated: number;
  /**
   * Sub-regions inactivated, or that would be: the selected paired rows, PLUS every sub-region cascading from a selected region-only row.
   */
  subRegionsInactivated: number;
  /**
   * How many sites are assigned to any of the above. They are NOT modified -- their assignment simply ends up pointing at something inactive, which is why the user is shown it before committing. The `sites` list is capped; this is the true total. Reads 0 until ID-7058 backfills the site columns.
   */
  sitesAffected: number;
  /**
   * The regions themselves, by name.
   */
  regions: Array<AffectedEntityDto>;
  /**
   * Every sub-region that goes with them, by name.
   */
  subRegions: Array<AffectedEntityDto>;
  /**
   * The affected sites, by name, capped at SITES_PREVIEW_LIMIT. EMPTY when nothing is assigned -- the normal answer until ID-7058 backfills. Compare against sitesAffected to tell a short list from a truncated one.
   */
  sites: Array<AffectedSiteDto>;
};

export type InviteUsersDto = {
  mailingList: Array<string>;
  reportId: number;
  filters: string;
};

/**
 * The protocol used for publishing
 */
export enum IssuePublishProtocol {
  EMPTY_STRING = "",
  MQTT = "mqtt",
}

/**
 * Insertion policy for issues in the queue
 */
export enum IssueQueueInsertionPolicy {
  LIFO = "LIFO",
  FIFO = "FIFO",
}

export type JiraAuthOrAccountDto = {
  username?: string;
  password?: string;
  url?: string;
  alertChannelId?: number;
};

export type JiraState = {
  name?: string;
  stateId: string;
  transitionId: string;
};

export type JobDeviceDto = {
  participation: JobDeviceParticipationDto;
  name: string;
  id: number;
};

export type JobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: string;
  done?: number;
  total?: number;
  failures?: number;
  result: {
    [key: string]: unknown;
  };
  startTime?: Date;
  endTime?: Date;
};

export enum JobDevicesOrderBy {
  NAME = "name",
  STATE = "state",
}

export type JobDevicesOrderBySortOption = {
  field: JobDevicesOrderBy;
  dir?: "asc" | "desc";
};

export enum JobOrderEnum {
  CREATED_AT = "createdAt",
  NAME = "name",
  STATE = "state",
  PROGRESS = "progress",
  DONE = "done",
}

export type JobOrderEnumSortOption = {
  field: JobOrderEnum;
  dir?: "asc" | "desc";
};

export type LabelDistributionDeviceDto = {
  name: string;
  id: number;
  cluster?: MinimalEntityDto;
  site?: MinimalEntityDto;
};

export type LabelDistributionDto = {
  label: string;
  quantity: number;
  opened?: number;
  closed?: number;
  englishName?: string;
  name?: string;
  family?: string;
  devicesCount?: number;
  clustersCount?: number;
  sitesCount?: number;
  devices?: Array<LabelDistributionDeviceDto>;
  clusters?: Array<MinimalEntityDto>;
  sites?: Array<MinimalEntityDto>;
};

export enum LabelDistributionOrderEnum {
  LABEL = "label",
  QUANTITY = "quantity",
}

export type LabelDistributionOrderEnumSortOption = {
  field: LabelDistributionOrderEnum;
  dir?: "asc" | "desc";
};

export type LabelsDistributionDto = {
  labels: {
    [key: string]: number;
  };
  total: number;
};

export type LabelUpdate = {
  catalogItemId: number;
  labelInGroup: string;
  /**
   * Populated when reading job details; ignored on write.
   */
  plu?: string;
  /**
   * Populated when reading job details; ignored on write.
   */
  catalogItemName?: string;
};

export enum LegacyUploadModeEnum {
  DEFAULT = "default",
  AGENT = "agent",
  BACKEND = "backend",
  DISABLE = "disable",
}

export type ListAccountSummariesDto = {
  accountIds?: Array<number>;
  name?: string;
  /**
   * Filter by active status. Defaults to true when omitted.
   */
  isActive?: boolean;
  /**
   * Sort by multiple fields and directions. Default direction for name is ascending.
   */
  sortBy?: Array<AccountOrderEnumSortOption>;
  limit: number;
  page: number;
};

export type ListAlertDeliveriesRequestDto = {
  limit: number;
  page: number;
};

export type ListAlertsRequestDto = {
  sortBy?: Array<AlertSpecsOrderEnumSortOption>;
  priority?: Array<AlertPriority>;
  severity?: Array<AlertSeverity>;
  name?: string;
  description?: string;
  enabled?: boolean;
  includeEscalated?: boolean;
  limit: number;
  page: number;
};

export type ListAlertsResponseDto = {
  priority: AlertPriority;
  severity: AlertSeverity;
  id: number;
  name: string;
  description: string;
  enabled: boolean;
  autoResolve: boolean;
  updatedAt: Date;
  subscriptions: Array<AlertSubscriptionItemDto>;
  updatedBy?: string;
  escalation: AlertEscalationSummaryDto | null;
};

export type ListCatalogDto = {
  siteId?: number;
  plu?: string;
  limit: number;
  page: number;
};

export type ListCatalogItemsSummaryQueryDto = {
  plus?: Array<string>;
  itemIds?: Array<number>;
  priceBy?: "weight" | "quantity";
  price?: Decimal2;
  families?: Array<string>;
  sortBy?: Array<CatalogItemsSummaryOrderEnumSortOption>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  siteId?: number;
  groupId?: number;
  search?: string;
  exact?: boolean;
  plu?: string;
  name?: string;
  englishName?: string;
  outOfScope?: boolean;
  limit: number;
  page: number;
};

export type ListCatalogMinimalDto = {
  search?: string;
  page?: number;
  limit?: number;
  /**
   * Site group ID to exclude items that already have labels in this group
   */
  notInGroup?: number;
};

export type ListCatalogUploadScheduledJobsDto = {
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  siteGroupIds?: Array<number>;
  name?: string;
  from?: Date;
  to?: Date;
  limit: number;
  page: number;
};

export type ListClusterModelDeploymentsDto = {
  name?: string;
  clusterIds?: Array<number>;
  sortBy?: Array<ClusterModelDeploymentsOrderEnumSortOption>;
  limit: number;
  page: number;
};

export type ListClusterSummariesDto = {
  clusterIds?: Array<number>;
  sortBy?: Array<ClusterSummariesOrderEnumSortOption>;
  name?: string;
  limit: number;
  page: number;
};

export type ListDatasetSummariesDto = {
  limit: number;
  page: number;
  id?: number;
  name?: string;
};

export enum ListDeviceConfigOrderEnum {
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
}

export type ListDeviceConfigOrderEnumSortOption = {
  field: ListDeviceConfigOrderEnum;
  dir?: "asc" | "desc";
};

export type ListDeviceEventsDto = {
  logLevel?: Array<string>;
  timeField?: "createdAt" | "addedAt";
  sortBy?: Array<DeviceEventsOrderEnumSortOption>;
  limit: number;
  page: number;
  fromDate?: Date;
  toDate?: Date;
  text?: string;
};

export type ListDeviceSummariesDto = {
  deviceIds?: Array<number>;
  state?: Array<QueryDeviceState>;
  excludeClusterIds?: Array<number>;
  siteIds?: Array<number>;
  excludeSiteIds?: Array<number>;
  /**
   * Sorting by one or more fields, each with an optional direction.
   */
  sortBy?: Array<DeviceOrderEnumSortOption>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  /**
   * Filter by one or more video states
   */
  videoState?: Array<
    "Unknown" | "Disabled" | "Disconnected" | "Down" | "OK" | "All"
  >;
  id?: number;
  name?: string;
  agentVersion?: string;
  os?: string;
  cpu?: string;
  modelName?: string;
  localIp?: string;
  lastPing?: Date;
  clusterId?: number;
  siteId?: number;
  configLocked?: boolean;
  limit: number;
  page: number;
};

export enum ListFamiliesOrderEnum {
  NAME = "name",
  CREATED_AT = "createdAt",
}

export type ListFamiliesOrderEnumSortOption = {
  field: ListFamiliesOrderEnum;
  dir?: "asc" | "desc";
};

export type ListHeadBlurImagesResponseDto = {
  results: Array<HeadBlurImagesStateDto>;
  page?: number;
  perPage?: number;
  total?: number;
  lastPage?: number;
};

export type ListHeadBlurVideosResponseDto = {
  results: Array<HeadBlurVideosStateDto>;
  page?: number;
  perPage?: number;
  total?: number;
  lastPage?: number;
};

export type ListJobsDto = {
  state?:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  sortBy?: Array<JobOrderEnumSortOption>;
  name?: string;
  from?: Date;
  to?: Date;
  limit: number;
  page: number;
};

export type ListLabelDistributionCountDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  sortBy?: Array<LabelDistributionOrderEnumSortOption>;
  label?: string;
  labels?: Array<string>;
  family?: string;
  families?: Array<string>;
  quantity?: Array<NumberConditionDto>;
};

export type ListLabelDistributionDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  sortBy?: Array<LabelDistributionOrderEnumSortOption>;
  label?: string;
  labels?: Array<string>;
  family?: string;
  families?: Array<string>;
  quantity?: Array<NumberConditionDto>;
  limit: number;
  page: number;
};

export type ListLookupTablesSummaryQueryDto = {
  sortBy?: Array<LookupTablesOrderEnumSortOption>;
  limit: number;
  page: number;
};

export type ListManagedAlertsRequestDto = {
  priority?: Array<AlertPriority>;
  severity?: Array<AlertSeverity>;
  sortBy?: Array<ManagedAlertsOrderEnumSortOption>;
  eventIds?: Array<string>;
  status?: Array<"Open" | "Closed">;
  deviceIds?: Array<number>;
  alertTypes?: Array<
    | "DeviceDown"
    | "ServerDown"
    | "CameraDown"
    | "HighResourceUsage"
    | "LookupTableDisabled"
    | "DeployedModelFailure"
    | "RegisterDisabledDeviceAttempt"
    | "RegisterDuplicateDeviceAttempt"
    | "TrainingFailed"
    | "NonScanDetectorDown"
    | "OnScreenAppDown"
    | "ZebraAdapterDown"
    | "AgentPortClash"
    | "LockedSamplesAboveThreshold"
    | "FailedToStoreSampleLackOfStorage"
    | "BlackScreenImageDetected"
    | "LocalStorageAlmostFull"
    | "AgentDoesNotReachEdgibox"
    | "VideoUploadError"
    | "ImageUploadError"
    | "PredictorDisabled"
    | "NonScanDetectorRepeatedFpsDrops"
    | "ModelBelowKpiThreshold"
    | "TrainingWarnings"
    | "LookupTableMismatch"
    | "MetricThresholdBreach"
    | "ServiceDown"
    | "DataCompletenessBelowThreshold"
    | "DeviceDownEscalated"
    | "ServerDownEscalated"
    | "CameraDownEscalated"
    | "HighResourceUsageEscalated"
    | "LookupTableDisabledEscalated"
    | "DeployedModelFailureEscalated"
    | "NonScanDetectorDownEscalated"
    | "OnScreenAppDownEscalated"
    | "ZebraAdapterDownEscalated"
    | "AgentPortClashEscalated"
    | "LockedSamplesAboveThresholdEscalated"
    | "FailedToStoreSampleLackOfStorageEscalated"
    | "BlackScreenImageDetectedEscalated"
    | "LocalStorageAlmostFullEscalated"
    | "AgentDoesNotReachEdgiboxEscalated"
    | "VideoUploadErrorEscalated"
    | "ImageUploadErrorEscalated"
    | "PredictorDisabledEscalated"
    | "NonScanDetectorRepeatedFpsDropsEscalated"
  >;
  name?: string;
  alertKey?: string;
  escalated?: boolean;
  fromDate?: Date;
  toDate?: Date;
  limit: number;
  page: number;
};

export type ListMinimalDeviceDto = {
  state?: "deploying" | "ready" | "disconnected" | "disabled" | "down";
  name?: string;
  clusterId?: number;
  siteId?: number;
  limit: number;
  page: number;
};

export type ListMinimalDto = {
  groupId?: number;
  accountId?: number;
  name?: string;
  limit: number;
  page: number;
};

export type ListMinimalModelDto = {
  type?: ModelType;
  orderBy?: "name" | "createdAt";
  sortBy?: Array<MinimalModelOrderEnumSortOption>;
  limit: number;
  page: number;
  search?: string;
  name?: string;
  role?: string;
};

export enum orderBy {
  NAME = "name",
  CREATED_AT = "createdAt",
}

export type ListModelDeploymentsDto = {
  name?: string;
  state?:
    | "pending"
    | "cancelled"
    | "installing"
    | "failed"
    | "running"
    | "stopped"
    | "all";
  states?: Array<
    "pending" | "cancelled" | "installing" | "failed" | "running" | "stopped"
  >;
  deviceStates?: Array<
    "deploying" | "ready" | "disconnected" | "disabled" | "down"
  >;
  clusterIds?: Array<number>;
  sortBy?: Array<ModelDeploymentsOrderEnumSortOption>;
  limit: number;
  page: number;
};

export enum state7 {
  PENDING = "pending",
  CANCELLED = "cancelled",
  INSTALLING = "installing",
  FAILED = "failed",
  RUNNING = "running",
  STOPPED = "stopped",
  ALL = "all",
}

export type ListModelPredictionsCountDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  timeField?: "createdAt" | "predictedAt";
  result?: Array<TransactionResultEnum>;
  from?: Date;
  to?: Date;
  label?: string;
  prediction?: string;
  fuzzy?: boolean;
};

export enum timeField3 {
  CREATED_AT = "createdAt",
  PREDICTED_AT = "predictedAt",
}

export type ListModelPredictionsDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  sortBy?: Array<PredictionsOrderEnumSortOption>;
  timeField?: "createdAt" | "predictedAt";
  result?: Array<TransactionResultEnum>;
  limit: number;
  page: number;
  from?: Date;
  to?: Date;
  label?: string;
  prediction?: string;
  fuzzy?: boolean;
};

export type ListModelSummariesDto = {
  type?: ModelType;
  sortBy?: Array<ModelSummariesOrderEnumSortOption>;
  search?: string;
  name?: string;
  role?: string;
  limit: number;
  page: number;
};

export type ListPendingSamplesSummaryQueryDto = {
  deviceIds?: Array<number>;
  operationIds?: Array<number>;
  actions?: Array<PendingActionEnum>;
  sortBy?: Array<PendingOrderEnumSortOption>;
  uuid?: string;
  from?: Date;
  to?: Date;
  ownedByMe?: boolean;
  limit: number;
  page: number;
};

export type ListPermissionsSummariesDto = {
  module?: Array<string>;
  search?: string;
  showBackend?: boolean;
  limit: number;
  page: number;
};

export type ListPredictionsCountDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  modelIds?: Array<number>;
  timeField?: "createdAt" | "predictedAt";
  result?: Array<TransactionResultEnum>;
  from?: Date;
  to?: Date;
  label?: string;
  prediction?: string;
  fuzzy?: boolean;
};

export type ListPredictionsDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  modelIds?: Array<number>;
  sortBy?: Array<PredictionsOrderEnumSortOption>;
  timeField?: "createdAt" | "predictedAt";
  result?: Array<TransactionResultEnum>;
  limit: number;
  page: number;
  from?: Date;
  to?: Date;
  label?: string;
  prediction?: string;
  fuzzy?: boolean;
};

export type ListRegionOptionsDto = {
  /**
   * Case-insensitive substring match on the name
   */
  name?: string;
  limit: number;
  page: number;
};

export type ListRegionSummariesDto = {
  sortBy?: Array<RegionRowOrderEnumSortOption>;
  /**
   * Case-insensitive substring match on the region name
   */
  region?: string;
  /**
   * Case-insensitive substring match on the sub-region name
   */
  subRegion?: string;
  regionIds?: Array<number>;
  subRegionIds?: Array<number>;
  /**
   * When true, list INACTIVE rows instead of active ones. Omitted or false = active only.
   */
  showInactive?: boolean;
  limit: number;
  page: number;
};

export type ListSamplesCountDto = {
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  deviceIds?: Array<number>;
  storageDeviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  siteGroupIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  timeField?: "createdAt" | "addedAt";
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  modelIds?: Array<number>;
  result?: Array<TransactionResultEnum>;
  labels?: Array<string>;
  predictions?: Array<string>;
  families?: Array<string>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  taggedByIds?: Array<number>;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  dataType?: Array<string>;
  datasetId?: number;
  fromDate?: Date;
  toDate?: Date;
  onlyWithPrediction?: boolean;
  showNonScans?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  family?: string;
  fuzzy?: boolean;
  matchStrength?: string;
  sessionId?: Array<string>;
  showOnlyWithImages?: boolean;
};

export type ListSamplesDto = {
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  deviceIds?: Array<number>;
  storageDeviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  siteGroupIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  sortBy?: Array<SamplesOrderEnumSortOption>;
  timeField?: "createdAt" | "addedAt";
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  modelIds?: Array<number>;
  result?: Array<TransactionResultEnum>;
  labels?: Array<string>;
  predictions?: Array<string>;
  families?: Array<string>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  taggedByIds?: Array<number>;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  dataType?: Array<string>;
  datasetId?: number;
  limit: number;
  page: number;
  fromDate?: Date;
  toDate?: Date;
  onlyWithPrediction?: boolean;
  showNonScans?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  family?: string;
  fuzzy?: boolean;
  matchStrength?: string;
  sessionId?: Array<string>;
  showOnlyWithImages?: boolean;
};

export type ListSamplesUploadsResponseDto = {
  results: Array<SampleUploadProgressDto>;
  page?: number;
  perPage?: number;
  total?: number;
  lastPage?: number;
};

export type ListSampleTagsDto = {
  sortBy?: Array<SampleTagOrderEnumSortOption>;
  name?: string;
  isVisible?: boolean;
  limit: number;
  page: number;
};

export type ListScheduledJobsDto = {
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  name?: string;
  from?: Date;
  to?: Date;
  limit: number;
  page: number;
};

export type ListSessionsAlertsDto = {
  deviceIds?: Array<number>;
  siteIds?: Array<number>;
  storageDeviceIds?: Array<number>;
  storage?:
    | "any"
    | "backend"
    | "cluster"
    | "edge"
    | "device"
    | "recorded"
    | "none";
  sortBy?: Array<ListSessionsAlertsOrderEnumSortOption>;
  timeField?: "createdAt" | "session";
  sessionIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  tagIds?: Array<number>;
  sessionTagIds?: Array<number>;
  sessionsTagsMatch?: "any" | "exact" | "all" | "none";
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  limit: number;
  page: number;
  from?: Date;
  to?: Date;
  sessionId?: Array<string>;
  onlyNonScans?: boolean;
  onlyStored?: boolean;
  headBlurred?: boolean;
  assistantId?: string;
  shopperId?: string;
};

export enum ListSessionsAlertsOrderEnum {
  CREATED_AT = "createdAt",
  SESSION = "session",
  SIZE = "size",
}

export type ListSessionsAlertsOrderEnumSortOption = {
  field: ListSessionsAlertsOrderEnum;
  dir?: "asc" | "desc";
};

export type ListSessionsAlertsResponseDto = {
  results: unknown[];
  /**
   * Summary statistics for the entire filtered dataset
   */
  summary: SessionsAlertsSummaryDto;
  count?: number;
  countIsEstimate?: boolean;
  lastPage?: number;
  perPage?: number;
  total: number;
  totalIsEstimate?: boolean;
  limit: number;
  page: number;
};

export type ListSessionsCountDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  storageDeviceIds?: Array<number>;
  storage?:
    | "any"
    | "backend"
    | "cluster"
    | "edge"
    | "device"
    | "recorded"
    | "none";
  timeField?: "createdAt" | "session";
  sessionIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  tagIds?: Array<number>;
  sessionTagIds?: Array<number>;
  sessionsTagsMatch?: "any" | "exact" | "all" | "none";
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  assigneeIds?: Array<number>;
  assigneeMatch?: "any" | "none";
  alertType?: Array<"non-scan" | "non-match" | "left-in-cart">;
  labels?: Array<string>;
  datasetId?: number;
  from?: Date;
  to?: Date;
  sessionId?: Array<string>;
  onlyNonScans?: boolean;
  onlyStored?: boolean;
  headBlurred?: boolean;
  assistantId?: string;
  shopperId?: string;
};

export type ListSessionsDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  storageDeviceIds?: Array<number>;
  storage?:
    | "any"
    | "backend"
    | "cluster"
    | "edge"
    | "device"
    | "recorded"
    | "none";
  sortBy?: Array<ListSessionsOrderEnumSortOption>;
  timeField?: "createdAt" | "session";
  sessionIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  tagIds?: Array<number>;
  sessionTagIds?: Array<number>;
  sessionsTagsMatch?: "any" | "exact" | "all" | "none";
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  assigneeIds?: Array<number>;
  assigneeMatch?: "any" | "none";
  alertType?: Array<"non-scan" | "non-match" | "left-in-cart">;
  labels?: Array<string>;
  datasetId?: number;
  limit: number;
  page: number;
  from?: Date;
  to?: Date;
  sessionId?: Array<string>;
  onlyNonScans?: boolean;
  onlyStored?: boolean;
  headBlurred?: boolean;
  assistantId?: string;
  shopperId?: string;
};

export enum ListSessionsOrderEnum {
  CREATED_AT = "createdAt",
  SESSION = "session",
  SIZE = "size",
}

export type ListSessionsOrderEnumSortOption = {
  field: ListSessionsOrderEnum;
  dir?: "asc" | "desc";
};

export type ListSiteGroupLabelsDto = {
  page: number;
  limit: number;
  search?: string;
};

export type ListSiteGroupsSummaryDto = {
  siteGroupIds?: Array<number>;
  name?: string;
  sortBy?: Array<SiteGroupOrderEnumSortOption>;
  limit: number;
  page: number;
};

export type ListSiteSummariesDto = {
  siteIds?: Array<number>;
  /**
   * Sorting by one or more fields, each with an optional direction.
   */
  sortBy?: Array<SiteOrderEnumSortOption>;
  groupId?: number;
  excludeGroupIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  name?: string;
  limit: number;
  page: number;
};

export type ListSubRegionOptionsDto = {
  /**
   * Case-insensitive substring match on the name
   */
  name?: string;
  /**
   * Limit to sub-regions of this region
   */
  regionId?: number;
  limit: number;
  page: number;
};

export type ListTrainingSummariesDto = {
  state?: Array<TrainingState>;
  sortBy?: Array<TrainingSummariesOrderEnumSortOption>;
  name?: string;
  createdSince?: Date;
  from?: Date;
  to?: Date;
  isVisible?: boolean;
  limit: number;
  page: number;
};

export type ListUploadOperationsQueryDto = {
  operationIds?: Array<number>;
  deviceIds?: Array<number>;
  sortBy?: Array<UploadOperationOrderEnumSortOption>;
  from?: Date;
  to?: Date;
  ownedByMe?: boolean;
  limit: number;
  page: number;
};

export type ListVideoUploadsResponseDto = {
  results: Array<VideoUploadProgressDto>;
  page?: number;
  perPage?: number;
  total?: number;
  lastPage?: number;
};

export type LoggedStreamableFile = {
  [key: string]: unknown;
};

export type LoginDto = {
  destination: string;
  context?: string;
};

export type LoginResponseDto = {
  redirectUrl?: string;
};

export type LookupTableDataDto = {
  translated_name: string;
  human_readable_name: string;
  comment: string;
};

export type LookupTableDetailsDto = {
  name: string;
  sites: Array<site>;
};

export type LookupTableDto = {
  data: {
    [key: string]: LookupTableDataDto;
  };
  name: string;
  siteIds: Array<number>;
};

export enum LookupTablesOrderEnum {
  NAME = "name",
}

export type LookupTablesOrderEnumSortOption = {
  field: LookupTablesOrderEnum;
  dir?: "asc" | "desc";
};

export type LookupTablesSummaryDto = {
  id: number;
  name: string;
  updatedAt: Date;
  sitesCount: number;
  hasData: boolean;
};

export type ManagedAlertChannelDto = {
  alertChannelType: AlertChannelType;
  id: number;
  name: string | null;
  url?: string | null;
  configurationInfo?: {
    [key: string]: unknown;
  };
  isGlobal: boolean;
};

export type ManagedAlertListItemAlertDto = {
  alertType:
    | "DeviceDown"
    | "ServerDown"
    | "CameraDown"
    | "HighResourceUsage"
    | "LookupTableDisabled"
    | "DeployedModelFailure"
    | "RegisterDisabledDeviceAttempt"
    | "RegisterDuplicateDeviceAttempt"
    | "TrainingFailed"
    | "NonScanDetectorDown"
    | "OnScreenAppDown"
    | "ZebraAdapterDown"
    | "AgentPortClash"
    | "LockedSamplesAboveThreshold"
    | "FailedToStoreSampleLackOfStorage"
    | "BlackScreenImageDetected"
    | "LocalStorageAlmostFull"
    | "AgentDoesNotReachEdgibox"
    | "VideoUploadError"
    | "ImageUploadError"
    | "PredictorDisabled"
    | "NonScanDetectorRepeatedFpsDrops"
    | "ModelBelowKpiThreshold"
    | "TrainingWarnings"
    | "LookupTableMismatch"
    | "MetricThresholdBreach"
    | "ServiceDown"
    | "DataCompletenessBelowThreshold"
    | "DeviceDownEscalated"
    | "ServerDownEscalated"
    | "CameraDownEscalated"
    | "HighResourceUsageEscalated"
    | "LookupTableDisabledEscalated"
    | "DeployedModelFailureEscalated"
    | "NonScanDetectorDownEscalated"
    | "OnScreenAppDownEscalated"
    | "ZebraAdapterDownEscalated"
    | "AgentPortClashEscalated"
    | "LockedSamplesAboveThresholdEscalated"
    | "FailedToStoreSampleLackOfStorageEscalated"
    | "BlackScreenImageDetectedEscalated"
    | "LocalStorageAlmostFullEscalated"
    | "AgentDoesNotReachEdgiboxEscalated"
    | "VideoUploadErrorEscalated"
    | "ImageUploadErrorEscalated"
    | "PredictorDisabledEscalated"
    | "NonScanDetectorRepeatedFpsDropsEscalated";
  id: number;
  parentSpecId: number | null;
};

export type ManagedAlertListItemDto = {
  priority: AlertPriority | null;
  severity: AlertSeverity | null;
  deviceId: number | null;
  accountId: number;
  id: number;
  alertSubscriptionId: number;
  channelName: string;
  alertSpecId: number;
  status: "Open" | "Closed";
  title: string;
  createdAt: Date;
  updatedAt: Date;
  managedAlertKey: string | null;
  alertSpec: ManagedAlertListItemAlertDto;
  alertChannel: ManagedAlertChannelDto | null;
};

export enum ManagedAlertsOrderEnum {
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
  NAME = "name",
  PRIORITY = "priority",
  SEVERITY = "severity",
}

export type ManagedAlertsOrderEnumSortOption = {
  field: ManagedAlertsOrderEnum;
  dir?: "asc" | "desc";
};

export type MetabaseFilter = {
  name: string;
  id: string;
  slug: string;
  type: string;
};

export type MetabaseQuestion = {
  name: string;
  title?: string;
  id: number;
  dashcardId: number;
  type: string;
  valueColumn?: ValueColumnDto;
};

export type MetricAlertChannelDto = {
  id: number;
  alertChannelType: "email" | "JIRA" | "slack" | "webhook";
  name: string | null;
};

export enum alertChannelType {
  EMAIL = "email",
  JIRA = "JIRA",
  SLACK = "slack",
  WEBHOOK = "webhook",
}

export type MetricAlertResponseDto = {
  priority: AlertPriority;
  severity: AlertSeverity;
  id: number;
  name: string;
  reportId: number;
  reportName: string;
  questionId: number;
  dashcardId: number;
  questionName: string;
  filterScope: string;
  operator: "BelowThreshold" | "AboveThreshold";
  thresholdValue: number;
  schedule: string | null;
  timezone: string | null;
  isEnabled: boolean;
  lastEvaluatedAt: Date | null;
  lastEvaluatedValue: number | null;
  channels: Array<MetricAlertChannelDto>;
  createdAt: Date;
  updatedAt: Date;
  updatedBy?: string;
  runs?: Array<MetricAlertRunDto>;
};

export type MetricAlertRunDto = {
  id: number;
  createdAt: Date;
  startTime: Date | null;
  endTime: Date | null;
  state: string | null;
  value: number | null;
  breached: boolean | null;
};

export enum MetricAlertsOrderEnum {
  NAME = "name",
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
  PRIORITY = "priority",
  SEVERITY = "severity",
}

export type MetricAlertsOrderEnumSortOption = {
  field: MetricAlertsOrderEnum;
  dir?: "asc" | "desc";
};

export type MinimalDatasetSummaryDto = {
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
};

export type MinimalDeviceDto = {
  name: string;
  id: number;
  state?: "deploying" | "ready" | "disconnected" | "disabled" | "down";
};

export type MinimalEntityDto = {
  name: string;
  id: number;
};

export enum MinimalModelOrderEnum {
  NAME = "name",
  CREATED_AT = "createdAt",
}

export type MinimalModelOrderEnumSortOption = {
  field: MinimalModelOrderEnum;
  dir?: "asc" | "desc";
};

export type ModelAssetsDto = {
  "stats.json"?: ModelAssetsStatsDto;
};

export type ModelAssetsStatsDto = {
  strict: ModelAssetsStatsItemDto;
  normal: ModelAssetsStatsItemDto;
  soft: ModelAssetsStatsItemDto;
};

export type ModelAssetsStatsItemDto = {
  git_commit: string;
  "mAP (accuracy of detector model)": number;
  "[scan]Alerts": number;
  "[scan]F1": number;
  "[scan]FP": number;
  "[scan]FPR": number;
  "[scan]GT": number;
  "[scan]Missed GT": number;
  "[scan]Precision": number;
  "[scan]Recall": number;
  "[scan]Scans total": number;
  "[scan]TP": number;
  "[scan]TP per scan (%)": number;
  "[scan]TP per session (%)": number;
  "[session]F1": number;
  "[session]FN": number;
  "[session]FP": number;
  "[session]FPR": number;
  "[session]Precision": number;
  "[session]Recall": number;
  "[session]Sessions total": number;
  "[session]TN": number;
  "[session]TP": number;
  "[session]TP per session (%)": number;
  "[session]GT": number;
};

export type ModelConfigDto = {
  /**
   * path
   */
  path: string;
  /**
   * config_path
   */
  config_path: string;
  /**
   * id
   */
  id: number;
};

export type ModelDeploymentDto = {
  state:
    | "pending"
    | "cancelled"
    | "installing"
    | "failed"
    | "running"
    | "stopped";
  device: DeviceWithStateDto;
  cluster?: MinimalEntityDto;
  updatedAt: Date;
  createdAt: Date;
  manuallyDeployedAt: Date;
};

export enum ModelDeploymentsOrderEnum {
  NAME = "name",
  DEVICE_STATE = "deviceState",
  CLUSTER = "cluster",
  STATE = "state",
  CREATED_AT = "createdAt",
  DEPLOYED_ON = "deployedOn",
}

export type ModelDeploymentsOrderEnumSortOption = {
  field: ModelDeploymentsOrderEnum;
  dir?: "asc" | "desc";
};

export type ModelDetailsDto = {
  type: ModelType;
  format: ModelFormat;
  devices: Array<MinimalEntityDto>;
  trainingCreatedFrom: ModelTrainingDto;
  state: "setup" | "building" | "created" | "failed";
  confusionMatrix: {
    [key: string]: {
      [key: string]: number;
    };
  };
  confidenceStats: {
    per_class_stats_dict?: {
      [key: string]: {
        recall?: {
          top_1?: number;
          top_2?: number;
          top_3?: number;
        };
        "n samples"?: number;
        n_samples?: number;
        precision?: {
          top_1?: number;
          top_2?: number;
          top_3?: number;
        };
        "class_prediction rate"?: number;
        class_prediction_rate?: number;
      };
    };
    filtering?: {
      final_message?: string;
      certain_rate?: number;
      certain_precision?: number;
      "top-1_recall"?: number;
      "top-1_precision"?: number;
      "top-1_pred_rate"?: number;
      "top-2_recall"?: number;
      "top-2_precision"?: number;
      "top-2_pred_rate"?: number;
      "top-3_recall"?: number;
      "top-3_precision"?: number;
      "top-3_pred_rate"?: number;
    };
  };
  dataReport: {
    val?: {
      [key: string]: {
        "0"?: number;
      };
    };
    train?: {
      [key: string]: {
        "0"?: number;
      };
    };
  };
  epochMetrics: {
    [key: string]: Array<number>;
  };
  id: number;
  name: string;
  role: string;
  createdAt: Date;
  description: string;
  maxPredictions?: number;
  trainingAccuracy?: number;
  trainingSamples?: number;
  validationAccuracy?: number;
  validationSamples?: number;
  classes?: number;
  assets: ModelAssetsDto;
};

export enum state8 {
  SETUP = "setup",
  BUILDING = "building",
  CREATED = "created",
  FAILED = "failed",
}

export enum ModelFormat {
  ONNX = "onnx",
  TFLITE = "tflite",
  PT = "pt",
  ZIP = "zip",
}

/**
 * hardware accel for classifier filtering model
 */
export enum ModelHardwareEnum {
  EMPTY_STRING = "",
  CPU = "cpu",
  OPENVINO = "openvino",
  OPENVINO_CPU = "openvino-cpu",
  OPENVINO_GPU = "openvino-gpu",
  OPENVINO_FP16 = "openvino-fp16",
  OPENVINO_FP32 = "openvino-fp32",
  CUDA = "cuda",
}

export type ModelMinimalDto = {
  name: string;
  id: number;
};

export enum ModelSummariesOrderEnum {
  NAME = "name",
  CREATED_AT = "createdAt",
}

export type ModelSummariesOrderEnumSortOption = {
  field: ModelSummariesOrderEnum;
  dir?: "asc" | "desc";
};

export type ModelSummaryDto = {
  devices: Array<MinimalEntityDto>;
  clusters: Array<MinimalEntityDto>;
  format: ModelFormat;
  type: ModelType;
  id: number;
  name: string;
  createdAt: Date;
  classes: number;
  trainSamples: number;
  validationSamples: number;
  accuracy: number;
  role: string;
};

export type ModelTrainingDto = {
  name: string;
  id: number;
  config?: string;
};

export enum ModelType {
  CLASSIFIER = "classifier",
  OBJECT_DETECTOR = "objectDetector",
  EMBEDDING_FILTER = "embeddingFilter",
}

export type MoveSubRegionConflictDto = {
  subRegionId: number;
  name: string;
  reason: string;
};

export type MoveSubRegionsBulkDto = {
  /**
   * The region the selected sub-regions are moved under.
   */
  regionId: number;
  /**
   * If true, validate the whole batch and report what WOULD happen without committing anything. The UI runs this first and only enables the real move once the preview comes back clean. REQUIRED -- unlike the inactivate verb this has no default, and an omitted flag is rejected rather than assumed. A move that silently previewed would look like a move that silently did nothing, and one that silently applied is the outcome all-or-nothing exists to prevent.
   */
  dryRun: boolean;
  query: BulkRegionRowsQueryDto;
};

export type MoveSubRegionsResultDto = {
  /**
   * Whether this was a preview (nothing committed) or a real move.
   */
  dryRun: boolean;
  /**
   * True only when rows actually moved. False for a preview, and false when conflicts blocked the batch.
   */
  applied: boolean;
  /**
   * Sub-regions that would move. Non-zero even on a preview, and even when conflicts blocked the batch.
   */
  eligible: number;
  /**
   * Sub-regions re-parented. A dry run reports the REAL count it would move -- that is the point of previewing through the applying code path -- so read `applied` to tell a preview from a commit.
   */
  moved: number;
  /**
   * Sites whose region_id was realigned to the target because their sub_region_id moved. As with `moved`, a dry run reports the real count and rolls it back.
   */
  sitesRealigned: number;
  /**
   * Names the target region already holds. ANY entry here means NOTHING was moved.
   */
  conflicts: Array<MoveSubRegionConflictDto>;
};

export type MultipartProgressDto = {
  /**
   * Which operation this is about. Missing on agents that predate the split - such a report is
   * always an upload, and carries only the upload fields. Use `isBlurProgress`/`progressOperation`
   * rather than reading this directly.
   */
  operation?: "upload" | "blur";
  /**
   * Upload-only, set when `operation` is `upload` (or missing).
   */
  totalBytes?: number;
  doneBytes?: number;
  remainingBytes?: number;
  currentRateBytesPerSecond?: number;
  averageRateBytesPerSecond?: number;
  /**
   * Size of the video being blurred - what an estimate is built from before the detector reports one.
   */
  videoSize?: number;
  videoSeconds?: number;
  currentFrame?: number;
  sourceTotalFrames?: number;
  totalFrames?: number;
  totalFramesWithHeads?: number;
  totalProcessingSec?: number;
  /**
   * Agent-side status string; empty before anything started.
   */
  status?: string;
  sessionId?: string;
  filename?: string;
  running?: boolean;
  /**
   * 0..1 of the item - bytes written for an upload, frames read for a blur. 0 until it can place itself.
   */
  percent?: number;
  remainingSeconds?: number;
  durationMs?: number;
  startTime?: Date;
  endTime?: Date;
  lastError?: string;
};

export type NameRequestDto = {
  name?: string;
};

export type NonScanAlertDroppedFramesConfigDto = {
  /**
   * Percentage of FPS drop to trigger alert (e.g., 20 for 20% drop)
   */
  dropped_frames_percentage?: number;
  /**
   * Number of FPS drop events required in a session to trigger alert
   */
  num_events_in_session?: number;
  /**
   * Sliding window duration in seconds for FPS drop detection
   */
  sliding_window_duration?: number;
};

export type NonScanDetectorServiceConfig = {
  /**
   * The server's port
   */
  port: number;
  /**
   * The server's host name
   */
  host: string;
  /**
   * The server's docker image.
   */
  image: string;
  /**
   * Should the agent manage the external non-scan detector process?
   */
  managed: boolean;
  /**
   * The host name by which the non-scan detector accesses the agent
   */
  agent_host: string;
  /**
   * streaming method - udp - network / shm - shared memory, "" - empty will default to udp
   */
  streaming_type?: StreamingType;
  /**
   * streaming encoding "" | "raw" | "jpeg" | "h264" | "h265" - specifiying this will attempt input stream reuse if no processing, otherwise encoding is required - "" - empty will auto select encoding based on streaming type and input video encoding - shm will prefer raw, udp will prefer no processing (ie using original encoded video), if processing is required (ie cropping) will prefer jpeg
   */
  streaming_encoding?: StreamingEncoding;
  /**
   * The port used by the non-scan-detector to receive the video stream from the agent
   */
  streaming_port: number;
  /**
   * path for shared memory file descriptor creation, alternative to network streaming
   */
  streaming_shm?: string;
  /**
   * The frame rate used by the non-scan-detector to receive the video stream from the agent
   */
  streaming_frame_rate: string | number;
  /**
   * choose hardware acceleration, defaults to cpu
   */
  streaming_hardware?: VideoStreamHardwareEnum;
  /**
   * choose hardware acceleration for format conversion, defaults to cpu
   */
  streaming_convert_hardware?: VideoStreamHardwareEnum;
  /**
   * The network mode used by the non-scan-detector (leave empty to determine automatically by the mode used for running the agent)
   */
  network_mode: string;
  /**
   * Timeout for accessing the non-scan detector
   */
  timeout: number;
  /**
   * Timeout for initializing the non-scan detector
   */
  init_timeout?: number;
  /**
   * Timeout for shutting down the non-scan detector
   */
  shutdown_timeout?: number;
  /**
   * Enable GPU in the server docker
   */
  gpu_enabled: boolean;
  /**
   * Which GPU to enable in the service docker
   */
  gpu_type: GpuTypeEnum;
  /**
   * hardware acceleration in non scan detector
   */
  gstreamer_hardware: VideoRecordingHardwareEnum;
  /**
   * How much of the available CPU resources the container can use
   */
  cpus: number;
  /**
   * run the service in docker's privileged mode
   */
  privileged: boolean;
  /**
   * video stream bitrate, 0 - encoder default
   */
  streaming_bitrate?: number;
  /**
   * stream to the non-scan detector constantly
   */
  constant_streaming?: boolean;
  /**
   * pull the service docker image when the agent starts it: false/""/off - never, true/once/first/on - when the image is missing, always - on every boot
   */
  auto_pull?: boolean | "" | "off" | "once" | "always" | "first" | "on";
  /**
   * add a postfix to the service container hostname
   */
  container_hostname_postfix?: boolean;
  /**
   * state transition timeout in seconds, -1 - auto (non-scan detector default)
   */
  state_transition_timeout?: number;
  /**
   * relative CPU weight of the container (docker cpu-shares), 0 - docker default
   */
  cpu_shares?: number;
  /**
   * service executable folder / path
   */
  path?: string;
  /**
   * video stream gstreamer pipeline override
   */
  pipeline?: string;
};

/**
 * Inference hardware used by the non scan detector
 */
export enum NonScanInferenceHardwareEnum {
  EMPTY_STRING = "",
  CPU = "CPU",
  NPU = "NPU",
  GPU = "GPU",
  GPU_0 = "GPU.0",
  GPU_1 = "GPU.1",
  CUDA = "CUDA",
  CUDA_0 = "CUDA.0",
  CUDA_1 = "CUDA.1",
  TPU = "TPU",
}

/**
 * Precision level for non scan detector
 */
export enum NonScanPrecisionLevelEnum {
  EMPTY_STRING = "",
  STRICT = "strict",
  NORMAL = "normal",
  SOFT = "soft",
}

/**
 * algorithm for non scan tracker
 */
export enum NonScanTrackerTypeEnum {
  EMPTY_STRING = "",
  SORT = "sort",
}

export type NotificationResponseDto = {
  /**
   * Unique notification ID
   */
  id: number;
  /**
   * Short title shown in the banner header
   */
  title: string;
  /**
   * Full body text of the notification banner
   */
  message: string;
  /**
   * Category of the notification (affects banner color and icon)
   */
  type:
    | "ScheduledMaintenance"
    | "IncidentOutage"
    | "IssueResolved"
    | "GeneralInformation";
  /**
   * Current lifecycle state of the notification
   */
  status: "Draft" | "Scheduled" | "Active" | "Archived" | "Canceled";
  /**
   * Account IDs this banner is scoped to. Empty array means global (all accounts).
   */
  targetAccountIds: Array<number>;
  /**
   * When the event starts (e.g. start of maintenance window)
   */
  startsAt: {
    [key: string]: unknown;
  } | null;
  /**
   * When the event ends. Banner is auto-archived after this time.
   */
  endsAt: {
    [key: string]: unknown;
  } | null;
  /**
   * Hours before startsAt at which the banner becomes active. Null means activate at startsAt.
   */
  notifyBeforeHours: number | null;
  /**
   * False indicates the notification has been soft-deleted
   */
  isActive: boolean;
  /**
   * ID of the SuperAdmin user who created this notification
   */
  createdById: number;
  /**
   * ID of the SuperAdmin user who last updated this notification
   */
  updatedById: {
    [key: string]: unknown;
  } | null;
  /**
   * File name of the generated standalone maintenance page, e.g. "scheduled-db-upgrade-12.html". Null until a page has been generated.
   */
  staticPageFileName: string | null;
  /**
   * Permanent public URL of the generated standalone maintenance page. DevOps redirects traffic here during the downtime this notification announces. Null until a page has been generated.
   */
  staticPageUrl: string | null;
  createdAt: Date;
  updatedAt: Date;
};

/**
 * Current lifecycle state of the notification
 */
export enum status3 {
  DRAFT = "Draft",
  SCHEDULED = "Scheduled",
  ACTIVE = "Active",
  ARCHIVED = "Archived",
  CANCELED = "Canceled",
}

export enum NotificationsOrderEnum {
  TYPE = "type",
  STARTS_AT = "startsAt",
  ENDS_AT = "endsAt",
  CREATED_AT = "createdAt",
  UPDATED_AT = "updatedAt",
}

export type NotificationsOrderEnumSortOption = {
  field: NotificationsOrderEnum;
  dir?: "asc" | "desc";
};

export type NotificationSummaryDto = {
  /**
   * Unique notification ID
   */
  id: number;
  /**
   * Short title shown in the banner header
   */
  title: string;
  /**
   * Category of the notification
   */
  type:
    | "ScheduledMaintenance"
    | "IncidentOutage"
    | "IssueResolved"
    | "GeneralInformation";
  /**
   * Current lifecycle state of the notification
   */
  status: "Draft" | "Scheduled" | "Active" | "Archived" | "Canceled";
  /**
   * False indicates the notification has been soft-deleted
   */
  isActive: boolean;
  /**
   * When the event starts
   */
  startsAt: {
    [key: string]: unknown;
  } | null;
  /**
   * When the event ends. Banner is auto-archived after this time.
   */
  endsAt: {
    [key: string]: unknown;
  } | null;
  /**
   * Hours before startsAt at which the banner becomes active.
   */
  notifyBeforeHours: number | null;
  createdAt: Date;
};

export type NumberConditionDto = {
  condition: NumberConditionEnum;
  value: number;
};

export enum NumberConditionEnum {
  GTE = "gte",
  __ = "!=",
  LTE = "lte",
  GT = "gt",
  _ = "<",
  LT = "lt",
  EQ = "eq",
  NOT = "not",
}

export type OidcParamsDto = {
  authorizationEndpoint: string;
  tokenEndpoint: string;
  userInfoEndpoint: string;
  clientId: string;
  clientSecret: string;
  scope: string;
  issuer: string;
};

export type OldRegionOfInterestDto = {
  /**
   * left
   */
  left: number;
  /**
   * top
   */
  top: number;
  /**
   * width
   */
  width: number;
  /**
   * height
   */
  height: number;
};

/**
 * enable/disable auto focus, "" does not apply, "on" enable, "off" disable
 */
export enum OnOffEnum {
  EMPTY_STRING = "",
  ON = "on",
  OFF = "off",
}

/**
 * on-screen-app log level
 */
export enum OnScreenAppLogLevelEnum {
  EMPTY_STRING = "",
  DEBUG = "debug",
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
}

export type OperationalHoursEntryResponseDto = {
  dayOfWeek:
    | "Monday"
    | "Tuesday"
    | "Wednesday"
    | "Thursday"
    | "Friday"
    | "Saturday"
    | "Sunday";
  startTime: string;
  endTime: string;
  enabled: boolean;
};

export type OperationalHoursResponseDto = {
  schedule: Array<OperationalHoursEntryResponseDto>;
  /**
   * Indicates the operational hours were inherited from a default source (site group or account level)
   */
  isDefault?: boolean;
  enabled: boolean;
  timezone: string;
};

export type PaginatedRequestDto = {
  limit: number;
  page: number;
};

export type PaginatedResponseDto = {
  results: unknown[];
  total: number;
  totalIsEstimate?: boolean;
  limit: number;
  page: number;
};

export type PaginatedResponseWithCountDto = {
  results: unknown[];
  count?: number;
  countIsEstimate?: boolean;
  lastPage?: number;
  perPage?: number;
  total: number;
  totalIsEstimate?: boolean;
  limit: number;
  page: number;
};

export type PartialDevice = {
  state: "deploying" | "ready" | "disconnected" | "disabled" | "down";
  agentVersion: string;
  name: string;
  id: number;
};

export type PartialDeviceConfigDto = {
  Agent?: ConfigAgentDto;
  Api?: ConfigApiDto;
  Analytics?: ConfigAnalyticsDto;
  VideoStream?: ConfigVideoStreamDto;
  Database?: ConfigDatabaseDto;
  DataManager?: ConfigDataManagerDto;
  Predictor?: ConfigPredictorDto;
  NonScanDetector?: ConfigNonScanDetectorDto;
  OnScreenApp?: ConfigOnScreenAppDto;
  ZebraAdapter?: ConfigZebraAdapterDto;
  MotionDetector?: ConfigMotionDetectorDto;
  DeviceManager?: ConfigDeviceManagerDto;
  ResourceMonitoring?: ConfigResourceMonitoringDto;
  Logger?: ConfigLoggerDto;
  Training?: ConfigTrainingDto;
  VideoRecording?: ConfigVideoRecordingDto;
  IssuesQueue?: ConfigIssuesQueueDto;
  Publish?: ConfigPublishDto;
  Webhooks?: ConfigWebhooksDto;
  Mqtt?: ConfigMqttDto;
};

export type PasswordDto = {
  password?: string;
};

export enum PendingActionEnum {
  UPLOAD = "upload",
  DELETE = "delete",
  RELABEL = "relabel",
  FAMILY = "family",
}

export enum PendingOrderEnum {
  LAST_ATTEMPTED = "lastAttempted",
  ACTION_TIME = "actionTime",
}

export type PendingOrderEnumSortOption = {
  field: PendingOrderEnum;
  dir?: "asc" | "desc";
};

export type PendingSampleDetailsDto = {
  toDelete?: boolean | null;
  toUpload?: boolean | null;
  deleteAfterUpload?: boolean | null;
  uploadOperationId?: number | null;
  uploadStartedAt?: Date | null;
  uploadCancelRequestedAt?: Date | null;
  label?: string | null;
  family?: string | null;
  lastErrorMessage?: string | null;
  id: number;
  uuid: string;
  deviceId: number;
  deviceName: string;
  agentVersion: string;
  uploadOwnedByCurrentUser: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export type PendingUploadOperationDto = {
  id: number;
  createdAt: Date;
  deleteAfterUpload: boolean;
  remaining: number;
  cancellationRequested: number;
  ownedByCurrentUser: boolean;
};

export type PermissionsAccountsBackendDto = {
  readDetails: boolean;
  readMinimal: boolean;
  readAgentVersions: boolean;
  readServiceVersions: boolean;
};

export type PermissionsAccountsDto = {
  backend: PermissionsAccountsBackendDto;
  view: boolean;
  create: boolean;
  edit: boolean;
};

export type PermissionsAlertsBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsAlertsDto = {
  global: PermissionsAlertsGlobalDto;
  escalation: PermissionsAlertsEscalationDto;
  backend: PermissionsAlertsBackendDto;
  view: boolean;
  download: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  subscribe: boolean;
};

export type PermissionsAlertsEscalationDto = {
  view: boolean;
  edit: boolean;
};

export type PermissionsAlertsGlobalDto = {
  create: boolean;
  delete: boolean;
  edit: boolean;
};

export type PermissionsCatalogBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsCatalogDto = {
  tags: PermissionsCatalogTagsDto;
  backend: PermissionsCatalogBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  download: boolean;
};

export type PermissionsCatalogTagsDto = {
  create: boolean;
  update: boolean;
  lock: boolean;
  unassignLocked: boolean;
  delete: boolean;
  merge: boolean;
};

export type PermissionsClustersBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsClustersDevicesDto = {
  view: boolean;
  edit: boolean;
};

export type PermissionsClustersDto = {
  tags: PermissionsClustersTagsDto;
  devices: PermissionsClustersDevicesDto;
  backend: PermissionsClustersBackendDto;
  view: boolean;
  download: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
};

export type PermissionsClustersTagsDto = {
  create: boolean;
  update: boolean;
  lock: boolean;
  unassignLocked: boolean;
  delete: boolean;
  merge: boolean;
};

export type PermissionsDatasetsBackendDto = {
  readDetails: boolean;
  readMinimal: boolean;
};

export type PermissionsDatasetsDto = {
  backend: PermissionsDatasetsBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
};

export type PermissionsDevicesBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
  readDeployments: boolean;
  readPassword: boolean;
  readData: boolean;
};

export type PermissionsDevicesDataDto = {
  view: boolean;
  edit: boolean;
};

export type PermissionsDevicesDto = {
  data: PermissionsDevicesDataDto;
  settings: PermissionsDevicesSettingsDto;
  versionHistory: PermissionsDevicesVersionHistoryDto;
  tags: PermissionsDevicesTagsDto;
  backend: PermissionsDevicesBackendDto;
  view: boolean;
  download: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  diagnostics: boolean;
  uploadLogs: boolean;
  logs: boolean;
  setupUI: boolean;
};

export type PermissionsDevicesSettingsDto = {
  view: boolean;
  edit: boolean;
};

export type PermissionsDevicesTagsDto = {
  create: boolean;
  update: boolean;
  lock: boolean;
  unassignLocked: boolean;
  delete: boolean;
  merge: boolean;
};

export type PermissionsDevicesVersionHistoryDto = {
  view: boolean;
  deploy: boolean;
};

export type PermissionsDto = {
  devices: PermissionsDevicesDto;
  clusters: PermissionsClustersDto;
  sites: PermissionsSitesDto;
  samples: PermissionsSamplesDto;
  json: PermissionsJsonDto;
  labelDistribution: PermissionsLabelDistributionDto;
  sessions: PermissionsSessionsDto;
  datasets: PermissionsDatasetsDto;
  catalog: PermissionsCatalogDto;
  pending: PermissionsPendingDto;
  trainings: PermissionsTrainingsDto;
  jobs: PermissionsJobsDto;
  models: PermissionsModelsDto;
  reports: PermissionsReportsDto;
  accounts: PermissionsAccountsDto;
  users: PermissionsUsersDto;
  alerts: PermissionsAlertsDto;
  lookupTable: PermissionsLookupTableDto;
  permissions: PermissionsPermissionsDto;
  predictions: PermissionsPredictionsDto;
  features: PermissionsFeaturesDto;
  siteGroups: PermissionsSiteGroupsDto;
  mcp: PermissionsMcpDto;
  notifications: PermissionsNotificationsDto;
  metricAlerts: PermissionsMetricAlertsDto;
  regions: PermissionsRegionsDto;
};

export type PermissionsFeaturesDto = {
  sections: PermissionsFeaturesSectionsDto;
  search: boolean;
};

export type PermissionsFeaturesSectionsDto = {
  resources: boolean;
  data: boolean;
  jobs: boolean;
  models: boolean;
  reports: boolean;
  settings: boolean;
};

export type PermissionsJobsCameraCalibrationBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsCameraCalibrationDto = {
  backend: PermissionsJobsCameraCalibrationBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsCapacityTaggingBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsCapacityTaggingDto = {
  backend: PermissionsJobsCapacityTaggingBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsDeleteSamplesBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsDeleteSamplesDto = {
  backend: PermissionsJobsDeleteSamplesBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsDeleteVideosBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsDeleteVideosDto = {
  backend: PermissionsJobsDeleteVideosBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsDeployComponentsBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsDeployComponentsDto = {
  backend: PermissionsJobsDeployComponentsBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsDeployModelsBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsDeployModelsDto = {
  backend: PermissionsJobsDeployModelsBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsDto = {
  cameraCalibration: PermissionsJobsCameraCalibrationDto;
  deleteSamples: PermissionsJobsDeleteSamplesDto;
  deleteVideos: PermissionsJobsDeleteVideosDto;
  scheduledTrainings: PermissionsJobsScheduledTrainingsDto;
  syncGroundTruths: PermissionsJobsSyncGroundTruthsDto;
  uploadSamples: PermissionsJobsUploadSamplesDto;
  uploadVideos: PermissionsJobsUploadVideosDto;
  headBlurVideos: PermissionsJobsHeadBlurVideosDto;
  headBlurImages: PermissionsJobsHeadBlurImagesDto;
  capacityTagging: PermissionsJobsCapacityTaggingDto;
  recoveryEstimates: PermissionsJobsRecoveryEstimatesDto;
  deployComponents: PermissionsJobsDeployComponentsDto;
  deployModels: PermissionsJobsDeployModelsDto;
  serviceHealthChecks: PermissionsJobsServiceHealthChecksDto;
  workerJobs: PermissionsJobsWorkerJobsDto;
  queues: PermissionsJobsQueuesDto;
};

export type PermissionsJobsHeadBlurImagesBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsHeadBlurImagesDto = {
  backend: PermissionsJobsHeadBlurImagesBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsHeadBlurVideosBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsHeadBlurVideosDto = {
  backend: PermissionsJobsHeadBlurVideosBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsQueuesBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsQueuesDto = {
  backend: PermissionsJobsQueuesBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsRecoveryEstimatesBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsRecoveryEstimatesDto = {
  backend: PermissionsJobsRecoveryEstimatesBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsScheduledTrainingsBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsScheduledTrainingsDto = {
  backend: PermissionsJobsScheduledTrainingsBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsServiceHealthChecksBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsServiceHealthChecksDto = {
  backend: PermissionsJobsServiceHealthChecksBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsSyncGroundTruthsBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsSyncGroundTruthsDto = {
  backend: PermissionsJobsSyncGroundTruthsBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsUploadSamplesBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsUploadSamplesDto = {
  backend: PermissionsJobsUploadSamplesBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsUploadVideosBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsJobsUploadVideosDto = {
  backend: PermissionsJobsUploadVideosBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJobsWorkerJobsBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
  readToken: boolean;
};

export type PermissionsJobsWorkerJobsDto = {
  backend: PermissionsJobsWorkerJobsBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
};

export type PermissionsJsonDto = {
  view: boolean;
};

export type PermissionsLabelDistributionBackendDto = {
  read: boolean;
};

export type PermissionsLabelDistributionDto = {
  backend: PermissionsLabelDistributionBackendDto;
  view: boolean;
};

export type PermissionsLookupTableBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsLookupTableDto = {
  backend: PermissionsLookupTableBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  download: boolean;
};

export type PermissionsMcpDto = {
  use: boolean;
  advancedUse: boolean;
  viewChatLog: boolean;
};

export type PermissionsMetricAlertsDto = {
  view: boolean;
  create: boolean;
  edit: boolean;
  delete: boolean;
  test: boolean;
};

export type PermissionsModelsBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
  readDeployments: boolean;
};

export type PermissionsModelsDto = {
  backend: PermissionsModelsBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  deploy: boolean;
  download: boolean;
};

export type PermissionsNotificationsBackendDto = {
  readDetails: boolean;
};

export type PermissionsNotificationsDto = {
  backend: PermissionsNotificationsBackendDto;
  view: boolean;
  create: boolean;
  edit: boolean;
  delete: boolean;
};

export type PermissionsPendingBackendDto = {
  readDetails: boolean;
};

export type PermissionsPendingDto = {
  backend: PermissionsPendingBackendDto;
  uploads: PermissionsPendingUploadsDto;
  view: boolean;
};

export type PermissionsPendingUploadsDto = {
  cancelOwn: boolean;
};

export type PermissionsPermissionsBackendDto = {
  readDetails: boolean;
};

export type PermissionsPermissionsDto = {
  backend: PermissionsPermissionsBackendDto;
  view: boolean;
  edit: boolean;
};

export type PermissionsPredictionsBackendDto = {
  readDetails: boolean;
  readModelDetails: boolean;
};

export type PermissionsPredictionsDto = {
  backend: PermissionsPredictionsBackendDto;
};

export type PermissionsRegionsDto = {
  view: boolean;
  download: boolean;
  create: boolean;
  edit: boolean;
  delete: boolean;
  upload: boolean;
};

export type PermissionsReportsBackendDto = {
  readDetails: boolean;
};

export type PermissionsReportsDto = {
  subscription: PermissionsReportsSubscriptionDto;
  backend: PermissionsReportsBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  editUrl: boolean;
  editConfig: boolean;
};

export type PermissionsReportsSubscriptionBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsReportsSubscriptionCustomSubscriptionBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsReportsSubscriptionCustomSubscriptionDto = {
  backend: PermissionsReportsSubscriptionCustomSubscriptionBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  approve: boolean;
};

export type PermissionsReportsSubscriptionDto = {
  backend: PermissionsReportsSubscriptionBackendDto;
  customSubscription: PermissionsReportsSubscriptionCustomSubscriptionDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  execute: boolean;
  addAttachments: boolean;
};

export type PermissionsSamplesBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
  readDeviceImages: boolean;
};

export type PermissionsSamplesDto = {
  tags: PermissionsSamplesTagsDto;
  backend: PermissionsSamplesBackendDto;
  view: boolean;
  delete: boolean;
  edit: boolean;
  blur: boolean;
  viewTaggedBy: boolean;
};

export type PermissionsSamplesTagsDto = {
  create: boolean;
  update: boolean;
  lock: boolean;
  unassignLocked: boolean;
  delete: boolean;
  merge: boolean;
};

export type PermissionsSessionsBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsSessionsDto = {
  tags: PermissionsSessionsTagsDto;
  backend: PermissionsSessionsBackendDto;
  video: PermissionsSessionsVideoDto;
  visualization: PermissionsSessionsVisualizationDto;
  view: boolean;
  delete: boolean;
  viewAssignee: boolean;
  updateAssignee: boolean;
};

export type PermissionsSessionsTagsDto = {
  create: boolean;
  update: boolean;
  lock: boolean;
  unassignLocked: boolean;
  delete: boolean;
  merge: boolean;
};

export type PermissionsSessionsVideoDto = {
  view: boolean;
  download: boolean;
  upload: boolean;
  blur: boolean;
};

export type PermissionsSessionsVisualizationDto = {
  view: boolean;
  tracks: boolean;
  debug: boolean;
};

export type PermissionsSiteGroupsDto = {
  list: boolean;
  details: boolean;
  create: boolean;
  update: boolean;
  delete: boolean;
  assignSites: boolean;
  removeSites: boolean;
  view: boolean;
  edit: boolean;
};

export type PermissionsSitesBackendDto = {
  readMinimal: boolean;
  readDeployments: boolean;
  readDetails: boolean;
};

export type PermissionsSitesDevicesDto = {
  view: boolean;
  edit: boolean;
};

export type PermissionsSitesDto = {
  tags: PermissionsSitesTagsDto;
  devices: PermissionsSitesDevicesDto;
  versionHistory: PermissionsSitesVersionHistoryDto;
  groups: PermissionsSitesGroupsDto;
  backend: PermissionsSitesBackendDto;
  view: boolean;
  download: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
};

export type PermissionsSitesGroupsDto = {
  list: boolean;
  details: boolean;
  create: boolean;
  update: boolean;
  delete: boolean;
  assignSites: boolean;
  removeSites: boolean;
};

export type PermissionsSitesTagsDto = {
  create: boolean;
  update: boolean;
  lock: boolean;
  unassignLocked: boolean;
  delete: boolean;
  merge: boolean;
};

export type PermissionsSitesVersionHistoryDto = {
  view: boolean;
  deploy: boolean;
};

export type PermissionsSummaryDto = {
  module: string;
  submodule: string;
  action: string;
  description: string;
  viewer: boolean;
  annotator: boolean;
  tech: boolean;
  owner: boolean;
  mlops: boolean;
  siteManager: boolean;
  annotatorManager: boolean;
  edgifyCandidate: boolean;
};

export type PermissionsTrainingsBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsTrainingsDto = {
  backend: PermissionsTrainingsBackendDto;
  view: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  createModel: boolean;
  execute: boolean;
  editDefaults: boolean;
};

export type PermissionsUsersBackendDto = {
  readMinimal: boolean;
  readDetails: boolean;
};

export type PermissionsUsersDto = {
  backend: PermissionsUsersBackendDto;
  view: boolean;
  download: boolean;
  create: boolean;
  delete: boolean;
  edit: boolean;
  invite: boolean;
  assignSites: boolean;
};

export type PredictionDto = {
  predictions: Array<PredictionEntryDto>;
  device?: MinimalEntityDto;
  model?: MinimalEntityDto;
  groundTruth?: PredictionGroundTruthDto;
  id: number;
  uuid: string;
  createdAt: Date;
  predictedAt: Date;
  capturedAt: Date;
  updatedAt: Date;
  captureDuration?: number;
  captureTrigger: string;
  certain: boolean;
  family?: string;
  sessionId: string;
  interactionStartTime?: Date;
};

export type PredictionEntryDto = {
  price?: Decimal2;
  label: string;
  certainty: number;
  englishName?: string;
};

export type PredictionGroundTruthDto = {
  state:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  addedAt: Date;
  createdAt: Date;
  updatedAt: Date;
  device?: DeviceWithActivation;
  cluster?: MinimalEntityDto;
  site?: MinimalEntityDto;
  storageDevice?: PartialDevice;
  totalPrice?: Decimal2;
  price?: Decimal2;
  weight?: Decimal2;
  loss?: Decimal2;
  editedLoss?: Decimal2;
  id: number;
  groupId: string;
  label: string;
  englishName?: string;
  editedLabel?: string;
  editedLabelEnglishName?: string;
  comment?: string;
  family: string;
  editedFamily?: string;
  category?: string;
  labelTrigger?: string;
  captureTrigger?: string;
  imgSource?: string;
  sessionId?: string;
  matchStrength?: string;
  storagePath?: string;
  tags?: Array<SampleTagDto>;
  taggedByName?: string;
  taggedById?: number;
  barcode?: string;
  count?: number;
  dataType?: string;
  data?: {
    [key: string]: unknown;
  };
  /**
   * true when the sample image had heads blurred on the device
   */
  headBlurred: boolean;
  /**
   * whether heads were found in the sample image, null when not evaluated
   */
  headsFound?: boolean;
  transactionDuration?: number;
  isActive?: boolean;
  result?: string;
  certainty?: number;
  inModel?: boolean;
  modelGroup?: string;
  modelFamily?: string;
};

export type PredictionModelConfig = {
  /**
   * path
   */
  path: string;
  /**
   * config_path
   */
  config_path: string;
  /**
   * id
   */
  id: number;
  /**
   * Minimal score for is_certain in a case 1 label is returned - or -1 to derive this automatically
   */
  top1_high_certainty_threshold: number;
  /**
   * Minimal score to include a label in the prediction or -1 to derive this automatically
   */
  min_confidence_per_prediction: number;
  /**
   * Minimal sum of scores of all returned labels (otherwise unknown) or -1 to derive this automatically
   */
  min_confidence_sum: number;
  /**
   * Maximum number of predicted classes to show in the results - or 0 to derive this automatically
   */
  number_of_classes_to_show: number;
};

export type PredictionOption = {
  label: string;
  certainty: number;
  originalLabel: string;
  bbox?: BboxDto;
};

export type PredictionOptionTranslated = {
  englishName?: string;
  label: string;
  certainty: number;
  originalLabel: string;
  bbox?: BboxDto;
};

export enum PredictionsOrderEnum {
  CREATED_AT = "createdAt",
  PREDICTED_AT = "predictedAt",
}

export type PredictionsOrderEnumSortOption = {
  field: PredictionsOrderEnum;
  dir?: "asc" | "desc";
};

export type PredictorInfoDto = {
  name: string;
  id: number;
  model?: MinimalEntityDto;
};

export type PredictRequestDto = {
  role?: string;
  family?: string;
  captureTrigger?: string;
  image: string;
};

export type PredictResponseDto = {
  sampleId: string;
  duration: number;
  predictedAt: Date;
  modelId: number;
  certain: boolean;
  predictions: Array<PredictionOption>;
};

export type PredictResponseTranslatedDto = {
  sampleId: string;
  duration: number;
  predictedAt: Date;
  modelId: number;
  certain: boolean;
  predictions: Array<PredictionOptionTranslated>;
};

export type PreviewMetricAlertDto = {
  reportId: number;
  questionId: number;
  dashcardId: number;
  filterScope: string;
};

export type PreviewMetricAlertResponseDto = {
  value: number | null;
};

export type PreviewTemplateDto = {
  subscriptionId: number;
  summaryText?: string;
  customReportQuestions?: Array<MetabaseQuestion>;
  summaryTable?: MetabaseQuestion;
};

export type ProjectIssueTypesDto = {
  username?: string;
  password?: string;
  url?: string;
  alertChannelId?: number;
  project: string;
};

/**
 * protocol to use for the service
 */
export enum ProtocolEnum {
  EMPTY_STRING = "",
  HTTP = "http",
  HTTPS = "https",
}

export type PublicNotificationResponseDto = {
  /**
   * Unique notification ID
   */
  id: number;
  /**
   * Short title shown in the banner header
   */
  title: string;
  /**
   * Full body text of the notification banner
   */
  message: string;
  /**
   * Category of the notification (affects banner color and icon)
   */
  type:
    | "ScheduledMaintenance"
    | "IncidentOutage"
    | "IssueResolved"
    | "GeneralInformation";
  /**
   * When the event starts (e.g. start of maintenance window)
   */
  startsAt: {
    [key: string]: unknown;
  } | null;
  /**
   * When the event ends. Banner is auto-archived after this time.
   */
  endsAt: {
    [key: string]: unknown;
  } | null;
};

export type PublishThumbnailsConfigDto = {
  /**
   * Width of thumbnail in pixels
   */
  width: number;
  /**
   * Height of thumbnail in pixels
   */
  height: number;
};

/**
 * MQTT QoS
 */
export enum QoS {
  "_0" = 0,
  "_1" = 1,
  "_2" = 2,
}

export enum QueryDeviceState {
  DEPLOYING = "deploying",
  READY = "ready",
  DISCONNECTED = "disconnected",
  DISABLED = "disabled",
  DOWN = "down",
  ALL = "all",
}

export type QueueBulkDto = {
  limit: number;
  page: number;
};

export enum QueueDefinitionEndpoint {
  GROUND_TRUTHS = "ground-truths",
  PREDICTIONS = "predictions",
  EVENTS = "events",
  SESSIONS = "sessions",
  SESSION_TAGGING = "session-tagging",
  SAMPLE_GROUP_TAGGING = "sample-group-tagging",
  SAMPLE_EVENT_TAGGING = "sample-event-tagging",
  AGENT_LOGS = "agent-logs",
}

export type QueueFailureDto = {
  data: {
    [key: string]: unknown;
  };
  error?: {
    name?: string;
    message?: string;
  };
};

export type QueueItemSummaryDto = {
  count: number;
  size: number;
};

export type QueuePendingDto = {
  data: {
    [key: string]: unknown;
  };
};

export type QueuesSummaryDto = {
  "ground-truths": QueueSummaryDto;
  predictions: QueueSummaryDto;
  events: QueueSummaryDto;
  sessions: QueueSummaryDto;
  "session-tagging": QueueSummaryDto;
  "sample-group-tagging": QueueSummaryDto;
  "sample-event-tagging": QueueSummaryDto;
  "agent-logs": QueueSummaryDto;
};

export type QueueSummaryDto = {
  pending: QueueItemSummaryDto;
  failures: QueueItemSummaryDto;
};

export type RecentSendStateDto = {
  state: string;
  approvalOutcome: string | null;
  sendRecorded: boolean;
  hasFailedRecipients: boolean;
};

export type RecoveryEstimatesDataWithNameDto = {
  /**
   * weekly = estimate --week-ending <weekEnding>; monthly = estimate-monthly --month <month>
   */
  mode: RecoveryEstimatesModeEnum;
  /**
   * Weekly runs: the store-local week-end date (YYYY-MM-DD) being finalized. Must be the last day of a reporting week (the day before calendar.week_start in the component config); the component refuses any other date.
   */
  weekEnding?: string;
  /**
   * Monthly runs: the calendar month (YYYY-MM) to finalize, after the weekly run that folds its last week.
   */
  month?: string;
  name?: string;
  description?: string;
};

export type RecoveryEstimatesGlobalRowDto = {
  /**
   * week | trailing | month_to_date | month_final
   */
  estimand: string;
  /**
   * Week-start date(s) or month the row covers, as labelled by the component
   */
  periodLabel: string;
  /**
   * One of the ten §4.3 metrics
   */
  metric: string;
  /**
   * greg | two_margin — the estimator that produced the row
   */
  estimator: string;
  /**
   * Point estimate for the whole fleet
   */
  estimate: number | null;
  /**
   * 95% margin of error; the interval is estimate ± moe
   */
  moe: number | null;
  /**
   * ok | directional | partial
   */
  reliabilityFlag: string | null;
  /**
   * Reviewed sessions backing the row
   */
  nReviews: number | null;
  /**
   * Directly observed count — a hard lower bound on estimate (blank for rates)
   */
  auditedCount: number | null;
  /**
   * Stores with a never-decided cell in this domain
   */
  storesPending: number | null;
  /**
   * Those cells' share of the domain's expected sessions
   */
  pendingSessionShare: number | null;
};

export type RecoveryEstimatesJobDataDto = {
  /**
   * weekly = estimate --week-ending <weekEnding>; monthly = estimate-monthly --month <month>
   */
  mode: RecoveryEstimatesModeEnum;
  /**
   * Weekly runs: the store-local week-end date (YYYY-MM-DD) being finalized. Must be the last day of a reporting week (the day before calendar.week_start in the component config); the component refuses any other date.
   */
  weekEnding?: string;
  /**
   * Monthly runs: the calendar month (YYYY-MM) to finalize, after the weekly run that folds its last week.
   */
  month?: string;
};

export type RecoveryEstimatesJobDto = {
  id: number;
  name?: string;
  result: RecoveryEstimatesResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: RecoveryEstimatesJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<JobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type RecoveryEstimatesJobSummaryDto = {
  id: number;
  name?: string;
  result: RecoveryEstimatesResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: RecoveryEstimatesJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

/**
 * weekly = estimate --week-ending <weekEnding>; monthly = estimate-monthly --month <month>
 */
export enum RecoveryEstimatesModeEnum {
  WEEKLY = "weekly",
  MONTHLY = "monthly",
}

export type RecoveryEstimatesPersistedDto = {
  /**
   * recovery_estimate_runs.id — the join key for every persisted row of this fold
   */
  runId: number;
  /**
   * The data cutoff the rows were keyed on (from the CSV, else the dispatched period end)
   */
  runAsOf: string;
  /**
   * Rows written to recovery_estimates
   */
  estimateRows: number;
  /**
   * Rows written to recovery_period_totals (one per period and store, GLOBAL included)
   */
  periodTotalRows: number;
  /**
   * Rows written to recovery_kpis
   */
  kpiRows: number;
  /**
   * CSV rows not persisted because they could not be keyed or parsed (each is also a verification defect)
   */
  skippedRows: number;
  /**
   * store_id values that are not a site of the account — persisted with site_id NULL
   */
  unknownStores: Array<string>;
};

export type RecoveryEstimatesPreCheckRequestDto = {
  /**
   * weekly = estimate --week-ending <weekEnding>; monthly = estimate-monthly --month <month>
   */
  mode: RecoveryEstimatesModeEnum;
  /**
   * Weekly runs: the store-local week-end date (YYYY-MM-DD) being finalized. Must be the last day of a reporting week (the day before calendar.week_start in the component config); the component refuses any other date.
   */
  weekEnding?: string;
  /**
   * Monthly runs: the calendar month (YYYY-MM) to finalize, after the weekly run that folds its last week.
   */
  month?: string;
};

export type RecoveryEstimatesPreCheckResponseDto = {
  mode: RecoveryEstimatesModeEnum;
  /**
   * calendar.week_start from the component config (monday … sunday)
   */
  weekStart: string;
  weekEnding?: string;
  /**
   * Whether weekEnding is the last day of a reporting week
   */
  weekEndingValid?: boolean;
  /**
   * Nearest valid week-ending on or before weekEnding
   */
  previousWeekEnding?: string;
  /**
   * Nearest valid week-ending on or after weekEnding
   */
  nextWeekEnding?: string;
  /**
   * First store-local date of the week (weekEnding − 6 days)
   */
  weekFrom?: string;
  /**
   * What the reviews CSV would carry (valid weekly runs only)
   */
  reviews?: RecoveryEstimatesReviewsStatsDto;
  month?: string;
  weeksExpected?: Array<string>;
  weeksFolded?: Array<string>;
  weeksMissing?: Array<string>;
  /**
   * Whether an estimates_monthly_<month>.csv already exists (a re-run overwrites it)
   */
  monthAlreadyFolded?: boolean;
};

export type RecoveryEstimatesResultDto = {
  /**
   * Executions completed (0 or 1) — drives the jobs-list progress bar
   */
  done?: number;
  /**
   * Always 1: one Cloud Run execution per run
   */
  total?: number;
  /**
   * Verification defects found (0 when verification passed)
   */
  failures?: number;
  mode: RecoveryEstimatesModeEnum;
  weekEnding?: string;
  month?: string;
  /**
   * calendar.week_start from the component config (monday … sunday)
   */
  weekStart?: string;
  /**
   * Bucket-relative path of the reviews CSV handed to estimate --reviews-csv
   */
  reviewsCsvPath?: string;
  /**
   * Where recovered / recovered_value in the reviews CSV came from: postgres — the product recovered / failed to recover tags and the recovered sample’s total_price; none — a run that folded on verdicts alone
   */
  reviewsValuesSource?: "postgres" | "none";
  reviews?: RecoveryEstimatesReviewsStatsDto;
  /**
   * Monthly: week-ending dates whose weeks overlap the month
   */
  weeksExpected?: Array<string>;
  /**
   * Monthly: those weeks with an estimates CSV in the state dir (already folded)
   */
  weeksFolded?: Array<string>;
  /**
   * Monthly: expected weeks not yet folded when the run started
   */
  weeksMissing?: Array<string>;
  /**
   * Bucket-relative path of the estimates CSV the component wrote
   */
  estimatesCsvPath?: string;
  /**
   * Bucket-relative path of the run summary JSON
   */
  summaryPath?: string;
  /**
   * The run summary JSON as written by the component
   */
  summary?: {
    [key: string]: unknown;
  } | null;
  verification?: RecoveryEstimatesVerificationDto;
  /**
   * recovery_estimate_runs.id of the persisted fold
   */
  runId?: number;
  persisted?: RecoveryEstimatesPersistedDto;
};

/**
 * Where recovered / recovered_value in the reviews CSV came from: postgres — the product recovered / failed to recover tags and the recovered sample’s total_price; none — a run that folded on verdicts alone
 */
export enum reviewsValuesSource {
  POSTGRES = "postgres",
  NONE = "none",
}

export type RecoveryEstimatesReviewsStatsDto = {
  /**
   * Dispatched (sent-for-scoring) sessions whose store-local business date falls in the week
   */
  sessionsInWeek: number;
  /**
   * Sessions with at least one reviewed (verdict-tagged) alert — the sessions the CSV covers
   */
  reviewedSessions: number;
  /**
   * Alerts with a verdict — the rows written
   */
  reviewedAlerts: number;
  /**
   * Alerts tagged both confirmed-non-scan and system-mistake — excluded from the CSV
   */
  conflictingAlerts: number;
  /**
   * Non-scan alerts of those sessions with no verdict yet (non-response for the component)
   */
  unreviewedAlerts: number;
  /**
   * Non-scan alert rows without a group id — cannot be keyed for the component, excluded
   */
  alertsWithoutGroupId: number;
  /**
   * Sessions excluded because no timezone resolves for their site/account
   */
  sessionsSkippedNoTimezone: number;
  /**
   * Confirmed alerts tagged product recovered whose recovered sample resolved — written recovered=True with its total_price
   */
  recoveredAlerts: number;
  /**
   * Confirmed alerts tagged failed to recover — written recovered=False
   */
  failedAlerts: number;
  /**
   * Confirmed alerts with neither outcome tag — written recovered=False by decision (provisional), so this count is the downward bias on the recovery rate
   */
  noOutcomeAlerts: number;
  /**
   * Confirmed alerts tagged both product recovered and failed to recover — written recovered=False
   */
  conflictingOutcomes: number;
  /**
   * Alerts tagged product recovered whose referenced sample is not present or has no total_price — written recovered=False
   */
  unresolvedPairs: number;
};

export type RecoveryEstimatesScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: RecoveryEstimatesJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type RecoveryEstimatesScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: RecoveryEstimatesJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type RecoveryEstimatesScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: RecoveryEstimatesJobDataDto;
};

export type RecoveryEstimatesUpdateJobDto = {
  name?: string;
  description?: string;
};

export type RecoveryEstimatesUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: RecoveryEstimatesJobDataDto;
};

export type RecoveryEstimatesVerificationDto = {
  /**
   * True when no defect was found (warnings do not fail verification)
   */
  passed: boolean;
  rowCount: number;
  /**
   * Distinct store_id values, GLOBAL excluded
   */
  storeCount: number;
  /**
   * Distinct estimand values present
   */
  estimands: Array<string>;
  /**
   * Contract violations — a defect in the run, not a wide interval
   */
  defects: Array<string>;
  /**
   * Non-fatal observations (directional rows, partial totals, pending stores, …)
   */
  warnings: Array<string>;
  /**
   * The fleet rows — the headline numbers, one per (estimand, metric)
   */
  global: Array<RecoveryEstimatesGlobalRowDto>;
};

export type RefreshLossDto = {
  sampleIds: Array<string>;
};

export type RegionOfInterestDto = {
  /**
   * the x coordinate of the top-left corner of the region of interest
   */
  x1: number;
  /**
   * the y coordinate of the top-left corner of the region of interest
   */
  y1: number;
  /**
   * the x coordinate of the bottom-right corner of the region of interest
   */
  x2: number;
  /**
   * the y coordinate of the bottom-right corner of the region of interest
   */
  y2: number;
};

export type RegionRowDto = {
  subRegionId: number | null;
  subRegion: string | null;
  subRegionIsVisible: boolean | null;
  /**
   * Live sites assigned to this row.
   */
  siteCount: number;
  /**
   * Devices at those same sites -- the two counts describe one set, so a row cannot report devices it has no sites for. Reads 0 until ID-7058 backfills.
   */
  deviceCount: number;
  updatedAt: Date;
  regionId: number;
  region: string;
  regionIsVisible: boolean;
};

export enum RegionRowOrderEnum {
  REGION = "region",
  SUB_REGION = "subRegion",
  SITE_COUNT = "siteCount",
  DEVICE_COUNT = "deviceCount",
  UPDATED_AT = "updatedAt",
}

export type RegionRowOrderEnumSortOption = {
  field: RegionRowOrderEnum;
  dir?: "asc" | "desc";
};

export type RegionsUploadResponseDto = {
  /**
   * Whether this was a preview (nothing committed) or a real apply
   */
  dryRun: boolean;
  results: Array<RegionUploadRowDto>;
  totalNew: number;
  totalUnchanged: number;
  totalReactivated: number;
  totalErrors: number;
};

export type RegionUploadRowDto = {
  /**
   * 1-based row number in the uploaded file, excluding the header
   */
  row: number;
  region: string;
  subRegion?: string | null;
  status: "new" | "unchanged" | "reactivated" | "error";
  /**
   * Present when status is error
   */
  message?: string;
};

export enum status4 {
  NEW = "new",
  UNCHANGED = "unchanged",
  REACTIVATED = "reactivated",
  ERROR = "error",
}

export type RegisterDeviceDto = {
  host: string;
  localIp?: string;
};

export type RejectPendingReportDto = {
  jobId: number;
  note?: string;
};

export type RelatedAccountDto = {
  account: AccountSummaryDto;
};

export type ReportDto = {
  id: number;
  name: string;
  description?: string;
  url: string;
  createdAt: Date;
  user: ReportUserDto;
  isEnvReport: boolean;
  isEnabled: boolean;
  showCustomReportSubscription: boolean;
  filters?: {
    [key: string]: unknown;
  };
};

export enum ReportsCompanionChatOutcome {
  ANSWERED = "answered",
  REFUSED = "refused",
  ERROR = "error",
  ABORTED = "aborted",
  MAX_ITERATIONS = "max_iterations",
}

export type ReportSendLogAttentionItemDto = {
  subscriptionId: number;
  subscriptionName: string;
  since: Date;
  reason: string;
  isCustomReport: boolean;
};

export type ReportSendLogRecentItemDto = {
  jobId: number;
  subscriptionId: number;
  subscriptionName: string;
  sentAt: Date | null;
  state: string;
  approvalOutcome: string | null;
  approvedAt: Date | null;
  sendRecorded: boolean;
  approvedBy: string | null;
  audience: ReportSubscriptionAudienceDto;
  hasSentCopy: boolean;
  sentSubject: string | null;
  sentTo: Array<string> | null;
  failedRecipients: Array<FailedRecipientDto> | null;
  isCustomReport: boolean;
};

export type ReportSendLogResponseDto = {
  summary: SubscriptionSendHistorySummaryDto;
  needsAttention: Array<ReportSendLogAttentionItemDto>;
  upcoming: Array<ReportSendLogUpcomingItemDto>;
  recent: Array<ReportSendLogRecentItemDto>;
};

export type ReportSendLogUpcomingItemDto = {
  subscriptionId: number;
  subscriptionName: string;
  nextSend: Date;
  audience: ReportSubscriptionAudienceDto;
  requiresApproval: boolean;
  isCustomReport: boolean;
};

export enum ReportsOrderEnum {
  NAME = "name",
  CREATED_AT = "createdAt",
}

export type ReportsOrderEnumSortOption = {
  field: ReportsOrderEnum;
  dir?: "asc" | "desc";
};

export type ReportSubscriptionAudienceDto = {
  external: number;
  internal: number;
  externalEmails: Array<string>;
  internalEmails: Array<string>;
  approverEmails: Array<string>;
};

export type ReportSubscriptionDetailDto = {
  subscriptionId: number;
  jobId: number;
  subscriptionName: string;
  cron: string;
  timezone: string;
  lastSent: Date | null;
  nextSend: Date | null;
  isPending: boolean;
  generatedDate: Date | null;
  pendingSummaryText: string | null;
  createdAt: Date;
  reportName: string;
  accountName: string;
  audience: ReportSubscriptionAudienceDto;
  createdBy?: UserMinimalDto;
  data: EmailReportsJobDataDto;
};

export type ReportSubscriptionDto = {
  subscriptionId: number;
  subscriptionName: string;
  jobId: number;
  cron: string;
  data: EmailReportsJobDataDto;
  timezone: string;
  isPending: boolean;
  lastSent: Date;
  latestData?: {
    [key: string]: unknown;
  };
};

export type ReportSubscriptionSummaryDto = {
  subscriptionId: number;
  scheduledJobId: number;
  isCustomReport: boolean;
  isPending: boolean;
  subscriptionName: string;
  cron: string;
  timezone: string;
  lastSent: Date | null;
  nextSend: Date | null;
  audience: ReportSubscriptionAudienceDto;
  createdBy?: UserMinimalDto;
};

export type ReportUserDto = {
  id: number;
  firstName: string;
  lastName: string;
};

export type ResourceAlertsConfigDto = {
  /**
   * Threshold percentage for triggering an alert, 0 to disable
   */
  threshold_percentage: number;
  /**
   * Alert after this many seconds above the threshold
   */
  alert_after_seconds: number;
  /**
   * Resolve after this many seconds below the threshold
   */
  resolve_after_seconds: number;
};

export type RevertConfigDto = {
  configDeploymentId: number;
};

export type ROIPredictorDto = {
  /**
   * the x coordinate of the top-left corner of the region of interest
   */
  x1: number;
  /**
   * the y coordinate of the top-left corner of the region of interest
   */
  y1: number;
  /**
   * the x coordinate of the bottom-right corner of the region of interest
   */
  x2: number;
  /**
   * the y coordinate of the bottom-right corner of the region of interest
   */
  y2: number;
  /**
   * List of capture triggers that should disable ROI predictor cropping
   */
  disable_on_capture_triggers: Array<string>;
  enabled: boolean;
};

export enum Role {
  VIEWER = "Viewer",
  ANNOTATOR = "Annotator",
  TECH = "Tech",
  OWNER = "Owner",
  MLOPS = "MLOps",
  SITE_MANAGER = "SiteManager",
  ANNOTATOR_MANAGER = "AnnotatorManager",
  EDGIFY_CANDIDATE = "EdgifyCandidate",
  SUPER_ADMIN = "SuperAdmin",
}

export type RoleCreatePermissionDto = {
  allowedRoles: Array<string>;
};

export type SampleDto = {
  state:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  addedAt: Date;
  createdAt: Date;
  updatedAt: Date;
  device?: DeviceWithActivation;
  cluster?: MinimalEntityDto;
  site?: MinimalEntityDto;
  storageDevice?: PartialDevice;
  totalPrice?: Decimal2;
  price?: Decimal2;
  weight?: Decimal2;
  calculatedTotalPrice?: Decimal2;
  predictions?: Array<GroundTruthPredictionDto>;
  id: number;
  uuid: string;
  groupId: string;
  label: string;
  englishName?: string;
  editedLabel?: string;
  editedLabelEnglishName?: string;
  comment?: string;
  family: string;
  editedFamily?: string;
  category?: string;
  labelTrigger?: string;
  captureTrigger?: string;
  imgSource?: string;
  sessionId?: string;
  matchStrength?: string;
  storagePath?: string;
  tags?: Array<SampleTagDto>;
  taggedByName?: string;
  taggedById?: number;
  barcode?: string;
  count?: number;
  dataType?: string;
  data?: {
    [key: string]: unknown;
  };
  /**
   * true when the sample image had heads blurred on the device
   */
  headBlurred: boolean;
  /**
   * whether heads were found in the sample image, null when not evaluated
   */
  headsFound?: boolean;
  sessionVideoLink?: string;
  videoStartTime?: Date;
};

export enum SamplesOrderEnum {
  CREATED_AT = "createdAt",
  ADDED_AT = "addedAt",
  LABEL = "label",
  FAMILY = "family",
}

export type SamplesOrderEnumSortOption = {
  field: SamplesOrderEnum;
  dir?: "asc" | "desc";
};

export type SampleSummaryDto = {
  state:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  addedAt: Date;
  createdAt: Date;
  updatedAt: Date;
  device?: DeviceWithActivation;
  cluster?: MinimalEntityDto;
  site?: MinimalEntityDto;
  storageDevice?: PartialDevice;
  totalPrice?: Decimal2;
  price?: Decimal2;
  weight?: Decimal2;
  calculatedTotalPrice?: Decimal2;
  predictions?: Array<GroundTruthPredictionDto>;
  id: number;
  uuid: string;
  groupId: string;
  label: string;
  englishName?: string;
  editedLabel?: string;
  editedLabelEnglishName?: string;
  comment?: string;
  family: string;
  editedFamily?: string;
  category?: string;
  labelTrigger?: string;
  captureTrigger?: string;
  imgSource?: string;
  sessionId?: string;
  matchStrength?: string;
  storagePath?: string;
  tags?: Array<SampleTagDto>;
  taggedByName?: string;
  taggedById?: number;
  barcode?: string;
  count?: number;
  dataType?: string;
  data?: {
    [key: string]: unknown;
  };
  /**
   * true when the sample image had heads blurred on the device
   */
  headBlurred: boolean;
  /**
   * whether heads were found in the sample image, null when not evaluated
   */
  headsFound?: boolean;
};

export type SampleTagAssignDto = {
  name: string;
  id?: number;
  isNew?: boolean;
  referencedSampleUuid?: string;
};

export type SampleTagDto = {
  name: string;
  id: number;
  count?: number;
  referencedSampleUuid?: string;
  isLocked?: boolean;
};

export enum SampleTagOrderEnum {
  CREATED_AT = "createdAt",
  NAME = "name",
}

export type SampleTagOrderEnumSortOption = {
  field: SampleTagOrderEnum;
  dir?: "asc" | "desc";
};

export type SampleTagReferencedDto = {
  name: string;
  id: number;
  count?: number;
  referencedSampleUuid?: string;
  isLocked?: boolean;
  referenced?: Array<string>;
};

export type SampleTagSummaryDto = {
  name: string;
  id: number;
  createdAt: Date;
  isLocked?: boolean;
};

export type SampleUploadProgressDto = {
  /**
   * UUID, unique per run. Available on agent ^1.57.0 || ^2.33.0
   */
  id?: string;
  /**
   * Optional label; multiple runs can share a name. Available on agent ^1.57.0 || ^2.33.0
   */
  name?: string;
  /**
   * True if this is the most recent run for the given name. Available on agent ^1.57.0 || ^2.33.0
   */
  latest?: boolean;
  /**
   * ISO date string when upload started. Available on agent ^1.57.0 || ^2.33.0
   */
  startTime?: string;
  /**
   * ISO date string when upload ended; omitted if still running. Available on agent ^1.57.0 || ^2.33.0
   */
  endTime?: string;
  /**
   * Original request args passed to StartSamplesUpload. Available on agent ^1.57.0 || ^2.33.0
   */
  args?: StartSamplesUploadRequestDto;
  running: boolean;
  total: number;
  remaining: number;
  done: number;
  lastError?: {
    [key: string]: unknown;
  };
  error?: {
    [key: string]: unknown;
  };
  failures?: number;
  skipped?: number;
  progress?: MultipartProgressDto;
};

export type SampleWithImageDto = {
  state:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  addedAt: Date;
  createdAt: Date;
  updatedAt: Date;
  device?: DeviceWithActivation;
  cluster?: MinimalEntityDto;
  site?: MinimalEntityDto;
  storageDevice?: PartialDevice;
  totalPrice?: Decimal2;
  price?: Decimal2;
  weight?: Decimal2;
  calculatedTotalPrice?: Decimal2;
  predictions?: Array<GroundTruthPredictionDto>;
  id: number;
  uuid: string;
  groupId: string;
  label: string;
  englishName?: string;
  editedLabel?: string;
  editedLabelEnglishName?: string;
  comment?: string;
  family: string;
  editedFamily?: string;
  category?: string;
  labelTrigger?: string;
  captureTrigger?: string;
  imgSource?: string;
  sessionId?: string;
  matchStrength?: string;
  storagePath?: string;
  tags?: Array<SampleTagDto>;
  taggedByName?: string;
  taggedById?: number;
  barcode?: string;
  count?: number;
  dataType?: string;
  data?: {
    [key: string]: unknown;
  };
  /**
   * true when the sample image had heads blurred on the device
   */
  headBlurred: boolean;
  /**
   * whether heads were found in the sample image, null when not evaluated
   */
  headsFound?: boolean;
  image?: {
    data?: string;
    error?: ErrorDto;
  };
  sessionVideoLink?: string;
  videoStartTime?: Date;
};

export type SaveAlertEscalationDto = {
  scope: AlertEscalationScope;
  thresholdType: AlertEscalationThresholdType;
  priority: AlertPriority;
  thresholdValue: number;
  timeWindowSec: number;
  useOperationalHours: boolean;
  channelIds: Array<number>;
};

export type SaveSampleRequestDto = {
  weight?: Decimal2;
  price?: Decimal2;
  sampleId: string;
  label: string;
  labelTrigger: string;
  captureTrigger?: string;
  family: string;
  category: string;
  groupId: string;
  imgSource: string;
  image: string;
  deviceId: number;
  barcode?: string;
  name?: string;
};

export type SaveSampleResponseDto = {
  matchStrength: string;
};

export type ScheduleConfigDeploymentsDataWithNameDto = {
  name?: string;
  description?: string;
  cleanDeviceConfig: {
    [key: string]: unknown;
  };
  isPartial: boolean;
  originalDeviceId?: number;
  userId?: number;
  devicesQuery?: BulkDevicesQueryDto;
  sitesQuery?: BulkSitesQueryDto;
  clustersQuery?: BulkClustersQueryDto;
};

export type ScheduleConfigDeploymentsJobDataDto = {
  name?: string;
  description?: string;
  cleanDeviceConfig: {
    [key: string]: unknown;
  };
  isPartial: boolean;
  originalDeviceId?: number;
  userId?: number;
  devicesQuery?: BulkDevicesQueryDto;
  sitesQuery?: BulkSitesQueryDto;
  clustersQuery?: BulkClustersQueryDto;
};

export type ScheduleConfigDeploymentsJobDeviceDto = {
  participation: ScheduleConfigDeploymentsJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type ScheduleConfigDeploymentsJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: ScheduleConfigDeploymentsJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: DeployComponentsDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum ScheduleConfigDeploymentsJobDeviceStateDto {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type ScheduleConfigDeploymentsJobDto = {
  id: number;
  name?: string;
  result: DeployComponentsJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: ScheduleConfigDeploymentsJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<ScheduleConfigDeploymentsJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type ScheduleConfigDeploymentsJobSummaryDto = {
  id: number;
  name?: string;
  result: DeployComponentsJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: ScheduleConfigDeploymentsJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type ScheduleConfigDeploymentsScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: ScheduleConfigDeploymentsJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type ScheduleConfigDeploymentsScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: ScheduleConfigDeploymentsJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type ScheduleConfigDeploymentsScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: ScheduleConfigDeploymentsJobDataDto;
};

export type ScheduleConfigDeploymentsUpdateJobDto = {
  name?: string;
  description?: string;
};

export type ScheduleConfigDeploymentsUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: ScheduleConfigDeploymentsJobDataDto;
};

export enum ScheduledJobOrderEnum {
  CREATED_AT = "createdAt",
  NAME = "name",
}

export type ScheduledJobOrderEnumSortOption = {
  field: ScheduledJobOrderEnum;
  dir?: "asc" | "desc";
};

export type ScheduledTrainingDetailsDto = {
  /**
   * Weekdays the training runs on, or null when it is not weekday-restricted
   */
  recurringDays: Array<
    | "Monday"
    | "Tuesday"
    | "Wednesday"
    | "Thursday"
    | "Friday"
    | "Saturday"
    | "Sunday"
  > | null;
  clusters: Array<MinimalEntityDto>;
  server?: MinimalEntityDto;
  inputModel: MinimalEntityDto;
  /**
   * Null when the schedule defers to the account default.
   */
  clientImageUrl?: string | null;
  /**
   * Null when the schedule defers to the account default.
   */
  serverImageUrl?: string | null;
  /**
   * Empty when the schedule defers to the account default configuration.
   */
  config: string;
  id: number;
  name: string;
  description: string;
  scheduledFor: Date;
  recurring: number;
  autoDeploy: boolean;
  isVisible: boolean;
  isTrainingWindow?: boolean;
  windowEnd?: Date;
  windowStart?: Date;
};

export enum ScheduledTrainingOrderEnum {
  NAME = "name",
  CREATED_AT = "createdAt",
  STATE = "state",
  SCHEDULED_FOR = "scheduledFor",
}

export type ScheduledTrainingOrderEnumSortOption = {
  field: ScheduledTrainingOrderEnum;
  dir?: "asc" | "desc";
};

export type ScheduledTrainingSummaryDto = {
  status:
    | "starting"
    | "running"
    | "completed"
    | "failed"
    | "cancelled"
    | "suspended";
  clusters: Array<MinimalEntityDto>;
  /**
   * Weekdays the training runs on, or null when it is not weekday-restricted
   */
  recurringDays: Array<
    | "Monday"
    | "Tuesday"
    | "Wednesday"
    | "Thursday"
    | "Friday"
    | "Saturday"
    | "Sunday"
  > | null;
  id: number;
  name: string;
  reason: string;
  scheduledFor: Date;
  recurring: number;
};

export enum status5 {
  STARTING = "starting",
  RUNNING = "running",
  COMPLETED = "completed",
  FAILED = "failed",
  CANCELLED = "cancelled",
  SUSPENDED = "suspended",
}

export type ScheduleJobScheduleDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
};

export type ScheduleModelDeploymentsDataWithNameDto = {
  devicesQuery?: BulkDevicesQueryDto;
  sitesQuery?: BulkSitesQueryDto;
  clustersQuery?: BulkClustersQueryDto;
  /**
   * Whether a cluster whose architecture leaves its in-site collaborator out of a model deployment
   * should deploy to it anyway. That is hybrid only: centralized clusters run the model on the
   * collaborator and always target it, distributed clusters target every device.
   *
   * Absent means false, so a hybrid cluster deploys to its workers alone, as it does when a device
   * joins it. Devices named explicitly through `devicesQuery`, and site deployments, are unaffected.
   *
   * The choice is recorded on each cluster's ClusterModelDeployment row, so a device that joins the
   * cluster later is deployed to on the same rule - see @common/cluster-utils/cluster-model-targets.
   */
  includeCollaboratorDevices?: boolean;
  name?: string;
  description?: string;
  modelId: number;
  role?:
    | "predictor"
    | "nonScanDetector"
    | "objectDetector"
    | "similarityFilter";
};

export type ScheduleModelDeploymentsJobDataDto = {
  devicesQuery?: BulkDevicesQueryDto;
  sitesQuery?: BulkSitesQueryDto;
  clustersQuery?: BulkClustersQueryDto;
  /**
   * Whether a cluster whose architecture leaves its in-site collaborator out of a model deployment
   * should deploy to it anyway. That is hybrid only: centralized clusters run the model on the
   * collaborator and always target it, distributed clusters target every device.
   *
   * Absent means false, so a hybrid cluster deploys to its workers alone, as it does when a device
   * joins it. Devices named explicitly through `devicesQuery`, and site deployments, are unaffected.
   *
   * The choice is recorded on each cluster's ClusterModelDeployment row, so a device that joins the
   * cluster later is deployed to on the same rule - see @common/cluster-utils/cluster-model-targets.
   */
  includeCollaboratorDevices?: boolean;
  modelId: number;
  role?:
    | "predictor"
    | "nonScanDetector"
    | "objectDetector"
    | "similarityFilter";
};

export type ScheduleModelDeploymentsJobDeviceDto = {
  participation: ScheduleModelDeploymentsJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type ScheduleModelDeploymentsJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: ScheduleModelDeploymentsJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: DeployComponentsDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum ScheduleModelDeploymentsJobDeviceStateDto {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type ScheduleModelDeploymentsJobDto = {
  id: number;
  name?: string;
  result: DeployComponentsJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: ScheduleModelDeploymentsJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<ScheduleModelDeploymentsJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type ScheduleModelDeploymentsJobSummaryDto = {
  id: number;
  name?: string;
  result: DeployComponentsJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: ScheduleModelDeploymentsJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type ScheduleModelDeploymentsScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: ScheduleModelDeploymentsJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type ScheduleModelDeploymentsScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: ScheduleModelDeploymentsJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type ScheduleModelDeploymentsScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: ScheduleModelDeploymentsJobDataDto;
};

export type ScheduleModelDeploymentsUpdateJobDto = {
  name?: string;
  description?: string;
};

export type ScheduleModelDeploymentsUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: ScheduleModelDeploymentsJobDataDto;
};

export type SendPendingReportDto = {
  jobId: number;
};

export type SendPendingReportResponseDto = {
  failedRecipients: Array<string>;
  success: boolean;
  totalEmails: number;
  successfulSends: number;
  failedSends: number;
};

export type ServiceDeploymentDto = {
  state:
    | "pending"
    | "downloading"
    | "installing"
    | "error"
    | "cancelled"
    | "deployed"
    | "removed";
  serviceName: string;
  version: string;
  error?: string;
  createdAt: Date;
  updatedAt: Date;
  type?: string;
  runningStartTime?: Date;
  runningEndTime?: Date;
};

export type ServiceHealthCheckJobDataDto = {
  serviceName: string;
  endpoint: string;
  method?: "GET" | "POST";
  expectedStatus?: number;
  expectedBodyContains?: string;
  timeoutMs?: number;
};

export enum method {
  GET = "GET",
  POST = "POST",
}

export type ServiceHealthCheckJobResultDto = {
  check: ServiceHealthCheckTestResultDto;
  total: number;
  done: number;
  failures: number;
};

export type ServiceHealthChecksDataWithNameDto = {
  serviceName: string;
  endpoint: string;
  method?: "GET" | "POST";
  expectedStatus?: number;
  expectedBodyContains?: string;
  timeoutMs?: number;
  name?: string;
  description?: string;
};

export type ServiceHealthChecksJobDto = {
  id: number;
  name?: string;
  result: ServiceHealthCheckJobResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: ServiceHealthCheckJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<JobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type ServiceHealthChecksJobSummaryDto = {
  id: number;
  name?: string;
  result: ServiceHealthCheckJobResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: ServiceHealthCheckJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type ServiceHealthChecksScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: ServiceHealthCheckJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type ServiceHealthChecksScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: ServiceHealthCheckJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type ServiceHealthChecksScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: ServiceHealthCheckJobDataDto;
};

export type ServiceHealthChecksUpdateJobDto = {
  name?: string;
  description?: string;
};

export type ServiceHealthChecksUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: ServiceHealthCheckJobDataDto;
};

export type ServiceHealthCheckTestResultDto = {
  healthy: boolean;
  status: number | null;
  checkedAt: string;
  /**
   * Explains why the check was unhealthy
   */
  reason?: string;
  endpoint: string;
  method: string;
  responseHeaders?: {
    [key: string]: unknown;
  };
  responseBody?: {
    [key: string]: unknown;
  };
  error?: string;
};

export type ServiceResourceAlertsConfigDto = {
  memory_alerts: ResourceAlertsConfigDto;
  cpu_alerts: ResourceAlertsConfigDto;
};

export type ServiceVersionDto = {
  types?: Array<string>;
  version: string;
  isDeployed: boolean;
  isLatest: boolean;
  type?: string;
};

export type SessionDeviceDto = {
  name: string;
  id: number;
  cluster?: MinimalEntityDto;
  site?: MinimalEntityDto;
  tags?: Array<MinimalEntityDto>;
};

export type SessionDto = {
  nonScans: {
    [key: string]: TransactionGroupDto;
  };
  sessionVideoLink?: string;
  sessionVisualizationLink?: string;
  transactions: Array<TransactionDto>;
  id: number;
  sessionId: string;
  state?: string;
  sampleCount: number;
  nonScanCount: number;
  nonMatchCount: number;
  leftInCartCount: number;
  tags?: Array<SampleTagReferencedDto>;
  storagePath?: string;
  createdAt?: Date;
  startTime?: Date;
  endTime?: Date;
  calculatedStartTime?: Date;
  calculatedEndTime: Date;
  startCause: string;
  stopCause: string;
  size?: number;
  codec?: string;
  width?: number;
  height?: number;
  fps?: number;
  device?: SessionDeviceDto;
  cluster?: MinimalEntityDto;
  storageDevice?: DeviceWithStateDto;
  assistantId?: string;
  shopperId?: string;
  sessionTags: Array<Tag>;
  assigneeName?: string;
  assigneeId?: number;
  /**
   * true when the session video had heads blurred on the device
   */
  headBlurred: boolean;
  /**
   * The camera model the session was recorded on, as it was tagged at the time (ID-6991).
   */
  cameraType?: string;
  /**
   * Left-in-cart as it worked for the session - disabled, silent or active; absent when the agent did not say (ID-7293).
   */
  leftInCartMode?: string;
  referencedTags?: Array<SampleTagReferencedDto>;
};

export type SessionsAlertsSummaryDto = {
  /**
   * Number of active devices in the specified sites during the time period
   */
  devices: number;
  /**
   * Total number of alert events across all filtered sessions
   */
  totalAlerts: number;
  /**
   * Number of alert events that have not been tagged yet
   */
  pendingAlerts: number;
  /**
   * Number of alert events that have been tagged
   */
  reviewedAlerts: number;
};

export type SessionSummaryDto = {
  id: number;
  sessionId: string;
  state?: string;
  sampleCount: number;
  nonScanCount: number;
  nonMatchCount: number;
  leftInCartCount: number;
  tags: Array<SampleTagDto>;
  storagePath?: string;
  createdAt?: Date;
  startTime?: Date;
  endTime: Date;
  calculatedStartTime?: Date;
  calculatedEndTime: Date;
  startCause: string;
  stopCause: string;
  size?: number;
  codec?: string;
  width?: number;
  height?: number;
  fps?: number;
  device?: SessionDeviceDto;
  cluster?: MinimalEntityDto;
  storageDevice?: DeviceWithStateDto;
  assistantId?: string;
  shopperId?: string;
  sessionTags: Array<Tag>;
  assigneeName?: string;
  assigneeId?: number;
  /**
   * true when the session video had heads blurred on the device
   */
  headBlurred: boolean;
  /**
   * The camera model the session was recorded on, as it was tagged at the time (ID-6991).
   */
  cameraType?: string;
  /**
   * Left-in-cart as it worked for the session - disabled, silent or active; absent when the agent did not say (ID-7293).
   */
  leftInCartMode?: string;
};

export type SetConfigFileRequestDto = {
  field:
    | "Mqtt.tls.ca_cert"
    | "Mqtt.tls.client_cert"
    | "Mqtt.tls.client_key"
    | "DataManager.tls.ca_cert"
    | "Agent.tls.server_cert"
    | "Agent.tls.server_key";
  /**
   * File content; empty string deletes the file and clears the config field
   */
  content: string;
};

export enum field {
  MQTT_TLS_CA_CERT = "Mqtt.tls.ca_cert",
  MQTT_TLS_CLIENT_CERT = "Mqtt.tls.client_cert",
  MQTT_TLS_CLIENT_KEY = "Mqtt.tls.client_key",
  DATA_MANAGER_TLS_CA_CERT = "DataManager.tls.ca_cert",
  AGENT_TLS_SERVER_CERT = "Agent.tls.server_cert",
  AGENT_TLS_SERVER_KEY = "Agent.tls.server_key",
}

export type SetDeviceAlertsDto = {
  query: BulkDevicesQueryDto;
  allAlerts?: boolean;
  alerts?: Array<DeviceAlertStateDto>;
  suppressedUntil?: Date | null;
};

export type SetGroupSampleTagsDto = {
  sampleUuid?: string;
  groupId?: string;
  sessionId?: string;
  referencedSampleUuid?: string | null;
  tags: Array<SampleTagAssignDto>;
};

export type SetGroupSampleTagsResponseDto = {
  sampleIds: Array<number>;
  createdTags?: Array<SampleTagDto>;
  removedTags?: {
    [key: string]: unknown;
  };
};

export type SetSampleTagsDto = {
  taggedId: number;
  tags: Array<SampleTagAssignDto>;
};

export type site = {
  id: number;
  name: string;
};

export type SiteAgentDeploymentDto = {
  agentVersion: string;
  createdAt: Date;
  updatedAt: Date;
};

export type SiteDetailsDto = {
  devices: Array<ClusterDeviceDto>;
  regionId?: number | null;
  subRegionId?: number | null;
  operationalHours?: OperationalHoursResponseDto;
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  labelWithLeastSamples: string;
  totalSamples: number;
  totalLabels: number;
  activationTime?: Date;
  region?: string;
  subRegion?: string;
  latitude?: number;
  longitude?: number;
  formattedAddress?: string;
  lookupTableId?: number;
  lookupTableName?: string;
  siteGroupId?: number;
  siteGroupName?: string;
  tags: Array<Tag>;
};

export type SiteGroupDetailsDto = {
  id: number;
  name: string;
  sites: Array<MinimalEntityDto>;
  operationalHours?: OperationalHoursResponseDto;
  createdAt: Date;
  updatedAt: Date;
};

export type SiteGroupLabel = {
  siteGroupId: number;
  siteGroupName: string;
  labelInGroup: string;
};

export type SiteGroupLabelDto = {
  siteGroupId: number;
  siteGroupName: string;
  labelInGroup: string;
};

export type SiteGroupLabelsResponseDto = {
  results: Array<CatalogItemLabelDto>;
  total: number;
  page: number;
  limit: number;
};

export enum SiteGroupOrderEnum {
  NAME = "name",
  UPDATED_AT = "updatedAt",
}

export type SiteGroupOrderEnumSortOption = {
  field: SiteGroupOrderEnum;
  dir?: "asc" | "desc";
};

export type SiteGroupSummaryDto = {
  id: number;
  name: string;
  sitesCount: number;
  translatedLabelsCount: number;
  createdAt: Date;
  updatedAt: Date;
  hasOperationalHours: boolean;
};

export enum SiteOrderEnum {
  NAME = "name",
}

export type SiteOrderEnumSortOption = {
  field: SiteOrderEnum;
  dir?: "asc" | "desc";
};

export type SitePriceDto = {
  priceInSite?: string | number;
  siteId: number;
  id?: number;
};

export type SitesConfigDeploymentBulkDto = {
  deviceConfig: PartialDeviceConfigDto;
  query: BulkSitesQueryDto;
  schedule?: ScheduleJobScheduleDto;
  name?: string;
  description?: string;
  isPartial: boolean;
  originalDeviceId?: number;
  dontCleanDangerousConfigParams?: boolean;
};

export type SiteServiceDeploymentsDto = {
  serviceName: string;
  version: string;
  error?: string;
  createdAt: Date;
  updatedAt: Date;
  type?: string;
  runningStartTime?: Date;
  runningEndTime?: Date;
};

export type SitesModelDeploymentBulkDto = {
  modelId: number;
  query: BulkSitesQueryDto;
  role?:
    | "predictor"
    | "nonScanDetector"
    | "objectDetector"
    | "similarityFilter";
  schedule?: ScheduleJobScheduleDto;
};

export type SitesServiceVersionDeploymentBulkDto = {
  serviceName:
    | "edgify-non-scan-detector"
    | "edgify-worker"
    | "edgify-on-screen-app"
    | "edgify-zebra-adapter"
    | "edgify-agent"
    | "edgify-model";
  schedule?: ScheduleJobScheduleDto;
  query: BulkSitesQueryDto;
  version: string;
  type?: string;
};

export type SiteSummaryDto = {
  id: number;
  name: string;
  lastPing: Date;
  readyDevices: Array<MinimalEntityDto>;
  offlineDevices: Array<MinimalEntityDto>;
  activationTime?: Date;
  agentVersion?: string;
  tags: Array<Tag>;
  hasOperationalHours: boolean;
  siteGroup?: MinimalEntityDto;
};

export type SiteUploadPreviewRowDto = {
  name: string;
  region?: string;
  subRegion?: string;
  /**
   * Site group name; created if it does not exist yet
   */
  group?: string;
  activationTime?: Date;
  tags: Array<string>;
  status: "new" | "existing" | "error";
  /**
   * Error message when status is error
   */
  error?: string;
  /**
   * Non-blocking notices for this row, e.g. a region that will be created. Empty when there are none.
   */
  warnings: Array<string>;
};

export type SiteUploadResponseDto = {
  /**
   * Whether this response is from a dry run (preview) or an actual apply
   */
  dryRun: boolean;
  results: Array<SiteUploadPreviewRowDto>;
  totalNew: number;
  totalExisting: number;
  totalErrors: number;
  /**
   * Rows carrying at least one warning (rows, not warnings)
   */
  totalWarnings: number;
};

export type SkippedForDatasetsDto = {
  uuid: string;
  datasets: Array<string>;
};

export type StartHeadBlurImagesRequestDto = {
  query?: GetSamplesQueryRequestDto;
  /**
   * Optional job name; multiple runs may share a name. Omit → agent uses "default".
   */
  name?: string;
  /**
   * re-blur even if the sample is already marked headBlurred
   */
  force?: boolean;
};

export type StartHeadBlurVideosRequestDto = {
  query?: GetSessionsRequestDto;
  /**
   * Optional job name; multiple runs may share a name. Omit → agent uses "default".
   */
  name?: string;
  /**
   * re-blur even if the session is already marked headBlurred
   */
  force?: boolean;
};

export type StartRecordingResponseDto = {
  start_time: Date;
  end_time: Date;
  session_id: string;
  path: string;
  size: number;
  codec: string;
  width: number;
  height: number;
  fps: number;
};

export type StartSamplesUploadRequestDto = {
  query?: GetSamplesQueryRequestDto;
  name?: string;
  /**
   * Upload destination. Added ^1.57.0 || ^2.33.0
   */
  target?: "cluster" | "backend";
  /**
   * Delete sample after upload. Added ^1.57.0 || ^2.33.0
   */
  delete?: boolean;
  /**
   * Re-upload even if already uploaded. Added ^1.57.0 || ^2.33.0
   */
  force?: boolean;
  /**
   * Max upload speed override, 0 = infinite. Added ^1.57.0 || ^2.33.0
   */
  maxUploadSpeed?: number;
  /**
   * Request timeout override ms, 0 = infinite. Added ^1.57.0 || ^2.33.0
   */
  timeout?: number;
  /**
   * Upload only already-blurred samples - forces query.head_blurred=true. Added ^1.58.0 || ^2.34.0
   */
  onlyHeadBlurred?: boolean;
  /**
   * Blur a sample before uploading it when it is not blurred yet; a blur failure fails the sample. Added ^1.58.0 || ^2.34.0
   */
  waitForBlur?: boolean;
};

/**
 * Upload destination. Added ^1.57.0 || ^2.33.0
 */
export enum target {
  CLUSTER = "cluster",
  BACKEND = "backend",
}

export type StartUploadResponseDto = {
  id?: string;
  name?: string;
};

export type StartVideoUploadRequestDto = {
  target?: VideoUploadTargetEnum;
  query?: GetSessionsRequestDto;
  delete?: boolean;
  force?: boolean;
  timeout?: number;
  maxUploadSpeed?: number;
  name?: string;
  /**
   * Upload only already-blurred videos - forces query.head_blurred=true. Added ^1.58.0 || ^2.34.0
   */
  onlyHeadBlurred?: boolean;
  /**
   * Blur a session before uploading it when it is not blurred yet; a blur failure fails the session. Added ^1.58.0 || ^2.34.0
   */
  waitForBlur?: boolean;
};

export type StateInputFlexibleDto = {
  project: string;
  issueType: string;
  username?: string;
  password?: string;
  url?: string;
  alertChannelId?: number;
};

export type StaticDatasetDetailsDto = {
  uploadStatistics?: StaticDatasetUploadStatisticsDto;
  jobStatus?: DatasetJobStatusDto;
  samplesJobStatus?: DatasetJobStatusDto;
  fromSamplesJobStatus?: DatasetJobStatusDto;
  retryJobStatus?: DatasetJobStatusDto;
  fromSessionsJobStatus?: DatasetJobStatusDto;
  retrySessionsJobStatus?: DatasetJobStatusDto;
  jobHistory?: Array<DatasetJobHistoryEntryDto>;
  analyticsJobStatus?: DatasetJobStatusDto;
  deleteJobStatus?: DatasetJobStatusDto;
  id: number;
  uuid: string;
  name: string;
  description?: string;
  storagePath: string;
  createdAt: Date;
  updatedAt: Date;
  isVisible: boolean;
  samplesCount: number;
  sessionsCount: number;
  missingSamplesCount: number;
  missingSessionsCount: number;
  uploadResultUrl?: string;
  storageUrl?: string;
  samplesStorageUrl?: string;
};

export type StaticDatasetSummaryDto = {
  id: number;
  uuid: string;
  name: string;
  description?: string;
  storagePath: string;
  createdAt: Date;
  updatedAt: Date;
  isVisible: boolean;
  /**
   * Number of samples in this dataset
   */
  samplesCount: number;
  /**
   * Number of sessions in this dataset
   */
  sessionsCount: number;
  /**
   * Number of missing samples in this dataset
   */
  missingSamplesCount: number;
  /**
   * Number of missing sessions in this dataset
   */
  missingSessionsCount: number;
  /**
   * True when a delete job is in progress for this dataset
   */
  isDeleting: boolean;
  /**
   * True while any job for this dataset (import, add, retry, recalculate, delete) is pending, running or cancelling
   */
  hasActiveJob: boolean;
};

export type StaticDatasetUploadStatisticsDto = {
  addedSamplesInCsv?: number;
  sessionsInCsv?: number;
  samplesInCsv?: number;
  addedSamplesCreated?: number;
  samplesTotal?: number;
  samplesMissing?: number;
  sessionsTotal?: number;
  sessionsMissing?: number;
  errors?: Array<UploadErrorDto>;
};

export type StoppedScheduledDto = {
  unscheduledBullRepeatableKey?: boolean;
  unscheduledBullStopRepeatableKey?: boolean;
  unscheduledBullJob?: boolean;
  unscheduledBullStopJob?: boolean;
};

export type StopRecordingRequestDto = {
  report?: boolean;
};

export type StopRecordingResponseDto = {
  recording?: VideoFileDto;
  report?: VideoReportDto;
  error?: string;
};

export type StorageUriDto = {
  uri: string;
};

export type StreamingConfig = {
  /**
   * streaming method - udp - network / shm - shared memory, "" - empty will default to udp
   */
  type?: StreamingType;
  /**
   * streaming encoding "" | "raw" | "jpeg" | "h264" | "h265" - specifying this will attempt input stream reuse if no processing, otherwise encoding is required - "" - empty will auto select encoding based on streaming type and input video encoding - shm will prefer raw, udp will prefer no processing (ie using original encoded video), if processing is required (ie cropping) will prefer jpeg
   */
  encoding?: StreamingEncoding;
  /**
   * The receiver process host name
   */
  host: string;
  /**
   * The receiver process port
   */
  port: number;
  /**
   * path for shared memory file descriptor creation, alternative to network streaming
   */
  shm?: string;
  /**
   * streaming framerate, empty or 0 will retain same framerate as source
   */
  frame_rate?: string | number;
  /**
   * choose hardware acceleration, defaults to cpu
   */
  hardware?: VideoStreamHardwareEnum;
  /**
   * choose hardware acceleration for format conversion, defaults to cpu
   */
  convert_hardware?: VideoStreamHardwareEnum;
  /**
   * Streaming bitrate in bits/sec
   */
  bitrate?: number;
  enabled: boolean;
};

/**
 * streaming encoding "" | "raw" | "jpeg" | "h264" | "h265" - specifying this will attempt input stream reuse if no processing, otherwise encoding is required - "" - empty will auto select encoding based on streaming type and input video encoding - shm will prefer raw, udp will prefer no processing (ie using original encoded video), if processing is required (ie cropping) will prefer jpeg
 */
export enum StreamingEncoding {
  EMPTY_STRING = "",
  RAW = "raw",
  JPEG = "jpeg",
  H264 = "h264",
  H265 = "h265",
}

/**
 * streaming method - udp - network / shm - shared memory, "" - empty will default to udp
 */
export enum StreamingType {
  EMPTY_STRING = "",
  UDP = "udp",
  SHM = "shm",
  D3D11 = "d3d11",
  D3D12 = "d3d12",
  CUDA = "cuda",
}

export type SubRegionOptionDto = {
  /**
   * Parent region, so the UI can cascade one dropdown off the other.
   */
  regionId: number;
  name: string;
  id: number;
};

export type SubscriptionSendHistoryEntryDto = {
  jobId: number;
  sentAt: Date | null;
  state: string;
  audience: ReportSubscriptionAudienceDto;
  approvedBy: string | null;
  approvalOutcome: string | null;
  approvedAt: Date | null;
  sendRecorded: boolean;
  rejectedBy: string | null;
  rejectedAt: Date | null;
  rejectionNote: string | null;
  hasSentCopy: boolean;
  sentSubject: string | null;
  sentTo: Array<string> | null;
  failedRecipients: Array<FailedRecipientDto> | null;
};

export type SubscriptionSendHistoryResponseDto = {
  results: unknown[];
  count?: number;
  countIsEstimate?: boolean;
  lastPage?: number;
  perPage?: number;
  total: number;
  totalIsEstimate?: boolean;
  limit: number;
  page: number;
  summary: SubscriptionSendHistorySummaryDto;
};

export type SubscriptionSendHistorySummaryDto = {
  windowSize: number;
  sent: number;
  failed: number;
  rejected: number;
  lapsed: number;
  rate: number;
  recentStates: Array<RecentSendStateDto>;
  availableOutcomeBuckets: Array<
    | "rejected"
    | "failed"
    | "sent"
    | "waitingApproval"
    | "approvalExpired"
    | "notSent"
    | "inProgress"
  >;
};

export type SyncGroundTruthsDataWithNameDto = {
  deviceIds: Array<number>;
  name?: string;
  description?: string;
};

export type SyncGroundTruthsDeviceResultDto = {
  name?: string;
  startTime?: Date;
  updateTime?: Date;
  total?: number;
  created?: number;
  updated?: number;
  done?: number;
  failures?: number;
  markedEvicted?: number;
  invalid?: number;
  state?: SyncGroundTruthsDeviceStateEnum;
  failure?: ErrorDto;
};

export enum SyncGroundTruthsDeviceStateEnum {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type SyncGroundTruthsJobDataDto = {
  deviceIds: Array<number>;
};

export type SyncGroundTruthsJobDetailsDto = {
  devices: {
    [key: string]: SyncGroundTruthsDeviceResultDto;
  };
};

export type SyncGroundTruthsJobDeviceDto = {
  participation: SyncGroundTruthsJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type SyncGroundTruthsJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: SyncGroundTruthsJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: SyncGroundTruthsDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum SyncGroundTruthsJobDeviceStateDto {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type SyncGroundTruthsJobDto = {
  id: number;
  name?: string;
  result: SyncGroundTruthsJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: SyncGroundTruthsJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<SyncGroundTruthsJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type SyncGroundTruthsJobSummaryDto = {
  id: number;
  name?: string;
  result: SyncGroundTruthsJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data: SyncGroundTruthsJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type SyncGroundTruthsScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: SyncGroundTruthsJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type SyncGroundTruthsScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: SyncGroundTruthsJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type SyncGroundTruthsScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data: SyncGroundTruthsJobDataDto;
};

export type SyncGroundTruthsUpdateJobDto = {
  name?: string;
  description?: string;
};

export type SyncGroundTruthsUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: SyncGroundTruthsJobDataDto;
};

export type TableSettingsDto = {
  /**
   * Column ids currently shown. Never empty -- an empty list is "unset", not "hide everything".
   */
  visibleColumns?: Array<string>;
  /**
   * Every column id the layout knew about, in display order; a column missing here is new to the layout.
   */
  columnOrder?: Array<string>;
  sort?: Array<TableSortOptionDto>;
  pageSize?: number;
};

export type TableSettingsEntryDto = {
  /**
   * The table's `tableKey`, e.g. `data.sessions`.
   */
  key: string;
  /**
   * Written by the server (TABLE_SETTINGS_VERSION); entries of any other version are not returned.
   */
  version: number;
  value: TableSettingsDto;
};

export type TableSortOptionDto = {
  field: string;
  dir: "asc" | "desc";
};

export type Tag = {
  id?: number;
  name: string;
  isLocked?: boolean;
};

export type TagDetailsDto = {
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  isLocked?: boolean;
  usedCount?: number;
  updatedBy?: string;
};

export enum TagOrderEnum {
  CREATED_AT = "createdAt",
  NAME = "name",
}

export type TagOrderEnumSortOption = {
  field: TagOrderEnum;
  dir?: "asc" | "desc";
};

export type TagSummaryDto = {
  name: string;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  isLocked: boolean;
};

export type TestConnectionRequestDto = {
  url: string;
  username: string;
  password: string;
  tls?: TestConnectionTlsDto;
  /**
   * Target to test: "mqtt" or "cluster". Inferred from URL scheme when empty.
   */
  goal?: string;
  /**
   * Connect timeout in ms; uses default 10 s when 0
   */
  timeout_ms?: number;
};

export type TestConnectionTlsDto = {
  ca_cert:
    | string
    | {
        path: string;
        content: string;
      };
  client_cert:
    | string
    | {
        path: string;
        content: string;
      };
  client_key:
    | string
    | {
        path: string;
        content: string;
      };
  insecure_skip_verify: boolean;
  server_name: string;
  min_version: string;
};

export type TestCreateAlertDto = {
  alertChannelId: number;
  title: string;
  message: string;
  timestamp: string;
  handling: string;
  accountId: number;
  accountName: string;
  device?: string;
  env: string;
};

export type TestEmailDto = {
  mailingList: Array<string>;
  filters: string;
  reportName: string;
  reportId: number;
  addAttachments?: boolean;
  fileType?: string;
  selectedQuestions?: Array<MetabaseQuestion>;
  internalMailingList?: Array<string>;
  approvers?: Array<string>;
  customReportQuestions?: Array<MetabaseQuestion>;
  summaryTable?: MetabaseQuestion;
  summaryText?: string;
  isCustomReport?: boolean;
};

export type TestMetricAlertDto = {
  alertAction: "Alert" | "Resolve";
};

export type TestMetricAlertResponseDto = {
  value: number | null;
  breached: boolean;
};

export type TestPartialResolveNotificationDto = {
  alertChannelId: number;
  messageTs: string;
  timestamp: string;
  message: string;
  numAlerts: number;
  numResolves: number;
};

export type TestRecurrenceNotificationDto = {
  alertChannelId: number;
  messageTs: string;
  timestamp: string;
  message?: string;
  numAlerts: number;
  numResolves?: number;
};

export type TestResolveAlertDto = {
  alertChannelId: number;
  messageTs: string;
  timestamp: string;
  message?: string;
  numAlerts?: number;
  numResolves?: number;
};

export type TestServiceHealthCheckDto = {
  endpoint: string;
  method?: "GET" | "POST";
  expectedStatus?: number;
  expectedBodyContains?: string;
  timeoutMs?: number;
};

/**
 * Minimum TLS version
 */
export enum TlsMinVersionEnum {
  EMPTY_STRING = "",
  _1_0 = "1.0",
  _1_1 = "1.1",
  _1_2 = "1.2",
  _1_3 = "1.3",
}

export type TpuInferenceServerConfig = {
  /**
   * The server's port
   */
  port: number;
  /**
   * The server's host name
   */
  host: string;
  /**
   * The server's docker image.
   */
  image: string;
  /**
   * enable
   */
  enabled: boolean;
};

export type TrainingClusterParticipationDto = {
  state:
    | "starting"
    | "running"
    | "completed"
    | "failed"
    | "cancelled"
    | "aborted"
    | "suspended";
  collaborator: TrainingDeviceParticipationDto;
  workers: Array<TrainingDeviceParticipationDto>;
  clusterId: number;
  clusterName: string;
  reason: string;
};

export enum state9 {
  STARTING = "starting",
  RUNNING = "running",
  COMPLETED = "completed",
  FAILED = "failed",
  CANCELLED = "cancelled",
  ABORTED = "aborted",
  SUSPENDED = "suspended",
}

export type TrainingDefaultCandidatesDto = {
  accountDefault?: CandidateImagesDto;
  latestDeployed?: CandidateImagesDto;
  /**
   * Newest published tag, whether or not any device runs it. Absent if the registry could not be read.
   */
  latestRelease?: CandidateImagesDto;
};

export type TrainingDefaultsDto = {
  /**
   * Worker container image URL to prefill.
   */
  clientImageUrl?: string;
  /**
   * Collaborator container image URL to prefill.
   */
  serverImageUrl?: string;
  /**
   * The account's default configuration YAML. Absent means start empty, i.e. the classifier defaults.
   */
  config?: string;
  autoDeploy?: boolean;
  /**
   * Per-field origin of the value above: `accountDefault` when it comes from the stored account defaults, `latestRelease` when it came from the newest published image, `latestDeployed` when the registry could not be reached and the newest version this account has deployed was used instead, `none` when there is nothing to prefill.
   */
  sources: {
    [key: string]:
      | "accountDefault"
      | "latestRelease"
      | "latestDeployed"
      | "none";
  };
  /**
   * Every container version the user could switch this job to.
   */
  candidates: TrainingDefaultCandidatesDto;
  /**
   * Whether this account has stored training-job defaults.
   */
  isSet: boolean;
  updatedAt?: Date;
  updatedByName?: string;
};

export type TrainingDetailsDto = {
  state:
    | "starting"
    | "running"
    | "completed"
    | "failed"
    | "cancelled"
    | "suspended";
  clusters: Array<MinimalEntityDto>;
  server?: MinimalEntityDto;
  inputModel: MinimalEntityDto;
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  description: string;
  recurring: number;
  autoDeploy: boolean;
  clientImageUrl: string;
  serverImageUrl: string;
  config: string;
  isTrainingWindow?: boolean;
  windowEnd?: Date;
  windowStart?: Date;
};

export enum state10 {
  STARTING = "starting",
  RUNNING = "running",
  COMPLETED = "completed",
  FAILED = "failed",
  CANCELLED = "cancelled",
  SUSPENDED = "suspended",
}

export type TrainingDeviceParticipationDto = {
  state:
    | "setup"
    | "deploying"
    | "pending"
    | "running"
    | "completed"
    | "failed"
    | "aborted"
    | "cancelled"
    | "suspended";
  deviceId: number;
  deviceName: string;
  token: string;
  reason: string;
};

export enum state11 {
  SETUP = "setup",
  DEPLOYING = "deploying",
  PENDING = "pending",
  RUNNING = "running",
  COMPLETED = "completed",
  FAILED = "failed",
  ABORTED = "aborted",
  CANCELLED = "cancelled",
  SUSPENDED = "suspended",
}

export type TrainingExecutionDetailsDto = {
  state?:
    | "starting"
    | "running"
    | "completed"
    | "failed"
    | "cancelled"
    | "suspended";
  participatingClusters: Array<MinimalEntityDto>;
  resultModel: MinimalEntityDto;
  epochMetrics: Array<EpochDetailsDto>;
  id: number;
  name: string;
  description: string;
  reason: string;
  createdAt: Date;
  updatedAt: Date;
};

export type TrainingParticipationsDto = {
  server: TrainingDeviceParticipationDto;
  clusters: Array<TrainingClusterParticipationDto>;
};

export type TrainingSampleStatsDto = {
  epochMetrics?: Array<EpochMetricsMetricDto>;
  dataReport?: Array<DataReportMetricDto>;
  confusionMatrix?: Array<ConfusionMatrixMetricDto>;
  confidenceStats?: Array<ConfidenceStatsMetricDto>;
};

export enum TrainingState {
  STARTING = "starting",
  RUNNING = "running",
  COMPLETED = "completed",
  FAILED = "failed",
  CANCELLED = "cancelled",
  SUSPENDED = "suspended",
}

export enum TrainingSummariesOrderEnum {
  NAME = "name",
  CREATED_AT = "createdAt",
  STATE = "state",
}

export type TrainingSummariesOrderEnumSortOption = {
  field: TrainingSummariesOrderEnum;
  dir?: "asc" | "desc";
};

export type TrainingSummaryDto = {
  state:
    | "starting"
    | "running"
    | "completed"
    | "failed"
    | "cancelled"
    | "suspended";
  clusters: Array<MinimalEntityDto>;
  id: number;
  name: string;
  createdAt: Date;
  reason: string;
};

export type TransactionDto = {
  loss?: Decimal2;
  editedLoss?: Decimal2;
  prediction?: TransactionPredictionDto;
  groundTruth?: TransactionGroundTruthDto;
  id: number;
  uuid: string;
  groupId?: string;
  createdAt: Date;
  addedAt?: Date;
  predictedAt?: Date;
  capturedAt?: Date;
  transactionDuration?: number;
  isActive?: boolean;
  result?: string;
  certainty?: number;
  inModel?: boolean;
  modelGroup?: string;
  modelFamily?: string;
};

export type TransactionGroundTruthDto = {
  state:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  addedAt: Date;
  createdAt: Date;
  updatedAt: Date;
  device?: DeviceWithActivation;
  cluster?: MinimalEntityDto;
  site?: MinimalEntityDto;
  storageDevice?: PartialDevice;
  totalPrice?: Decimal2;
  price?: Decimal2;
  weight?: Decimal2;
  id: number;
  groupId: string;
  label: string;
  englishName?: string;
  editedLabel?: string;
  editedLabelEnglishName?: string;
  comment?: string;
  family: string;
  editedFamily?: string;
  category?: string;
  labelTrigger?: string;
  captureTrigger?: string;
  imgSource?: string;
  sessionId?: string;
  matchStrength?: string;
  storagePath?: string;
  tags?: Array<SampleTagDto>;
  taggedByName?: string;
  taggedById?: number;
  barcode?: string;
  count?: number;
  dataType?: string;
  data?: {
    [key: string]: unknown;
  };
  /**
   * true when the sample image had heads blurred on the device
   */
  headBlurred: boolean;
  /**
   * whether heads were found in the sample image, null when not evaluated
   */
  headsFound?: boolean;
};

export type TransactionGroupDto = {
  groupId: string;
  startTime?: Date;
  endTime?: Date;
  tags?: Array<SampleTagReferencedDto>;
  referencedTags?: Array<SampleTagReferencedDto>;
  transactions: Array<TransactionDto>;
};

export type TransactionPredictionDto = {
  predictions: Array<PredictionEntryDto>;
  device?: MinimalEntityDto;
  model?: MinimalEntityDto;
  id: number;
  createdAt: Date;
  predictedAt: Date;
  capturedAt: Date;
  updatedAt: Date;
  captureDuration?: number;
  captureTrigger: string;
  certain: boolean;
  family?: string;
  sessionId: string;
  interactionStartTime?: Date;
};

export enum TransactionResultEnum {
  TOP1_CORRECT = "Top1_Correct",
  TOP2_CORRECT = "Top2_Correct",
  TOP3_CORRECT = "Top3_Correct",
  TOP4_CORRECT = "Top4_Correct",
  TOP5_CORRECT = "Top5_Correct",
  UNKNOWN = "Unknown",
  OUT_OF_SCOPE = "Out_Of_Scope",
  NON_SCAN = "Non_Scan",
  MISTAKE = "Mistake",
}

export type UnassignGroupSampleTagsDto = {
  sampleUuid?: string;
  groupId?: string;
  sessionId?: string;
  all?: boolean;
  tagIds?: Array<number>;
};

export type UnassignGroupSampleTagsResponseDto = {
  sampleIds: Array<number>;
};

export type UnassignSampleTagsDto = {
  all?: boolean;
  sampleIds?: Array<number>;
  sampleUuids?: Array<string>;
  tagIds?: Array<number>;
};

export type UnassignSampleTagsResponseDto = {
  taggedIds: Array<number>;
  missingSampleIds?: Array<number>;
  missingSampleUuids?: Array<string>;
};

export type UnassignTagsDto = {
  all?: boolean;
  elementIds: Array<{
    [key: string]: unknown;
  }>;
  tags: Array<string>;
};

export type UnassignTagsResponseDto = {
  foundElementsIds: Array<{
    [key: string]: unknown;
  }>;
  missingElements: Array<{
    [key: string]: unknown;
  }>;
};

export type UpdateAccountAlertDto = {
  isEnabled: boolean;
};

export type UpdateAccountDto = {
  logoImage?: Blob | File;
  defaultClusterArchitecture?:
    | ("distributed" | "hybrid" | "centralized")
    | null;
  timezone?: string;
  /**
   * Months of history kept for the partitioned high-volume tables
   */
  retentionMonths?: number;
  /**
   * Device tags that name a camera model, most significant first. A session records the name of the first of these its device carries.
   */
  cameraTypeTagIds?: Array<number>;
  name?: string;
  companyName?: string;
  userId?: number;
  currency?: string;
  accountReportUrl?: string;
  showAccountReport?: boolean;
  showEnvReport?: boolean;
  status?: string;
  defaultClusterID?: number;
  enableSiteSpecificPricing?: boolean;
  autoSampleSessionsEnabled?: boolean;
  autoSampleSessionsPercentage?: number;
  nonScanDailyCapacityThreshold?: number;
};

export type UpdateAccountIsActiveBulkDto = {
  isActive: boolean;
  query: BulkAccountsQueryDto;
};

export type UpdateAlertChannelDto = {
  name?: string | null;
  authenticationInfo?: AuthenticationFieldsDto;
  configurationInfo?: {
    [key: string]: unknown;
  };
};

export type UpdateAlertDto = {
  priority?: AlertPriority;
  severity?: AlertSeverity;
  description?: string;
  handling?: string;
  alertInterval?: number;
  timeWindowSec?: number;
  occurrenceThreshold?: number;
  useOperationalHours?: boolean;
};

export type UpdateAlertSubscriptionsDto = {
  subscriptions: {
    [key: string]: boolean;
  };
};

export type UpdateCatalogItemDto = {
  priceBy?: "weight" | "quantity";
  price?: Decimal2;
  name?: string;
  englishName?: string;
  family?: string;
  outOfScope?: boolean;
  tags?: Array<Tag>;
  /**
   * Tags to add to the item. Unlike `tags`, which replaces the item's tags, every tag the item already has stays.
   * Send either `tags` or `assignTags`, not both.
   */
  assignTags?: Array<Tag>;
};

export type UpdateCatalogItemsOutOfScopeBulkDto = {
  outOfScope: boolean;
  query: BulkCatalogItemsQueryDto;
};

export type UpdateCatalogItemsTaggingBulkDto = {
  assignTags?: Array<Tag>;
  unAssignTags?: Array<Tag>;
  all?: boolean;
  query: BulkCatalogItemsQueryDto;
};

export type UpdateClusterDevicesBulkDto = {
  query: BulkDevicesQueryDto;
};

export type UpdateClusterDto = {
  architecture?: "distributed" | "hybrid" | "centralized";
  name?: string;
  serverDeviceId?: number;
  deviceIds?: Array<number>;
  isVisible?: boolean;
  activationTime?: Date;
  tags?: Array<Tag>;
};

export type UpdateClustersTaggingBulkDto = {
  assignTags?: Array<Tag>;
  unAssignTags?: Array<Tag>;
  all?: boolean;
  query: BulkClustersQueryDto;
};

export type UpdateDatasetDto = {
  name?: string;
  deviceIds?: Array<number>;
  isVisible?: boolean;
};

export type UpdatedCatalogItemDto = {
  priceBy?: "weight" | "quantity";
  price?: string | number;
  siteGroupLabels?: Array<SiteGroupLabel>;
  id?: number;
  plu?: string;
  name?: string;
  englishName?: string;
  family?: string;
  outOfScope?: boolean;
  tags: Array<Tag>;
  createdAt?: Date;
  updatedAt?: Date;
  updatedBy?: string;
  repImgUrl?: string;
};

export type UpdateDeviceDto = {
  state?: "deploying" | "ready" | "disconnected" | "disabled" | "down";
  name?: string;
  description?: string;
  activationTime?: Date;
  agentVersion?: string;
  configLocked?: boolean;
  tags?: Array<Tag>;
};

export type UpdateDevicesActivationTimeDto = {
  activationTime: Date;
  query: BulkDevicesQueryDto;
};

export type UpdateDevicesTagsDto = {
  tags?: Array<Tag>;
  query: BulkDevicesQueryDto;
};

export type UpdateDeviceTaggingsBulkDto = {
  assignTags?: Array<Tag>;
  unAssignTags?: Array<Tag>;
  all?: boolean;
  query: BulkDevicesQueryDto;
};

export type UpdateDomainAuthSettingDto = {
  defaultAccountId?: number;
  company?: string;
  params?: UpdateOidcParamsDto;
};

export type UpdateGroupSampleTagsDto = {
  sampleUuid?: string;
  groupId?: string;
  sessionId?: string;
  referencedSampleUuid?: string | null;
  assign?: Array<SampleTagAssignDto>;
  unassign?: Array<number>;
};

export type UpdateLookupTableDto = {
  file?: Blob | File;
  name?: string;
  siteIds?: Array<number>;
};

export type UpdateManagedAlertStatusBulkDto = {
  alertAction: BulkAlertAction;
  query: BulkManagedAlertsQueryDto;
};

export type UpdateManagedAlertStatusDto = {
  alertAction: AlertAction;
};

export type UpdateMetricAlertDto = {
  priority?: AlertPriority;
  severity?: AlertSeverity;
  channelIds?: Array<number>;
  name?: string;
  reportId?: number;
  questionId?: number;
  dashcardId?: number;
  questionName?: string;
  filterScope?: string;
  operator?: "BelowThreshold" | "AboveThreshold";
  thresholdValue?: number;
  schedule?: string;
  timezone?: string;
};

export type UpdateModelDto = {
  name?: string;
  description?: string;
  isVisible?: boolean;
};

export type UpdateNotificationDto = {
  /**
   * Short title shown in the banner header
   */
  title?: string;
  /**
   * Full body text of the notification banner
   */
  message?: string;
  /**
   * Category of the notification (affects banner color and icon)
   */
  type?:
    | "ScheduledMaintenance"
    | "IncidentOutage"
    | "IssueResolved"
    | "GeneralInformation";
  /**
   * Lifecycle state of the notification
   */
  status?: "Draft" | "Scheduled" | "Active" | "Archived" | "Canceled";
  /**
   * When the event starts (e.g. start of maintenance window)
   */
  startsAt?: Date;
  /**
   * When the event ends. The banner is automatically archived after this time.
   */
  endsAt?: Date;
  /**
   * How many hours before startsAt to make the notification active. 0 means activate exactly at startsAt.
   */
  notifyBeforeHours?: number;
  /**
   * Account IDs that should see this banner. Pass an empty array to make it global.
   */
  targetAccountIds?: Array<number>;
};

export type UpdateOidcParamsDto = {
  authorizationEndpoint?: string;
  tokenEndpoint?: string;
  userInfoEndpoint?: string;
  clientId?: string;
  clientSecret?: string;
  scope?: string;
  issuer?: string;
};

export type UpdateRegionDto = {
  name?: string;
  /**
   * Set true to reactivate an inactivated region. Inactivate through PATCH /regions/inactivateBulk.
   */
  isVisible?: boolean;
};

export type UpdateReportConfigDto = {
  filters?: {
    [key: string]: unknown;
  };
};

export type UpdateReportDto = {
  name?: string;
  description?: string;
  isEnabled?: boolean;
  showCustomReportSubscription?: boolean;
};

export type UpdateReportUrlDto = {
  url: string;
};

export type UpdateSampleDto = {
  editedLabel?: string | null;
  editedFamily?: string | null;
  tags?: Array<Tag>;
};

export type UpdateSampleLossDto = {
  editedLoss?: (string | number) | null;
};

export type UpdateSampleMetadataDto = {
  comment?: string | null;
};

export type UpdateSamplesBulkDto = {
  params: UpdateSamplesBulkParamsDto;
  query: BulkSamplesQueryDto;
};

export type UpdateSamplesBulkParamsDto = {
  editedLabel?: string | null;
  editedFamily?: string | null;
  valueToUpdate: "label" | "family";
  tags?: Array<Tag>;
};

export enum valueToUpdate {
  LABEL = "label",
  FAMILY = "family",
}

export type UpdateSamplesMetadataBulkBodyDto = {
  query: BulkSamplesQueryDto;
  params: UpdateSampleMetadataDto;
};

export type UpdateSamplesTaggingBulkDto = {
  assignTags?: Array<Tag>;
  unAssignTags?: Array<Tag>;
  all?: boolean;
  query: BulkSamplesQueryDto;
};

export type UpdateScheduledTrainingDto = {
  /**
   * Omit to use the account default, then false.
   */
  autoDeploy?: boolean;
  /**
   * Worker container image URL. Omit to use the account's default training-job settings, else the newest edgify-worker version this account has deployed -- resolved when the training is created rather than snapshotted here, so a schedule follows the fleet instead of freezing a version.
   */
  clientImageUrl?: string;
  /**
   * Collaborator container image URL. Same defaulting as `clientImageUrl`.
   */
  serverImageUrl?: string;
  /**
   * Training configuration YAML. Omit to use the account's default configuration, or send an empty string to run with the worker's built-in classifier defaults.
   */
  config?: string;
  /**
   * Weekdays the training runs on, evaluated in the account timezone. Null (or omitted) means no weekday restriction: the recurrence simply repeats every `recurring` days. A list must name between 1 and 7 days -- an empty list is rejected rather than silently read as unrestricted, since `null` is the one spelling of that.
   */
  recurringDays?: Array<
    | "Monday"
    | "Tuesday"
    | "Wednesday"
    | "Thursday"
    | "Friday"
    | "Saturday"
    | "Sunday"
  > | null;
  name?: string;
  description?: string;
  clusterIds?: Array<number>;
  serverDeviceId?: number;
  inputModelId?: number;
  isTrainingWindow?: boolean;
  windowEnd?: Date;
  windowStart?: Date;
  recurring?: number;
  scheduledFor?: Date;
};

export type UpdateSessionsAssigneeBulkDto = {
  query: BulkSessionsQueryDto;
  assigneeId: number | null;
};

export type UpdateSessionsTaggingBulkDto = {
  query: BulkSessionsQueryDto;
  assignTags?: Array<Tag>;
  unAssignTags?: Array<Tag>;
  all?: boolean;
};

export type UpdateSiteDevicesBulkDto = {
  query: BulkDevicesQueryDto;
};

export type UpdateSiteDto = {
  /**
   * Region id from the regions tables. null clears the region and its sub-region.
   */
  regionId?: number | null;
  /**
   * Sub-region id from the regions tables; sets its region as well. null clears only the sub-region.
   */
  subRegionId?: number | null;
  isVisible?: boolean;
  activationTime?: Date;
  latitude?: number;
  longitude?: number;
  tags?: Array<Tag>;
  name?: string;
  deviceIds?: Array<number>;
};

export type UpdateSiteGroupDto = {
  name?: string;
  siteIds?: Array<number>;
};

export type UpdateSiteGroupSitesBulkDto = {
  query: BulkSitesQueryDto;
};

export type UpdateSitesActivationTimeDto = {
  activationTime: Date;
  query: BulkSitesQueryDto;
};

export type UpdateSitesGroupBulkDto = {
  query: BulkSitesQueryDto;
  groupId: number;
};

export type UpdateSitesRegionsDto = {
  /**
   * Region id from the regions tables. null clears the region and its sub-region.
   */
  regionId?: number | null;
  /**
   * Sub-region id from the regions tables; sets its region as well. null clears only the sub-region.
   */
  subRegionId?: number | null;
  query: BulkSitesQueryDto;
};

export type UpdateSitesTaggingsBulkDto = {
  assignTags?: Array<Tag>;
  unAssignTags?: Array<Tag>;
  all?: boolean;
  query: BulkSitesQueryDto;
};

export type UpdateStateDto = {
  state:
    | "failed"
    | "deploying"
    | "pending"
    | "cancelled"
    | "running"
    | "completed"
    | "suspended"
    | "aborted"
    | "setup";
  deviceId: number;
  role: "server" | "worker" | "collaborator" | "mediator";
  errorMsg?: string;
};

export enum role5 {
  SERVER = "server",
  WORKER = "worker",
  COLLABORATOR = "collaborator",
  MEDIATOR = "mediator",
}

export type UpdateSubRegionDto = {
  name?: string;
  /**
   * Set true to reactivate an inactivated sub-region. Inactivate through PATCH /regions/inactivateBulk.
   */
  isVisible?: boolean;
};

export type UpdateSummaryTextDto = {
  subscriptionId: number;
  summaryText: string;
};

export type UpdateTableSettingsDto = {
  /**
   * Column ids to show. null or [] clears the stored choice (the table falls back to its defaults).
   */
  visibleColumns?: Array<string> | null;
  /**
   * Every known column id in display order -- also the list a later-added column is checked against. null or [] clears the stored order.
   */
  columnOrder?: Array<string> | null;
  /**
   * null or [] clears the stored sort.
   */
  sort?: Array<TableSortOptionDto> | null;
  /**
   * null clears the stored page size.
   */
  pageSize?: number | null;
};

export type UpdateTagDto = {
  name?: string;
  isLocked?: boolean;
};

export type UpdateTrainingDefaultsDto = {
  /**
   * Worker container image URL.
   */
  clientImageUrl?: string | null;
  /**
   * Collaborator container image URL.
   */
  serverImageUrl?: string | null;
  /**
   * Default training configuration YAML. Unset means new jobs start with an empty configuration.
   */
  config?: string | null;
  autoDeploy?: boolean | null;
};

export type UpdateTrainingDto = {
  /**
   * Omit to use the account default, then false.
   */
  autoDeploy?: boolean;
  /**
   * Worker container image URL. Omit to use the account's default training-job settings, else the newest edgify-worker version this account has deployed -- resolved when the training is created rather than snapshotted here, so a schedule follows the fleet instead of freezing a version.
   */
  clientImageUrl?: string;
  /**
   * Collaborator container image URL. Same defaulting as `clientImageUrl`.
   */
  serverImageUrl?: string;
  /**
   * Training configuration YAML. Omit to use the account's default configuration, or send an empty string to run with the worker's built-in classifier defaults.
   */
  config?: string;
  name?: string;
  description?: string;
  clusterIds?: Array<number>;
  serverDeviceId?: number;
  inputModelId?: number;
  isTrainingWindow?: boolean;
  windowEnd?: Date;
  windowStart?: Date;
  isVisible?: boolean;
};

export type UpdateUserDto = {
  firstName?: string;
  lastName?: string;
  defaultAccount?: number;
  profileImg?: Blob | File;
  lastConnected?: Date;
};

export type UploadCancellationResultDto = {
  cancelledBeforeStart: number;
  alreadyStarted: number;
  notOwnedOrNotCancellable: number;
};

export type UploadClustersFileDto = {
  file: Blob | File;
  /**
   * If true, validate and return preview without applying changes
   */
  dryRun: boolean;
};

export type UploadDevicesFileDto = {
  file: Blob | File;
  /**
   * If true, validate and return preview without applying changes
   */
  dryRun: boolean;
};

export type UploadedSampleDto = {
  uuid: string;
  sampleId: string;
  group_id?: string;
  groupId?: string;
  label?: string;
  ux_source?: string;
  uxSource?: string;
  labelTrigger?: string;
  capture_trigger?: string;
  captureTrigger?: string;
  added_at?: Date;
  addedAt?: Date;
  predicted_at?: Date;
  predictedAt?: Date;
  family?: string;
  img_source?: string;
  imgSource?: string;
  category?: string;
  session_id?: string;
  sessionId?: string;
  match_strength?: string;
  matchStrength?: string;
  barcode?: string;
  price?: string;
  weight?: string;
  count?: number;
  total_price?: string;
  totalPrice?: string;
  name?: string;
  device_id?: number;
  deviceId?: number;
  captured_at?: Date;
  capturedAt?: Date;
  data_type?: string;
  dataType?: string;
  head_blurred?: boolean;
  headBlurred?: boolean;
  heads_found?: boolean;
  headsFound?: boolean;
};

export type UploadedVideoDto = {
  start_time?: Date;
  startTime?: Date;
  end_time?: Date;
  endTime?: Date;
  size?: number;
  width?: number;
  height?: number;
  fps?: number;
  deviceId?: number;
  bitrate?: number;
  visualizationSize?: number;
  artifactsSize?: number;
  headDetectionsSize?: number;
  nonScanModelId?: number;
  predictorModelId?: number;
  file: string;
  visualization?: string;
  artifacts?: string;
  headDetections?: string;
  session_id?: string;
  sessionId?: string;
  path?: string;
  codec?: string;
  startCause?: string;
  stopCause?: string;
  metadata?: {
    [key: string]: unknown;
  };
  nonScanPrecisionLevel?: string;
  agentAlertMode?: string;
  clientAppMode?: string;
  head_blurred?: boolean;
  headBlurred?: boolean;
};

export type UploadErrorDto = {
  uuid: string;
  message: string;
};

export type UploadFileDto = {
  file: Blob | File;
  /**
   * Site ID(s) for site-specific catalog upload
   */
  siteIds?: Array<number>;
  /**
   * Group ID(s) for group-specific catalog upload (applies to all sites in each group)
   */
  groupIds?: Array<number>;
  /**
   * Upload mode for site-group uploads: "full" replaces all label translations in the group, "partial" adds/updates only the labels in the file
   */
  uploadMode?: "full" | "partial";
  schedule?: ScheduleJobScheduleDto;
  /**
   * Custom job name. Overrides the auto-generated name.
   */
  name?: string;
  /**
   * Whether to apply the upload immediately
   */
  immediateApply?: boolean;
};

export type UploadModelDto = {
  description?: string;
  name: string;
  file: Blob | File;
};

export type UploadOperationCancellationResultDto = {
  operationId: number;
  cancelledBeforeStart: number;
  alreadyStarted: number;
  notOwnedOrNotCancellable: number;
};

export type UploadOperationCreatedDto = {
  operationId: number;
};

export enum UploadOperationOrderEnum {
  CREATED_AT = "createdAt",
}

export type UploadOperationOrderEnumSortOption = {
  field: UploadOperationOrderEnum;
  dir?: "asc" | "desc";
};

export type UploadRegionsFileDto = {
  file: Blob | File;
  /**
   * If true, validate and return a preview without applying anything
   */
  dryRun: boolean;
};

export type UploadSamplesBulkQueryDto = {
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  deviceIds?: Array<number>;
  storageDeviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  siteGroupIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  timeField?: "createdAt" | "addedAt";
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  modelIds?: Array<number>;
  result?: Array<TransactionResultEnum>;
  labels?: Array<string>;
  predictions?: Array<string>;
  families?: Array<string>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  taggedByIds?: Array<number>;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  dataType?: Array<string>;
  datasetId?: number;
  /**
   * delete the sample off the device once uploaded to storage
   */
  deleteAfterUpload?: boolean;
  fromDate?: Date;
  toDate?: Date;
  onlyWithPrediction?: boolean;
  showNonScans?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  family?: string;
  fuzzy?: boolean;
  matchStrength?: string;
  sessionId?: Array<string>;
  showOnlyWithImages?: boolean;
};

export type UploadSamplesDataWithNameDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  architecture?: Array<"distributed" | "hybrid" | "centralized">;
  query?: GetSamplesQueryRequestDto;
  target?: VideoUploadTargetEnum;
  targetEdge?: VideoUploadTargetEnum;
  targetCluster?: VideoUploadTargetEnum;
  maxUploadSpeed?: number;
  legacyUpload?: LegacyUploadModeEnum;
  pageSize?: number;
  name?: string;
  description?: string;
  delete?: boolean;
  deleteEdge?: boolean;
  deleteCluster?: boolean;
  force?: boolean;
  forceEdge?: boolean;
  forceCluster?: boolean;
  timeout?: number;
  /**
   * Upload only already-blurred samples - forces query.head_blurred=true on the agent. Requires ^1.58.0 || ^2.34.0
   */
  onlyHeadBlurred?: boolean;
  /**
   * Blur a sample before uploading it when it is not blurred yet; a blur failure fails the sample. Requires ^1.58.0 || ^2.34.0
   */
  waitForBlur?: boolean;
};

export type UploadSamplesDeviceResultDto = {
  lastStart?: Date;
  lastProgress?: Date;
  legacyMode?: "agent" | "backend";
  failure?: ErrorDto;
  retries?: number;
  wasRunning?: boolean;
  remaining?: number;
  failures?: number;
  done?: number;
  skipped?: number;
  total?: number;
  _meta?: SampleUploadProgressDto;
};

export enum legacyMode {
  AGENT = "agent",
  BACKEND = "backend",
}

export type UploadSamplesJobDataDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  architecture?: Array<"distributed" | "hybrid" | "centralized">;
  query?: GetSamplesQueryRequestDto;
  target?: VideoUploadTargetEnum;
  targetEdge?: VideoUploadTargetEnum;
  targetCluster?: VideoUploadTargetEnum;
  maxUploadSpeed?: number;
  legacyUpload?: LegacyUploadModeEnum;
  pageSize?: number;
  delete?: boolean;
  deleteEdge?: boolean;
  deleteCluster?: boolean;
  force?: boolean;
  forceEdge?: boolean;
  forceCluster?: boolean;
  timeout?: number;
  /**
   * Upload only already-blurred samples - forces query.head_blurred=true on the agent. Requires ^1.58.0 || ^2.34.0
   */
  onlyHeadBlurred?: boolean;
  /**
   * Blur a sample before uploading it when it is not blurred yet; a blur failure fails the sample. Requires ^1.58.0 || ^2.34.0
   */
  waitForBlur?: boolean;
};

export type UploadSamplesJobDetailsDto = {
  total?: number;
  done?: number;
  remaining?: number;
  legacyDevices?: {
    [key: string]: Array<number>;
  };
};

export type UploadSamplesJobDeviceDto = {
  participation: UploadSamplesJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type UploadSamplesJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: UploadSamplesJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: UploadSamplesDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum UploadSamplesJobDeviceStateDto {
  PENDING = "pending",
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
  CANCELLED = "cancelled",
  ABORTED = "aborted",
  STOPPED = "stopped",
}

export type UploadSamplesJobDto = {
  id: number;
  name?: string;
  result: UploadSamplesJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: UploadSamplesJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<UploadSamplesJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type UploadSamplesJobSummaryDto = {
  id: number;
  name?: string;
  result: UploadSamplesJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: UploadSamplesJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type UploadSamplesScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: UploadSamplesJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type UploadSamplesScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: UploadSamplesJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type UploadSamplesScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: UploadSamplesJobDataDto;
};

export type UploadSamplesUpdateJobDto = {
  name?: string;
  description?: string;
};

export type UploadSamplesUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: UploadSamplesJobDataDto;
};

export type UploadSitesFileDto = {
  file: Blob | File;
  /**
   * If true, validate and return preview without applying changes
   */
  dryRun: boolean;
};

export type UploadStaticDatasetDto = {
  file: Blob | File;
  /**
   * Dataset name
   */
  name: string;
  /**
   * Dataset description
   */
  description?: string;
};

export type UploadVideosDataWithNameDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  architecture?: Array<"distributed" | "hybrid" | "centralized">;
  query?: GetSessionsRequestDto;
  target?: VideoUploadTargetEnum;
  targetEdge?: VideoUploadTargetEnum;
  targetCluster?: VideoUploadTargetEnum;
  devicesRole?: DeviceRoleEnum;
  maxUploadSpeed?: number;
  name?: string;
  description?: string;
  delete?: boolean;
  deleteEdge?: boolean;
  deleteCluster?: boolean;
  force?: boolean;
  forceEdge?: boolean;
  forceCluster?: boolean;
  timeout?: number;
  /**
   * Upload only already-blurred videos - forces query.head_blurred=true on the agent. Requires ^1.58.0 || ^2.34.0
   */
  onlyHeadBlurred?: boolean;
  /**
   * Blur a session before uploading it when it is not blurred yet; a blur failure fails the session. Requires ^1.58.0 || ^2.34.0
   */
  waitForBlur?: boolean;
};

export type UploadVideosDeviceResultDto = {
  lastStart?: Date;
  lastProgress?: Date;
  failure?: ErrorDto;
  retries?: number;
  wasRunning?: boolean;
  remaining?: number;
  _meta?: VideoUploadProgressDto;
};

export type UploadVideosJobDataDto = {
  deviceIds?: Array<number>;
  clusterIds?: Array<number>;
  siteIds?: Array<number>;
  architecture?: Array<"distributed" | "hybrid" | "centralized">;
  query?: GetSessionsRequestDto;
  target?: VideoUploadTargetEnum;
  targetEdge?: VideoUploadTargetEnum;
  targetCluster?: VideoUploadTargetEnum;
  devicesRole?: DeviceRoleEnum;
  maxUploadSpeed?: number;
  delete?: boolean;
  deleteEdge?: boolean;
  deleteCluster?: boolean;
  force?: boolean;
  forceEdge?: boolean;
  forceCluster?: boolean;
  timeout?: number;
  /**
   * Upload only already-blurred videos - forces query.head_blurred=true on the agent. Requires ^1.58.0 || ^2.34.0
   */
  onlyHeadBlurred?: boolean;
  /**
   * Blur a session before uploading it when it is not blurred yet; a blur failure fails the session. Requires ^1.58.0 || ^2.34.0
   */
  waitForBlur?: boolean;
};

export type UploadVideosJobDeviceDto = {
  participation: UploadVideosJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type UploadVideosJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: UploadVideosJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: UploadVideosDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum UploadVideosJobDeviceStateDto {
  PENDING = "pending",
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
  CANCELLED = "cancelled",
  ABORTED = "aborted",
  STOPPED = "stopped",
}

export type UploadVideosJobDto = {
  id: number;
  name?: string;
  result: UploadVideosJobResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: UploadVideosJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<UploadVideosJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type UploadVideosJobResultDto = {
  failure?: ErrorDto;
  devices?: {
    total?: number;
    stateCounts?: {
      pending?: number;
      running?: number;
      done?: number;
      failed?: number;
      cancelled?: number;
      aborted?: number;
      stopped?: number;
    };
    states?: {
      pending?: Array<number>;
      running?: Array<number>;
      done?: Array<number>;
      failed?: Array<number>;
      cancelled?: Array<number>;
      aborted?: Array<number>;
      stopped?: Array<number>;
    };
  };
};

export type UploadVideosJobSummaryDto = {
  id: number;
  name?: string;
  result: UploadVideosJobResultDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: UploadVideosJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type UploadVideosScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: UploadVideosJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type UploadVideosScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: UploadVideosJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type UploadVideosScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: UploadVideosJobDataDto;
};

export type UploadVideosUpdateJobDto = {
  name?: string;
  description?: string;
};

export type UploadVideosUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: UploadVideosJobDataDto;
};

export type UserDetails = {
  /**
   * Sites associated with the user
   */
  associatedSites?: Array<MinimalEntityDto>;
  id: number;
  defaultAccount: number;
  email: string;
  firstName: string;
  lastName: string;
  profileImg: string;
  company: string;
  isSuperAdmin: boolean;
  referrer?: string;
  lastConnected: Date;
  isDeleted?: boolean;
};

export type UserDetailsDto = {
  role:
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
    | "SuperAdmin";
  /**
   * The caller's own dashboard settings (ID-6897). Only GET /me fills this; the users list never carries other users' UI state.
   */
  userSettings?: UserSettingsDto;
  defaultClusterArchitecture?:
    | ("distributed" | "hybrid" | "centralized")
    | null;
  /**
   * Sites associated with the user
   */
  associatedSites?: Array<MinimalEntityDto>;
  defaultOperationalHours?: OperationalHoursResponseDto;
  id: number;
  firstName: string;
  lastName: string;
  email: string | null;
  company: string;
  profileImg: string;
  defaultAccount: number;
  accountId: number;
  accountName: string;
  token: string;
  isActive: boolean;
  accountLogo: string;
  timezone?: string;
  defaultClusterId?: number;
  defaultClusterName?: string;
  currency?: string;
  accountReportUrl?: string;
  envReportUrl?: string;
  showEnvReport?: boolean;
  showAccountReport?: boolean;
  referrer?: string;
  showRoleSwitcher?: boolean;
  accountStatus?: string;
  lastConnected: Date;
  isDeleted?: boolean;
  environment: string;
  enableSiteSpecificPricing?: boolean;
  autoSampleSessionsEnabled?: boolean;
  /**
   * Device tags that name a camera model, most significant first (ID-6991).
   */
  cameraTypeTagIds?: Array<number>;
  bigQuerySqlCompanionEnabled?: boolean;
  autoSampleSessionsPercentage?: number;
  nonScanDailyCapacityThreshold?: number;
  retentionMonths?: number;
};

export type UserMinimalDto = {
  id: number;
  firstName: string;
  lastName: string;
};

export enum UserOrderEnum {
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  COMPANY = "company",
  ID = "id",
  ROLE = "role",
}

export type UserOrderEnumSortOption = {
  field: UserOrderEnum;
  dir?: "asc" | "desc";
};

export type UserQueryDto = {
  userIds?: Array<number>;
  roles?: Array<
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
  >;
  excludeRoles?: Array<
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
  >;
  sortBy?: Array<UserOrderEnumSortOption>;
  id?: number;
  firstName?: string;
  lastName?: string;
  company?: string;
  limit: number;
  page: number;
};

export type UserSettingsDto = {
  tablesSettings?: Array<TableSettingsEntryDto>;
};

export type UxSourceDto = {
  uxSource: string;
};

export type ValueColumnDto = {
  name: string;
  displayName: string;
  title: string;
  index: number;
};

export type VideoFileDto = {
  start_time: Date;
  end_time: Date;
  session_id: string;
  path: string;
  size: number;
  codec: string;
  width: number;
  height: number;
  fps: number;
};

export type VideoFrameDto = {
  image: string;
  frame: number;
  time: number;
};

/**
 * cleaning behaviour for video recordings once capacity is reached, "" | "fifo" - delete oldest videos once capacity is reached, "off" - will stop recording / not allow uploads when capacity is reached
 */
export enum VideoRecordingCleanStrategyEnum {
  EMPTY_STRING = "",
  FIFO = "fifo",
  OFF = "off",
}

/**
 * video recording ext - mp4,mkv,webm - leaving this empty will decide preffered based on encoding
 */
export enum VideoRecordingContainerEnum {
  EMPTY_STRING = "",
  MP4 = "mp4",
  MKV = "mkv",
  WEBM = "webm",
}

/**
 * encoding format for video
 */
export enum VideoRecordingEncodingEnum {
  EMPTY_STRING = "",
  H264 = "h264",
  H265 = "h265",
  JPEG = "jpeg",
  MJPEG = "mjpeg",
  JPG = "jpg",
  MJPG = "mjpg",
  VP8 = "vp8",
  VP9 = "vp9",
  MPEG4 = "mpeg4",
  RAW = "raw",
  FFV1 = "ffv1",
}

/**
 * hardware acceleration in non scan detector
 */
export enum VideoRecordingHardwareEnum {
  EMPTY_STRING = "",
  CPU = "cpu",
  VAAPI = "vaapi",
  VA = "va",
  QSV = "qsv",
  NVCODEC = "nvcodec",
  NVV4L2 = "nvv4l2",
  MEDIAFOUNDATION = "mediafoundation",
  D3D11 = "d3d11",
  D3D12 = "d3d12",
  VULKAN = "vulkan",
  OPENGL = "opengl",
  V4L2 = "v4l2",
  VPU = "vpu",
  IMX = "imx",
}

/**
 * switch backend for video encoding
 */
export enum VideoRecordingTypeEnum {
  EMPTY_STRING = "",
  OPENCV = "opencv",
  GSTREAMER = "gstreamer",
}

export type VideoReportDto = {
  frames: Array<VideoFrameDto>;
  total_frame_count: number;
  duration: number;
};

/**
 * camera type: "" - usb, or external when external_camera_source is set; zebra - the zebra adapter camera (source composed from the ZebraAdapter config)
 */
export enum VideoStreamCameraTypeEnum {
  EMPTY_STRING = "",
  USB = "usb",
  EXTERNAL = "external",
  ZEBRA = "zebra",
}

/**
 * capture mode
 */
export enum VideoStreamCaptureModeEnum {
  EMPTY_STRING = "",
  ON_DEMAND = "on-demand",
  STREAMING = "streaming",
}

/**
 * video stream encoding "" | "raw" | "jpeg" | "h264" | "h265" | "mjpeg" - "" - empty is auto - (raw for webcam, dynamic decoding for rtsp)
 */
export enum VideoStreamEncoding {
  EMPTY_STRING = "",
  RAW = "raw",
  JPEG = "jpeg",
  H264 = "h264",
  H265 = "h265",
  BAYER = "bayer",
  MJPEG = "mjpeg",
}

/**
 * video stream format - when using raw encoding and need to pick camera color format
 */
export enum VideoStreamFormatEnum {
  EMPTY_STRING = "",
  A444_16LE = "A444_16LE",
  A444_16BE = "A444_16BE",
  AYUV64 = "AYUV64",
  RGBA64_LE = "RGBA64_LE",
  ARGB64 = "ARGB64",
  ARGB64_LE = "ARGB64_LE",
  BGRA64_LE = "BGRA64_LE",
  ABGR64_LE = "ABGR64_LE",
  RGBA64_BE = "RGBA64_BE",
  ARGB64_BE = "ARGB64_BE",
  BGRA64_BE = "BGRA64_BE",
  ABGR64_BE = "ABGR64_BE",
  A422_16LE = "A422_16LE",
  A422_16BE = "A422_16BE",
  A420_16LE = "A420_16LE",
  A420_16BE = "A420_16BE",
  A444_12LE = "A444_12LE",
  GBRA_12LE = "GBRA_12LE",
  A444_12BE = "A444_12BE",
  GBRA_12BE = "GBRA_12BE",
  Y412_LE = "Y412_LE",
  Y412_BE = "Y412_BE",
  A422_12LE = "A422_12LE",
  A422_12BE = "A422_12BE",
  A420_12LE = "A420_12LE",
  A420_12BE = "A420_12BE",
  A444_10LE = "A444_10LE",
  GBRA_10LE = "GBRA_10LE",
  A444_10BE = "A444_10BE",
  GBRA_10BE = "GBRA_10BE",
  A422_10LE = "A422_10LE",
  A422_10BE = "A422_10BE",
  A420_10LE = "A420_10LE",
  A420_10BE = "A420_10BE",
  BGR10A2_LE = "BGR10A2_LE",
  RGB10A2_LE = "RGB10A2_LE",
  Y410 = "Y410",
  A444 = "A444",
  GBRA = "GBRA",
  AYUV = "AYUV",
  VUYA = "VUYA",
  RGBA = "RGBA",
  RBGA = "RBGA",
  ARGB = "ARGB",
  BGRA = "BGRA",
  ABGR = "ABGR",
  A422 = "A422",
  A420 = "A420",
  AV12 = "AV12",
  Y444_16LE = "Y444_16LE",
  GBR_16LE = "GBR_16LE",
  Y444_16BE = "Y444_16BE",
  GBR_16BE = "GBR_16BE",
  V216 = "v216",
  P016_LE = "P016_LE",
  P016_BE = "P016_BE",
  Y444_12LE = "Y444_12LE",
  GBR_12LE = "GBR_12LE",
  Y444_12BE = "Y444_12BE",
  GBR_12BE = "GBR_12BE",
  I422_12LE = "I422_12LE",
  I422_12BE = "I422_12BE",
  Y212_LE = "Y212_LE",
  Y212_BE = "Y212_BE",
  I420_12LE = "I420_12LE",
  I420_12BE = "I420_12BE",
  P012_LE = "P012_LE",
  P012_BE = "P012_BE",
  Y444_10LE = "Y444_10LE",
  GBR_10LE = "GBR_10LE",
  Y444_10BE = "Y444_10BE",
  GBR_10BE = "GBR_10BE",
  R210 = "r210",
  I422_10LE = "I422_10LE",
  I422_10BE = "I422_10BE",
  NV16_10LE32 = "NV16_10LE32",
  Y210 = "Y210",
  UYVP = "UYVP",
  V210 = "v210",
  I420_10LE = "I420_10LE",
  I420_10BE = "I420_10BE",
  P010_10LE = "P010_10LE",
  NV12_10LE40 = "NV12_10LE40",
  NV12_10LE32 = "NV12_10LE32",
  P010_10BE = "P010_10BE",
  MT2110R = "MT2110R",
  MT2110T = "MT2110T",
  NV12_10BE_8L128 = "NV12_10BE_8L128",
  NV12_10LE40_4L4 = "NV12_10LE40_4L4",
  Y444 = "Y444",
  BGRP = "BGRP",
  GBR = "GBR",
  RGBP = "RGBP",
  NV24 = "NV24",
  V308 = "v308",
  IYU2 = "IYU2",
  RGBX = "RGBx",
  X_RGB = "xRGB",
  BGRX = "BGRx",
  X_BGR = "xBGR",
  RGB = "RGB",
  BGR = "BGR",
  Y42B = "Y42B",
  NV16 = "NV16",
  NV61 = "NV61",
  YUY2 = "YUY2",
  YVYU = "YVYU",
  UYVY = "UYVY",
  VYUY = "VYUY",
  I420 = "I420",
  YV12 = "YV12",
  NV12 = "NV12",
  NV21 = "NV21",
  NV12_16L32S = "NV12_16L32S",
  NV12_32L32 = "NV12_32L32",
  NV12_4L4 = "NV12_4L4",
  NV12_64Z32 = "NV12_64Z32",
  NV12_8L128 = "NV12_8L128",
  Y41B = "Y41B",
  IYU1 = "IYU1",
  YUV9 = "YUV9",
  YVU9 = "YVU9",
  BGR16 = "BGR16",
  RGB16 = "RGB16",
  BGR15 = "BGR15",
  RGB15 = "RGB15",
  RGB8P = "RGB8P",
  GRAY16_LE = "GRAY16_LE",
  GRAY16_BE = "GRAY16_BE",
  GRAY10_LE32 = "GRAY10_LE32",
  GRAY = "GRAY",
}

/**
 * choose hardware acceleration, defaults to cpu
 */
export enum VideoStreamHardwareEnum {
  EMPTY_STRING = "",
  CPU = "cpu",
  VAAPI = "vaapi",
  VA = "va",
  QSV = "qsv",
  NVCODEC = "nvcodec",
  NVV4L2 = "nvv4l2",
  MEDIAFOUNDATION = "mediafoundation",
  D3D11 = "d3d11",
  D3D12 = "d3d12",
  VULKAN = "vulkan",
  OPENGL = "opengl",
  V4L2 = "v4l2",
  VPU = "vpu",
  IMX = "imx",
}

/**
 * choose source plugin, used for different camera interfaces
 */
export enum VideoStreamSourcePluginEnum {
  EMPTY_STRING = "",
  V4L2SRC = "v4l2src",
  KSVIDEOSRC = "ksvideosrc",
  TCAMSRC = "tcamsrc",
  MFVIDEOSRC = "mfvideosrc",
  DIRECTSHOW = "directshow",
  DSHOWVIDEOSRC = "dshowvideosrc",
  UVC = "uvc",
  V4L2 = "v4l2",
  WINKS = "winks",
  MEDIAFOUNDATION = "mediafoundation",
  SOUPHTTPSRC = "souphttpsrc",
  HTTP = "http",
  HTTPS = "https",
}

/**
 * switch backend for video capture
 */
export enum VideoStreamTypeEnum {
  EMPTY_STRING = "",
  OPENCV = "opencv",
  GSTREAMER = "gstreamer",
}

export type VideoUploadProgressDto = {
  /**
   * UUID, unique per run. Available on agent ^1.57.0 || ^2.33.0
   */
  id?: string;
  /**
   * Optional label; multiple runs can share a name. Available on agent ^1.57.0 || ^2.33.0
   */
  name?: string;
  /**
   * True if this is the most recent run for the given name. Available on agent ^1.57.0 || ^2.33.0
   */
  latest?: boolean;
  /**
   * ISO date string when upload started. Available on agent ^1.57.0 || ^2.33.0
   */
  startTime?: string;
  /**
   * ISO date string when upload ended; omitted if still running. Available on agent ^1.57.0 || ^2.33.0
   */
  endTime?: string;
  /**
   * Original request args passed to StartVideoUpload. Available on agent ^1.57.0 || ^2.33.0
   */
  args?: {
    [key: string]: unknown;
  };
  running: boolean;
  total: number;
  remaining: number;
  done: number;
  progress?: MultipartProgressDto;
  lastError?: {
    [key: string]: unknown;
  };
  error?: {
    [key: string]: unknown;
  };
  failures?: number;
  skipped?: number;
};

export enum VideoUploadTargetEnum {
  BACKEND = "backend",
  CLUSTER = "cluster",
}

export type WorkerJobDataDto = {
  deviceIds: Array<number>;
  jobType: "no_scan_find_candidates";
  version?: string;
  keepContainer?: boolean;
  jobInput?: {
    [key: string]: unknown;
  };
};

export enum jobType {
  NO_SCAN_FIND_CANDIDATES = "no_scan_find_candidates",
}

export type WorkerJobDataWithNameDto = {
  deviceIds: Array<number>;
  jobType: "no_scan_find_candidates";
  version?: string;
  keepContainer?: boolean;
  jobInput?: {
    [key: string]: unknown;
  };
  name?: string;
  description?: string;
};

export type WorkerJobDetailsDto = {
  devices: {
    [key: string]: WorkerJobDeviceDto;
  };
};

export type WorkerJobDeviceDto = {
  name?: string;
  startTime?: Date;
  updateTime?: Date;
  total?: number;
  created?: number;
  updated?: number;
  done?: number;
  failures?: number;
  markedDeleted?: number;
  invalid?: number;
  state?: WorkerJobDeviceStateEnum;
  failure?: ErrorDto;
};

export type WorkerJobDeviceResultDto = {
  total?: number;
  created?: number;
  updated?: number;
  done?: number;
  failures?: number;
  markedDeleted?: number;
  invalid?: number;
  startTime?: Date;
  updateTime?: Date;
  failure?: ErrorDto;
};

export enum WorkerJobDeviceStateEnum {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type WorkerJobJobDeviceDto = {
  participation: WorkerJobJobDeviceParticipationDto;
  name: string;
  id: number;
};

export type WorkerJobJobDeviceParticipationDto = {
  createdAt: Date;
  updatedAt: Date;
  state: WorkerJobJobDeviceStateDto;
  done?: number;
  total?: number;
  failures?: number;
  result: WorkerJobDeviceResultDto;
  startTime?: Date;
  endTime?: Date;
};

export enum WorkerJobJobDeviceStateDto {
  RUNNING = "running",
  DONE = "done",
  FAILED = "failed",
}

export type WorkerJobJobDto = {
  id: number;
  name?: string;
  result: WorkerJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: WorkerJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<WorkerJobJobDeviceDto>;
  scheduledJob?: MinimalEntityDto;
  description?: string;
};

export type WorkerJobJobSummaryDto = {
  id: number;
  name?: string;
  result: WorkerJobDetailsDto;
  createdAt: Date;
  updatedAt: Date;
  startTime?: Date;
  endTime?: Date;
  data?: WorkerJobDataDto;
  done?: number;
  failures?: number;
  pending?: number;
  cancelled?: number;
  expired?: number;
  total?: number;
  /**
   * in milliseconds
   */
  durationMs?: number;
  state:
    | "pending"
    | "running"
    | "done"
    | "failed"
    | "cancelled"
    | "cancelling"
    | "suspended"
    | "aborted";
  devices?: Array<MinimalEntityDto>;
  scheduledJob?: MinimalEntityDto;
};

export type WorkerJobScheduledJobDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: WorkerJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
  description?: string;
};

export type WorkerJobScheduledJobSummaryDto = {
  name: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: WorkerJobDataDto;
  id: number;
  createdAt: Date;
  updatedAt: Date;
  scheduled?: boolean;
  shouldBeScheduled?: boolean;
  scheduleError?: string;
  latestJobId?: number;
  /**
   * Scheduling warnings intended for UI display
   */
  warnings?: Array<string>;
};

export type WorkerJobScheduleJobDto = {
  name: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: WorkerJobDataDto;
};

export enum WorkerJobTypesEnum {
  NO_SCAN_FIND_CANDIDATES = "no_scan_find_candidates",
}

export type WorkerJobUpdateJobDto = {
  name?: string;
  description?: string;
};

export type WorkerJobUpdateScheduledJobDto = {
  name?: string;
  description?: string;
  /**
   * in milliseconds
   */
  every?: number;
  /**
   * in milliseconds
   */
  duration?: number;
  timezone?: string;
  cronStart?: string;
  cronEnd?: string;
  startDate?: Date;
  endDate?: Date;
  runOnce?: boolean;
  data?: WorkerJobDataDto;
};

export type ZebraAdapterAgentConfigDto = {
  /**
   * agent host for external service to connect to
   */
  host: string;
  /**
   * agent port for external service to connect to
   */
  port: number;
  /**
   * use https for agent connection
   */
  https: boolean;
  /**
   * skip ssl verification for agent connection
   */
  skip_ssl_verify: boolean;
  /**
   * enable agent for zebra adapter
   */
  enabled: boolean;
  /**
   * image source for agent (zebra or agent)
   */
  image_from: ZebraAdapterImageFromEnum;
};

/**
 * image source for agent (zebra or agent)
 */
export enum ZebraAdapterImageFromEnum {
  EMPTY_STRING = "",
  ZEBRA = "zebra",
  AGENT = "agent",
}

/**
 * zebra adapter log level
 */
export enum ZebraAdapterLogLevelEnum {
  EMPTY_STRING = "",
  TRACE = "trace",
  DEBUG = "debug",
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
  CRITICAL = "critical",
  OFF = "off",
}

export type CurrencyControllerVersionResponse = unknown;

export type AccountsControllerCreateData = {
  formData: CreateAccountDto;
};

export type AccountsControllerCreateResponse = number;

export type AccountsControllerListAvailableAgentVersionsResponse =
  Array<string>;

export type AccountsControllerListAvailableServiceVersionsData = {
  limit: number;
  page: number;
  serviceName:
    | "edgify-non-scan-detector"
    | "edgify-worker"
    | "edgify-on-screen-app"
    | "edgify-zebra-adapter"
    | "edgify-agent"
    | "edgify-model";
};

export type AccountsControllerListAvailableServiceVersionsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<string>;
    /**
     * Optional array of deployment types (e.g., CPU, GPU). Only present for services that support multiple types.
     */
    types?: Array<string>;
  };

export type AccountsControllerListMinimalData = {
  accountId?: number;
  groupId?: number;
  limit: number;
  name?: string;
  page: number;
};

export type AccountsControllerListMinimalResponse = PaginatedResponseDto & {
  results?: Array<MinimalEntityDto>;
};

export type AccountsControllerListSummariesData = {
  accountIds?: Array<number>;
  /**
   * Filter by active status. Defaults to true when omitted.
   */
  isActive?: boolean;
  limit: number;
  name?: string;
  page: number;
  /**
   * Sort by multiple fields and directions. Default direction for name is ascending.
   */
  sortBy?: Array<AccountOrderEnumSortOption>;
};

export type AccountsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<AccountSummaryDto>;
  };

export type AccountsControllerFindOneData = {
  id: number;
};

export type AccountsControllerFindOneResponse = AccountDetailsDto;

export type AccountsControllerUpdateByIdData = {
  formData: UpdateAccountDto;
  id: number;
};

export type AccountsControllerUpdateByIdResponse = unknown;

export type AccountsControllerUpdateIsActiveBulkData = {
  requestBody: UpdateAccountIsActiveBulkDto;
};

export type AccountsControllerUpdateIsActiveBulkResponse = unknown;

export type AccountsControllerUpdateData = {
  formData: UpdateAccountDto;
};

export type AccountsControllerUpdateResponse = unknown;

export type AccountsControllerUpsertDefaultOperationalHoursData = {
  id: number;
  requestBody: CreateOperationalHoursDto;
};

export type AccountsControllerUpsertDefaultOperationalHoursResponse =
  OperationalHoursResponseDto;

export type AlertsControllerEmitTestAlertData = {
  requestBody: EmitTestAlertDto;
};

export type AlertsControllerEmitTestAlertResponse = unknown;

export type AlertsControllerUpdateAccountAlertData = {
  requestBody: UpdateAccountAlertDto;
};

export type AlertsControllerUpdateAccountAlertResponse = unknown;

export type AlertsControllerListAlertChannelsResponse =
  AlertChannelsResponseDto;

export type AlertsControllerCreateAlertChannelData = {
  requestBody: CreateAlertChannelDto;
};

export type AlertsControllerCreateAlertChannelResponse = number;

export type AlertsControllerListAlertDeliveriesData = {
  id: number;
  limit: number;
  page: number;
};

export type AlertsControllerListAlertDeliveriesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<AlertDeliveryDto>;
  };

export type AlertsControllerCreateGlobalAlertChannelData = {
  requestBody: CreateAlertChannelDto;
};

export type AlertsControllerCreateGlobalAlertChannelResponse = number;

export type AlertsControllerUpdateAlertChannelData = {
  id: number;
  requestBody: UpdateAlertChannelDto;
};

export type AlertsControllerUpdateAlertChannelResponse = unknown;

export type AlertsControllerDeleteAlertChannelData = {
  id: number;
};

export type AlertsControllerDeleteAlertChannelResponse = unknown;

export type AlertsControllerUpdateGlobalAlertChannelData = {
  id: number;
  requestBody: UpdateAlertChannelDto;
};

export type AlertsControllerUpdateGlobalAlertChannelResponse = unknown;

export type AlertsControllerDeleteGlobalAlertChannelData = {
  id: number;
};

export type AlertsControllerDeleteGlobalAlertChannelResponse = unknown;

export type AlertsControllerListManagedAlertsData = {
  alertKey?: string;
  alertTypes?: Array<
    | "DeviceDown"
    | "ServerDown"
    | "CameraDown"
    | "HighResourceUsage"
    | "LookupTableDisabled"
    | "DeployedModelFailure"
    | "RegisterDisabledDeviceAttempt"
    | "RegisterDuplicateDeviceAttempt"
    | "TrainingFailed"
    | "NonScanDetectorDown"
    | "OnScreenAppDown"
    | "ZebraAdapterDown"
    | "AgentPortClash"
    | "LockedSamplesAboveThreshold"
    | "FailedToStoreSampleLackOfStorage"
    | "BlackScreenImageDetected"
    | "LocalStorageAlmostFull"
    | "AgentDoesNotReachEdgibox"
    | "VideoUploadError"
    | "ImageUploadError"
    | "PredictorDisabled"
    | "NonScanDetectorRepeatedFpsDrops"
    | "ModelBelowKpiThreshold"
    | "TrainingWarnings"
    | "LookupTableMismatch"
    | "MetricThresholdBreach"
    | "ServiceDown"
    | "DataCompletenessBelowThreshold"
    | "DeviceDownEscalated"
    | "ServerDownEscalated"
    | "CameraDownEscalated"
    | "HighResourceUsageEscalated"
    | "LookupTableDisabledEscalated"
    | "DeployedModelFailureEscalated"
    | "NonScanDetectorDownEscalated"
    | "OnScreenAppDownEscalated"
    | "ZebraAdapterDownEscalated"
    | "AgentPortClashEscalated"
    | "LockedSamplesAboveThresholdEscalated"
    | "FailedToStoreSampleLackOfStorageEscalated"
    | "BlackScreenImageDetectedEscalated"
    | "LocalStorageAlmostFullEscalated"
    | "AgentDoesNotReachEdgiboxEscalated"
    | "VideoUploadErrorEscalated"
    | "ImageUploadErrorEscalated"
    | "PredictorDisabledEscalated"
    | "NonScanDetectorRepeatedFpsDropsEscalated"
  >;
  deviceIds?: Array<number>;
  escalated?: boolean;
  eventIds?: Array<string>;
  fromDate?: Date;
  limit: number;
  name?: string;
  page: number;
  priority?: Array<AlertPriority>;
  severity?: Array<AlertSeverity>;
  sortBy?: Array<ManagedAlertsOrderEnumSortOption>;
  status?: Array<"Open" | "Closed">;
  toDate?: Date;
};

export type AlertsControllerListManagedAlertsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ManagedAlertListItemDto>;
  };

export type AlertsControllerDownloadManagedAlertsData = {
  requestBody: DownloadManagedAlertsRequestDto;
};

export type AlertsControllerDownloadManagedAlertsResponse =
  LoggedStreamableFile;

export type AlertsControllerListManagedAlertsGroupedByEventData = {
  alertKey?: string;
  alertTypes?: Array<
    | "DeviceDown"
    | "ServerDown"
    | "CameraDown"
    | "HighResourceUsage"
    | "LookupTableDisabled"
    | "DeployedModelFailure"
    | "RegisterDisabledDeviceAttempt"
    | "RegisterDuplicateDeviceAttempt"
    | "TrainingFailed"
    | "NonScanDetectorDown"
    | "OnScreenAppDown"
    | "ZebraAdapterDown"
    | "AgentPortClash"
    | "LockedSamplesAboveThreshold"
    | "FailedToStoreSampleLackOfStorage"
    | "BlackScreenImageDetected"
    | "LocalStorageAlmostFull"
    | "AgentDoesNotReachEdgibox"
    | "VideoUploadError"
    | "ImageUploadError"
    | "PredictorDisabled"
    | "NonScanDetectorRepeatedFpsDrops"
    | "ModelBelowKpiThreshold"
    | "TrainingWarnings"
    | "LookupTableMismatch"
    | "MetricThresholdBreach"
    | "ServiceDown"
    | "DataCompletenessBelowThreshold"
    | "DeviceDownEscalated"
    | "ServerDownEscalated"
    | "CameraDownEscalated"
    | "HighResourceUsageEscalated"
    | "LookupTableDisabledEscalated"
    | "DeployedModelFailureEscalated"
    | "NonScanDetectorDownEscalated"
    | "OnScreenAppDownEscalated"
    | "ZebraAdapterDownEscalated"
    | "AgentPortClashEscalated"
    | "LockedSamplesAboveThresholdEscalated"
    | "FailedToStoreSampleLackOfStorageEscalated"
    | "BlackScreenImageDetectedEscalated"
    | "LocalStorageAlmostFullEscalated"
    | "AgentDoesNotReachEdgiboxEscalated"
    | "VideoUploadErrorEscalated"
    | "ImageUploadErrorEscalated"
    | "PredictorDisabledEscalated"
    | "NonScanDetectorRepeatedFpsDropsEscalated"
  >;
  deviceIds?: Array<number>;
  escalated?: boolean;
  eventIds?: Array<string>;
  fromDate?: Date;
  limit: number;
  name?: string;
  page: number;
  priority?: Array<AlertPriority>;
  severity?: Array<AlertSeverity>;
  sortBy?: Array<ManagedAlertsOrderEnumSortOption>;
  status?: Array<"Open" | "Closed">;
  toDate?: Date;
};

export type AlertsControllerListManagedAlertsGroupedByEventResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<GroupedManagedAlertDto>;
  };

export type AlertsControllerUpdateManagedAlertStatusData = {
  id: number;
  requestBody: UpdateManagedAlertStatusDto;
};

export type AlertsControllerUpdateManagedAlertStatusResponse = number;

export type AlertsControllerUpdateManagedAlertStatusBulkData = {
  requestBody: UpdateManagedAlertStatusBulkDto;
};

export type AlertsControllerUpdateManagedAlertStatusBulkResponse = {
  count?: number;
};

export type AlertsControllerListAlertsData = {
  description?: string;
  enabled?: boolean;
  includeEscalated?: boolean;
  limit: number;
  name?: string;
  page: number;
  priority?: Array<AlertPriority>;
  severity?: Array<AlertSeverity>;
  sortBy?: Array<AlertSpecsOrderEnumSortOption>;
};

export type AlertsControllerListAlertsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ListAlertsResponseDto>;
  };

export type AlertsControllerGetAlertByIdData = {
  id: number;
};

export type AlertsControllerGetAlertByIdResponse = AlertDetailsDto;

export type AlertsControllerUpdateAlertData = {
  id: number;
  requestBody: UpdateAlertDto;
};

export type AlertsControllerUpdateAlertResponse = number;

export type AlertsControllerUpdateAlertSubscriptionsData = {
  id: number;
  requestBody: UpdateAlertSubscriptionsDto;
};

export type AlertsControllerUpdateAlertSubscriptionsResponse = unknown;

export type AlertsControllerGetAlertEscalationData = {
  id: number;
};

export type AlertsControllerGetAlertEscalationResponse =
  AlertEscalationResponseDto;

export type AlertsControllerUpdateAlertEscalationData = {
  id: number;
  requestBody: SaveAlertEscalationDto;
};

export type AlertsControllerUpdateAlertEscalationResponse =
  AlertEscalationResponseDto;

export type AuthControllerLoginData = {
  requestBody: LoginDto;
};

export type AuthControllerLoginResponse = LoginResponseDto;

export type AuthControllerLogoutResponse = unknown;

export type AuthControllerMagicCallbackResponse = {
  [key: string]: unknown;
};

export type AuthControllerCallbackResponse = unknown;

export type AuthControllerOidcCallbackResponse = unknown;

export type AuthControllerAccountSwitchData = {
  requestBody: AccountSwitchDto;
};

export type AuthControllerAccountSwitchResponse = unknown;

export type CameraCalibrationControllerCreateScheduleData = {
  requestBody: CameraCalibrationScheduleJobDto;
};

export type CameraCalibrationControllerCreateScheduleResponse =
  CameraCalibrationScheduledJobSummaryDto;

export type CameraCalibrationControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type CameraCalibrationControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<CameraCalibrationScheduledJobSummaryDto>;
  };

export type CameraCalibrationControllerGetScheduledJobData = {
  id: number;
};

export type CameraCalibrationControllerGetScheduledJobResponse =
  CameraCalibrationScheduledJobDto;

export type CameraCalibrationControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: CameraCalibrationUpdateScheduledJobDto;
};

export type CameraCalibrationControllerUpdateScheduledJobResponse =
  CameraCalibrationScheduledJobDto;

export type CameraCalibrationControllerDeleteScheduledJobData = {
  id: number;
};

export type CameraCalibrationControllerDeleteScheduledJobResponse = boolean;

export type CameraCalibrationControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CameraCalibrationControllerCancelScheduledJobsBulkResponse = number;

export type CameraCalibrationControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CameraCalibrationControllerStopScheduledJobsBulkResponse = number;

export type CameraCalibrationControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CameraCalibrationControllerResumeScheduledJobsBulkResponse = number;

export type CameraCalibrationControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CameraCalibrationControllerDeleteScheduledJobsBulkResponse = number;

export type CameraCalibrationControllerStartScheduledJobData = {
  id: number;
};

export type CameraCalibrationControllerStartScheduledJobResponse =
  CameraCalibrationJobDto;

export type CameraCalibrationControllerCancelScheduledJobData = {
  id: number;
};

export type CameraCalibrationControllerCancelScheduledJobResponse = boolean;

export type CameraCalibrationControllerStopScheduledJobData = {
  id: number;
};

export type CameraCalibrationControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type CameraCalibrationControllerResumeScheduledJobData = {
  id: number;
};

export type CameraCalibrationControllerResumeScheduledJobResponse =
  CameraCalibrationScheduledJobSummaryDto;

export type CameraCalibrationControllerStartJobData = {
  requestBody: CameraCalibrationDataWithNameDto;
};

export type CameraCalibrationControllerStartJobResponse =
  CameraCalibrationJobDto;

export type CameraCalibrationControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type CameraCalibrationControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<CameraCalibrationJobSummaryDto>;
  };

export type CameraCalibrationControllerGetJobData = {
  id: number;
};

export type CameraCalibrationControllerGetJobResponse = CameraCalibrationJobDto;

export type CameraCalibrationControllerDeleteJobData = {
  id: number;
};

export type CameraCalibrationControllerDeleteJobResponse = boolean;

export type CameraCalibrationControllerUpdateJobData = {
  id: number;
  requestBody: CameraCalibrationUpdateJobDto;
};

export type CameraCalibrationControllerUpdateJobResponse =
  CameraCalibrationJobDto;

export type CameraCalibrationControllerCancelJobData = {
  id: number;
};

export type CameraCalibrationControllerCancelJobResponse = boolean;

export type CameraCalibrationControllerStopJobData = {
  id: number;
};

export type CameraCalibrationControllerStopJobResponse = boolean;

export type CameraCalibrationControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type CameraCalibrationControllerCancelJobsBulkResponse = number;

export type CameraCalibrationControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type CameraCalibrationControllerDeleteJobsBulkResponse = number;

export type CapacityTaggingControllerPreCheckData = {
  requestBody: CapacityTaggingPreCheckRequestDto;
};

export type CapacityTaggingControllerPreCheckResponse =
  CapacityTaggingPreCheckResponseDto;

export type CapacityTaggingControllerCreateScheduleData = {
  requestBody: CapacityTaggingScheduleJobDto;
};

export type CapacityTaggingControllerCreateScheduleResponse =
  CapacityTaggingScheduledJobSummaryDto;

export type CapacityTaggingControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type CapacityTaggingControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<CapacityTaggingScheduledJobSummaryDto>;
  };

export type CapacityTaggingControllerGetScheduledJobData = {
  id: number;
};

export type CapacityTaggingControllerGetScheduledJobResponse =
  CapacityTaggingScheduledJobDto;

export type CapacityTaggingControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: CapacityTaggingUpdateScheduledJobDto;
};

export type CapacityTaggingControllerUpdateScheduledJobResponse =
  CapacityTaggingScheduledJobDto;

export type CapacityTaggingControllerDeleteScheduledJobData = {
  id: number;
};

export type CapacityTaggingControllerDeleteScheduledJobResponse = boolean;

export type CapacityTaggingControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CapacityTaggingControllerCancelScheduledJobsBulkResponse = number;

export type CapacityTaggingControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CapacityTaggingControllerStopScheduledJobsBulkResponse = number;

export type CapacityTaggingControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CapacityTaggingControllerResumeScheduledJobsBulkResponse = number;

export type CapacityTaggingControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CapacityTaggingControllerDeleteScheduledJobsBulkResponse = number;

export type CapacityTaggingControllerStartScheduledJobData = {
  id: number;
};

export type CapacityTaggingControllerStartScheduledJobResponse =
  CapacityTaggingJobDto;

export type CapacityTaggingControllerCancelScheduledJobData = {
  id: number;
};

export type CapacityTaggingControllerCancelScheduledJobResponse = boolean;

export type CapacityTaggingControllerStopScheduledJobData = {
  id: number;
};

export type CapacityTaggingControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type CapacityTaggingControllerResumeScheduledJobData = {
  id: number;
};

export type CapacityTaggingControllerResumeScheduledJobResponse =
  CapacityTaggingScheduledJobSummaryDto;

export type CapacityTaggingControllerStartJobData = {
  requestBody: CapacityTaggingDataWithNameDto;
};

export type CapacityTaggingControllerStartJobResponse = CapacityTaggingJobDto;

export type CapacityTaggingControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type CapacityTaggingControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<CapacityTaggingJobSummaryDto>;
  };

export type CapacityTaggingControllerGetJobData = {
  id: number;
};

export type CapacityTaggingControllerGetJobResponse = CapacityTaggingJobDto;

export type CapacityTaggingControllerDeleteJobData = {
  id: number;
};

export type CapacityTaggingControllerDeleteJobResponse = boolean;

export type CapacityTaggingControllerUpdateJobData = {
  id: number;
  requestBody: CapacityTaggingUpdateJobDto;
};

export type CapacityTaggingControllerUpdateJobResponse = CapacityTaggingJobDto;

export type CapacityTaggingControllerCancelJobData = {
  id: number;
};

export type CapacityTaggingControllerCancelJobResponse = boolean;

export type CapacityTaggingControllerStopJobData = {
  id: number;
};

export type CapacityTaggingControllerStopJobResponse = boolean;

export type CapacityTaggingControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type CapacityTaggingControllerCancelJobsBulkResponse = number;

export type CapacityTaggingControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type CapacityTaggingControllerDeleteJobsBulkResponse = number;

export type CatalogControllerListLabelsData = {
  limit: number;
  page: number;
  plu?: string;
  siteId?: number;
};

export type CatalogControllerListLabelsResponse = PaginatedResponseDto & {
  results?: Array<MinimalEntityDto>;
};

export type CatalogControllerListMinimalData = {
  limit?: number;
  /**
   * Site group ID to exclude items that already have labels in this group
   */
  notInGroup?: number;
  page?: number;
  search?: string;
};

export type CatalogControllerListMinimalResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<CatalogMinimalItemDto>;
  };

export type CatalogControllerListFamiliesData = {
  /**
   * Case-insensitive partial match on family name
   */
  familyName?: string;
  limit: number;
  page: number;
  siteId: number;
  sortBy?: Array<ListFamiliesOrderEnumSortOption>;
};

export type CatalogControllerListFamiliesResponse = unknown;

export type CatalogControllerListSummariesData = {
  englishName?: string;
  exact?: boolean;
  families?: Array<string>;
  groupId?: number;
  itemIds?: Array<number>;
  limit: number;
  name?: string;
  outOfScope?: boolean;
  page: number;
  plu?: string;
  plus?: Array<string>;
  price?: Decimal2;
  priceBy?: "weight" | "quantity";
  search?: string;
  siteId?: number;
  sortBy?: Array<CatalogItemsSummaryOrderEnumSortOption>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
};

export type CatalogControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<CatalogItemDetailsDto>;
  };

export type CatalogControllerDownloadCatalogData = {
  requestBody: DownloadCatalogItemsRequestDto;
};

export type CatalogControllerDownloadCatalogResponse = LoggedStreamableFile;

export type CatalogControllerFindData = {
  siteId: number;
};

export type CatalogControllerFindResponse = LookupTableDto;

export type CatalogControllerUpdateTagsBulkData = {
  requestBody: UpdateCatalogItemsTaggingBulkDto;
};

export type CatalogControllerUpdateTagsBulkResponse = unknown;

export type CatalogControllerUpdateOutOfScopeBulkData = {
  requestBody: UpdateCatalogItemsOutOfScopeBulkDto;
};

export type CatalogControllerUpdateOutOfScopeBulkResponse = unknown;

export type CatalogControllerDeleteBulkData = {
  requestBody: BulkCatalogItemsQueryDto;
};

export type CatalogControllerDeleteBulkResponse = unknown;

export type CatalogControllerGetDetailsData = {
  groupId?: number;
  label: string;
  siteId?: number;
};

export type CatalogControllerGetDetailsResponse = CatalogItemDetailsDto;

export type CatalogControllerCreateData = {
  label: string;
  requestBody: CreateCatalogItemDto;
};

export type CatalogControllerCreateResponse = CreatedCatalogItemDto;

export type CatalogControllerUpdateData = {
  groupId?: number;
  label: string;
  requestBody: UpdateCatalogItemDto;
  siteId?: number;
};

export type CatalogControllerUpdateResponse = UpdatedCatalogItemDto;

export type CatalogControllerDeleteData = {
  groupId?: number;
  label: string;
  siteId?: number;
};

export type CatalogControllerDeleteResponse = unknown;

export type CatalogControllerGetSitePricesData = {
  label: string;
};

export type CatalogControllerGetSitePricesResponse = CatalogItemSitePricesDto;

export type CatalogControllerGetLabelsData = {
  label: string;
};

export type CatalogControllerGetLabelsResponse = CatalogItemLabelsDto;

export type CatalogControllerUploadData = {
  formData: UploadFileDto;
};

export type CatalogControllerUploadResponse = {
  [key: string]: unknown;
};

export type CatalogTaggingControllerListTagsData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TagOrderEnumSortOption>;
};

export type CatalogTaggingControllerListTagsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<TagSummaryDto>;
  };

export type CatalogTaggingControllerCreateTagsData = {
  requestBody: CreateTagsDto;
};

export type CatalogTaggingControllerCreateTagsResponse = {
  [key: string]: unknown;
};

export type CatalogTaggingControllerAssignTagsData = {
  requestBody: AssignTagsDto;
};

export type CatalogTaggingControllerAssignTagsResponse = AssignTagsResponseDto;

export type CatalogTaggingControllerUnassignTagsData = {
  requestBody: UnassignTagsDto;
};

export type CatalogTaggingControllerUnassignTagsResponse =
  UnassignTagsResponseDto;

export type CatalogTaggingControllerGetDetailsData = {
  id: number;
};

export type CatalogTaggingControllerGetDetailsResponse = TagDetailsDto;

export type CatalogTaggingControllerUpdateTagData = {
  id: number;
  requestBody: UpdateTagDto;
};

export type CatalogTaggingControllerUpdateTagResponse = TagDetailsDto;

export type CatalogTaggingControllerDeleteTagData = {
  id: number;
};

export type CatalogTaggingControllerDeleteTagResponse = unknown;

export type CatalogTaggingControllerMergeTagToData = {
  id: number;
  mergedToId: number;
};

export type CatalogTaggingControllerMergeTagToResponse = unknown;

export type CatalogTaggingControllerListSummariesData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TagOrderEnumSortOption>;
};

export type CatalogTaggingControllerListSummariesResponse = unknown;

export type CatalogUploadJobControllerGetScheduledJobData = {
  id: number;
};

export type CatalogUploadJobControllerGetScheduledJobResponse =
  CatalogUploadScheduledJobDto & {
    /**
     * Signed GCS download URL (1-hour expiry)
     */
    gcsFileUrl?: string | null;
  };

export type CatalogUploadJobControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: CatalogUploadUpdateScheduledJobDto;
};

export type CatalogUploadJobControllerUpdateScheduledJobResponse =
  CatalogUploadScheduledJobDto;

export type CatalogUploadJobControllerDeleteScheduledJobData = {
  id: number;
};

export type CatalogUploadJobControllerDeleteScheduledJobResponse = boolean;

export type CatalogUploadJobControllerGetJobData = {
  id: number;
};

export type CatalogUploadJobControllerGetJobResponse = CatalogUploadJobDto & {
  /**
   * Signed GCS download URL (1-hour expiry)
   */
  gcsFileUrl?: string | null;
};

export type CatalogUploadJobControllerDeleteJobData = {
  id: number;
};

export type CatalogUploadJobControllerDeleteJobResponse = boolean;

export type CatalogUploadJobControllerUpdateJobData = {
  id: number;
  requestBody: CatalogUploadUpdateJobDto;
};

export type CatalogUploadJobControllerUpdateJobResponse = CatalogUploadJobDto;

export type CatalogUploadJobControllerGetJobDevicesData = {
  id: number;
  limit: number;
  /**
   * Filter by device name (case-insensitive substring)
   */
  name?: string;
  page: number;
  sortBy?: Array<JobDevicesOrderBySortOption>;
  state?: "pending" | "done" | "failed" | "cancelled";
};

export type CatalogUploadJobControllerGetJobDevicesResponse = {
  [key: string]: unknown;
};

export type CatalogUploadJobControllerCreateScheduleData = {
  requestBody: CatalogUploadScheduleJobDto;
};

export type CatalogUploadJobControllerCreateScheduleResponse =
  CatalogUploadScheduledJobSummaryDto;

export type CatalogUploadJobControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  siteGroupIds?: Array<number>;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type CatalogUploadJobControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<CatalogUploadScheduledJobSummaryDto>;
  };

export type CatalogUploadJobControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CatalogUploadJobControllerCancelScheduledJobsBulkResponse = number;

export type CatalogUploadJobControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CatalogUploadJobControllerStopScheduledJobsBulkResponse = number;

export type CatalogUploadJobControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CatalogUploadJobControllerResumeScheduledJobsBulkResponse = number;

export type CatalogUploadJobControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type CatalogUploadJobControllerDeleteScheduledJobsBulkResponse = number;

export type CatalogUploadJobControllerStartScheduledJobData = {
  id: number;
};

export type CatalogUploadJobControllerStartScheduledJobResponse =
  CatalogUploadJobDto;

export type CatalogUploadJobControllerCancelScheduledJobData = {
  id: number;
};

export type CatalogUploadJobControllerCancelScheduledJobResponse = boolean;

export type CatalogUploadJobControllerStopScheduledJobData = {
  id: number;
};

export type CatalogUploadJobControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type CatalogUploadJobControllerResumeScheduledJobData = {
  id: number;
};

export type CatalogUploadJobControllerResumeScheduledJobResponse =
  CatalogUploadScheduledJobSummaryDto;

export type CatalogUploadJobControllerStartJobData = {
  requestBody: CatalogUploadDataWithNameDto;
};

export type CatalogUploadJobControllerStartJobResponse = CatalogUploadJobDto;

export type CatalogUploadJobControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type CatalogUploadJobControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<CatalogUploadJobSummaryDto>;
  };

export type CatalogUploadJobControllerCancelJobData = {
  id: number;
};

export type CatalogUploadJobControllerCancelJobResponse = boolean;

export type CatalogUploadJobControllerStopJobData = {
  id: number;
};

export type CatalogUploadJobControllerStopJobResponse = boolean;

export type CatalogUploadJobControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type CatalogUploadJobControllerCancelJobsBulkResponse = number;

export type CatalogUploadJobControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type CatalogUploadJobControllerDeleteJobsBulkResponse = number;

export type ClustersControllerDownloadData = {
  requestBody: DownloadClusterSummariesRequestDto;
};

export type ClustersControllerDownloadResponse = LoggedStreamableFile;

export type ClustersControllerCreateData = {
  requestBody: CreateClusterDto;
};

export type ClustersControllerCreateResponse = EntityIdDto;

export type ClustersControllerListSummariesData = {
  clusterIds?: Array<number>;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ClusterSummariesOrderEnumSortOption>;
};

export type ClustersControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ClusterSummaryDto>;
  };

export type ClustersControllerListMinimalData = {
  accountId?: number;
  groupId?: number;
  limit: number;
  name?: string;
  page: number;
};

export type ClustersControllerListMinimalResponse = PaginatedResponseDto & {
  results?: Array<MinimalEntityDto>;
};

export type ClustersControllerDeployModelBulkData = {
  requestBody: ClustersModelDeploymentBulkDto;
};

export type ClustersControllerDeployModelBulkResponse = unknown;

export type ClustersControllerDeployConfigBulkData = {
  requestBody: ClustersConfigDeploymentBulkDto;
};

export type ClustersControllerDeployConfigBulkResponse = {
  id?: number;
  scheduled?: boolean;
};

export type ClustersControllerUpdateTagsBulkData = {
  requestBody: UpdateClustersTaggingBulkDto;
};

export type ClustersControllerUpdateTagsBulkResponse = unknown;

export type ClustersControllerUploadData = {
  formData: UploadClustersFileDto;
};

export type ClustersControllerUploadResponse = ClusterUploadResponseDto;

export type ClustersControllerGetDetailsData = {
  id: number;
  /**
   * Whether to include labels distribution in the response
   */
  withLabelDistribution?: boolean;
};

export type ClustersControllerGetDetailsResponse = ClusterDetailsDto;

export type ClustersControllerUpdateData = {
  id: number;
  requestBody: UpdateClusterDto;
};

export type ClustersControllerUpdateResponse = unknown;

export type ClustersControllerDeleteData = {
  id: number;
};

export type ClustersControllerDeleteResponse = unknown;

export type ClustersControllerAddDevicesData = {
  id: number;
  requestBody: UpdateClusterDevicesBulkDto;
};

export type ClustersControllerAddDevicesResponse = number;

export type ClustersControllerRemoveDevicesData = {
  id: number;
  requestBody: UpdateClusterDevicesBulkDto;
};

export type ClustersControllerRemoveDevicesResponse = number;

export type ClustersTaggingControllerListTagsData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TagOrderEnumSortOption>;
};

export type ClustersTaggingControllerListTagsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<TagSummaryDto>;
  };

export type ClustersTaggingControllerCreateTagsData = {
  requestBody: CreateTagsDto;
};

export type ClustersTaggingControllerCreateTagsResponse = {
  [key: string]: unknown;
};

export type ClustersTaggingControllerAssignTagsData = {
  requestBody: AssignTagsDto;
};

export type ClustersTaggingControllerAssignTagsResponse = AssignTagsResponseDto;

export type ClustersTaggingControllerUnassignTagsData = {
  requestBody: UnassignTagsDto;
};

export type ClustersTaggingControllerUnassignTagsResponse =
  UnassignTagsResponseDto;

export type ClustersTaggingControllerGetDetailsData = {
  id: number;
};

export type ClustersTaggingControllerGetDetailsResponse = TagDetailsDto;

export type ClustersTaggingControllerUpdateTagData = {
  id: number;
  requestBody: UpdateTagDto;
};

export type ClustersTaggingControllerUpdateTagResponse = TagDetailsDto;

export type ClustersTaggingControllerDeleteTagData = {
  id: number;
};

export type ClustersTaggingControllerDeleteTagResponse = unknown;

export type ClustersTaggingControllerMergeTagToData = {
  id: number;
  mergedToId: number;
};

export type ClustersTaggingControllerMergeTagToResponse = unknown;

export type ClustersTaggingControllerListSummariesData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TagOrderEnumSortOption>;
};

export type ClustersTaggingControllerListSummariesResponse = unknown;

export type DashboardAlertsControllerCreateAlertData = {
  requestBody: CreateDashboardAlertDto;
};

export type DashboardAlertsControllerCreateAlertResponse = unknown;

export type DatasetsControllerCreateData = {
  requestBody: CreateDatasetDto;
};

export type DatasetsControllerCreateResponse = EntityIdDto;

export type DatasetsControllerListSummariesData = {
  id?: number;
  limit: number;
  name?: string;
  page: number;
};

export type DatasetsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<MinimalDatasetSummaryDto>;
  };

export type DatasetsControllerGetDetailsData = {
  id: number;
};

export type DatasetsControllerGetDetailsResponse = DatasetDetailsDto;

export type DatasetsControllerUpdateData = {
  id: number;
  requestBody: UpdateDatasetDto;
};

export type DatasetsControllerUpdateResponse = unknown;

export type DeleteSamplesJobControllerCreateScheduleData = {
  requestBody: DeleteSamplesScheduleJobDto;
};

export type DeleteSamplesJobControllerCreateScheduleResponse =
  DeleteSamplesScheduledJobSummaryDto;

export type DeleteSamplesJobControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type DeleteSamplesJobControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeleteSamplesScheduledJobSummaryDto>;
  };

export type DeleteSamplesJobControllerGetScheduledJobData = {
  id: number;
};

export type DeleteSamplesJobControllerGetScheduledJobResponse =
  DeleteSamplesScheduledJobDto;

export type DeleteSamplesJobControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: DeleteSamplesUpdateScheduledJobDto;
};

export type DeleteSamplesJobControllerUpdateScheduledJobResponse =
  DeleteSamplesScheduledJobDto;

export type DeleteSamplesJobControllerDeleteScheduledJobData = {
  id: number;
};

export type DeleteSamplesJobControllerDeleteScheduledJobResponse = boolean;

export type DeleteSamplesJobControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeleteSamplesJobControllerCancelScheduledJobsBulkResponse = number;

export type DeleteSamplesJobControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeleteSamplesJobControllerStopScheduledJobsBulkResponse = number;

export type DeleteSamplesJobControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeleteSamplesJobControllerResumeScheduledJobsBulkResponse = number;

export type DeleteSamplesJobControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeleteSamplesJobControllerDeleteScheduledJobsBulkResponse = number;

export type DeleteSamplesJobControllerStartScheduledJobData = {
  id: number;
};

export type DeleteSamplesJobControllerStartScheduledJobResponse =
  DeleteSamplesJobDto;

export type DeleteSamplesJobControllerCancelScheduledJobData = {
  id: number;
};

export type DeleteSamplesJobControllerCancelScheduledJobResponse = boolean;

export type DeleteSamplesJobControllerStopScheduledJobData = {
  id: number;
};

export type DeleteSamplesJobControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type DeleteSamplesJobControllerResumeScheduledJobData = {
  id: number;
};

export type DeleteSamplesJobControllerResumeScheduledJobResponse =
  DeleteSamplesScheduledJobSummaryDto;

export type DeleteSamplesJobControllerStartJobData = {
  requestBody: DeleteSamplesDataWithNameDto;
};

export type DeleteSamplesJobControllerStartJobResponse = DeleteSamplesJobDto;

export type DeleteSamplesJobControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type DeleteSamplesJobControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeleteSamplesJobSummaryDto>;
  };

export type DeleteSamplesJobControllerGetJobData = {
  id: number;
};

export type DeleteSamplesJobControllerGetJobResponse = DeleteSamplesJobDto;

export type DeleteSamplesJobControllerDeleteJobData = {
  id: number;
};

export type DeleteSamplesJobControllerDeleteJobResponse = boolean;

export type DeleteSamplesJobControllerUpdateJobData = {
  id: number;
  requestBody: DeleteSamplesUpdateJobDto;
};

export type DeleteSamplesJobControllerUpdateJobResponse = DeleteSamplesJobDto;

export type DeleteSamplesJobControllerCancelJobData = {
  id: number;
};

export type DeleteSamplesJobControllerCancelJobResponse = boolean;

export type DeleteSamplesJobControllerStopJobData = {
  id: number;
};

export type DeleteSamplesJobControllerStopJobResponse = boolean;

export type DeleteSamplesJobControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type DeleteSamplesJobControllerCancelJobsBulkResponse = number;

export type DeleteSamplesJobControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type DeleteSamplesJobControllerDeleteJobsBulkResponse = number;

export type DeleteVideosJobControllerCreateScheduleData = {
  requestBody: DeleteVideosScheduleJobDto;
};

export type DeleteVideosJobControllerCreateScheduleResponse =
  DeleteVideosScheduledJobSummaryDto;

export type DeleteVideosJobControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type DeleteVideosJobControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeleteVideosScheduledJobSummaryDto>;
  };

export type DeleteVideosJobControllerGetScheduledJobData = {
  id: number;
};

export type DeleteVideosJobControllerGetScheduledJobResponse =
  DeleteVideosScheduledJobDto;

export type DeleteVideosJobControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: DeleteVideosUpdateScheduledJobDto;
};

export type DeleteVideosJobControllerUpdateScheduledJobResponse =
  DeleteVideosScheduledJobDto;

export type DeleteVideosJobControllerDeleteScheduledJobData = {
  id: number;
};

export type DeleteVideosJobControllerDeleteScheduledJobResponse = boolean;

export type DeleteVideosJobControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeleteVideosJobControllerCancelScheduledJobsBulkResponse = number;

export type DeleteVideosJobControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeleteVideosJobControllerStopScheduledJobsBulkResponse = number;

export type DeleteVideosJobControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeleteVideosJobControllerResumeScheduledJobsBulkResponse = number;

export type DeleteVideosJobControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeleteVideosJobControllerDeleteScheduledJobsBulkResponse = number;

export type DeleteVideosJobControllerStartScheduledJobData = {
  id: number;
};

export type DeleteVideosJobControllerStartScheduledJobResponse =
  DeleteVideosJobDto;

export type DeleteVideosJobControllerCancelScheduledJobData = {
  id: number;
};

export type DeleteVideosJobControllerCancelScheduledJobResponse = boolean;

export type DeleteVideosJobControllerStopScheduledJobData = {
  id: number;
};

export type DeleteVideosJobControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type DeleteVideosJobControllerResumeScheduledJobData = {
  id: number;
};

export type DeleteVideosJobControllerResumeScheduledJobResponse =
  DeleteVideosScheduledJobSummaryDto;

export type DeleteVideosJobControllerStartJobData = {
  requestBody: DeleteVideosDataWithNameDto;
};

export type DeleteVideosJobControllerStartJobResponse = DeleteVideosJobDto;

export type DeleteVideosJobControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type DeleteVideosJobControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeleteVideosJobSummaryDto>;
  };

export type DeleteVideosJobControllerGetJobData = {
  id: number;
};

export type DeleteVideosJobControllerGetJobResponse = DeleteVideosJobDto;

export type DeleteVideosJobControllerDeleteJobData = {
  id: number;
};

export type DeleteVideosJobControllerDeleteJobResponse = boolean;

export type DeleteVideosJobControllerUpdateJobData = {
  id: number;
  requestBody: DeleteVideosUpdateJobDto;
};

export type DeleteVideosJobControllerUpdateJobResponse = DeleteVideosJobDto;

export type DeleteVideosJobControllerCancelJobData = {
  id: number;
};

export type DeleteVideosJobControllerCancelJobResponse = boolean;

export type DeleteVideosJobControllerStopJobData = {
  id: number;
};

export type DeleteVideosJobControllerStopJobResponse = boolean;

export type DeleteVideosJobControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type DeleteVideosJobControllerCancelJobsBulkResponse = number;

export type DeleteVideosJobControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type DeleteVideosJobControllerDeleteJobsBulkResponse = number;

export type DeployComponentsControllerCreateScheduleData = {
  requestBody: DeployComponentsScheduleJobDto;
};

export type DeployComponentsControllerCreateScheduleResponse =
  DeployComponentsScheduledJobSummaryDto;

export type DeployComponentsControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type DeployComponentsControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeployComponentsScheduledJobSummaryDto>;
  };

export type DeployComponentsControllerGetScheduledJobData = {
  id: number;
};

export type DeployComponentsControllerGetScheduledJobResponse =
  DeployComponentsScheduledJobDto;

export type DeployComponentsControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: DeployComponentsUpdateScheduledJobDto;
};

export type DeployComponentsControllerUpdateScheduledJobResponse =
  DeployComponentsScheduledJobDto;

export type DeployComponentsControllerDeleteScheduledJobData = {
  id: number;
};

export type DeployComponentsControllerDeleteScheduledJobResponse = boolean;

export type DeployComponentsControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeployComponentsControllerCancelScheduledJobsBulkResponse = number;

export type DeployComponentsControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeployComponentsControllerStopScheduledJobsBulkResponse = number;

export type DeployComponentsControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeployComponentsControllerResumeScheduledJobsBulkResponse = number;

export type DeployComponentsControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeployComponentsControllerDeleteScheduledJobsBulkResponse = number;

export type DeployComponentsControllerStartScheduledJobData = {
  id: number;
};

export type DeployComponentsControllerStartScheduledJobResponse =
  DeployComponentsJobDto;

export type DeployComponentsControllerCancelScheduledJobData = {
  id: number;
};

export type DeployComponentsControllerCancelScheduledJobResponse = boolean;

export type DeployComponentsControllerStopScheduledJobData = {
  id: number;
};

export type DeployComponentsControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type DeployComponentsControllerResumeScheduledJobData = {
  id: number;
};

export type DeployComponentsControllerResumeScheduledJobResponse =
  DeployComponentsScheduledJobSummaryDto;

export type DeployComponentsControllerStartJobData = {
  requestBody: DeployComponentsDataWithNameDto;
};

export type DeployComponentsControllerStartJobResponse = DeployComponentsJobDto;

export type DeployComponentsControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type DeployComponentsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeployComponentsJobSummaryDto>;
  };

export type DeployComponentsControllerGetJobData = {
  id: number;
};

export type DeployComponentsControllerGetJobResponse = DeployComponentsJobDto;

export type DeployComponentsControllerDeleteJobData = {
  id: number;
};

export type DeployComponentsControllerDeleteJobResponse = boolean;

export type DeployComponentsControllerUpdateJobData = {
  id: number;
  requestBody: DeployComponentsUpdateJobDto;
};

export type DeployComponentsControllerUpdateJobResponse =
  DeployComponentsJobDto;

export type DeployComponentsControllerCancelJobData = {
  id: number;
};

export type DeployComponentsControllerCancelJobResponse = boolean;

export type DeployComponentsControllerStopJobData = {
  id: number;
};

export type DeployComponentsControllerStopJobResponse = boolean;

export type DeployComponentsControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type DeployComponentsControllerCancelJobsBulkResponse = number;

export type DeployComponentsControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type DeployComponentsControllerDeleteJobsBulkResponse = number;

export type DeviceRestartControllerCreateScheduleData = {
  requestBody: DeviceRestartScheduleJobDto;
};

export type DeviceRestartControllerCreateScheduleResponse =
  DeviceRestartScheduledJobSummaryDto;

export type DeviceRestartControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type DeviceRestartControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeviceRestartScheduledJobSummaryDto>;
  };

export type DeviceRestartControllerGetScheduledJobData = {
  id: number;
};

export type DeviceRestartControllerGetScheduledJobResponse =
  DeviceRestartScheduledJobDto;

export type DeviceRestartControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: DeviceRestartUpdateScheduledJobDto;
};

export type DeviceRestartControllerUpdateScheduledJobResponse =
  DeviceRestartScheduledJobDto;

export type DeviceRestartControllerDeleteScheduledJobData = {
  id: number;
};

export type DeviceRestartControllerDeleteScheduledJobResponse = boolean;

export type DeviceRestartControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeviceRestartControllerCancelScheduledJobsBulkResponse = number;

export type DeviceRestartControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeviceRestartControllerStopScheduledJobsBulkResponse = number;

export type DeviceRestartControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeviceRestartControllerResumeScheduledJobsBulkResponse = number;

export type DeviceRestartControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type DeviceRestartControllerDeleteScheduledJobsBulkResponse = number;

export type DeviceRestartControllerStartScheduledJobData = {
  id: number;
};

export type DeviceRestartControllerStartScheduledJobResponse =
  DeviceRestartJobDto;

export type DeviceRestartControllerCancelScheduledJobData = {
  id: number;
};

export type DeviceRestartControllerCancelScheduledJobResponse = boolean;

export type DeviceRestartControllerStopScheduledJobData = {
  id: number;
};

export type DeviceRestartControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type DeviceRestartControllerResumeScheduledJobData = {
  id: number;
};

export type DeviceRestartControllerResumeScheduledJobResponse =
  DeviceRestartScheduledJobSummaryDto;

export type DeviceRestartControllerStartJobData = {
  requestBody: DeviceRestartDataWithNameDto;
};

export type DeviceRestartControllerStartJobResponse = DeviceRestartJobDto;

export type DeviceRestartControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type DeviceRestartControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeviceRestartJobSummaryDto>;
  };

export type DeviceRestartControllerGetJobData = {
  id: number;
};

export type DeviceRestartControllerGetJobResponse = DeviceRestartJobDto;

export type DeviceRestartControllerDeleteJobData = {
  id: number;
};

export type DeviceRestartControllerDeleteJobResponse = boolean;

export type DeviceRestartControllerUpdateJobData = {
  id: number;
  requestBody: DeviceRestartUpdateJobDto;
};

export type DeviceRestartControllerUpdateJobResponse = DeviceRestartJobDto;

export type DeviceRestartControllerCancelJobData = {
  id: number;
};

export type DeviceRestartControllerCancelJobResponse = boolean;

export type DeviceRestartControllerStopJobData = {
  id: number;
};

export type DeviceRestartControllerStopJobResponse = boolean;

export type DeviceRestartControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type DeviceRestartControllerCancelJobsBulkResponse = number;

export type DeviceRestartControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type DeviceRestartControllerDeleteJobsBulkResponse = number;

export type DevicesControllerStateCountsResponse = DevicesStateCountsDto;

export type DevicesControllerListSummariesData = {
  agentVersion?: string;
  clusterId?: number;
  configLocked?: boolean;
  cpu?: string;
  deviceIds?: Array<number>;
  excludeClusterIds?: Array<number>;
  excludeSiteIds?: Array<number>;
  id?: number;
  lastPing?: Date;
  limit: number;
  localIp?: string;
  modelName?: string;
  name?: string;
  os?: string;
  page: number;
  siteId?: number;
  siteIds?: Array<number>;
  /**
   * Sorting by one or more fields, each with an optional direction.
   */
  sortBy?: Array<DeviceOrderEnumSortOption>;
  state?: Array<QueryDeviceState>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  /**
   * Filter by one or more video states
   */
  videoState?: Array<
    "Unknown" | "Disabled" | "Disconnected" | "Down" | "OK" | "All"
  >;
};

export type DevicesControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeviceSummaryDto>;
  };

export type DevicesControllerDownloadData = {
  requestBody: DownloadDeviceSummariesRequestDto;
};

export type DevicesControllerDownloadResponse = LoggedStreamableFile;

export type DevicesControllerListMinimalData = {
  clusterId?: number;
  limit: number;
  name?: string;
  page: number;
  siteId?: number;
  state?: "deploying" | "ready" | "disconnected" | "disabled" | "down";
};

export type DevicesControllerListMinimalResponse = PaginatedResponseDto & {
  results?: Array<MinimalEntityDto>;
};

export type DevicesControllerCreateData = {
  requestBody: CreateDeviceDto;
};

export type DevicesControllerCreateResponse = EntityIdDto;

export type DevicesControllerUpdateActivationTimeData = {
  requestBody: UpdateDevicesActivationTimeDto;
};

export type DevicesControllerUpdateActivationTimeResponse = unknown;

export type DevicesControllerUpdateTagsData = {
  requestBody: UpdateDevicesTagsDto;
};

export type DevicesControllerUpdateTagsResponse = unknown;

export type DevicesControllerUpdateTagsBulkData = {
  requestBody: UpdateDeviceTaggingsBulkDto;
};

export type DevicesControllerUpdateTagsBulkResponse = unknown;

export type DevicesControllerDeployModelBulkData = {
  requestBody: DevicesModelDeploymentBulkDto;
};

export type DevicesControllerDeployModelBulkResponse = unknown;

export type DevicesControllerUpdateConfigLockBulkData = {
  requestBody: DevicesConfigLockBulkDto;
};

export type DevicesControllerUpdateConfigLockBulkResponse = unknown;

export type DevicesControllerDeployServiceVersionBulkData = {
  requestBody: DevicesServiceVersionDeploymentBulkDto;
};

export type DevicesControllerDeployServiceVersionBulkResponse = {
  id?: number;
  scheduled?: boolean;
};

export type DevicesControllerDeployConfigBulkData = {
  requestBody: DevicesConfigDeploymentBulkDto;
};

export type DevicesControllerDeployConfigBulkResponse = {
  id?: number;
  scheduled?: boolean;
};

export type DevicesControllerRestartBulkData = {
  requestBody: DevicesRestartBulkDto;
};

export type DevicesControllerRestartBulkResponse = {
  id?: number;
  scheduled?: boolean;
};

export type DevicesControllerCancelConfigData = {
  requestBody: CancelConfigDeploymentDto;
};

export type DevicesControllerCancelConfigResponse = boolean;

export type DevicesControllerListAvailableComponentVersionsData = {
  /**
   * The component name
   */
  componentName:
    | "edgify-non-scan-detector"
    | "edgify-worker"
    | "edgify-on-screen-app"
    | "edgify-zebra-adapter"
    | "edgify-agent"
    | "edgify-model";
  limit: number;
  page: number;
  version?: string;
};

export type DevicesControllerListAvailableComponentVersionsResponse =
  PaginatedResponseDto & {
    results?: Array<ServiceVersionDto>;
  };

export type DevicesControllerUploadData = {
  formData: UploadDevicesFileDto;
};

export type DevicesControllerUploadResponse = DeviceUploadResponseDto;

export type DevicesControllerGetDetailsData = {
  id: number;
  /**
   * Whether to include labels distribution in the response
   */
  withLabelDistribution?: boolean;
};

export type DevicesControllerGetDetailsResponse = DeviceDetailsDto;

export type DevicesControllerUpdateData = {
  id: number;
  requestBody: UpdateDeviceDto;
};

export type DevicesControllerUpdateResponse = unknown;

export type DevicesControllerListDeviceEventsData = {
  fromDate?: Date;
  id: number;
  limit: number;
  logLevel?: Array<string>;
  page: number;
  sortBy?: Array<DeviceEventsOrderEnumSortOption>;
  text?: string;
  timeField?: "createdAt" | "addedAt";
  toDate?: Date;
};

export type DevicesControllerListDeviceEventsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeviceEventDto>;
  };

export type DevicesControllerGetConfigData = {
  id: number;
};

export type DevicesControllerGetConfigResponse = DeviceConfigDto;

export type DevicesControllerSetConfigData = {
  id: number;
  requestBody: DeviceConfigDto;
};

export type DevicesControllerSetConfigResponse = DeviceConfigDto;

export type DevicesControllerRevertConfigData = {
  id: number;
  requestBody: RevertConfigDto;
};

export type DevicesControllerRevertConfigResponse = boolean;

export type DevicesControllerGetPasswordData = {
  id: number;
};

export type DevicesControllerGetPasswordResponse = PasswordDto;

export type DevicesControllerSetPasswordData = {
  id: number;
  requestBody: PasswordDto;
};

export type DevicesControllerSetPasswordResponse = unknown;

export type DevicesControllerGetConfigLockStateData = {
  id: number;
};

export type DevicesControllerGetConfigLockStateResponse = boolean;

export type DevicesControllerRestartData = {
  id: number;
};

export type DevicesControllerRestartResponse = unknown;

export type DevicesControllerGetSamplesData = {
  captureTrigger?: Array<string>;
  category?: Array<string>;
  datasetType?: Array<string>;
  dataType?: Array<string>;
  deviceId?: Array<number>;
  direction?: string;
  family?: Array<string>;
  from?: Date;
  groupId?: Array<string>;
  headBlurred?: boolean;
  headsFound?: boolean;
  id: number;
  imgSource?: Array<string>;
  label?: Array<string>;
  labelTrigger?: Array<string>;
  limit?: number;
  opened?: boolean;
  orderBy?: string;
  page?: number;
  pendingRemoteAction?: string;
  sampleId?: Array<string>;
  timeField?: string;
  to?: Date;
  uploadedBackend?: boolean;
  uploadedCluster?: boolean;
};

export type DevicesControllerGetSamplesResponse = GetSamplesQueryResponseDto;

export type DevicesControllerAddSampleData = {
  id: number;
  requestBody: AddSampleRequestDto;
};

export type DevicesControllerAddSampleResponse = string;

export type DevicesControllerSaveSampleData = {
  id: number;
  requestBody: SaveSampleRequestDto;
};

export type DevicesControllerSaveSampleResponse = SaveSampleResponseDto;

export type DevicesControllerDeleteSamplesData = {
  id: number;
  requestBody: Array<string>;
};

export type DevicesControllerDeleteSamplesResponse = unknown;

export type DevicesControllerGetSamplesSizeData = {
  captureTrigger?: Array<string>;
  category?: Array<string>;
  datasetType?: Array<string>;
  dataType?: Array<string>;
  deviceId?: Array<number>;
  direction?: string;
  family?: Array<string>;
  from?: Date;
  groupId?: Array<string>;
  headBlurred?: boolean;
  headsFound?: boolean;
  id: number;
  imgSource?: Array<string>;
  label?: Array<string>;
  labelTrigger?: Array<string>;
  limit?: number;
  opened?: boolean;
  orderBy?: string;
  page?: number;
  pendingRemoteAction?: string;
  sampleId?: Array<string>;
  timeField?: string;
  to?: Date;
  uploadedBackend?: boolean;
  uploadedCluster?: boolean;
};

export type DevicesControllerGetSamplesSizeResponse = number;

export type DevicesControllerGetSamplesStatsData = {
  id: number;
};

export type DevicesControllerGetSamplesStatsResponse = DataStreamDto;

export type DevicesControllerStartRecordingData = {
  id: number;
};

export type DevicesControllerStartRecordingResponse = StartRecordingResponseDto;

export type DevicesControllerStopRecordingData = {
  id: number;
  requestBody: StopRecordingRequestDto;
};

export type DevicesControllerStopRecordingResponse = StopRecordingResponseDto;

export type DevicesControllerStartVideoUploadData = {
  id: number;
  requestBody: StartVideoUploadRequestDto;
};

export type DevicesControllerStartVideoUploadResponse = StartUploadResponseDto;

export type DevicesControllerStopVideoUploadData = {
  id: number;
  requestBody: NameRequestDto;
};

export type DevicesControllerStopVideoUploadResponse = unknown;

export type DevicesControllerGetVideoUploadStateData = {
  id: number;
};

export type DevicesControllerGetVideoUploadStateResponse =
  VideoUploadProgressDto;

export type DevicesControllerStartSamplesUploadData = {
  id: number;
  requestBody: StartSamplesUploadRequestDto;
};

export type DevicesControllerStartSamplesUploadResponse =
  StartUploadResponseDto;

export type DevicesControllerStopSamplesUploadData = {
  id: number;
  requestBody: NameRequestDto;
};

export type DevicesControllerStopSamplesUploadResponse = unknown;

export type DevicesControllerGetSamplesUploadStateData = {
  id: number;
};

export type DevicesControllerGetSamplesUploadStateResponse =
  SampleUploadProgressDto;

export type DevicesControllerListSamplesUploadsData = {
  /**
   * true → only running; false → only finished
   */
  active?: boolean;
  id: number;
  /**
   * true → only most recent run per name; false → only non-latest
   */
  latest?: boolean;
  limit?: number;
  page?: number;
};

export type DevicesControllerListSamplesUploadsResponse =
  ListSamplesUploadsResponseDto;

export type DevicesControllerGetSamplesUploadStateByNameData = {
  id: number;
  name: string;
};

export type DevicesControllerGetSamplesUploadStateByNameResponse =
  SampleUploadProgressDto;

export type DevicesControllerListVideoUploadsData = {
  /**
   * true → only running; false → only finished
   */
  active?: boolean;
  id: number;
  /**
   * true → only most recent run per name; false → only non-latest
   */
  latest?: boolean;
  limit?: number;
  page?: number;
};

export type DevicesControllerListVideoUploadsResponse =
  ListVideoUploadsResponseDto;

export type DevicesControllerGetVideoUploadStateByNameData = {
  id: number;
  name: string;
};

export type DevicesControllerGetVideoUploadStateByNameResponse =
  VideoUploadProgressDto;

export type DevicesControllerStartHeadBlurVideosData = {
  id: number;
  requestBody: StartHeadBlurVideosRequestDto;
};

export type DevicesControllerStartHeadBlurVideosResponse =
  StartUploadResponseDto;

export type DevicesControllerStopHeadBlurVideosData = {
  id: number;
  requestBody: NameRequestDto;
};

export type DevicesControllerStopHeadBlurVideosResponse = unknown;

export type DevicesControllerGetHeadBlurVideosStateData = {
  id: number;
};

export type DevicesControllerGetHeadBlurVideosStateResponse =
  HeadBlurVideosStateDto;

export type DevicesControllerGetHeadBlurVideoStateData = {
  id: number;
};

export type DevicesControllerGetHeadBlurVideoStateResponse = BlurProgressDto;

export type DevicesControllerListHeadBlurVideosData = {
  /**
   * true → only running; false → only finished
   */
  active?: boolean;
  id: number;
  /**
   * true → only most recent run per name; false → only non-latest
   */
  latest?: boolean;
  limit?: number;
  page?: number;
};

export type DevicesControllerListHeadBlurVideosResponse =
  ListHeadBlurVideosResponseDto;

export type DevicesControllerGetHeadBlurVideosStateByNameData = {
  id: number;
  name: string;
};

export type DevicesControllerGetHeadBlurVideosStateByNameResponse =
  HeadBlurVideosStateDto;

export type DevicesControllerStartHeadBlurImagesData = {
  id: number;
  requestBody: StartHeadBlurImagesRequestDto;
};

export type DevicesControllerStartHeadBlurImagesResponse =
  StartUploadResponseDto;

export type DevicesControllerStopHeadBlurImagesData = {
  id: number;
  requestBody: NameRequestDto;
};

export type DevicesControllerStopHeadBlurImagesResponse = unknown;

export type DevicesControllerGetHeadBlurImagesStateData = {
  id: number;
};

export type DevicesControllerGetHeadBlurImagesStateResponse =
  HeadBlurImagesStateDto;

export type DevicesControllerListHeadBlurImagesData = {
  /**
   * true → only running; false → only finished
   */
  active?: boolean;
  id: number;
  /**
   * true → only most recent run per name; false → only non-latest
   */
  latest?: boolean;
  limit?: number;
  page?: number;
};

export type DevicesControllerListHeadBlurImagesResponse =
  ListHeadBlurImagesResponseDto;

export type DevicesControllerHeadBlurImageData = {
  id: number;
  requestBody: HeadBlurImageRequestDto;
};

export type DevicesControllerHeadBlurImageResponse = HeadBlurImageResponseDto;

export type DevicesControllerGetHeadBlurImagesStateByNameData = {
  id: number;
  name: string;
};

export type DevicesControllerGetHeadBlurImagesStateByNameResponse =
  HeadBlurImagesStateDto;

export type DevicesControllerCaptureData = {
  id: number;
  requestBody: CaptureRequestDto;
};

export type DevicesControllerCaptureResponse = string;

export type DevicesControllerCaptureAndPredictData = {
  id: number;
  requestBody: CaptureAndPredictRequestDto;
};

export type DevicesControllerCaptureAndPredictResponse =
  CaptureAndPredictResponseTranslatedDto;

export type DevicesControllerPredictData = {
  id: number;
  requestBody: PredictRequestDto;
};

export type DevicesControllerPredictResponse = PredictResponseTranslatedDto;

export type DevicesControllerGetSampleData = {
  id: number;
  sampleId: string;
};

export type DevicesControllerGetSampleResponse = unknown;

export type DevicesControllerGetSampleThumbnailData = {
  expand?: boolean;
  height?: number;
  id: number;
  raw?: boolean;
  sampleId: string;
  width?: number;
};

export type DevicesControllerGetSampleThumbnailResponse = unknown;

export type DevicesControllerSyncSamplesData = {
  id: number;
};

export type DevicesControllerSyncSamplesResponse = unknown;

export type DevicesControllerUnlockSamplesData = {
  id: number;
  requestBody: GetSamplesQueryRequestDto;
};

export type DevicesControllerUnlockSamplesResponse = unknown;

export type DevicesControllerUnlockSamplesByUuidsData = {
  id: number;
  requestBody: Array<string>;
};

export type DevicesControllerUnlockSamplesByUuidsResponse = unknown;

export type DevicesControllerUnlockAllSamplesData = {
  id: number;
};

export type DevicesControllerUnlockAllSamplesResponse = unknown;

export type DevicesControllerLockSamplesData = {
  id: number;
  requestBody: GetSamplesQueryRequestDto;
};

export type DevicesControllerLockSamplesResponse = unknown;

export type DevicesControllerLockAllSamplesData = {
  id: number;
};

export type DevicesControllerLockAllSamplesResponse = unknown;

export type DevicesControllerGetSessionsData = {
  deviceId?: Array<number>;
  direction?: string;
  from?: Date;
  headBlurred?: boolean;
  id: number;
  limit?: number;
  order?: string;
  page?: number;
  sessionId?: Array<string>;
  shouldUpload?: boolean;
  timeField?: string;
  to?: Date;
  uploadedBackend?: boolean;
  uploadedCluster?: boolean;
};

export type DevicesControllerGetSessionsResponse = GetSessionsResponseDto;

export type DevicesControllerGetSessionsSizeData = {
  deviceId?: Array<number>;
  direction?: string;
  from?: Date;
  headBlurred?: boolean;
  id: number;
  limit?: number;
  order?: string;
  page?: number;
  sessionId?: Array<string>;
  shouldUpload?: boolean;
  timeField?: string;
  to?: Date;
  uploadedBackend?: boolean;
  uploadedCluster?: boolean;
};

export type DevicesControllerGetSessionsSizeResponse = number;

export type DevicesControllerSyncSessionsData = {
  id: number;
};

export type DevicesControllerSyncSessionsResponse = unknown;

export type DevicesControllerDeleteSessionData = {
  id: number;
  sessionId: string;
};

export type DevicesControllerDeleteSessionResponse = unknown;

export type DevicesControllerUploadLogsData = {
  id: number;
};

export type DevicesControllerUploadLogsResponse = unknown;

export type DevicesControllerUploadTrainerLogsData = {
  id: number;
};

export type DevicesControllerUploadTrainerLogsResponse = unknown;

export type DevicesControllerDeployAgentVersionData = {
  id: number;
  requestBody: DeployAgentVersionRequestDto;
};

export type DevicesControllerDeployAgentVersionResponse = unknown;

export type DevicesControllerGetAgentDeploymentsData = {
  id: number;
  limit: number;
  page: number;
};

export type DevicesControllerGetAgentDeploymentsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<AgentDeploymentDto>;
  };

export type DevicesControllerDeployServiceData = {
  id: number;
  requestBody: DeployServiceVersionDto;
};

export type DevicesControllerDeployServiceResponse = {
  id?: number;
  scheduled?: boolean;
};

export type DevicesControllerGetServiceDeploymentsData = {
  id: number;
  limit: number;
  page: number;
  serviceName?:
    | "edgify-non-scan-detector"
    | "edgify-worker"
    | "edgify-on-screen-app"
    | "edgify-zebra-adapter"
    | "edgify-agent"
    | "edgify-model";
};

export type DevicesControllerGetServiceDeploymentsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ServiceDeploymentDto>;
  };

export type DevicesControllerGetAvailableServiceVersionsData = {
  id: number;
  limit: number;
  page: number;
  /**
   * The service name
   */
  serviceName:
    | "edgify-non-scan-detector"
    | "edgify-worker"
    | "edgify-on-screen-app"
    | "edgify-zebra-adapter"
    | "edgify-agent"
    | "edgify-model";
  version?: string;
};

export type DevicesControllerGetAvailableServiceVersionsResponse =
  PaginatedResponseDto & {
    results?: Array<ServiceVersionDto>;
  };

export type DevicesControllerTestAlertNonMatchData = {
  id: number;
};

export type DevicesControllerTestAlertNonMatchResponse = unknown;

export type DevicesControllerTestAlertNonScanData = {
  id: number;
};

export type DevicesControllerTestAlertNonScanResponse = unknown;

export type DevicesControllerTestAlertLeftInCartData = {
  id: number;
};

export type DevicesControllerTestAlertLeftInCartResponse = unknown;

export type DevicesControllerListCamerasData = {
  id: number;
  raw?: boolean;
};

export type DevicesControllerListCamerasResponse = {
  [key: string]: unknown;
};

export type DevicesControllerListInternalCamerasData = {
  id: number;
  raw?: boolean;
};

export type DevicesControllerListInternalCamerasResponse = {
  [key: string]: unknown;
};

export type DevicesControllerListExternalCameraData = {
  id: number;
  raw?: boolean;
  uri?: string;
};

export type DevicesControllerListExternalCameraResponse = {
  [key: string]: unknown;
};

export type DevicesControllerGetCameraControlsData = {
  id: number;
  raw?: boolean;
};

export type DevicesControllerGetCameraControlsResponse =
  | string
  | {
      [key: string]: unknown;
    };

export type DevicesControllerSetCameraControlsData = {
  id: number;
  requestBody: {
    [key: string]: unknown;
  };
};

export type DevicesControllerSetCameraControlsResponse = {
  [key: string]: unknown;
};

export type DevicesControllerListConfigDeploymentsData = {
  id: number;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ListDeviceConfigOrderEnumSortOption>;
};

export type DevicesControllerListConfigDeploymentsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<DeviceConfigDeploymentDto>;
  };

export type DevicesControllerDisableDeviceAlertsData = {
  requestBody: DisableDeviceAlertsDto;
};

export type DevicesControllerDisableDeviceAlertsResponse = unknown;

export type DevicesControllerEnableDeviceAlertsData = {
  requestBody: EnableDeviceAlertsDto;
};

export type DevicesControllerEnableDeviceAlertsResponse = unknown;

export type DevicesControllerGetDeviceAlertsStatusData = {
  requestBody: DeviceAlertsStatusRequestDto;
};

export type DevicesControllerGetDeviceAlertsStatusResponse =
  DeviceAlertsStatusDto;

export type DevicesControllerSetDeviceAlertsData = {
  requestBody: SetDeviceAlertsDto;
};

export type DevicesControllerSetDeviceAlertsResponse = DeviceAlertsStatusDto;

export type DevicesControllerTestConnectionData = {
  id: number;
  requestBody: TestConnectionRequestDto;
};

export type DevicesControllerTestConnectionResponse = unknown;

export type DevicesControllerGetConfigFileData = {
  field:
    | "Mqtt.tls.ca_cert"
    | "Mqtt.tls.client_cert"
    | "Mqtt.tls.client_key"
    | "DataManager.tls.ca_cert"
    | "Agent.tls.server_cert"
    | "Agent.tls.server_key";
  id: number;
};

export type DevicesControllerGetConfigFileResponse = GetConfigFileResponseDto;

export type DevicesControllerSetConfigFileData = {
  id: number;
  requestBody: SetConfigFileRequestDto;
};

export type DevicesControllerSetConfigFileResponse = unknown;

export type DevicesControllerDeleteConfigFileData = {
  field:
    | "Mqtt.tls.ca_cert"
    | "Mqtt.tls.client_cert"
    | "Mqtt.tls.client_key"
    | "DataManager.tls.ca_cert"
    | "Agent.tls.server_cert"
    | "Agent.tls.server_key";
  id: number;
};

export type DevicesControllerDeleteConfigFileResponse = unknown;

export type DevicesControllerGenerateCertificateData = {
  id: number;
};

export type DevicesControllerGenerateCertificateResponse = unknown;

export type DevicesControllerGetCertValidityData = {
  field:
    | "Mqtt.tls.ca_cert"
    | "Mqtt.tls.client_cert"
    | "DataManager.tls.ca_cert"
    | "Agent.tls.server_cert"
    | "Agent.tls.ca_cert";
  id: number;
};

export type DevicesControllerGetCertValidityResponse =
  GetCertValidityResponseDto;

export type DevicesTaggingControllerListTagsData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TagOrderEnumSortOption>;
};

export type DevicesTaggingControllerListTagsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<TagSummaryDto>;
  };

export type DevicesTaggingControllerCreateTagsData = {
  requestBody: CreateTagsDto;
};

export type DevicesTaggingControllerCreateTagsResponse = {
  [key: string]: unknown;
};

export type DevicesTaggingControllerAssignTagsData = {
  requestBody: AssignTagsDto;
};

export type DevicesTaggingControllerAssignTagsResponse = AssignTagsResponseDto;

export type DevicesTaggingControllerUnassignTagsData = {
  requestBody: UnassignTagsDto;
};

export type DevicesTaggingControllerUnassignTagsResponse =
  UnassignTagsResponseDto;

export type DevicesTaggingControllerGetDetailsData = {
  id: number;
};

export type DevicesTaggingControllerGetDetailsResponse = TagDetailsDto;

export type DevicesTaggingControllerUpdateTagData = {
  id: number;
  requestBody: UpdateTagDto;
};

export type DevicesTaggingControllerUpdateTagResponse = TagDetailsDto;

export type DevicesTaggingControllerDeleteTagData = {
  id: number;
};

export type DevicesTaggingControllerDeleteTagResponse = unknown;

export type DevicesTaggingControllerMergeTagToData = {
  id: number;
  mergedToId: number;
};

export type DevicesTaggingControllerMergeTagToResponse = unknown;

export type DevicesTaggingControllerListSummariesData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TagOrderEnumSortOption>;
};

export type DevicesTaggingControllerListSummariesResponse = unknown;

export type DomainAuthSettingsControllerCreateData = {
  requestBody: CreateDomainAuthSettingDto;
};

export type DomainAuthSettingsControllerCreateResponse =
  DomainAuthSettingResponseDto;

export type DomainAuthSettingsControllerListResponse =
  Array<DomainAuthSettingResponseDto>;

export type DomainAuthSettingsControllerFindOneData = {
  domain: string;
};

export type DomainAuthSettingsControllerFindOneResponse =
  DomainAuthSettingResponseDto;

export type DomainAuthSettingsControllerUpdateData = {
  domain: string;
  requestBody: UpdateDomainAuthSettingDto;
};

export type DomainAuthSettingsControllerUpdateResponse =
  DomainAuthSettingResponseDto;

export type DomainAuthSettingsControllerRemoveData = {
  domain: string;
};

export type DomainAuthSettingsControllerRemoveResponse = unknown;

export type EmailReportsControllerCreateScheduleData = {
  requestBody: EmailReportsScheduleJobDto;
};

export type EmailReportsControllerCreateScheduleResponse =
  EmailReportsScheduledJobSummaryDto;

export type EmailReportsControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type EmailReportsControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<EmailReportsScheduledJobSummaryDto>;
  };

export type EmailReportsControllerListSubscriptionsByReportData = {
  limit: number;
  page: number;
  reportId: number;
};

export type EmailReportsControllerListSubscriptionsByReportResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ReportSubscriptionSummaryDto>;
  };

export type EmailReportsControllerGetSubscriptionDetailData = {
  subscriptionId: number;
};

export type EmailReportsControllerGetSubscriptionDetailResponse =
  ReportSubscriptionDetailDto;

export type EmailReportsControllerListApproverCandidateEmailsResponse =
  Array<string>;

export type EmailReportsControllerGetLastSentCopyData = {
  subscriptionId: number;
};

export type EmailReportsControllerGetLastSentCopyResponse = string;

export type EmailReportsControllerDownloadSubscriptionPdfData = {
  subscriptionId: number;
};

export type EmailReportsControllerDownloadSubscriptionPdfResponse = unknown;

export type EmailReportsControllerGetSubscriptionSendHistoryData = {
  limit: number;
  outcomes?: Array<
    | "rejected"
    | "failed"
    | "sent"
    | "waitingApproval"
    | "approvalExpired"
    | "notSent"
    | "inProgress"
  >;
  page: number;
  since?: Date;
  subscriptionId: number;
  until?: Date;
};

export type EmailReportsControllerGetSubscriptionSendHistoryResponse =
  SubscriptionSendHistoryResponseDto;

export type EmailReportsControllerDownloadSubscriptionSendHistoryData = {
  requestBody: DownloadSubscriptionSendHistoryRequestDto;
};

export type EmailReportsControllerDownloadSubscriptionSendHistoryResponse =
  LoggedStreamableFile;

export type EmailReportsControllerPreviewHistoricalSendData = {
  jobId: number;
  subscriptionId: number;
};

export type EmailReportsControllerPreviewHistoricalSendResponse = string;

export type EmailReportsControllerGetReportSendLogData = {
  reportId: number;
};

export type EmailReportsControllerGetReportSendLogResponse =
  ReportSendLogResponseDto;

export type EmailReportsControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: EmailReportsUpdateScheduledJobDto;
};

export type EmailReportsControllerUpdateScheduledJobResponse =
  EmailReportsScheduledJobDto;

export type EmailReportsControllerDeleteScheduledJobData = {
  id: number;
};

export type EmailReportsControllerDeleteScheduledJobResponse = boolean;

export type EmailReportsControllerGetScheduledJobData = {
  id: number;
};

export type EmailReportsControllerGetScheduledJobResponse =
  EmailReportsScheduledJobDto;

export type EmailReportsControllerStartScheduledJobData = {
  id: number;
};

export type EmailReportsControllerStartScheduledJobResponse = {
  [key: string]: unknown;
};

export type EmailReportsControllerCancelScheduledJobData = {
  id: number;
};

export type EmailReportsControllerCancelScheduledJobResponse = boolean;

export type EmailReportsControllerStopScheduledJobData = {
  id: number;
};

export type EmailReportsControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type EmailReportsControllerResumeScheduledJobData = {
  id: number;
};

export type EmailReportsControllerResumeScheduledJobResponse =
  EmailReportsScheduledJobSummaryDto;

export type EmailReportsControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type EmailReportsControllerCancelScheduledJobsBulkResponse = number;

export type EmailReportsControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type EmailReportsControllerStopScheduledJobsBulkResponse = number;

export type EmailReportsControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type EmailReportsControllerResumeScheduledJobsBulkResponse = number;

export type EmailReportsControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type EmailReportsControllerDeleteScheduledJobsBulkResponse = number;

export type EmailReportsControllerUnsubscribeData = {
  email: string;
  id: number;
};

export type EmailReportsControllerUnsubscribeResponse = {
  [key: string]: unknown;
};

export type EmailReportsControllerSendPendingReportData = {
  requestBody: SendPendingReportDto;
};

export type EmailReportsControllerSendPendingReportResponse =
  SendPendingReportResponseDto;

export type EmailReportsControllerRejectPendingReportData = {
  requestBody: RejectPendingReportDto;
};

export type EmailReportsControllerRejectPendingReportResponse = unknown;

export type EmailReportsControllerPreviewPendingReportData = {
  subscriptionId: number;
};

export type EmailReportsControllerPreviewPendingReportResponse = string;

export type EmailReportsControllerPreviewTemplateData = {
  requestBody: PreviewTemplateDto;
};

export type EmailReportsControllerPreviewTemplateResponse = string;

export type EmailReportsControllerUpdateSummaryTextData = {
  requestBody: UpdateSummaryTextDto;
};

export type EmailReportsControllerUpdateSummaryTextResponse = unknown;

export type EmailReportsControllerStartJobData = {
  requestBody: EmailReportsDataWithNameDto;
};

export type EmailReportsControllerStartJobResponse = EmailReportsJobDto;

export type EmailReportsControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type EmailReportsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<EmailReportsJobSummaryDto>;
  };

export type EmailReportsControllerGetJobData = {
  id: number;
};

export type EmailReportsControllerGetJobResponse = EmailReportsJobDto;

export type EmailReportsControllerDeleteJobData = {
  id: number;
};

export type EmailReportsControllerDeleteJobResponse = boolean;

export type EmailReportsControllerUpdateJobData = {
  id: number;
  requestBody: EmailReportsUpdateJobDto;
};

export type EmailReportsControllerUpdateJobResponse = EmailReportsJobDto;

export type EmailReportsControllerCancelJobData = {
  id: number;
};

export type EmailReportsControllerCancelJobResponse = boolean;

export type EmailReportsControllerStopJobData = {
  id: number;
};

export type EmailReportsControllerStopJobResponse = boolean;

export type EmailReportsControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type EmailReportsControllerCancelJobsBulkResponse = number;

export type EmailReportsControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type EmailReportsControllerDeleteJobsBulkResponse = number;

export type FeedbackControllerCreateFeedbackData = {
  formData: CreateFeedbackDto;
};

export type FeedbackControllerCreateFeedbackResponse = unknown;

export type HeadBlurImagesControllerCreateScheduleData = {
  requestBody: HeadBlurImagesScheduleJobDto;
};

export type HeadBlurImagesControllerCreateScheduleResponse =
  HeadBlurImagesScheduledJobSummaryDto;

export type HeadBlurImagesControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type HeadBlurImagesControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<HeadBlurImagesScheduledJobSummaryDto>;
  };

export type HeadBlurImagesControllerGetScheduledJobData = {
  id: number;
};

export type HeadBlurImagesControllerGetScheduledJobResponse =
  HeadBlurImagesScheduledJobDto;

export type HeadBlurImagesControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: HeadBlurImagesUpdateScheduledJobDto;
};

export type HeadBlurImagesControllerUpdateScheduledJobResponse =
  HeadBlurImagesScheduledJobDto;

export type HeadBlurImagesControllerDeleteScheduledJobData = {
  id: number;
};

export type HeadBlurImagesControllerDeleteScheduledJobResponse = boolean;

export type HeadBlurImagesControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type HeadBlurImagesControllerCancelScheduledJobsBulkResponse = number;

export type HeadBlurImagesControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type HeadBlurImagesControllerStopScheduledJobsBulkResponse = number;

export type HeadBlurImagesControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type HeadBlurImagesControllerResumeScheduledJobsBulkResponse = number;

export type HeadBlurImagesControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type HeadBlurImagesControllerDeleteScheduledJobsBulkResponse = number;

export type HeadBlurImagesControllerStartScheduledJobData = {
  id: number;
};

export type HeadBlurImagesControllerStartScheduledJobResponse =
  HeadBlurImagesJobDto;

export type HeadBlurImagesControllerCancelScheduledJobData = {
  id: number;
};

export type HeadBlurImagesControllerCancelScheduledJobResponse = boolean;

export type HeadBlurImagesControllerStopScheduledJobData = {
  id: number;
};

export type HeadBlurImagesControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type HeadBlurImagesControllerResumeScheduledJobData = {
  id: number;
};

export type HeadBlurImagesControllerResumeScheduledJobResponse =
  HeadBlurImagesScheduledJobSummaryDto;

export type HeadBlurImagesControllerStartJobData = {
  requestBody: HeadBlurImagesDataWithNameDto;
};

export type HeadBlurImagesControllerStartJobResponse = HeadBlurImagesJobDto;

export type HeadBlurImagesControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type HeadBlurImagesControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<HeadBlurImagesJobSummaryDto>;
  };

export type HeadBlurImagesControllerGetJobData = {
  id: number;
};

export type HeadBlurImagesControllerGetJobResponse = HeadBlurImagesJobDto;

export type HeadBlurImagesControllerDeleteJobData = {
  id: number;
};

export type HeadBlurImagesControllerDeleteJobResponse = boolean;

export type HeadBlurImagesControllerUpdateJobData = {
  id: number;
  requestBody: HeadBlurImagesUpdateJobDto;
};

export type HeadBlurImagesControllerUpdateJobResponse = HeadBlurImagesJobDto;

export type HeadBlurImagesControllerCancelJobData = {
  id: number;
};

export type HeadBlurImagesControllerCancelJobResponse = boolean;

export type HeadBlurImagesControllerStopJobData = {
  id: number;
};

export type HeadBlurImagesControllerStopJobResponse = boolean;

export type HeadBlurImagesControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type HeadBlurImagesControllerCancelJobsBulkResponse = number;

export type HeadBlurImagesControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type HeadBlurImagesControllerDeleteJobsBulkResponse = number;

export type HeadBlurVideosControllerCreateScheduleData = {
  requestBody: HeadBlurVideosScheduleJobDto;
};

export type HeadBlurVideosControllerCreateScheduleResponse =
  HeadBlurVideosScheduledJobSummaryDto;

export type HeadBlurVideosControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type HeadBlurVideosControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<HeadBlurVideosScheduledJobSummaryDto>;
  };

export type HeadBlurVideosControllerGetScheduledJobData = {
  id: number;
};

export type HeadBlurVideosControllerGetScheduledJobResponse =
  HeadBlurVideosScheduledJobDto;

export type HeadBlurVideosControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: HeadBlurVideosUpdateScheduledJobDto;
};

export type HeadBlurVideosControllerUpdateScheduledJobResponse =
  HeadBlurVideosScheduledJobDto;

export type HeadBlurVideosControllerDeleteScheduledJobData = {
  id: number;
};

export type HeadBlurVideosControllerDeleteScheduledJobResponse = boolean;

export type HeadBlurVideosControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type HeadBlurVideosControllerCancelScheduledJobsBulkResponse = number;

export type HeadBlurVideosControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type HeadBlurVideosControllerStopScheduledJobsBulkResponse = number;

export type HeadBlurVideosControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type HeadBlurVideosControllerResumeScheduledJobsBulkResponse = number;

export type HeadBlurVideosControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type HeadBlurVideosControllerDeleteScheduledJobsBulkResponse = number;

export type HeadBlurVideosControllerStartScheduledJobData = {
  id: number;
};

export type HeadBlurVideosControllerStartScheduledJobResponse =
  HeadBlurVideosJobDto;

export type HeadBlurVideosControllerCancelScheduledJobData = {
  id: number;
};

export type HeadBlurVideosControllerCancelScheduledJobResponse = boolean;

export type HeadBlurVideosControllerStopScheduledJobData = {
  id: number;
};

export type HeadBlurVideosControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type HeadBlurVideosControllerResumeScheduledJobData = {
  id: number;
};

export type HeadBlurVideosControllerResumeScheduledJobResponse =
  HeadBlurVideosScheduledJobSummaryDto;

export type HeadBlurVideosControllerStartJobData = {
  requestBody: HeadBlurVideosDataWithNameDto;
};

export type HeadBlurVideosControllerStartJobResponse = HeadBlurVideosJobDto;

export type HeadBlurVideosControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type HeadBlurVideosControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<HeadBlurVideosJobSummaryDto>;
  };

export type HeadBlurVideosControllerGetJobData = {
  id: number;
};

export type HeadBlurVideosControllerGetJobResponse = HeadBlurVideosJobDto;

export type HeadBlurVideosControllerDeleteJobData = {
  id: number;
};

export type HeadBlurVideosControllerDeleteJobResponse = boolean;

export type HeadBlurVideosControllerUpdateJobData = {
  id: number;
  requestBody: HeadBlurVideosUpdateJobDto;
};

export type HeadBlurVideosControllerUpdateJobResponse = HeadBlurVideosJobDto;

export type HeadBlurVideosControllerCancelJobData = {
  id: number;
};

export type HeadBlurVideosControllerCancelJobResponse = boolean;

export type HeadBlurVideosControllerStopJobData = {
  id: number;
};

export type HeadBlurVideosControllerStopJobResponse = boolean;

export type HeadBlurVideosControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type HeadBlurVideosControllerCancelJobsBulkResponse = number;

export type HeadBlurVideosControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type HeadBlurVideosControllerDeleteJobsBulkResponse = number;

export type JiraControllerGetIssueTypeData = {
  requestBody: JiraAuthOrAccountDto;
};

export type JiraControllerGetIssueTypeResponse = {
  [key: string]: unknown;
};

export type JiraControllerGetProjectIssueTypesData = {
  requestBody: ProjectIssueTypesDto;
};

export type JiraControllerGetProjectIssueTypesResponse = {
  [key: string]: unknown;
};

export type JiraControllerGetStateData = {
  requestBody: StateInputFlexibleDto;
};

export type JiraControllerGetStateResponse = Array<JiraState>;

export type LabelDistributionControllerListLabelDistributionData = {
  clusterIds?: Array<number>;
  deviceIds?: Array<number>;
  families?: Array<string>;
  family?: string;
  label?: string;
  labels?: Array<string>;
  limit: number;
  page: number;
  quantity?: Array<NumberConditionDto>;
  siteIds?: Array<number>;
  sortBy?: Array<LabelDistributionOrderEnumSortOption>;
};

export type LabelDistributionControllerListLabelDistributionResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<LabelDistributionDto>;
  };

export type LabelDistributionControllerLabelDistributionCountData = {
  clusterIds?: Array<number>;
  deviceIds?: Array<number>;
  families?: Array<string>;
  family?: string;
  label?: string;
  labels?: Array<string>;
  quantity?: Array<NumberConditionDto>;
  siteIds?: Array<number>;
  sortBy?: Array<LabelDistributionOrderEnumSortOption>;
};

export type LabelDistributionControllerLabelDistributionCountResponse = number;

export type LookupTableControllerCreateData = {
  formData: CreateLookupTableDto;
};

export type LookupTableControllerCreateResponse = EntityIdDto;

export type LookupTableControllerListSummariesData = {
  limit: number;
  page: number;
  sortBy?: Array<LookupTablesOrderEnumSortOption>;
};

export type LookupTableControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<LookupTablesSummaryDto>;
  };

export type LookupTableControllerUpdateData = {
  formData: UpdateLookupTableDto;
  id: number;
};

export type LookupTableControllerUpdateResponse = boolean;

export type LookupTableControllerGetDetailsData = {
  id: number;
};

export type LookupTableControllerGetDetailsResponse = LookupTableDetailsDto;

export type LookupTableControllerDeleteData = {
  id: number;
};

export type LookupTableControllerDeleteResponse = unknown;

export type LookupTableControllerDownloadCatalogData = {
  id: number;
};

export type LookupTableControllerDownloadCatalogResponse = unknown;

export type MetricAlertsControllerCreateData = {
  requestBody: CreateMetricAlertDto;
};

export type MetricAlertsControllerCreateResponse = MetricAlertResponseDto;

export type MetricAlertsControllerListData = {
  limit: number;
  name?: string;
  page: number;
  priority?: Array<AlertPriority>;
  severity?: Array<AlertSeverity>;
  sortBy?: Array<MetricAlertsOrderEnumSortOption>;
};

export type MetricAlertsControllerListResponse = PaginatedResponseDto & {
  results?: Array<MetricAlertResponseDto>;
};

export type MetricAlertsControllerGetByIdData = {
  id: number;
};

export type MetricAlertsControllerGetByIdResponse = MetricAlertResponseDto;

export type MetricAlertsControllerUpdateData = {
  id: number;
  requestBody: UpdateMetricAlertDto;
};

export type MetricAlertsControllerUpdateResponse = MetricAlertResponseDto;

export type MetricAlertsControllerRemoveData = {
  id: number;
};

export type MetricAlertsControllerRemoveResponse = unknown;

export type MetricAlertsControllerPreviewData = {
  requestBody: PreviewMetricAlertDto;
};

export type MetricAlertsControllerPreviewResponse =
  PreviewMetricAlertResponseDto;

export type MetricAlertsControllerTestData = {
  id: number;
  requestBody: TestMetricAlertDto;
};

export type MetricAlertsControllerTestResponse = TestMetricAlertResponseDto;

export type ModelsControllerListSummariesData = {
  limit: number;
  name?: string;
  page: number;
  role?: string;
  search?: string;
  sortBy?: Array<ModelSummariesOrderEnumSortOption>;
  type?: ModelType;
};

export type ModelsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ModelSummaryDto>;
  };

export type ModelsControllerListMinimalData = {
  limit: number;
  name?: string;
  orderBy?: "name" | "createdAt";
  page: number;
  role?: string;
  search?: string;
  sortBy?: Array<MinimalModelOrderEnumSortOption>;
  type?: ModelType;
};

export type ModelsControllerListMinimalResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ModelMinimalDto>;
  };

export type ModelsControllerListModelRolesData = {
  limit: number;
  name?: string;
  page: number;
  role?: string;
  search?: string;
  sortBy?: Array<ModelSummariesOrderEnumSortOption>;
  type?: ModelType;
};

export type ModelsControllerListModelRolesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<string>;
  };

export type ModelsControllerGetDetailsData = {
  id: number;
};

export type ModelsControllerGetDetailsResponse = ModelDetailsDto;

export type ModelsControllerUpdateData = {
  id: number;
  requestBody: UpdateModelDto;
};

export type ModelsControllerUpdateResponse = unknown;

export type ModelsControllerUploadModelData = {
  formData: UploadModelDto;
};

export type ModelsControllerUploadModelResponse = EntityIdDto;

export type ModelsControllerDownloadModelData = {
  id: number;
};

export type ModelsControllerDownloadModelResponse = unknown;

export type ModelsControllerListDeploymentsData = {
  clusterIds?: Array<number>;
  deviceStates?: Array<
    "deploying" | "ready" | "disconnected" | "disabled" | "down"
  >;
  id: number;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ModelDeploymentsOrderEnumSortOption>;
  state?:
    | "pending"
    | "cancelled"
    | "installing"
    | "failed"
    | "running"
    | "stopped"
    | "all";
  states?: Array<
    "pending" | "cancelled" | "installing" | "failed" | "running" | "stopped"
  >;
};

export type ModelsControllerListDeploymentsResponse = PaginatedResponseDto & {
  results?: Array<ModelDeploymentDto>;
};

export type ModelsControllerListClusterDeploymentsData = {
  clusterIds?: Array<number>;
  id: number;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ClusterModelDeploymentsOrderEnumSortOption>;
};

export type ModelsControllerListClusterDeploymentsResponse =
  PaginatedResponseDto & {
    results?: Array<ClusterModelDeploymentDto>;
  };

export type ModelsControllerDeployModelData = {
  id: number;
  requestBody: DeployModelDto;
};

export type ModelsControllerDeployModelResponse = DeployModelResponseDto;

export type NotificationsControllerGetActiveResponse =
  Array<NotificationResponseDto>;

export type NotificationsControllerCreateData = {
  requestBody: CreateNotificationDto;
};

export type NotificationsControllerCreateResponse = NotificationResponseDto;

export type NotificationsControllerGetActivePublicResponse =
  Array<PublicNotificationResponseDto>;

export type NotificationsControllerListSummariesData = {
  /**
   * Filter by active state. Defaults to true (only active records).
   */
  isActive?: boolean;
  limit: number;
  page: number;
  sortBy?: Array<NotificationsOrderEnumSortOption>;
  /**
   * Filter by status
   */
  status?: "Draft" | "Scheduled" | "Active" | "Archived" | "Canceled";
  /**
   * Filter by title (case-insensitive partial match)
   */
  title?: string;
  /**
   * Filter by notification type
   */
  type?:
    | "ScheduledMaintenance"
    | "IncidentOutage"
    | "IssueResolved"
    | "GeneralInformation";
};

export type NotificationsControllerListSummariesResponse =
  PaginatedResponseDto & {
    results?: Array<NotificationSummaryDto>;
  };

export type NotificationsControllerFindOneData = {
  id: number;
};

export type NotificationsControllerFindOneResponse = NotificationResponseDto;

export type NotificationsControllerUpdateData = {
  id: number;
  requestBody: UpdateNotificationDto;
};

export type NotificationsControllerUpdateResponse = NotificationResponseDto;

export type NotificationsControllerRemoveData = {
  id: number;
};

export type NotificationsControllerRemoveResponse = unknown;

export type PageViewsControllerReportData = {
  page: string;
};

export type PageViewsControllerReportResponse = unknown;

export type PendingControllerListSummariesData = {
  actions?: Array<PendingActionEnum>;
  deviceIds?: Array<number>;
  from?: Date;
  limit: number;
  operationIds?: Array<number>;
  ownedByMe?: boolean;
  page: number;
  sortBy?: Array<PendingOrderEnumSortOption>;
  to?: Date;
  uuid?: string;
};

export type PendingControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<PendingSampleDetailsDto>;
  };

export type PendingControllerListUploadOperationsData = {
  deviceIds?: Array<number>;
  from?: Date;
  limit: number;
  operationIds?: Array<number>;
  ownedByMe?: boolean;
  page: number;
  sortBy?: Array<UploadOperationOrderEnumSortOption>;
  to?: Date;
};

export type PendingControllerListUploadOperationsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<PendingUploadOperationDto>;
  };

export type PendingControllerCancelOperationData = {
  id: number;
};

export type PendingControllerCancelOperationResponse =
  UploadOperationCancellationResultDto;

export type PendingControllerCancelSelectedData = {
  requestBody: CancelPendingUploadsDto;
};

export type PendingControllerCancelSelectedResponse =
  UploadCancellationResultDto;

export type PermissionsControllerListSummariesData = {
  limit: number;
  module?: Array<string>;
  page: number;
  search?: string;
  showBackend?: boolean;
};

export type PermissionsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<PermissionsSummaryDto>;
  };

export type PermissionsControllerGetAllResponse = {
  [key: string]: unknown;
};

export type PermissionsControllerGetPermissionsEndpointsResponse = {
  [key: string]: unknown;
};

export type PermissionsControllerGetUserPermissionsResponse = PermissionsDto;

export type PermissionsControllerReloadResponse = unknown;

export type PermissionsControllerGetPermissionsTemplateResponse =
  PermissionsDto;

export type PredictionsControllerListPredictionsCountData = {
  clusterIds?: Array<number>;
  deviceIds?: Array<number>;
  from?: Date;
  fuzzy?: boolean;
  label?: string;
  modelIds?: Array<number>;
  prediction?: string;
  result?: Array<TransactionResultEnum>;
  timeField?: "createdAt" | "predictedAt";
  to?: Date;
};

export type PredictionsControllerListPredictionsCountResponse = number;

export type PredictionsControllerListPredictionsData = {
  clusterIds?: Array<number>;
  deviceIds?: Array<number>;
  from?: Date;
  fuzzy?: boolean;
  label?: string;
  limit: number;
  modelIds?: Array<number>;
  page: number;
  prediction?: string;
  result?: Array<TransactionResultEnum>;
  sortBy?: Array<PredictionsOrderEnumSortOption>;
  timeField?: "createdAt" | "predictedAt";
  to?: Date;
};

export type PredictionsControllerListPredictionsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<PredictionDto>;
  };

export type PredictionsControllerListModelPredictionsCountData = {
  clusterIds?: Array<number>;
  deviceIds?: Array<number>;
  from?: Date;
  fuzzy?: boolean;
  id: number;
  label?: string;
  prediction?: string;
  result?: Array<TransactionResultEnum>;
  timeField?: "createdAt" | "predictedAt";
  to?: Date;
};

export type PredictionsControllerListModelPredictionsCountResponse = number;

export type PredictionsControllerListModelPredictionsData = {
  clusterIds?: Array<number>;
  deviceIds?: Array<number>;
  from?: Date;
  fuzzy?: boolean;
  id: number;
  label?: string;
  limit: number;
  page: number;
  prediction?: string;
  result?: Array<TransactionResultEnum>;
  sortBy?: Array<PredictionsOrderEnumSortOption>;
  timeField?: "createdAt" | "predictedAt";
  to?: Date;
};

export type PredictionsControllerListModelPredictionsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<PredictionDto>;
  };

export type QueuesControllerGetSummaryResponse = QueuesSummaryDto;

export type QueuesControllerListQueueFailuresData = {
  limit: number;
  page: number;
  queue: QueueDefinitionEndpoint;
};

export type QueuesControllerListQueueFailuresResponse = PaginatedResponseDto & {
  results?: Array<QueueFailureDto>;
};

export type QueuesControllerResolveQueueFailuresData = {
  queue: QueueDefinitionEndpoint;
  requestBody: QueueBulkDto;
};

export type QueuesControllerResolveQueueFailuresResponse = number;

export type QueuesControllerDeleteQueueFailuresData = {
  queue: QueueDefinitionEndpoint;
  requestBody: QueueBulkDto;
};

export type QueuesControllerDeleteQueueFailuresResponse = "OK";

export type QueuesControllerPatchQueueFailureData = {
  index: number;
  override: boolean;
  queue: QueueDefinitionEndpoint;
  requestBody: {
    [key: string]: unknown;
  };
  resolve: boolean;
};

export type QueuesControllerPatchQueueFailureResponse = {
  [key: string]: unknown;
};

export type QueuesControllerDeleteQueueFailureData = {
  index: number;
  queue: QueueDefinitionEndpoint;
};

export type QueuesControllerDeleteQueueFailureResponse = unknown;

export type QueuesControllerResolveQueueFailureData = {
  index: number;
  queue: QueueDefinitionEndpoint;
};

export type QueuesControllerResolveQueueFailureResponse = unknown;

export type QueuesControllerListQueuePendingData = {
  limit: number;
  page: number;
  queue: QueueDefinitionEndpoint;
};

export type QueuesControllerListQueuePendingResponse = PaginatedResponseDto & {
  results?: Array<QueuePendingDto>;
};

export type QueuesControllerPostQueuePendingData = {
  queue: QueueDefinitionEndpoint;
  requestBody: {
    [key: string]: unknown;
  };
};

export type QueuesControllerPostQueuePendingResponse = unknown;

export type QueuesControllerDeleteQueuePendingData = {
  index: number;
  queue: QueueDefinitionEndpoint;
};

export type QueuesControllerDeleteQueuePendingResponse = unknown;

export type RecoveryEstimatesControllerPreCheckData = {
  requestBody: RecoveryEstimatesPreCheckRequestDto;
};

export type RecoveryEstimatesControllerPreCheckResponse =
  RecoveryEstimatesPreCheckResponseDto;

export type RecoveryEstimatesControllerCreateScheduleData = {
  requestBody: RecoveryEstimatesScheduleJobDto;
};

export type RecoveryEstimatesControllerCreateScheduleResponse =
  RecoveryEstimatesScheduledJobSummaryDto;

export type RecoveryEstimatesControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type RecoveryEstimatesControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<RecoveryEstimatesScheduledJobSummaryDto>;
  };

export type RecoveryEstimatesControllerGetScheduledJobData = {
  id: number;
};

export type RecoveryEstimatesControllerGetScheduledJobResponse =
  RecoveryEstimatesScheduledJobDto;

export type RecoveryEstimatesControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: RecoveryEstimatesUpdateScheduledJobDto;
};

export type RecoveryEstimatesControllerUpdateScheduledJobResponse =
  RecoveryEstimatesScheduledJobDto;

export type RecoveryEstimatesControllerDeleteScheduledJobData = {
  id: number;
};

export type RecoveryEstimatesControllerDeleteScheduledJobResponse = boolean;

export type RecoveryEstimatesControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type RecoveryEstimatesControllerCancelScheduledJobsBulkResponse = number;

export type RecoveryEstimatesControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type RecoveryEstimatesControllerStopScheduledJobsBulkResponse = number;

export type RecoveryEstimatesControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type RecoveryEstimatesControllerResumeScheduledJobsBulkResponse = number;

export type RecoveryEstimatesControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type RecoveryEstimatesControllerDeleteScheduledJobsBulkResponse = number;

export type RecoveryEstimatesControllerStartScheduledJobData = {
  id: number;
};

export type RecoveryEstimatesControllerStartScheduledJobResponse =
  RecoveryEstimatesJobDto;

export type RecoveryEstimatesControllerCancelScheduledJobData = {
  id: number;
};

export type RecoveryEstimatesControllerCancelScheduledJobResponse = boolean;

export type RecoveryEstimatesControllerStopScheduledJobData = {
  id: number;
};

export type RecoveryEstimatesControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type RecoveryEstimatesControllerResumeScheduledJobData = {
  id: number;
};

export type RecoveryEstimatesControllerResumeScheduledJobResponse =
  RecoveryEstimatesScheduledJobSummaryDto;

export type RecoveryEstimatesControllerStartJobData = {
  requestBody: RecoveryEstimatesDataWithNameDto;
};

export type RecoveryEstimatesControllerStartJobResponse =
  RecoveryEstimatesJobDto;

export type RecoveryEstimatesControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type RecoveryEstimatesControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<RecoveryEstimatesJobSummaryDto>;
  };

export type RecoveryEstimatesControllerGetJobData = {
  id: number;
};

export type RecoveryEstimatesControllerGetJobResponse = RecoveryEstimatesJobDto;

export type RecoveryEstimatesControllerDeleteJobData = {
  id: number;
};

export type RecoveryEstimatesControllerDeleteJobResponse = boolean;

export type RecoveryEstimatesControllerUpdateJobData = {
  id: number;
  requestBody: RecoveryEstimatesUpdateJobDto;
};

export type RecoveryEstimatesControllerUpdateJobResponse =
  RecoveryEstimatesJobDto;

export type RecoveryEstimatesControllerCancelJobData = {
  id: number;
};

export type RecoveryEstimatesControllerCancelJobResponse = boolean;

export type RecoveryEstimatesControllerStopJobData = {
  id: number;
};

export type RecoveryEstimatesControllerStopJobResponse = boolean;

export type RecoveryEstimatesControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type RecoveryEstimatesControllerCancelJobsBulkResponse = number;

export type RecoveryEstimatesControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type RecoveryEstimatesControllerDeleteJobsBulkResponse = number;

export type RegionsControllerListSummariesData = {
  limit: number;
  page: number;
  /**
   * Case-insensitive substring match on the region name
   */
  region?: string;
  regionIds?: Array<number>;
  /**
   * When true, list INACTIVE rows instead of active ones. Omitted or false = active only.
   */
  showInactive?: boolean;
  sortBy?: Array<RegionRowOrderEnumSortOption>;
  /**
   * Case-insensitive substring match on the sub-region name
   */
  subRegion?: string;
  subRegionIds?: Array<number>;
};

export type RegionsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<RegionRowDto>;
  };

export type RegionsControllerListRegionOptionsData = {
  limit: number;
  /**
   * Case-insensitive substring match on the name
   */
  name?: string;
  page: number;
};

export type RegionsControllerListRegionOptionsResponse =
  PaginatedResponseDto & {
    results?: Array<MinimalEntityDto>;
  };

export type RegionsControllerListSubRegionOptionsData = {
  limit: number;
  /**
   * Case-insensitive substring match on the name
   */
  name?: string;
  page: number;
  /**
   * Limit to sub-regions of this region
   */
  regionId?: number;
};

export type RegionsControllerListSubRegionOptionsResponse =
  PaginatedResponseDto & {
    results?: Array<SubRegionOptionDto>;
  };

export type RegionsControllerCreateData = {
  requestBody: CreateRegionDto;
};

export type RegionsControllerCreateResponse = CreateRegionResponseDto;

export type RegionsControllerMoveSubRegionsBulkData = {
  requestBody: MoveSubRegionsBulkDto;
};

export type RegionsControllerMoveSubRegionsBulkResponse =
  MoveSubRegionsResultDto;

export type RegionsControllerUpdateSubRegionData = {
  id: number;
  requestBody: UpdateSubRegionDto;
};

export type RegionsControllerUpdateSubRegionResponse = MinimalEntityDto;

export type RegionsControllerInactivateBulkData = {
  requestBody: InactivateRowsBulkDto;
};

export type RegionsControllerInactivateBulkResponse = InactivateRowsResultDto;

export type RegionsControllerUpdateRegionData = {
  id: number;
  requestBody: UpdateRegionDto;
};

export type RegionsControllerUpdateRegionResponse = MinimalEntityDto;

export type RegionsControllerUploadData = {
  formData: UploadRegionsFileDto;
};

export type RegionsControllerUploadResponse = RegionsUploadResponseDto;

export type RegionsControllerDownloadData = {
  requestBody: DownloadRegionsRequestDto;
};

export type RegionsControllerDownloadResponse = LoggedStreamableFile;

export type MetabaseControllerGetMetabaseUrlResponse = Array<{
  [key: string]: unknown;
}>;

export type MetabaseControllerGeneratePdfData = {
  requestBody: GeneratePdfDto;
};

export type MetabaseControllerGeneratePdfResponse = unknown;

export type MetabaseControllerListReportsData = {
  description?: string;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ReportsOrderEnumSortOption>;
};

export type MetabaseControllerListReportsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ReportDto>;
  };

export type MetabaseControllerCreateReportData = {
  requestBody: CreateReportDto;
};

export type MetabaseControllerCreateReportResponse = number;

export type MetabaseControllerGetReportDetailsData = {
  id: number;
};

export type MetabaseControllerGetReportDetailsResponse = DetailedReportDto;

export type MetabaseControllerUpdateReportData = {
  id: number;
  requestBody: UpdateReportDto;
};

export type MetabaseControllerUpdateReportResponse = number;

export type MetabaseControllerDeleteReportData = {
  id: number;
};

export type MetabaseControllerDeleteReportResponse = unknown;

export type MetabaseControllerUpdateReportConfigData = {
  id: number;
  requestBody: UpdateReportConfigDto;
};

export type MetabaseControllerUpdateReportConfigResponse = number;

export type MetabaseControllerUpdateReportUrlData = {
  id: number;
  requestBody: UpdateReportUrlDto;
};

export type MetabaseControllerUpdateReportUrlResponse = number;

export type MetabaseControllerSendTestReportData = {
  requestBody: TestEmailDto;
};

export type MetabaseControllerSendTestReportResponse = EmailSendOutcomeDto;

export type MetabaseControllerContactUsData = {
  requestBody: ContactUsDto;
};

export type MetabaseControllerContactUsResponse = string;

export type MetabaseControllerFetchReportMetadataData = {
  id: number;
  questionTypes: Array<string>;
};

export type MetabaseControllerFetchReportMetadataResponse =
  DashboardMetadataResponseDto;

export type MetabaseControllerPreviewCustomReportData = {
  requestBody: TestEmailDto;
};

export type MetabaseControllerPreviewCustomReportResponse = string;

export type ReportsCompanionControllerGetEligibilityResponse =
  EligibilityResponseDto;

export type ReportsCompanionControllerChatData = {
  requestBody: ChatRequestDto;
};

export type ReportsCompanionControllerChatResponse = unknown;

export type ReportsCompanionControllerListChatTurnsData = {
  /**
   * SuperAdmin only: the accounts to list. Ignored for anyone else, who only ever sees their own account.
   */
  accountIds?: Array<number>;
  limit: number;
  outcome?: Array<ReportsCompanionChatOutcome>;
  page: number;
  /**
   * Case-insensitive substring of the question.
   */
  question?: string;
  /**
   * Sort by multiple fields and directions. Defaults to newest first.
   */
  sortBy?: Array<ChatTurnOrderEnumSortOption>;
};

export type ReportsCompanionControllerListChatTurnsResponse =
  PaginatedResponseDto & {
    results?: Array<ChatTurnResponseDto>;
  };

export type ReportsCompanionControllerGetChatConversationData = {
  id: number;
};

export type ReportsCompanionControllerGetChatConversationResponse =
  Array<ChatTurnResponseDto>;

export type SamplesControllerListSamplesCountData = {
  clusterIds?: Array<number>;
  datasetId?: number;
  dataType?: Array<string>;
  deviceIds?: Array<number>;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  families?: Array<string>;
  family?: string;
  fromDate?: Date;
  fuzzy?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  labels?: Array<string>;
  matchStrength?: string;
  modelIds?: Array<number>;
  onlyWithPrediction?: boolean;
  predictions?: Array<string>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  result?: Array<TransactionResultEnum>;
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  sessionId?: Array<string>;
  showNonScans?: boolean;
  showOnlyWithImages?: boolean;
  siteGroupIds?: Array<number>;
  siteIds?: Array<number>;
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  storageDeviceIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  taggedByIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  timeField?: "createdAt" | "addedAt";
  toDate?: Date;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
};

export type SamplesControllerListSamplesCountResponse = number;

export type SamplesControllerGetUxSourceData = {
  limit: number;
  page: number;
};

export type SamplesControllerGetUxSourceResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<UxSourceDto>;
  };

export type SamplesControllerListSamplesData = {
  clusterIds?: Array<number>;
  datasetId?: number;
  dataType?: Array<string>;
  deviceIds?: Array<number>;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  families?: Array<string>;
  family?: string;
  fromDate?: Date;
  fuzzy?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  labels?: Array<string>;
  limit: number;
  matchStrength?: string;
  modelIds?: Array<number>;
  onlyWithPrediction?: boolean;
  page: number;
  predictions?: Array<string>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  result?: Array<TransactionResultEnum>;
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  sessionId?: Array<string>;
  showNonScans?: boolean;
  showOnlyWithImages?: boolean;
  siteGroupIds?: Array<number>;
  siteIds?: Array<number>;
  sortBy?: Array<SamplesOrderEnumSortOption>;
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  storageDeviceIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  taggedByIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  timeField?: "createdAt" | "addedAt";
  toDate?: Date;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
};

export type SamplesControllerListSamplesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<SampleSummaryDto>;
  };

export type SamplesControllerUpdateGroupLossData = {
  groupId: string;
  requestBody: UpdateSampleLossDto;
};

export type SamplesControllerUpdateGroupLossResponse = {
  [key: string]: unknown;
};

export type SamplesControllerRefreshLossBulkData = {
  clusterIds?: Array<number>;
  datasetId?: number;
  dataType?: Array<string>;
  deviceIds?: Array<number>;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  families?: Array<string>;
  family?: string;
  fromDate?: Date;
  fuzzy?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  labels?: Array<string>;
  matchStrength?: string;
  modelIds?: Array<number>;
  onlyWithPrediction?: boolean;
  predictions?: Array<string>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  result?: Array<TransactionResultEnum>;
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  sessionId?: Array<string>;
  showNonScans?: boolean;
  showOnlyWithImages?: boolean;
  siteGroupIds?: Array<number>;
  siteIds?: Array<number>;
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  storageDeviceIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  taggedByIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  timeField?: "createdAt" | "addedAt";
  toDate?: Date;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
};

export type SamplesControllerRefreshLossBulkResponse = unknown;

export type SamplesControllerRefreshLossData = {
  requestBody: RefreshLossDto;
};

export type SamplesControllerRefreshLossResponse = unknown;

export type SamplesControllerSetRepresentativeImageBulkData = {
  clusterIds?: Array<number>;
  datasetId?: number;
  dataType?: Array<string>;
  deviceIds?: Array<number>;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  families?: Array<string>;
  family?: string;
  fromDate?: Date;
  fuzzy?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  labels?: Array<string>;
  matchStrength?: string;
  modelIds?: Array<number>;
  onlyWithPrediction?: boolean;
  predictions?: Array<string>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  result?: Array<TransactionResultEnum>;
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  sessionId?: Array<string>;
  showNonScans?: boolean;
  showOnlyWithImages?: boolean;
  siteGroupIds?: Array<number>;
  siteIds?: Array<number>;
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  storageDeviceIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  taggedByIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  timeField?: "createdAt" | "addedAt";
  toDate?: Date;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
};

export type SamplesControllerSetRepresentativeImageBulkResponse = unknown;

export type SamplesControllerGetSampleDetailsAndImageData = {
  uuid: string;
};

export type SamplesControllerGetSampleDetailsAndImageResponse =
  SampleWithImageDto;

export type SamplesControllerUpdateSampleData = {
  requestBody: UpdateSampleDto;
  uuid: string;
};

export type SamplesControllerUpdateSampleResponse = {
  [key: string]: unknown;
};

export type SamplesControllerDeleteSampleData = {
  uuid: string;
};

export type SamplesControllerDeleteSampleResponse = {
  [key: string]: unknown;
};

export type SamplesControllerGetSampleDetailsData = {
  uuid: string;
};

export type SamplesControllerGetSampleDetailsResponse = SampleDto;

export type SamplesControllerUpdateBulkData = {
  requestBody: UpdateSamplesBulkDto;
};

export type SamplesControllerUpdateBulkResponse = unknown;

export type SamplesControllerDeleteBulkData = {
  clusterIds?: Array<number>;
  datasetId?: number;
  dataType?: Array<string>;
  deviceIds?: Array<number>;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  families?: Array<string>;
  family?: string;
  fromDate?: Date;
  fuzzy?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  labels?: Array<string>;
  matchStrength?: string;
  modelIds?: Array<number>;
  onlyWithPrediction?: boolean;
  predictions?: Array<string>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  result?: Array<TransactionResultEnum>;
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  sessionId?: Array<string>;
  showNonScans?: boolean;
  showOnlyWithImages?: boolean;
  siteGroupIds?: Array<number>;
  siteIds?: Array<number>;
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  storageDeviceIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  taggedByIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  timeField?: "createdAt" | "addedAt";
  toDate?: Date;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
};

export type SamplesControllerDeleteBulkResponse = unknown;

export type SamplesControllerUpdateSamplesMetadataBulkData = {
  requestBody: UpdateSamplesMetadataBulkBodyDto;
};

export type SamplesControllerUpdateSamplesMetadataBulkResponse = {
  [key: string]: unknown;
};

export type SamplesControllerUpdateTagsBulkData = {
  requestBody: UpdateSamplesTaggingBulkDto;
};

export type SamplesControllerUpdateTagsBulkResponse = unknown;

export type SamplesControllerUpdateSampleMetadataData = {
  requestBody: UpdateSampleMetadataDto;
  uuid: string;
};

export type SamplesControllerUpdateSampleMetadataResponse = {
  [key: string]: unknown;
};

export type SamplesControllerUpdateLossData = {
  requestBody: UpdateSampleLossDto;
  uuid: string;
};

export type SamplesControllerUpdateLossResponse = {
  [key: string]: unknown;
};

export type SamplesControllerUploadBulkData = {
  clusterIds?: Array<number>;
  datasetId?: number;
  dataType?: Array<string>;
  /**
   * delete the sample off the device once uploaded to storage
   */
  deleteAfterUpload?: boolean;
  deviceIds?: Array<number>;
  /**
   * Device IPv4 or IPv4 prefix with at least two octets (e.g. 192.168 or 192.168.1.10)
   */
  deviceIp?: string;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  families?: Array<string>;
  family?: string;
  fromDate?: Date;
  fuzzy?: boolean;
  headBlurred?: boolean;
  headsFound?: boolean;
  labels?: Array<string>;
  matchStrength?: string;
  modelIds?: Array<number>;
  onlyWithPrediction?: boolean;
  predictions?: Array<string>;
  /**
   * Filter samples to sites assigned to this region (active regions only).
   */
  regionId?: number;
  result?: Array<TransactionResultEnum>;
  sampleId?: Array<string>;
  sampleIds?: Array<number>;
  sessionId?: Array<string>;
  showNonScans?: boolean;
  showOnlyWithImages?: boolean;
  siteGroupIds?: Array<number>;
  siteIds?: Array<number>;
  state?:
    | "existing"
    | "deleted"
    | "overridden"
    | "evicted"
    | "reported_only"
    | "missing";
  storageDeviceIds?: Array<number>;
  /**
   * Filter samples to sites assigned to this sub-region (active, under an active region).
   */
  subRegionId?: number;
  taggedByIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  timeField?: "createdAt" | "addedAt";
  toDate?: Date;
  /**
   * UX source filter (case-insensitive exact match)
   */
  uxSource?: string;
};

export type SamplesControllerUploadBulkResponse = UploadOperationCreatedDto;

export type SamplesControllerUploadSampleData = {
  deleteAfterUpload?: boolean;
  uuid: string;
};

export type SamplesControllerUploadSampleResponse = {
  [key: string]: unknown;
};

export type SamplesControllerGetSampleImageData = {
  raw?: boolean;
  /**
   * Answer a cloud-stored sample with a 302 to storage instead of its bytes. Omitted falls back to the SAMPLE_IMAGE_REDIRECT config default.
   */
  redirect?: boolean;
  uuid: string;
};

export type SamplesControllerGetSampleImageResponse = unknown;

export type SamplesControllerGetSampleThumbnailData = {
  expand?: boolean;
  height?: number;
  raw?: boolean;
  uuid: string;
  width?: number;
};

export type SamplesControllerGetSampleThumbnailResponse = unknown;

export type SamplesControllerGetSampleImageInDeviceData = {
  deviceId: number;
  raw?: boolean;
  uuid: string;
};

export type SamplesControllerGetSampleImageInDeviceResponse = unknown;

export type ScheduleConfigDeploymentsControllerCreateScheduleData = {
  requestBody: ScheduleConfigDeploymentsScheduleJobDto;
};

export type ScheduleConfigDeploymentsControllerCreateScheduleResponse =
  ScheduleConfigDeploymentsScheduledJobSummaryDto;

export type ScheduleConfigDeploymentsControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type ScheduleConfigDeploymentsControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ScheduleConfigDeploymentsScheduledJobSummaryDto>;
  };

export type ScheduleConfigDeploymentsControllerGetScheduledJobData = {
  id: number;
};

export type ScheduleConfigDeploymentsControllerGetScheduledJobResponse =
  ScheduleConfigDeploymentsScheduledJobDto;

export type ScheduleConfigDeploymentsControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: ScheduleConfigDeploymentsUpdateScheduledJobDto;
};

export type ScheduleConfigDeploymentsControllerUpdateScheduledJobResponse =
  ScheduleConfigDeploymentsScheduledJobDto;

export type ScheduleConfigDeploymentsControllerDeleteScheduledJobData = {
  id: number;
};

export type ScheduleConfigDeploymentsControllerDeleteScheduledJobResponse =
  boolean;

export type ScheduleConfigDeploymentsControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ScheduleConfigDeploymentsControllerCancelScheduledJobsBulkResponse =
  number;

export type ScheduleConfigDeploymentsControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ScheduleConfigDeploymentsControllerStopScheduledJobsBulkResponse =
  number;

export type ScheduleConfigDeploymentsControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ScheduleConfigDeploymentsControllerResumeScheduledJobsBulkResponse =
  number;

export type ScheduleConfigDeploymentsControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ScheduleConfigDeploymentsControllerDeleteScheduledJobsBulkResponse =
  number;

export type ScheduleConfigDeploymentsControllerStartScheduledJobData = {
  id: number;
};

export type ScheduleConfigDeploymentsControllerStartScheduledJobResponse =
  ScheduleConfigDeploymentsJobDto;

export type ScheduleConfigDeploymentsControllerCancelScheduledJobData = {
  id: number;
};

export type ScheduleConfigDeploymentsControllerCancelScheduledJobResponse =
  boolean;

export type ScheduleConfigDeploymentsControllerStopScheduledJobData = {
  id: number;
};

export type ScheduleConfigDeploymentsControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type ScheduleConfigDeploymentsControllerResumeScheduledJobData = {
  id: number;
};

export type ScheduleConfigDeploymentsControllerResumeScheduledJobResponse =
  ScheduleConfigDeploymentsScheduledJobSummaryDto;

export type ScheduleConfigDeploymentsControllerStartJobData = {
  requestBody: ScheduleConfigDeploymentsDataWithNameDto;
};

export type ScheduleConfigDeploymentsControllerStartJobResponse =
  ScheduleConfigDeploymentsJobDto;

export type ScheduleConfigDeploymentsControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type ScheduleConfigDeploymentsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ScheduleConfigDeploymentsJobSummaryDto>;
  };

export type ScheduleConfigDeploymentsControllerGetJobData = {
  id: number;
};

export type ScheduleConfigDeploymentsControllerGetJobResponse =
  ScheduleConfigDeploymentsJobDto;

export type ScheduleConfigDeploymentsControllerDeleteJobData = {
  id: number;
};

export type ScheduleConfigDeploymentsControllerDeleteJobResponse = boolean;

export type ScheduleConfigDeploymentsControllerUpdateJobData = {
  id: number;
  requestBody: ScheduleConfigDeploymentsUpdateJobDto;
};

export type ScheduleConfigDeploymentsControllerUpdateJobResponse =
  ScheduleConfigDeploymentsJobDto;

export type ScheduleConfigDeploymentsControllerCancelJobData = {
  id: number;
};

export type ScheduleConfigDeploymentsControllerCancelJobResponse = boolean;

export type ScheduleConfigDeploymentsControllerStopJobData = {
  id: number;
};

export type ScheduleConfigDeploymentsControllerStopJobResponse = boolean;

export type ScheduleConfigDeploymentsControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type ScheduleConfigDeploymentsControllerCancelJobsBulkResponse = number;

export type ScheduleConfigDeploymentsControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type ScheduleConfigDeploymentsControllerDeleteJobsBulkResponse = number;

export type ScheduledTrainingsControllerListSummariesData = {
  limit: number;
  page: number;
  sortBy?: Array<ScheduledTrainingOrderEnumSortOption>;
};

export type ScheduledTrainingsControllerListSummariesResponse =
  PaginatedResponseDto & {
    results?: Array<ScheduledTrainingSummaryDto>;
  };

export type ScheduledTrainingsControllerGetDetailsData = {
  id: number;
};

export type ScheduledTrainingsControllerGetDetailsResponse =
  ScheduledTrainingDetailsDto;

export type ScheduledTrainingsControllerUpdateData = {
  id: number;
  requestBody: UpdateScheduledTrainingDto;
};

export type ScheduledTrainingsControllerUpdateResponse = unknown;

export type ScheduledTrainingsControllerDeleteData = {
  id: number;
};

export type ScheduledTrainingsControllerDeleteResponse = unknown;

export type ScheduledTrainingsControllerCreateScheduledTrainingData = {
  requestBody: CreateScheduledTrainingDto;
};

export type ScheduledTrainingsControllerCreateScheduledTrainingResponse =
  EntityIdDto;

export type ScheduledTrainingsControllerDeleteBulkData = {
  requestBody: BulkScheduledTrainingsDto;
};

export type ScheduledTrainingsControllerDeleteBulkResponse = number;

export type ScheduledTrainingsControllerStartData = {
  id: number;
};

export type ScheduledTrainingsControllerStartResponse = EntityIdDto;

export type ScheduleModelDeploymentsControllerCreateScheduleData = {
  requestBody: ScheduleModelDeploymentsScheduleJobDto;
};

export type ScheduleModelDeploymentsControllerCreateScheduleResponse =
  ScheduleModelDeploymentsScheduledJobSummaryDto;

export type ScheduleModelDeploymentsControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type ScheduleModelDeploymentsControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ScheduleModelDeploymentsScheduledJobSummaryDto>;
  };

export type ScheduleModelDeploymentsControllerGetScheduledJobData = {
  id: number;
};

export type ScheduleModelDeploymentsControllerGetScheduledJobResponse =
  ScheduleModelDeploymentsScheduledJobDto;

export type ScheduleModelDeploymentsControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: ScheduleModelDeploymentsUpdateScheduledJobDto;
};

export type ScheduleModelDeploymentsControllerUpdateScheduledJobResponse =
  ScheduleModelDeploymentsScheduledJobDto;

export type ScheduleModelDeploymentsControllerDeleteScheduledJobData = {
  id: number;
};

export type ScheduleModelDeploymentsControllerDeleteScheduledJobResponse =
  boolean;

export type ScheduleModelDeploymentsControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ScheduleModelDeploymentsControllerCancelScheduledJobsBulkResponse =
  number;

export type ScheduleModelDeploymentsControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ScheduleModelDeploymentsControllerStopScheduledJobsBulkResponse =
  number;

export type ScheduleModelDeploymentsControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ScheduleModelDeploymentsControllerResumeScheduledJobsBulkResponse =
  number;

export type ScheduleModelDeploymentsControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ScheduleModelDeploymentsControllerDeleteScheduledJobsBulkResponse =
  number;

export type ScheduleModelDeploymentsControllerStartScheduledJobData = {
  id: number;
};

export type ScheduleModelDeploymentsControllerStartScheduledJobResponse =
  ScheduleModelDeploymentsJobDto;

export type ScheduleModelDeploymentsControllerCancelScheduledJobData = {
  id: number;
};

export type ScheduleModelDeploymentsControllerCancelScheduledJobResponse =
  boolean;

export type ScheduleModelDeploymentsControllerStopScheduledJobData = {
  id: number;
};

export type ScheduleModelDeploymentsControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type ScheduleModelDeploymentsControllerResumeScheduledJobData = {
  id: number;
};

export type ScheduleModelDeploymentsControllerResumeScheduledJobResponse =
  ScheduleModelDeploymentsScheduledJobSummaryDto;

export type ScheduleModelDeploymentsControllerStartJobData = {
  requestBody: ScheduleModelDeploymentsDataWithNameDto;
};

export type ScheduleModelDeploymentsControllerStartJobResponse =
  ScheduleModelDeploymentsJobDto;

export type ScheduleModelDeploymentsControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type ScheduleModelDeploymentsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ScheduleModelDeploymentsJobSummaryDto>;
  };

export type ScheduleModelDeploymentsControllerGetJobData = {
  id: number;
};

export type ScheduleModelDeploymentsControllerGetJobResponse =
  ScheduleModelDeploymentsJobDto;

export type ScheduleModelDeploymentsControllerDeleteJobData = {
  id: number;
};

export type ScheduleModelDeploymentsControllerDeleteJobResponse = boolean;

export type ScheduleModelDeploymentsControllerUpdateJobData = {
  id: number;
  requestBody: ScheduleModelDeploymentsUpdateJobDto;
};

export type ScheduleModelDeploymentsControllerUpdateJobResponse =
  ScheduleModelDeploymentsJobDto;

export type ScheduleModelDeploymentsControllerCancelJobData = {
  id: number;
};

export type ScheduleModelDeploymentsControllerCancelJobResponse = boolean;

export type ScheduleModelDeploymentsControllerStopJobData = {
  id: number;
};

export type ScheduleModelDeploymentsControllerStopJobResponse = boolean;

export type ScheduleModelDeploymentsControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type ScheduleModelDeploymentsControllerCancelJobsBulkResponse = number;

export type ScheduleModelDeploymentsControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type ScheduleModelDeploymentsControllerDeleteJobsBulkResponse = number;

export type ServiceHealthChecksControllerTestData = {
  requestBody: TestServiceHealthCheckDto;
};

export type ServiceHealthChecksControllerTestResponse =
  ServiceHealthCheckTestResultDto;

export type ServiceHealthChecksControllerCreateScheduleData = {
  requestBody: ServiceHealthChecksScheduleJobDto;
};

export type ServiceHealthChecksControllerCreateScheduleResponse =
  ServiceHealthChecksScheduledJobSummaryDto;

export type ServiceHealthChecksControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type ServiceHealthChecksControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ServiceHealthChecksScheduledJobSummaryDto>;
  };

export type ServiceHealthChecksControllerGetScheduledJobData = {
  id: number;
};

export type ServiceHealthChecksControllerGetScheduledJobResponse =
  ServiceHealthChecksScheduledJobDto;

export type ServiceHealthChecksControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: ServiceHealthChecksUpdateScheduledJobDto;
};

export type ServiceHealthChecksControllerUpdateScheduledJobResponse =
  ServiceHealthChecksScheduledJobDto;

export type ServiceHealthChecksControllerDeleteScheduledJobData = {
  id: number;
};

export type ServiceHealthChecksControllerDeleteScheduledJobResponse = boolean;

export type ServiceHealthChecksControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ServiceHealthChecksControllerCancelScheduledJobsBulkResponse =
  number;

export type ServiceHealthChecksControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ServiceHealthChecksControllerStopScheduledJobsBulkResponse = number;

export type ServiceHealthChecksControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ServiceHealthChecksControllerResumeScheduledJobsBulkResponse =
  number;

export type ServiceHealthChecksControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type ServiceHealthChecksControllerDeleteScheduledJobsBulkResponse =
  number;

export type ServiceHealthChecksControllerStartScheduledJobData = {
  id: number;
};

export type ServiceHealthChecksControllerStartScheduledJobResponse =
  ServiceHealthChecksJobDto;

export type ServiceHealthChecksControllerCancelScheduledJobData = {
  id: number;
};

export type ServiceHealthChecksControllerCancelScheduledJobResponse = boolean;

export type ServiceHealthChecksControllerStopScheduledJobData = {
  id: number;
};

export type ServiceHealthChecksControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type ServiceHealthChecksControllerResumeScheduledJobData = {
  id: number;
};

export type ServiceHealthChecksControllerResumeScheduledJobResponse =
  ServiceHealthChecksScheduledJobSummaryDto;

export type ServiceHealthChecksControllerStartJobData = {
  requestBody: ServiceHealthChecksDataWithNameDto;
};

export type ServiceHealthChecksControllerStartJobResponse =
  ServiceHealthChecksJobDto;

export type ServiceHealthChecksControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type ServiceHealthChecksControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<ServiceHealthChecksJobSummaryDto>;
  };

export type ServiceHealthChecksControllerGetJobData = {
  id: number;
};

export type ServiceHealthChecksControllerGetJobResponse =
  ServiceHealthChecksJobDto;

export type ServiceHealthChecksControllerDeleteJobData = {
  id: number;
};

export type ServiceHealthChecksControllerDeleteJobResponse = boolean;

export type ServiceHealthChecksControllerUpdateJobData = {
  id: number;
  requestBody: ServiceHealthChecksUpdateJobDto;
};

export type ServiceHealthChecksControllerUpdateJobResponse =
  ServiceHealthChecksJobDto;

export type ServiceHealthChecksControllerCancelJobData = {
  id: number;
};

export type ServiceHealthChecksControllerCancelJobResponse = boolean;

export type ServiceHealthChecksControllerStopJobData = {
  id: number;
};

export type ServiceHealthChecksControllerStopJobResponse = boolean;

export type ServiceHealthChecksControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type ServiceHealthChecksControllerCancelJobsBulkResponse = number;

export type ServiceHealthChecksControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type ServiceHealthChecksControllerDeleteJobsBulkResponse = number;

export type SessionsControllerListSessionsCountData = {
  alertType?: Array<"non-scan" | "non-match" | "left-in-cart">;
  assigneeIds?: Array<number>;
  assigneeMatch?: "any" | "none";
  assistantId?: string;
  clusterIds?: Array<number>;
  datasetId?: number;
  deviceIds?: Array<number>;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  from?: Date;
  headBlurred?: boolean;
  labels?: Array<string>;
  onlyNonScans?: boolean;
  onlyStored?: boolean;
  sessionId?: Array<string>;
  sessionIds?: Array<number>;
  sessionsTagsMatch?: "any" | "exact" | "all" | "none";
  sessionTagIds?: Array<number>;
  shopperId?: string;
  siteIds?: Array<number>;
  storage?:
    | "any"
    | "backend"
    | "cluster"
    | "edge"
    | "device"
    | "recorded"
    | "none";
  storageDeviceIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  timeField?: "createdAt" | "session";
  to?: Date;
};

export type SessionsControllerListSessionsCountResponse = number;

export type SessionsControllerListSessionsAlertsData = {
  assistantId?: string;
  deviceIds?: Array<number>;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  from?: Date;
  headBlurred?: boolean;
  limit: number;
  onlyNonScans?: boolean;
  onlyStored?: boolean;
  page: number;
  sessionId?: Array<string>;
  sessionIds?: Array<number>;
  sessionsTagsMatch?: "any" | "exact" | "all" | "none";
  sessionTagIds?: Array<number>;
  shopperId?: string;
  siteIds?: Array<number>;
  sortBy?: Array<ListSessionsAlertsOrderEnumSortOption>;
  storage?:
    | "any"
    | "backend"
    | "cluster"
    | "edge"
    | "device"
    | "recorded"
    | "none";
  storageDeviceIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  timeField?: "createdAt" | "session";
  to?: Date;
};

export type SessionsControllerListSessionsAlertsResponse =
  ListSessionsAlertsResponseDto;

export type SessionsControllerGetSessionData = {
  alertType?: Array<"non-scan" | "non-match" | "left-in-cart">;
  assigneeIds?: Array<number>;
  assigneeMatch?: "any" | "none";
  assistantId?: string;
  clusterIds?: Array<number>;
  datasetId?: number;
  deviceIds?: Array<number>;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  from?: Date;
  headBlurred?: boolean;
  labels?: Array<string>;
  onlyNonScans?: boolean;
  onlyStored?: boolean;
  sessionId?: Array<string>;
  sessionIds?: Array<number>;
  sessionsTagsMatch?: "any" | "exact" | "all" | "none";
  sessionTagIds?: Array<number>;
  shopperId?: string;
  siteIds?: Array<number>;
  storage?:
    | "any"
    | "backend"
    | "cluster"
    | "edge"
    | "device"
    | "recorded"
    | "none";
  storageDeviceIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  timeField?: "createdAt" | "session";
  to?: Date;
  uuid: string;
};

export type SessionsControllerGetSessionResponse = SessionDto;

export type SessionsControllerListSessionsData = {
  alertType?: Array<"non-scan" | "non-match" | "left-in-cart">;
  assigneeIds?: Array<number>;
  assigneeMatch?: "any" | "none";
  assistantId?: string;
  clusterIds?: Array<number>;
  datasetId?: number;
  deviceIds?: Array<number>;
  devicesTagIds?: Array<number>;
  devicesTagsMatch?: "any" | "exact" | "all" | "none";
  from?: Date;
  headBlurred?: boolean;
  labels?: Array<string>;
  limit: number;
  onlyNonScans?: boolean;
  onlyStored?: boolean;
  page: number;
  sessionId?: Array<string>;
  sessionIds?: Array<number>;
  sessionsTagsMatch?: "any" | "exact" | "all" | "none";
  sessionTagIds?: Array<number>;
  shopperId?: string;
  siteIds?: Array<number>;
  sortBy?: Array<ListSessionsOrderEnumSortOption>;
  storage?:
    | "any"
    | "backend"
    | "cluster"
    | "edge"
    | "device"
    | "recorded"
    | "none";
  storageDeviceIds?: Array<number>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
  timeField?: "createdAt" | "session";
  to?: Date;
};

export type SessionsControllerListSessionsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<SessionSummaryDto>;
  };

export type SessionsControllerDownloadSessionVideoData = {
  uuid: string;
};

export type SessionsControllerDownloadSessionVideoResponse =
  LoggedStreamableFile;

export type SessionsControllerDownloadSessionVisualizationData = {
  uuid: string;
};

export type SessionsControllerDownloadSessionVisualizationResponse =
  LoggedStreamableFile;

export type SessionsControllerStreamSessionData = {
  range: string;
  uuid: string;
};

export type SessionsControllerStreamSessionResponse = LoggedStreamableFile;

export type SessionsControllerUpdateTagsBulkData = {
  requestBody: UpdateSessionsTaggingBulkDto;
};

export type SessionsControllerUpdateTagsBulkResponse = unknown;

export type SessionsControllerUpdateAssigneeBulkData = {
  requestBody: UpdateSessionsAssigneeBulkDto;
};

export type SessionsControllerUpdateAssigneeBulkResponse = unknown;

export type SessionsTaggingControllerListTagsData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TagOrderEnumSortOption>;
};

export type SessionsTaggingControllerListTagsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<TagSummaryDto>;
  };

export type SessionsTaggingControllerCreateTagsData = {
  requestBody: CreateTagsDto;
};

export type SessionsTaggingControllerCreateTagsResponse = {
  [key: string]: unknown;
};

export type SessionsTaggingControllerAssignTagsData = {
  requestBody: AssignTagsDto;
};

export type SessionsTaggingControllerAssignTagsResponse = AssignTagsResponseDto;

export type SessionsTaggingControllerUnassignTagsData = {
  requestBody: UnassignTagsDto;
};

export type SessionsTaggingControllerUnassignTagsResponse =
  UnassignTagsResponseDto;

export type SessionsTaggingControllerGetDetailsData = {
  id: number;
};

export type SessionsTaggingControllerGetDetailsResponse = TagDetailsDto;

export type SessionsTaggingControllerUpdateTagData = {
  id: number;
  requestBody: UpdateTagDto;
};

export type SessionsTaggingControllerUpdateTagResponse = TagDetailsDto;

export type SessionsTaggingControllerDeleteTagData = {
  id: number;
};

export type SessionsTaggingControllerDeleteTagResponse = unknown;

export type SessionsTaggingControllerMergeTagToData = {
  id: number;
  mergedToId: number;
};

export type SessionsTaggingControllerMergeTagToResponse = unknown;

export type SessionsTaggingControllerListSummariesData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TagOrderEnumSortOption>;
};

export type SessionsTaggingControllerListSummariesResponse = unknown;

export type SiteGroupsControllerUpsertOperationalHoursBulkData = {
  requestBody: BulkUpsertSiteGroupsOperationalHoursDto;
};

export type SiteGroupsControllerUpsertOperationalHoursBulkResponse = unknown;

export type SiteGroupsControllerListSummariesData = {
  limit: number;
  name?: string;
  page: number;
  siteGroupIds?: Array<number>;
  sortBy?: Array<SiteGroupOrderEnumSortOption>;
};

export type SiteGroupsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<SiteGroupSummaryDto>;
  };

export type SiteGroupsControllerDetailsData = {
  id: number;
};

export type SiteGroupsControllerDetailsResponse = SiteGroupDetailsDto;

export type SiteGroupsControllerUpdateData = {
  id: number;
  requestBody: UpdateSiteGroupDto;
};

export type SiteGroupsControllerUpdateResponse = unknown;

export type SiteGroupsControllerDeleteData = {
  id: number;
};

export type SiteGroupsControllerDeleteResponse = unknown;

export type SiteGroupsControllerCreateData = {
  requestBody: CreateSiteGroupDto;
};

export type SiteGroupsControllerCreateResponse = unknown;

export type SiteGroupsControllerUpsertOperationalHoursData = {
  id: number;
  requestBody: CreateOperationalHoursDto;
};

export type SiteGroupsControllerUpsertOperationalHoursResponse =
  OperationalHoursResponseDto;

export type SiteGroupsControllerAddSitesData = {
  id: number;
  requestBody: UpdateSiteGroupSitesBulkDto;
};

export type SiteGroupsControllerAddSitesResponse = number;

export type SiteGroupsControllerRemoveSitesData = {
  id: number;
  requestBody: UpdateSiteGroupSitesBulkDto;
};

export type SiteGroupsControllerRemoveSitesResponse = number;

export type SiteGroupsControllerGetLabelsData = {
  id: number;
  limit: number;
  page: number;
  search?: string;
};

export type SiteGroupsControllerGetLabelsResponse = SiteGroupLabelsResponseDto;

export type SiteGroupsControllerDownloadLabelsData = {
  id: number;
};

export type SiteGroupsControllerDownloadLabelsResponse = unknown;

export type SiteGroupsControllerBulkUpdateLabelsData = {
  id: number;
  requestBody: BulkUpdateSiteGroupLabelsDto;
};

export type SiteGroupsControllerBulkUpdateLabelsResponse = {
  [key: string]: unknown;
};

export type SiteGroupsControllerCheckDuplicateLabelData = {
  excludeCatalogItemId: number;
  id: number;
  labelInGroup: string;
};

export type SiteGroupsControllerCheckDuplicateLabelResponse =
  CheckDuplicateLabelResponseDto;

export type SitesControllerDownloadData = {
  requestBody: DownloadSiteSummariesRequestDto;
};

export type SitesControllerDownloadResponse = LoggedStreamableFile;

export type SitesControllerCreateData = {
  requestBody: CreateSiteDto;
};

export type SitesControllerCreateResponse = EntityIdDto;

export type SitesControllerListSummariesData = {
  excludeGroupIds?: Array<number>;
  groupId?: number;
  limit: number;
  name?: string;
  page: number;
  siteIds?: Array<number>;
  /**
   * Sorting by one or more fields, each with an optional direction.
   */
  sortBy?: Array<SiteOrderEnumSortOption>;
  tagIds?: Array<number>;
  tagsMatch?: "any" | "exact" | "all" | "none";
};

export type SitesControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<SiteSummaryDto>;
  };

export type SitesControllerListMinimalData = {
  accountId?: number;
  groupId?: number;
  limit: number;
  name?: string;
  page: number;
};

export type SitesControllerListMinimalResponse = PaginatedResponseDto & {
  results?: Array<MinimalEntityDto>;
};

export type SitesControllerGetRegionsData = {
  limit: number;
  /**
   * Case-insensitive substring match on the name
   */
  name?: string;
  page: number;
};

export type SitesControllerGetRegionsResponse = PaginatedResponseDto & {
  results?: Array<MinimalEntityDto>;
};

export type SitesControllerUpdateRegionsData = {
  requestBody: UpdateSitesRegionsDto;
};

export type SitesControllerUpdateRegionsResponse = number;

export type SitesControllerGetSubRegionsData = {
  limit: number;
  /**
   * Case-insensitive substring match on the name
   */
  name?: string;
  page: number;
  /**
   * Limit to sub-regions of this region
   */
  regionId?: number;
};

export type SitesControllerGetSubRegionsResponse = PaginatedResponseDto & {
  results?: Array<SubRegionOptionDto>;
};

export type SitesControllerUpdateTagsBulkData = {
  requestBody: UpdateSitesTaggingsBulkDto;
};

export type SitesControllerUpdateTagsBulkResponse = unknown;

export type SitesControllerDeployModelBulkData = {
  requestBody: SitesModelDeploymentBulkDto;
};

export type SitesControllerDeployModelBulkResponse = unknown;

export type SitesControllerUpdateActivationTimeData = {
  requestBody: UpdateSitesActivationTimeDto;
};

export type SitesControllerUpdateActivationTimeResponse = number;

export type SitesControllerUpdateSiteGroupBulkData = {
  requestBody: UpdateSitesGroupBulkDto;
};

export type SitesControllerUpdateSiteGroupBulkResponse = number;

export type SitesControllerDeployServiceVersionBulkData = {
  requestBody: SitesServiceVersionDeploymentBulkDto;
};

export type SitesControllerDeployServiceVersionBulkResponse = {
  id?: number;
  scheduled?: boolean;
};

export type SitesControllerDeployConfigBulkData = {
  requestBody: SitesConfigDeploymentBulkDto;
};

export type SitesControllerDeployConfigBulkResponse = {
  id?: number;
  scheduled?: boolean;
};

export type SitesControllerUpsertOperationalHoursBulkData = {
  requestBody: BulkUpsertSitesOperationalHoursDto;
};

export type SitesControllerUpsertOperationalHoursBulkResponse = unknown;

export type SitesControllerListAvailableComponentVersionsData = {
  /**
   * The component name
   */
  componentName:
    | "edgify-non-scan-detector"
    | "edgify-worker"
    | "edgify-on-screen-app"
    | "edgify-zebra-adapter"
    | "edgify-agent"
    | "edgify-model";
  limit: number;
  page: number;
  version?: string;
};

export type SitesControllerListAvailableComponentVersionsResponse =
  PaginatedResponseDto & {
    results?: Array<ServiceVersionDto>;
  };

export type SitesControllerUploadData = {
  formData: UploadSitesFileDto;
};

export type SitesControllerUploadResponse = SiteUploadResponseDto;

export type SitesControllerGetDetailsData = {
  id: number;
};

export type SitesControllerGetDetailsResponse = SiteDetailsDto;

export type SitesControllerUpdateData = {
  id: number;
  requestBody: UpdateSiteDto;
};

export type SitesControllerUpdateResponse = unknown;

export type SitesControllerDeployVersionData = {
  id: number;
  requestBody: DeployAgentVersionRequestDto;
};

export type SitesControllerDeployVersionResponse = unknown;

export type SitesControllerGetVersionHistoryData = {
  id: number;
  limit: number;
  page: number;
};

export type SitesControllerGetVersionHistoryResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<SiteAgentDeploymentDto>;
  };

export type SitesControllerDeployServiceData = {
  id: number;
  requestBody: DeployServiceVersionDto;
};

export type SitesControllerDeployServiceResponse = unknown;

export type SitesControllerGetServiceDeploymentsData = {
  id: number;
  limit: number;
  page: number;
  serviceName?:
    | "edgify-non-scan-detector"
    | "edgify-worker"
    | "edgify-on-screen-app"
    | "edgify-zebra-adapter"
    | "edgify-agent"
    | "edgify-model";
};

export type SitesControllerGetServiceDeploymentsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<SiteServiceDeploymentsDto>;
  };

export type SitesControllerGetAvailableServiceVersionsData = {
  id: number;
  limit: number;
  page: number;
  /**
   * The service name
   */
  serviceName:
    | "edgify-non-scan-detector"
    | "edgify-worker"
    | "edgify-on-screen-app"
    | "edgify-zebra-adapter"
    | "edgify-agent"
    | "edgify-model";
  version?: string;
};

export type SitesControllerGetAvailableServiceVersionsResponse =
  PaginatedResponseDto & {
    results?: Array<ServiceVersionDto>;
  };

export type SitesControllerGetLatestSiteDeviceDeploymentData = {
  id: number;
};

export type SitesControllerGetLatestSiteDeviceDeploymentResponse =
  | -1
  | 0
  | 1
  | 2;

export type SitesControllerAddDevicesData = {
  id: number;
  requestBody: UpdateSiteDevicesBulkDto;
};

export type SitesControllerAddDevicesResponse = number;

export type SitesControllerRemoveDevicesData = {
  id: number;
  requestBody: UpdateSiteDevicesBulkDto;
};

export type SitesControllerRemoveDevicesResponse = number;

export type SitesControllerDeleteData = {
  id: number;
  requestBody: DeleteSiteDeviceDto;
};

export type SitesControllerDeleteResponse = PartialDevice;

export type SitesControllerUpsertOperationalHoursData = {
  id: number;
  requestBody: CreateOperationalHoursDto;
};

export type SitesControllerUpsertOperationalHoursResponse =
  OperationalHoursResponseDto;

export type SitesTaggingControllerListTagsData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TagOrderEnumSortOption>;
};

export type SitesTaggingControllerListTagsResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<TagSummaryDto>;
  };

export type SitesTaggingControllerCreateTagsData = {
  requestBody: CreateTagsDto;
};

export type SitesTaggingControllerCreateTagsResponse = {
  [key: string]: unknown;
};

export type SitesTaggingControllerAssignTagsData = {
  requestBody: AssignTagsDto;
};

export type SitesTaggingControllerAssignTagsResponse = AssignTagsResponseDto;

export type SitesTaggingControllerUnassignTagsData = {
  requestBody: UnassignTagsDto;
};

export type SitesTaggingControllerUnassignTagsResponse =
  UnassignTagsResponseDto;

export type SitesTaggingControllerGetDetailsData = {
  id: number;
};

export type SitesTaggingControllerGetDetailsResponse = TagDetailsDto;

export type SitesTaggingControllerUpdateTagData = {
  id: number;
  requestBody: UpdateTagDto;
};

export type SitesTaggingControllerUpdateTagResponse = TagDetailsDto;

export type SitesTaggingControllerDeleteTagData = {
  id: number;
};

export type SitesTaggingControllerDeleteTagResponse = unknown;

export type SitesTaggingControllerMergeTagToData = {
  id: number;
  mergedToId: number;
};

export type SitesTaggingControllerMergeTagToResponse = unknown;

export type SitesTaggingControllerListSummariesData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TagOrderEnumSortOption>;
};

export type SitesTaggingControllerListSummariesResponse = unknown;

export type SlackControllerCallbackData = {
  code: string;
  state: string;
};

export type SlackControllerCallbackResponse = unknown;

export type SlackControllerGetSlackAuthUrlData = {
  requestBody: CreateSlackAlertChannelDto;
};

export type SlackControllerGetSlackAuthUrlResponse = string;

export type SlackControllerGetGlobalSlackAuthUrlData = {
  requestBody: CreateSlackAlertChannelDto;
};

export type SlackControllerGetGlobalSlackAuthUrlResponse = string;

export type SlackControllerTestRecurrenceNotificationData = {
  requestBody: TestRecurrenceNotificationDto;
};

export type SlackControllerTestRecurrenceNotificationResponse = {
  [key: string]: unknown;
};

export type SlackControllerTestPartialResolveNotificationData = {
  requestBody: TestPartialResolveNotificationDto;
};

export type SlackControllerTestPartialResolveNotificationResponse = {
  [key: string]: unknown;
};

export type SlackControllerTestCreateAlertData = {
  requestBody: TestCreateAlertDto;
};

export type SlackControllerTestCreateAlertResponse = {
  [key: string]: unknown;
};

export type SlackControllerTestResolveAlertData = {
  requestBody: TestResolveAlertDto;
};

export type SlackControllerTestResolveAlertResponse = {
  [key: string]: unknown;
};

export type StaticDatasetsControllerListData = {
  fromDate?: Date;
  limit: number;
  page: number;
  toDate?: Date;
};

export type StaticDatasetsControllerListResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<StaticDatasetSummaryDto>;
  };

export type StaticDatasetsControllerListMinimalResponse =
  Array<DatasetMinimalDto>;

export type StaticDatasetsControllerGetDetailsData = {
  id: number;
};

export type StaticDatasetsControllerGetDetailsResponse =
  StaticDatasetDetailsDto;

export type StaticDatasetsControllerDeleteData = {
  id: number;
};

export type StaticDatasetsControllerDeleteResponse = unknown;

export type StaticDatasetsControllerCountSamplesData = {
  id: number;
};

export type StaticDatasetsControllerCountSamplesResponse = unknown;

export type StaticDatasetsControllerAnalyzeData = {
  formData: AnalyzeDatasetDto;
};

export type StaticDatasetsControllerAnalyzeResponse = unknown;

export type StaticDatasetsControllerCreateData = {
  requestBody: CreateDatasetFromTempDto;
};

export type StaticDatasetsControllerCreateResponse = unknown;

export type StaticDatasetsControllerUploadData = {
  formData: UploadStaticDatasetDto;
};

export type StaticDatasetsControllerUploadResponse = unknown;

export type StaticDatasetsControllerStartData = {
  id: number;
};

export type StaticDatasetsControllerStartResponse = unknown;

export type StaticDatasetsControllerCreateEmptyData = {
  requestBody: CreateEmptyDatasetDto;
};

export type StaticDatasetsControllerCreateEmptyResponse = unknown;

export type StaticDatasetsControllerAddSamplesFromFilterData = {
  id: number;
  requestBody: AddSamplesFromFilterDto;
};

export type StaticDatasetsControllerAddSamplesFromFilterResponse = unknown;

export type StaticDatasetsControllerRetryMissingSamplesData = {
  id: number;
};

export type StaticDatasetsControllerRetryMissingSamplesResponse = unknown;

export type StaticDatasetsControllerRecalculateAnalyticsData = {
  id: number;
};

export type StaticDatasetsControllerRecalculateAnalyticsResponse = unknown;

export type StaticDatasetsControllerResumeFromSamplesData = {
  id: number;
};

export type StaticDatasetsControllerResumeFromSamplesResponse = unknown;

export type StaticDatasetsControllerAddSessionsFromFilterData = {
  id: number;
  requestBody: AddSessionsFromFilterDto;
};

export type StaticDatasetsControllerAddSessionsFromFilterResponse = unknown;

export type StaticDatasetsControllerRetryMissingSessionsData = {
  id: number;
};

export type StaticDatasetsControllerRetryMissingSessionsResponse = unknown;

export type StaticDatasetsControllerResumeFromSessionsData = {
  id: number;
};

export type StaticDatasetsControllerResumeFromSessionsResponse = unknown;

export type SyncGroundTruthsControllerCreateScheduleData = {
  requestBody: SyncGroundTruthsScheduleJobDto;
};

export type SyncGroundTruthsControllerCreateScheduleResponse =
  SyncGroundTruthsScheduledJobSummaryDto;

export type SyncGroundTruthsControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type SyncGroundTruthsControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<SyncGroundTruthsScheduledJobSummaryDto>;
  };

export type SyncGroundTruthsControllerGetScheduledJobData = {
  id: number;
};

export type SyncGroundTruthsControllerGetScheduledJobResponse =
  SyncGroundTruthsScheduledJobDto;

export type SyncGroundTruthsControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: SyncGroundTruthsUpdateScheduledJobDto;
};

export type SyncGroundTruthsControllerUpdateScheduledJobResponse =
  SyncGroundTruthsScheduledJobDto;

export type SyncGroundTruthsControllerDeleteScheduledJobData = {
  id: number;
};

export type SyncGroundTruthsControllerDeleteScheduledJobResponse = boolean;

export type SyncGroundTruthsControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type SyncGroundTruthsControllerCancelScheduledJobsBulkResponse = number;

export type SyncGroundTruthsControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type SyncGroundTruthsControllerStopScheduledJobsBulkResponse = number;

export type SyncGroundTruthsControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type SyncGroundTruthsControllerResumeScheduledJobsBulkResponse = number;

export type SyncGroundTruthsControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type SyncGroundTruthsControllerDeleteScheduledJobsBulkResponse = number;

export type SyncGroundTruthsControllerStartScheduledJobData = {
  id: number;
};

export type SyncGroundTruthsControllerStartScheduledJobResponse =
  SyncGroundTruthsJobDto;

export type SyncGroundTruthsControllerCancelScheduledJobData = {
  id: number;
};

export type SyncGroundTruthsControllerCancelScheduledJobResponse = boolean;

export type SyncGroundTruthsControllerStopScheduledJobData = {
  id: number;
};

export type SyncGroundTruthsControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type SyncGroundTruthsControllerResumeScheduledJobData = {
  id: number;
};

export type SyncGroundTruthsControllerResumeScheduledJobResponse =
  SyncGroundTruthsScheduledJobSummaryDto;

export type SyncGroundTruthsControllerStartJobData = {
  requestBody: SyncGroundTruthsDataWithNameDto;
};

export type SyncGroundTruthsControllerStartJobResponse = SyncGroundTruthsJobDto;

export type SyncGroundTruthsControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type SyncGroundTruthsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<SyncGroundTruthsJobSummaryDto>;
  };

export type SyncGroundTruthsControllerGetJobData = {
  id: number;
};

export type SyncGroundTruthsControllerGetJobResponse = SyncGroundTruthsJobDto;

export type SyncGroundTruthsControllerDeleteJobData = {
  id: number;
};

export type SyncGroundTruthsControllerDeleteJobResponse = boolean;

export type SyncGroundTruthsControllerUpdateJobData = {
  id: number;
  requestBody: SyncGroundTruthsUpdateJobDto;
};

export type SyncGroundTruthsControllerUpdateJobResponse =
  SyncGroundTruthsJobDto;

export type SyncGroundTruthsControllerCancelJobData = {
  id: number;
};

export type SyncGroundTruthsControllerCancelJobResponse = boolean;

export type SyncGroundTruthsControllerStopJobData = {
  id: number;
};

export type SyncGroundTruthsControllerStopJobResponse = boolean;

export type SyncGroundTruthsControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type SyncGroundTruthsControllerCancelJobsBulkResponse = number;

export type SyncGroundTruthsControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type SyncGroundTruthsControllerDeleteJobsBulkResponse = number;

export type TagsControllerListTagsData = {
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<SampleTagOrderEnumSortOption>;
};

export type TagsControllerListTagsResponse = PaginatedResponseWithCountDto & {
  results?: Array<SampleTagSummaryDto>;
};

export type TagsControllerCreateData = {
  requestBody: CreateSampleTagDto;
};

export type TagsControllerCreateResponse = unknown;

export type TagsControllerSetTagsData = {
  requestBody: SetSampleTagsDto;
};

export type TagsControllerSetTagsResponse = unknown;

export type TagsControllerDeleteData = {
  id: number;
};

export type TagsControllerDeleteResponse = unknown;

export type TagsControllerUpdateData = {
  id: number;
  requestBody: UpdateTagDto;
};

export type TagsControllerUpdateResponse = TagDetailsDto;

export type TagsControllerGetDetailsData = {
  id: number;
};

export type TagsControllerGetDetailsResponse = TagDetailsDto;

export type TagsControllerMergeTagToData = {
  id: number;
  mergedToId: number;
};

export type TagsControllerMergeTagToResponse = unknown;

export type TagsControllerAssignTagsData = {
  requestBody: AssignSampleTagsDto;
};

export type TagsControllerAssignTagsResponse = AssignSampleTagsResponseDto;

export type TagsControllerSetGroupTagsData = {
  requestBody: SetGroupSampleTagsDto;
};

export type TagsControllerSetGroupTagsResponse = SetGroupSampleTagsResponseDto;

export type TagsControllerUpdateGroupTagsData = {
  requestBody: UpdateGroupSampleTagsDto;
};

export type TagsControllerUpdateGroupTagsResponse =
  SetGroupSampleTagsResponseDto;

export type TagsControllerAssignGroupTagsData = {
  requestBody: AssignGroupSampleTagsDto;
};

export type TagsControllerAssignGroupTagsResponse =
  AssignGroupSampleTagsResponseDto;

export type TagsControllerUnassignGroupTagsData = {
  requestBody: UnassignGroupSampleTagsDto;
};

export type TagsControllerUnassignGroupTagsResponse =
  UnassignGroupSampleTagsResponseDto;

export type TagsControllerUnassignTagsData = {
  requestBody: UnassignSampleTagsDto;
};

export type TagsControllerUnassignTagsResponse = UnassignSampleTagsResponseDto;

export type TrainingsControllerListSummariesData = {
  createdSince?: Date;
  from?: Date;
  isVisible?: boolean;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<TrainingSummariesOrderEnumSortOption>;
  state?: Array<TrainingState>;
  to?: Date;
};

export type TrainingsControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<TrainingSummaryDto>;
  };

export type TrainingsControllerGetDefaultsResponse = TrainingDefaultsDto;

export type TrainingsControllerUpdateDefaultsData = {
  requestBody: UpdateTrainingDefaultsDto;
};

export type TrainingsControllerUpdateDefaultsResponse = TrainingDefaultsDto;

export type TrainingsControllerClearDefaultsResponse = TrainingDefaultsDto;

export type TrainingsControllerGetDetailsData = {
  id: number;
};

export type TrainingsControllerGetDetailsResponse = TrainingDetailsDto;

export type TrainingsControllerUpdateData = {
  id: number;
  requestBody: UpdateTrainingDto;
};

export type TrainingsControllerUpdateResponse = unknown;

export type TrainingsControllerGetTrainingExecutionDetailsData = {
  id: number;
};

export type TrainingsControllerGetTrainingExecutionDetailsResponse =
  TrainingExecutionDetailsDto;

export type TrainingsControllerGetParticipationsData = {
  id: number;
};

export type TrainingsControllerGetParticipationsResponse =
  TrainingParticipationsDto;

export type TrainingsControllerGetSampleStatsData = {
  id: number;
};

export type TrainingsControllerGetSampleStatsResponse = TrainingSampleStatsDto;

export type TrainingsControllerDeleteTrainingsBulkData = {
  requestBody: BulkTrainingsDto;
};

export type TrainingsControllerDeleteTrainingsBulkResponse = number;

export type TrainingsControllerCancelTrainingsBulkData = {
  requestBody: BulkTrainingsDto;
};

export type TrainingsControllerCancelTrainingsBulkResponse = number;

export type TrainingsControllerCreateTrainingData = {
  requestBody: CreateTrainingDto;
};

export type TrainingsControllerCreateTrainingResponse = EntityIdDto;

export type TrainingsControllerCancelTrainingData = {
  id: number;
};

export type TrainingsControllerCancelTrainingResponse = unknown;

export type TrainingsControllerCreateModelData = {
  id: number;
};

export type TrainingsControllerCreateModelResponse = unknown;

export type UploadSamplesControllerCreateScheduleData = {
  requestBody: UploadSamplesScheduleJobDto;
};

export type UploadSamplesControllerCreateScheduleResponse =
  UploadSamplesScheduledJobSummaryDto;

export type UploadSamplesControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type UploadSamplesControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<UploadSamplesScheduledJobSummaryDto>;
  };

export type UploadSamplesControllerGetScheduledJobData = {
  id: number;
};

export type UploadSamplesControllerGetScheduledJobResponse =
  UploadSamplesScheduledJobDto;

export type UploadSamplesControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: UploadSamplesUpdateScheduledJobDto;
};

export type UploadSamplesControllerUpdateScheduledJobResponse =
  UploadSamplesScheduledJobDto;

export type UploadSamplesControllerDeleteScheduledJobData = {
  id: number;
};

export type UploadSamplesControllerDeleteScheduledJobResponse = boolean;

export type UploadSamplesControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type UploadSamplesControllerCancelScheduledJobsBulkResponse = number;

export type UploadSamplesControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type UploadSamplesControllerStopScheduledJobsBulkResponse = number;

export type UploadSamplesControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type UploadSamplesControllerResumeScheduledJobsBulkResponse = number;

export type UploadSamplesControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type UploadSamplesControllerDeleteScheduledJobsBulkResponse = number;

export type UploadSamplesControllerStartScheduledJobData = {
  id: number;
};

export type UploadSamplesControllerStartScheduledJobResponse =
  UploadSamplesJobDto;

export type UploadSamplesControllerCancelScheduledJobData = {
  id: number;
};

export type UploadSamplesControllerCancelScheduledJobResponse = boolean;

export type UploadSamplesControllerStopScheduledJobData = {
  id: number;
};

export type UploadSamplesControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type UploadSamplesControllerResumeScheduledJobData = {
  id: number;
};

export type UploadSamplesControllerResumeScheduledJobResponse =
  UploadSamplesScheduledJobSummaryDto;

export type UploadSamplesControllerStartJobData = {
  requestBody: UploadSamplesDataWithNameDto;
};

export type UploadSamplesControllerStartJobResponse = UploadSamplesJobDto;

export type UploadSamplesControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type UploadSamplesControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<UploadSamplesJobSummaryDto>;
  };

export type UploadSamplesControllerGetJobData = {
  id: number;
};

export type UploadSamplesControllerGetJobResponse = UploadSamplesJobDto;

export type UploadSamplesControllerDeleteJobData = {
  id: number;
};

export type UploadSamplesControllerDeleteJobResponse = boolean;

export type UploadSamplesControllerUpdateJobData = {
  id: number;
  requestBody: UploadSamplesUpdateJobDto;
};

export type UploadSamplesControllerUpdateJobResponse = UploadSamplesJobDto;

export type UploadSamplesControllerCancelJobData = {
  id: number;
};

export type UploadSamplesControllerCancelJobResponse = boolean;

export type UploadSamplesControllerStopJobData = {
  id: number;
};

export type UploadSamplesControllerStopJobResponse = boolean;

export type UploadSamplesControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type UploadSamplesControllerCancelJobsBulkResponse = number;

export type UploadSamplesControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type UploadSamplesControllerDeleteJobsBulkResponse = number;

export type UploadVideosControllerGetStorageUriResponse = StorageUriDto;

export type UploadVideosControllerCreateScheduleData = {
  requestBody: UploadVideosScheduleJobDto;
};

export type UploadVideosControllerCreateScheduleResponse =
  UploadVideosScheduledJobSummaryDto;

export type UploadVideosControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type UploadVideosControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<UploadVideosScheduledJobSummaryDto>;
  };

export type UploadVideosControllerGetScheduledJobData = {
  id: number;
};

export type UploadVideosControllerGetScheduledJobResponse =
  UploadVideosScheduledJobDto;

export type UploadVideosControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: UploadVideosUpdateScheduledJobDto;
};

export type UploadVideosControllerUpdateScheduledJobResponse =
  UploadVideosScheduledJobDto;

export type UploadVideosControllerDeleteScheduledJobData = {
  id: number;
};

export type UploadVideosControllerDeleteScheduledJobResponse = boolean;

export type UploadVideosControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type UploadVideosControllerCancelScheduledJobsBulkResponse = number;

export type UploadVideosControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type UploadVideosControllerStopScheduledJobsBulkResponse = number;

export type UploadVideosControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type UploadVideosControllerResumeScheduledJobsBulkResponse = number;

export type UploadVideosControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type UploadVideosControllerDeleteScheduledJobsBulkResponse = number;

export type UploadVideosControllerStartScheduledJobData = {
  id: number;
};

export type UploadVideosControllerStartScheduledJobResponse =
  UploadVideosJobDto;

export type UploadVideosControllerCancelScheduledJobData = {
  id: number;
};

export type UploadVideosControllerCancelScheduledJobResponse = boolean;

export type UploadVideosControllerStopScheduledJobData = {
  id: number;
};

export type UploadVideosControllerStopScheduledJobResponse =
  StoppedScheduledDto;

export type UploadVideosControllerResumeScheduledJobData = {
  id: number;
};

export type UploadVideosControllerResumeScheduledJobResponse =
  UploadVideosScheduledJobSummaryDto;

export type UploadVideosControllerStartJobData = {
  requestBody: UploadVideosDataWithNameDto;
};

export type UploadVideosControllerStartJobResponse = UploadVideosJobDto;

export type UploadVideosControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type UploadVideosControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<UploadVideosJobSummaryDto>;
  };

export type UploadVideosControllerGetJobData = {
  id: number;
};

export type UploadVideosControllerGetJobResponse = UploadVideosJobDto;

export type UploadVideosControllerDeleteJobData = {
  id: number;
};

export type UploadVideosControllerDeleteJobResponse = boolean;

export type UploadVideosControllerUpdateJobData = {
  id: number;
  requestBody: UploadVideosUpdateJobDto;
};

export type UploadVideosControllerUpdateJobResponse = UploadVideosJobDto;

export type UploadVideosControllerCancelJobData = {
  id: number;
};

export type UploadVideosControllerCancelJobResponse = boolean;

export type UploadVideosControllerStopJobData = {
  id: number;
};

export type UploadVideosControllerStopJobResponse = boolean;

export type UploadVideosControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type UploadVideosControllerCancelJobsBulkResponse = number;

export type UploadVideosControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type UploadVideosControllerDeleteJobsBulkResponse = number;

export type UsersControllerAssignSitesData = {
  requestBody: AssignSitesDto;
};

export type UsersControllerAssignSitesResponse = unknown;

export type UsersControllerMeResponse = UserDetailsDto;

export type UsersControllerListEmailsData = {
  limit: number;
  page: number;
};

export type UsersControllerListEmailsResponse = PaginatedResponseDto & {
  results?: Array<string>;
};

export type UsersControllerRelatedAccountsResponse = Array<RelatedAccountDto>;

export type UsersControllerCheckUserData = {
  requestBody: CheckUserDto;
};

export type UsersControllerCheckUserResponse =
  | FullUserDetailsDto
  | FloatingUserDetailsDto;

export type UsersControllerCreateData = {
  formData: CreateUserClientDto;
};

export type UsersControllerCreateResponse = CreateUserResponseDto;

export type UsersControllerFindAllData = {
  company?: string;
  excludeRoles?: Array<
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
  >;
  firstName?: string;
  id?: number;
  lastName?: string;
  limit: number;
  page: number;
  roles?: Array<
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
  >;
  sortBy?: Array<UserOrderEnumSortOption>;
  userIds?: Array<number>;
};

export type UsersControllerFindAllResponse = PaginatedResponseDto & {
  results?: Array<UserDetailsDto>;
};

export type UsersControllerListMinimalData = {
  company?: string;
  excludeRoles?: Array<
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
  >;
  firstName?: string;
  id?: number;
  lastName?: string;
  limit: number;
  page: number;
  roles?: Array<
    | "Viewer"
    | "Annotator"
    | "Tech"
    | "Owner"
    | "MLOps"
    | "SiteManager"
    | "AnnotatorManager"
    | "EdgifyCandidate"
  >;
  sortBy?: Array<UserOrderEnumSortOption>;
  userIds?: Array<number>;
};

export type UsersControllerListMinimalResponse = PaginatedResponseDto & {
  results?: Array<UserMinimalDto>;
};

export type UsersControllerDownloadData = {
  requestBody: DownloadUsersRequestDto;
};

export type UsersControllerDownloadResponse = LoggedStreamableFile;

export type UsersControllerGetRoleCreatePermissionResponse =
  RoleCreatePermissionDto;

export type UsersControllerFindOneData = {
  id: number;
};

export type UsersControllerFindOneResponse =
  | FullUserDetailsDto
  | FloatingUserDetailsDto;

export type UsersControllerRemoveData = {
  id: number;
};

export type UsersControllerRemoveResponse = unknown;

export type UsersControllerUpdateData = {
  formData: UpdateUserDto;
};

export type UsersControllerUpdateResponse = number;

export type UsersControllerUpdateTableSettingsData = {
  requestBody: UpdateTableSettingsDto;
  tableKey: string;
};

export type UsersControllerUpdateTableSettingsResponse = UserSettingsDto;

export type UsersControllerDeleteTableSettingsData = {
  tableKey: string;
};

export type UsersControllerDeleteTableSettingsResponse = UserSettingsDto;

export type UsersControllerAdminUpdateData = {
  formData: AdminUpdateUserDto;
};

export type UsersControllerAdminUpdateResponse = number;

export type UsersControllerDeleteUsersBulkData = {
  requestBody: DeleteUsersBulkDto;
};

export type UsersControllerDeleteUsersBulkResponse = number;

export type UsersControllerInviteUsersToReportData = {
  requestBody: InviteUsersDto;
};

export type UsersControllerInviteUsersToReportResponse = EmailSendOutcomeDto;

export type WorkerJobControllerGetJobInputData = {
  jobType: WorkerJobTypesEnum;
};

export type WorkerJobControllerGetJobInputResponse = {
  [key: string]: unknown;
};

export type WorkerJobControllerGetTokenData = {
  deviceId: number;
  jobId: number;
};

export type WorkerJobControllerGetTokenResponse = string;

export type WorkerJobControllerCreateScheduleData = {
  requestBody: WorkerJobScheduleJobDto;
};

export type WorkerJobControllerCreateScheduleResponse =
  WorkerJobScheduledJobSummaryDto;

export type WorkerJobControllerListScheduledData = {
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<ScheduledJobOrderEnumSortOption>;
  to?: Date;
};

export type WorkerJobControllerListScheduledResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<WorkerJobScheduledJobSummaryDto>;
  };

export type WorkerJobControllerGetScheduledJobData = {
  id: number;
};

export type WorkerJobControllerGetScheduledJobResponse =
  WorkerJobScheduledJobDto;

export type WorkerJobControllerUpdateScheduledJobData = {
  id: number;
  /**
   * allow partial update for data
   */
  partial?: boolean;
  requestBody: WorkerJobUpdateScheduledJobDto;
};

export type WorkerJobControllerUpdateScheduledJobResponse =
  WorkerJobScheduledJobDto;

export type WorkerJobControllerDeleteScheduledJobData = {
  id: number;
};

export type WorkerJobControllerDeleteScheduledJobResponse = boolean;

export type WorkerJobControllerCancelScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type WorkerJobControllerCancelScheduledJobsBulkResponse = number;

export type WorkerJobControllerStopScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type WorkerJobControllerStopScheduledJobsBulkResponse = number;

export type WorkerJobControllerResumeScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type WorkerJobControllerResumeScheduledJobsBulkResponse = number;

export type WorkerJobControllerDeleteScheduledJobsBulkData = {
  requestBody: DeleteScheduledJobsBulkDto;
};

export type WorkerJobControllerDeleteScheduledJobsBulkResponse = number;

export type WorkerJobControllerStartScheduledJobData = {
  id: number;
};

export type WorkerJobControllerStartScheduledJobResponse = WorkerJobJobDto;

export type WorkerJobControllerCancelScheduledJobData = {
  id: number;
};

export type WorkerJobControllerCancelScheduledJobResponse = boolean;

export type WorkerJobControllerStopScheduledJobData = {
  id: number;
};

export type WorkerJobControllerStopScheduledJobResponse = StoppedScheduledDto;

export type WorkerJobControllerResumeScheduledJobData = {
  id: number;
};

export type WorkerJobControllerResumeScheduledJobResponse =
  WorkerJobScheduledJobSummaryDto;

export type WorkerJobControllerStartJobData = {
  requestBody: WorkerJobDataWithNameDto;
};

export type WorkerJobControllerStartJobResponse = WorkerJobJobDto;

export type WorkerJobControllerListSummariesData = {
  /**
   * Filters on how many items the job actually completed.
   */
  done?: Array<NumberConditionDto>;
  from?: Date;
  limit: number;
  name?: string;
  page: number;
  sortBy?: Array<JobOrderEnumSortOption>;
  state?: Array<
    | "done"
    | "failed"
    | "pending"
    | "cancelled"
    | "running"
    | "cancelling"
    | "suspended"
    | "aborted"
  >;
  to?: Date;
  /**
   * Filters on the job's target size, eg. `total=gt:0` to hide jobs that had nothing to do.
   */
  total?: Array<NumberConditionDto>;
};

export type WorkerJobControllerListSummariesResponse =
  PaginatedResponseWithCountDto & {
    results?: Array<WorkerJobJobSummaryDto>;
  };

export type WorkerJobControllerGetJobData = {
  id: number;
};

export type WorkerJobControllerGetJobResponse = WorkerJobJobDto;

export type WorkerJobControllerDeleteJobData = {
  id: number;
};

export type WorkerJobControllerDeleteJobResponse = boolean;

export type WorkerJobControllerUpdateJobData = {
  id: number;
  requestBody: WorkerJobUpdateJobDto;
};

export type WorkerJobControllerUpdateJobResponse = WorkerJobJobDto;

export type WorkerJobControllerCancelJobData = {
  id: number;
};

export type WorkerJobControllerCancelJobResponse = boolean;

export type WorkerJobControllerStopJobData = {
  id: number;
};

export type WorkerJobControllerStopJobResponse = boolean;

export type WorkerJobControllerCancelJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type WorkerJobControllerCancelJobsBulkResponse = number;

export type WorkerJobControllerDeleteJobsBulkData = {
  requestBody: DeleteJobsBulkDto;
};

export type WorkerJobControllerDeleteJobsBulkResponse = number;

export type DeviceControllerDownloadModel0Data = {
  id: number;
  type: "model" | "config";
};

export type DeviceControllerDownloadModel0Response = LoggedStreamableFile;

export type DeviceControllerDownloadModel1Data = {
  id: number;
  type: "model" | "config";
};

export type DeviceControllerDownloadModel1Response = LoggedStreamableFile;

export type DeviceControllerGetCurrentTime0Response = Date;

export type DeviceControllerGetCurrentTime1Response = Date;

export type DeviceControllerSavePredictions0Response = unknown;

export type DeviceControllerSavePredictions1Response = unknown;

export type DeviceControllerSaveGroundTruths0Response = unknown;

export type DeviceControllerSaveGroundTruths1Response = unknown;

export type DeviceControllerSaveEvents0Response = unknown;

export type DeviceControllerSaveEvents1Response = unknown;

export type DeviceControllerSaveDataStream0Response = unknown;

export type DeviceControllerSaveDataStream1Response = unknown;

export type DeviceControllerGetClusterInfo0Response = ClusterInfoDto;

export type DeviceControllerGetClusterInfo1Response = ClusterInfoDto;

export type DeviceControllerGetLookupTable0Response = string;

export type DeviceControllerGetLookupTable1Response = string;

export type DeviceControllerSaveVideo0Data = {
  formData: UploadedVideoDto;
};

export type DeviceControllerSaveVideo0Response = unknown;

export type DeviceControllerSaveVideo1Data = {
  formData: UploadedVideoDto;
};

export type DeviceControllerSaveVideo1Response = unknown;

export type DeviceControllerSaveImage0Data = {
  formData: UploadedSampleDto;
};

export type DeviceControllerSaveImage0Response = unknown;

export type DeviceControllerSaveImage1Data = {
  formData: UploadedSampleDto;
};

export type DeviceControllerSaveImage1Response = unknown;

export type DeviceControllerSaveLog0Response = unknown;

export type DeviceControllerSaveLog1Response = unknown;

export type DeviceControllerDownloadAgent0Data = {
  filename: string;
};

export type DeviceControllerDownloadAgent0Response = LoggedStreamableFile;

export type DeviceControllerDownloadAgent1Data = {
  filename: string;
};

export type DeviceControllerDownloadAgent1Response = LoggedStreamableFile;

export type DeviceJobsControllerUpdateStatusData = {
  requestBody: DeviceJobStatusUpdateDto;
};

export type DeviceJobsControllerUpdateStatusResponse = unknown;

export type DeviceRegistrationControllerRegisterDevice0Data = {
  requestBody: RegisterDeviceDto;
};

export type DeviceRegistrationControllerRegisterDevice0Response = string;

export type DeviceRegistrationControllerRegisterDevice1Data = {
  requestBody: RegisterDeviceDto;
};

export type DeviceRegistrationControllerRegisterDevice1Response = string;

export type TrainingControllerGetDetailsResponse = {
  [key: string]: unknown;
};

export type TrainingControllerUpdateTrainingDeviceStateData = {
  requestBody: UpdateStateDto;
};

export type TrainingControllerUpdateTrainingDeviceStateResponse = unknown;

export type TrainingControllerCreateMetricResponse = unknown;

export type TrainingControllerGetMetricData = {
  type: string;
};

export type TrainingControllerGetMetricResponse = {
  [key: string]: unknown;
};

export type TrainingControllerGetPreTrainedModelMetricData = {
  type: string;
};

export type TrainingControllerGetPreTrainedModelMetricResponse = {
  [key: string]: unknown;
};

export type TrainingControllerCreateCheckpointData = {
  formData: CreateCheckpointDto;
};

export type TrainingControllerCreateCheckpointResponse = unknown;

export type TrainingControllerDownloadCheckpointResponse = LoggedStreamableFile;

export type TrainingControllerDownloadPreTrainedModelResponse =
  LoggedStreamableFile;

export type HealthControllerDetailedCheckResponse = {
  status?: string;
  info?: {
    [key: string]: {
      status: string;
      [key: string]: unknown | string;
    };
  } | null;
  error?: {
    [key: string]: {
      status: string;
      [key: string]: unknown | string;
    };
  } | null;
  details?: {
    [key: string]: {
      status: string;
      [key: string]: unknown | string;
    };
  };
};

export type HealthControllerCheckResponse = {
  status?: string;
  info?: {
    [key: string]: {
      status: string;
      [key: string]: unknown | string;
    };
  } | null;
  error?: {
    [key: string]: {
      status: string;
      [key: string]: unknown | string;
    };
  } | null;
  details?: {
    [key: string]: {
      status: string;
      [key: string]: unknown | string;
    };
  };
};

export type DgTransactionControllerTrimTransactionData = {
  /**
   * XML file containing transaction details
   */
  formData: {
    /**
     * The XML file for the transaction
     */
    file: Blob | File;
  };
};

export type DgTransactionControllerTrimTransactionResponse = unknown;

export type VersionControllerVersionResponse = string;

export type AlertsControllerGetAlertByIdResponseTransformer = (
  data: any,
) => Promise<AlertsControllerGetAlertByIdResponse>;

export type AlertDetailsDtoModelResponseTransformer = (
  data: any,
) => AlertDetailsDto;

export type DisabledDeviceDtoModelResponseTransformer = (
  data: any,
) => DisabledDeviceDto;

export const DisabledDeviceDtoModelResponseTransformer: DisabledDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.suppressedUntil) {
      data.suppressedUntil = new Date(data.suppressedUntil);
    }
    return data;
  };

export const AlertDetailsDtoModelResponseTransformer: AlertDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (Array.isArray(data?.disabledDevices)) {
      data.disabledDevices.forEach(DisabledDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const AlertsControllerGetAlertByIdResponseTransformer: AlertsControllerGetAlertByIdResponseTransformer =
  async (data) => {
    AlertDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type CameraCalibrationControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<CameraCalibrationControllerCreateScheduleResponse>;

export type CameraCalibrationScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => CameraCalibrationScheduledJobSummaryDto;

export const CameraCalibrationScheduledJobSummaryDtoModelResponseTransformer: CameraCalibrationScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const CameraCalibrationControllerCreateScheduleResponseTransformer: CameraCalibrationControllerCreateScheduleResponseTransformer =
  async (data) => {
    CameraCalibrationScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type CameraCalibrationControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<CameraCalibrationControllerGetScheduledJobResponse>;

export type CameraCalibrationScheduledJobDtoModelResponseTransformer = (
  data: any,
) => CameraCalibrationScheduledJobDto;

export const CameraCalibrationScheduledJobDtoModelResponseTransformer: CameraCalibrationScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const CameraCalibrationControllerGetScheduledJobResponseTransformer: CameraCalibrationControllerGetScheduledJobResponseTransformer =
  async (data) => {
    CameraCalibrationScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type CameraCalibrationControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<CameraCalibrationControllerUpdateScheduledJobResponse>;

export const CameraCalibrationControllerUpdateScheduledJobResponseTransformer: CameraCalibrationControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    CameraCalibrationScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type CameraCalibrationControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<CameraCalibrationControllerStartScheduledJobResponse>;

export type CameraCalibrationJobDtoModelResponseTransformer = (
  data: any,
) => CameraCalibrationJobDto;

export type CameraCalibrationJobDeviceDtoModelResponseTransformer = (
  data: any,
) => CameraCalibrationJobDeviceDto;

export type CameraCalibrationJobDeviceParticipationDtoModelResponseTransformer =
  (data: any) => CameraCalibrationJobDeviceParticipationDto;

export type CameraCalibrationDeviceResultDtoModelResponseTransformer = (
  data: any,
) => CameraCalibrationDeviceResultDto;

export type PredictResponseDtoModelResponseTransformer = (
  data: any,
) => PredictResponseDto;

export const PredictResponseDtoModelResponseTransformer: PredictResponseDtoModelResponseTransformer =
  (data) => {
    if (data?.predictedAt) {
      data.predictedAt = new Date(data.predictedAt);
    }
    return data;
  };

export const CameraCalibrationDeviceResultDtoModelResponseTransformer: CameraCalibrationDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.captureTime) {
      data.captureTime = new Date(data.captureTime);
    }
    if (data?.updateTime) {
      data.updateTime = new Date(data.updateTime);
    }
    if (data?.prediction) {
      PredictResponseDtoModelResponseTransformer(data.prediction);
    }
    return data;
  };

export const CameraCalibrationJobDeviceParticipationDtoModelResponseTransformer: CameraCalibrationJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      CameraCalibrationDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const CameraCalibrationJobDeviceDtoModelResponseTransformer: CameraCalibrationJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      CameraCalibrationJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const CameraCalibrationJobDtoModelResponseTransformer: CameraCalibrationJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(
        CameraCalibrationJobDeviceDtoModelResponseTransformer,
      );
    }
    return data;
  };

export const CameraCalibrationControllerStartScheduledJobResponseTransformer: CameraCalibrationControllerStartScheduledJobResponseTransformer =
  async (data) => {
    CameraCalibrationJobDtoModelResponseTransformer(data);
    return data;
  };

export type CameraCalibrationControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<CameraCalibrationControllerResumeScheduledJobResponse>;

export const CameraCalibrationControllerResumeScheduledJobResponseTransformer: CameraCalibrationControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    CameraCalibrationScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type CameraCalibrationControllerStartJobResponseTransformer = (
  data: any,
) => Promise<CameraCalibrationControllerStartJobResponse>;

export const CameraCalibrationControllerStartJobResponseTransformer: CameraCalibrationControllerStartJobResponseTransformer =
  async (data) => {
    CameraCalibrationJobDtoModelResponseTransformer(data);
    return data;
  };

export type CameraCalibrationControllerGetJobResponseTransformer = (
  data: any,
) => Promise<CameraCalibrationControllerGetJobResponse>;

export const CameraCalibrationControllerGetJobResponseTransformer: CameraCalibrationControllerGetJobResponseTransformer =
  async (data) => {
    CameraCalibrationJobDtoModelResponseTransformer(data);
    return data;
  };

export type CameraCalibrationControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<CameraCalibrationControllerUpdateJobResponse>;

export const CameraCalibrationControllerUpdateJobResponseTransformer: CameraCalibrationControllerUpdateJobResponseTransformer =
  async (data) => {
    CameraCalibrationJobDtoModelResponseTransformer(data);
    return data;
  };

export type CapacityTaggingControllerPreCheckResponseTransformer = (
  data: any,
) => Promise<CapacityTaggingControllerPreCheckResponse>;

export type CapacityTaggingPreCheckResponseDtoModelResponseTransformer = (
  data: any,
) => CapacityTaggingPreCheckResponseDto;

export const CapacityTaggingPreCheckResponseDtoModelResponseTransformer: CapacityTaggingPreCheckResponseDtoModelResponseTransformer =
  (data) => {
    if (data?.windowFrom) {
      data.windowFrom = new Date(data.windowFrom);
    }
    if (data?.windowTo) {
      data.windowTo = new Date(data.windowTo);
    }
    return data;
  };

export const CapacityTaggingControllerPreCheckResponseTransformer: CapacityTaggingControllerPreCheckResponseTransformer =
  async (data) => {
    CapacityTaggingPreCheckResponseDtoModelResponseTransformer(data);
    return data;
  };

export type CapacityTaggingControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<CapacityTaggingControllerCreateScheduleResponse>;

export type CapacityTaggingScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => CapacityTaggingScheduledJobSummaryDto;

export type CapacityTaggingJobDataDtoModelResponseTransformer = (
  data: any,
) => CapacityTaggingJobDataDto;

export const CapacityTaggingJobDataDtoModelResponseTransformer: CapacityTaggingJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.fromDate) {
      data.fromDate = new Date(data.fromDate);
    }
    if (data?.toDate) {
      data.toDate = new Date(data.toDate);
    }
    return data;
  };

export const CapacityTaggingScheduledJobSummaryDtoModelResponseTransformer: CapacityTaggingScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      CapacityTaggingJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const CapacityTaggingControllerCreateScheduleResponseTransformer: CapacityTaggingControllerCreateScheduleResponseTransformer =
  async (data) => {
    CapacityTaggingScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type CapacityTaggingControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<CapacityTaggingControllerGetScheduledJobResponse>;

export type CapacityTaggingScheduledJobDtoModelResponseTransformer = (
  data: any,
) => CapacityTaggingScheduledJobDto;

export const CapacityTaggingScheduledJobDtoModelResponseTransformer: CapacityTaggingScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      CapacityTaggingJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const CapacityTaggingControllerGetScheduledJobResponseTransformer: CapacityTaggingControllerGetScheduledJobResponseTransformer =
  async (data) => {
    CapacityTaggingScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type CapacityTaggingControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<CapacityTaggingControllerUpdateScheduledJobResponse>;

export const CapacityTaggingControllerUpdateScheduledJobResponseTransformer: CapacityTaggingControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    CapacityTaggingScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type CapacityTaggingControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<CapacityTaggingControllerStartScheduledJobResponse>;

export type CapacityTaggingJobDtoModelResponseTransformer = (
  data: any,
) => CapacityTaggingJobDto;

export type CapacityTaggingResultDtoModelResponseTransformer = (
  data: any,
) => CapacityTaggingResultDto;

export const CapacityTaggingResultDtoModelResponseTransformer: CapacityTaggingResultDtoModelResponseTransformer =
  (data) => {
    if (data?.windowFrom) {
      data.windowFrom = new Date(data.windowFrom);
    }
    if (data?.windowTo) {
      data.windowTo = new Date(data.windowTo);
    }
    return data;
  };

export type JobDeviceDtoModelResponseTransformer = (data: any) => JobDeviceDto;

export type JobDeviceParticipationDtoModelResponseTransformer = (
  data: any,
) => JobDeviceParticipationDto;

export const JobDeviceParticipationDtoModelResponseTransformer: JobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const JobDeviceDtoModelResponseTransformer: JobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      JobDeviceParticipationDtoModelResponseTransformer(data.participation);
    }
    return data;
  };

export const CapacityTaggingJobDtoModelResponseTransformer: CapacityTaggingJobDtoModelResponseTransformer =
  (data) => {
    if (data?.result) {
      CapacityTaggingResultDtoModelResponseTransformer(data.result);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      CapacityTaggingJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(JobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const CapacityTaggingControllerStartScheduledJobResponseTransformer: CapacityTaggingControllerStartScheduledJobResponseTransformer =
  async (data) => {
    CapacityTaggingJobDtoModelResponseTransformer(data);
    return data;
  };

export type CapacityTaggingControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<CapacityTaggingControllerResumeScheduledJobResponse>;

export const CapacityTaggingControllerResumeScheduledJobResponseTransformer: CapacityTaggingControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    CapacityTaggingScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type CapacityTaggingControllerStartJobResponseTransformer = (
  data: any,
) => Promise<CapacityTaggingControllerStartJobResponse>;

export const CapacityTaggingControllerStartJobResponseTransformer: CapacityTaggingControllerStartJobResponseTransformer =
  async (data) => {
    CapacityTaggingJobDtoModelResponseTransformer(data);
    return data;
  };

export type CapacityTaggingControllerGetJobResponseTransformer = (
  data: any,
) => Promise<CapacityTaggingControllerGetJobResponse>;

export const CapacityTaggingControllerGetJobResponseTransformer: CapacityTaggingControllerGetJobResponseTransformer =
  async (data) => {
    CapacityTaggingJobDtoModelResponseTransformer(data);
    return data;
  };

export type CapacityTaggingControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<CapacityTaggingControllerUpdateJobResponse>;

export const CapacityTaggingControllerUpdateJobResponseTransformer: CapacityTaggingControllerUpdateJobResponseTransformer =
  async (data) => {
    CapacityTaggingJobDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<CatalogControllerGetDetailsResponse>;

export type CatalogItemDetailsDtoModelResponseTransformer = (
  data: any,
) => CatalogItemDetailsDto;

export const CatalogItemDetailsDtoModelResponseTransformer: CatalogItemDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const CatalogControllerGetDetailsResponseTransformer: CatalogControllerGetDetailsResponseTransformer =
  async (data) => {
    CatalogItemDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogControllerCreateResponseTransformer = (
  data: any,
) => Promise<CatalogControllerCreateResponse>;

export type CreatedCatalogItemDtoModelResponseTransformer = (
  data: any,
) => CreatedCatalogItemDto;

export const CreatedCatalogItemDtoModelResponseTransformer: CreatedCatalogItemDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const CatalogControllerCreateResponseTransformer: CatalogControllerCreateResponseTransformer =
  async (data) => {
    CreatedCatalogItemDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogControllerUpdateResponseTransformer = (
  data: any,
) => Promise<CatalogControllerUpdateResponse>;

export type UpdatedCatalogItemDtoModelResponseTransformer = (
  data: any,
) => UpdatedCatalogItemDto;

export const UpdatedCatalogItemDtoModelResponseTransformer: UpdatedCatalogItemDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const CatalogControllerUpdateResponseTransformer: CatalogControllerUpdateResponseTransformer =
  async (data) => {
    UpdatedCatalogItemDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogTaggingControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<CatalogTaggingControllerGetDetailsResponse>;

export type TagDetailsDtoModelResponseTransformer = (
  data: any,
) => TagDetailsDto;

export const TagDetailsDtoModelResponseTransformer: TagDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const CatalogTaggingControllerGetDetailsResponseTransformer: CatalogTaggingControllerGetDetailsResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogTaggingControllerUpdateTagResponseTransformer = (
  data: any,
) => Promise<CatalogTaggingControllerUpdateTagResponse>;

export const CatalogTaggingControllerUpdateTagResponseTransformer: CatalogTaggingControllerUpdateTagResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogUploadJobControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<CatalogUploadJobControllerUpdateScheduledJobResponse>;

export type CatalogUploadScheduledJobDtoModelResponseTransformer = (
  data: any,
) => CatalogUploadScheduledJobDto;

export const CatalogUploadScheduledJobDtoModelResponseTransformer: CatalogUploadScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const CatalogUploadJobControllerUpdateScheduledJobResponseTransformer: CatalogUploadJobControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    CatalogUploadScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogUploadJobControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<CatalogUploadJobControllerUpdateJobResponse>;

export type CatalogUploadJobDtoModelResponseTransformer = (
  data: any,
) => CatalogUploadJobDto;

export type CatalogUploadJobDeviceDtoModelResponseTransformer = (
  data: any,
) => CatalogUploadJobDeviceDto;

export type CatalogUploadJobDeviceParticipationDtoModelResponseTransformer = (
  data: any,
) => CatalogUploadJobDeviceParticipationDto;

export type CatalogUploadDeviceResultDtoModelResponseTransformer = (
  data: any,
) => CatalogUploadDeviceResultDto;

export const CatalogUploadDeviceResultDtoModelResponseTransformer: CatalogUploadDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.updateTime) {
      data.updateTime = new Date(data.updateTime);
    }
    return data;
  };

export const CatalogUploadJobDeviceParticipationDtoModelResponseTransformer: CatalogUploadJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      CatalogUploadDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const CatalogUploadJobDeviceDtoModelResponseTransformer: CatalogUploadJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      CatalogUploadJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const CatalogUploadJobDtoModelResponseTransformer: CatalogUploadJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(CatalogUploadJobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const CatalogUploadJobControllerUpdateJobResponseTransformer: CatalogUploadJobControllerUpdateJobResponseTransformer =
  async (data) => {
    CatalogUploadJobDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogUploadJobControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<CatalogUploadJobControllerCreateScheduleResponse>;

export type CatalogUploadScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => CatalogUploadScheduledJobSummaryDto;

export const CatalogUploadScheduledJobSummaryDtoModelResponseTransformer: CatalogUploadScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const CatalogUploadJobControllerCreateScheduleResponseTransformer: CatalogUploadJobControllerCreateScheduleResponseTransformer =
  async (data) => {
    CatalogUploadScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogUploadJobControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<CatalogUploadJobControllerStartScheduledJobResponse>;

export const CatalogUploadJobControllerStartScheduledJobResponseTransformer: CatalogUploadJobControllerStartScheduledJobResponseTransformer =
  async (data) => {
    CatalogUploadJobDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogUploadJobControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<CatalogUploadJobControllerResumeScheduledJobResponse>;

export const CatalogUploadJobControllerResumeScheduledJobResponseTransformer: CatalogUploadJobControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    CatalogUploadScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type CatalogUploadJobControllerStartJobResponseTransformer = (
  data: any,
) => Promise<CatalogUploadJobControllerStartJobResponse>;

export const CatalogUploadJobControllerStartJobResponseTransformer: CatalogUploadJobControllerStartJobResponseTransformer =
  async (data) => {
    CatalogUploadJobDtoModelResponseTransformer(data);
    return data;
  };

export type ClustersControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<ClustersControllerGetDetailsResponse>;

export type ClusterDetailsDtoModelResponseTransformer = (
  data: any,
) => ClusterDetailsDto;

export const ClusterDetailsDtoModelResponseTransformer: ClusterDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.clusterModelDeployment?.createdAt) {
      data.clusterModelDeployment.createdAt = new Date(
        data.clusterModelDeployment.createdAt,
      );
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.activationTime) {
      data.activationTime = new Date(data.activationTime);
    }
    return data;
  };

export const ClustersControllerGetDetailsResponseTransformer: ClustersControllerGetDetailsResponseTransformer =
  async (data) => {
    ClusterDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type ClustersTaggingControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<ClustersTaggingControllerGetDetailsResponse>;

export const ClustersTaggingControllerGetDetailsResponseTransformer: ClustersTaggingControllerGetDetailsResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type ClustersTaggingControllerUpdateTagResponseTransformer = (
  data: any,
) => Promise<ClustersTaggingControllerUpdateTagResponse>;

export const ClustersTaggingControllerUpdateTagResponseTransformer: ClustersTaggingControllerUpdateTagResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type DatasetsControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<DatasetsControllerGetDetailsResponse>;

export type DatasetDetailsDtoModelResponseTransformer = (
  data: any,
) => DatasetDetailsDto;

export const DatasetDetailsDtoModelResponseTransformer: DatasetDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const DatasetsControllerGetDetailsResponseTransformer: DatasetsControllerGetDetailsResponseTransformer =
  async (data) => {
    DatasetDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteSamplesJobControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<DeleteSamplesJobControllerCreateScheduleResponse>;

export type DeleteSamplesScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => DeleteSamplesScheduledJobSummaryDto;

export type DeleteSamplesJobDataDtoModelResponseTransformer = (
  data: any,
) => DeleteSamplesJobDataDto;

export type GetSamplesQueryRequestDtoModelResponseTransformer = (
  data: any,
) => GetSamplesQueryRequestDto;

export const GetSamplesQueryRequestDtoModelResponseTransformer: GetSamplesQueryRequestDtoModelResponseTransformer =
  (data) => {
    if (data?.from) {
      data.from = new Date(data.from);
    }
    if (data?.to) {
      data.to = new Date(data.to);
    }
    return data;
  };

export const DeleteSamplesJobDataDtoModelResponseTransformer: DeleteSamplesJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.query) {
      GetSamplesQueryRequestDtoModelResponseTransformer(data.query);
    }
    return data;
  };

export const DeleteSamplesScheduledJobSummaryDtoModelResponseTransformer: DeleteSamplesScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      DeleteSamplesJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const DeleteSamplesJobControllerCreateScheduleResponseTransformer: DeleteSamplesJobControllerCreateScheduleResponseTransformer =
  async (data) => {
    DeleteSamplesScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteSamplesJobControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeleteSamplesJobControllerGetScheduledJobResponse>;

export type DeleteSamplesScheduledJobDtoModelResponseTransformer = (
  data: any,
) => DeleteSamplesScheduledJobDto;

export const DeleteSamplesScheduledJobDtoModelResponseTransformer: DeleteSamplesScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      DeleteSamplesJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const DeleteSamplesJobControllerGetScheduledJobResponseTransformer: DeleteSamplesJobControllerGetScheduledJobResponseTransformer =
  async (data) => {
    DeleteSamplesScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteSamplesJobControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeleteSamplesJobControllerUpdateScheduledJobResponse>;

export const DeleteSamplesJobControllerUpdateScheduledJobResponseTransformer: DeleteSamplesJobControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    DeleteSamplesScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteSamplesJobControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeleteSamplesJobControllerStartScheduledJobResponse>;

export type DeleteSamplesJobDtoModelResponseTransformer = (
  data: any,
) => DeleteSamplesJobDto;

export type DeleteSamplesJobDeviceDtoModelResponseTransformer = (
  data: any,
) => DeleteSamplesJobDeviceDto;

export type DeleteSamplesJobDeviceParticipationDtoModelResponseTransformer = (
  data: any,
) => DeleteSamplesJobDeviceParticipationDto;

export type DeleteSamplesDeviceResultDtoModelResponseTransformer = (
  data: any,
) => DeleteSamplesDeviceResultDto;

export const DeleteSamplesDeviceResultDtoModelResponseTransformer: DeleteSamplesDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.updateTime) {
      data.updateTime = new Date(data.updateTime);
    }
    return data;
  };

export const DeleteSamplesJobDeviceParticipationDtoModelResponseTransformer: DeleteSamplesJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      DeleteSamplesDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const DeleteSamplesJobDeviceDtoModelResponseTransformer: DeleteSamplesJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      DeleteSamplesJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const DeleteSamplesJobDtoModelResponseTransformer: DeleteSamplesJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      DeleteSamplesJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(DeleteSamplesJobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const DeleteSamplesJobControllerStartScheduledJobResponseTransformer: DeleteSamplesJobControllerStartScheduledJobResponseTransformer =
  async (data) => {
    DeleteSamplesJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteSamplesJobControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeleteSamplesJobControllerResumeScheduledJobResponse>;

export const DeleteSamplesJobControllerResumeScheduledJobResponseTransformer: DeleteSamplesJobControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    DeleteSamplesScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteSamplesJobControllerStartJobResponseTransformer = (
  data: any,
) => Promise<DeleteSamplesJobControllerStartJobResponse>;

export const DeleteSamplesJobControllerStartJobResponseTransformer: DeleteSamplesJobControllerStartJobResponseTransformer =
  async (data) => {
    DeleteSamplesJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteSamplesJobControllerGetJobResponseTransformer = (
  data: any,
) => Promise<DeleteSamplesJobControllerGetJobResponse>;

export const DeleteSamplesJobControllerGetJobResponseTransformer: DeleteSamplesJobControllerGetJobResponseTransformer =
  async (data) => {
    DeleteSamplesJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteSamplesJobControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<DeleteSamplesJobControllerUpdateJobResponse>;

export const DeleteSamplesJobControllerUpdateJobResponseTransformer: DeleteSamplesJobControllerUpdateJobResponseTransformer =
  async (data) => {
    DeleteSamplesJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteVideosJobControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<DeleteVideosJobControllerCreateScheduleResponse>;

export type DeleteVideosScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => DeleteVideosScheduledJobSummaryDto;

export type DeleteVideosJobDataDtoModelResponseTransformer = (
  data: any,
) => DeleteVideosJobDataDto;

export type GetSessionsRequestDtoModelResponseTransformer = (
  data: any,
) => GetSessionsRequestDto;

export const GetSessionsRequestDtoModelResponseTransformer: GetSessionsRequestDtoModelResponseTransformer =
  (data) => {
    if (data?.from) {
      data.from = new Date(data.from);
    }
    if (data?.to) {
      data.to = new Date(data.to);
    }
    return data;
  };

export const DeleteVideosJobDataDtoModelResponseTransformer: DeleteVideosJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.query) {
      GetSessionsRequestDtoModelResponseTransformer(data.query);
    }
    return data;
  };

export const DeleteVideosScheduledJobSummaryDtoModelResponseTransformer: DeleteVideosScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      DeleteVideosJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const DeleteVideosJobControllerCreateScheduleResponseTransformer: DeleteVideosJobControllerCreateScheduleResponseTransformer =
  async (data) => {
    DeleteVideosScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteVideosJobControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeleteVideosJobControllerGetScheduledJobResponse>;

export type DeleteVideosScheduledJobDtoModelResponseTransformer = (
  data: any,
) => DeleteVideosScheduledJobDto;

export const DeleteVideosScheduledJobDtoModelResponseTransformer: DeleteVideosScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      DeleteVideosJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const DeleteVideosJobControllerGetScheduledJobResponseTransformer: DeleteVideosJobControllerGetScheduledJobResponseTransformer =
  async (data) => {
    DeleteVideosScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteVideosJobControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeleteVideosJobControllerUpdateScheduledJobResponse>;

export const DeleteVideosJobControllerUpdateScheduledJobResponseTransformer: DeleteVideosJobControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    DeleteVideosScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteVideosJobControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeleteVideosJobControllerStartScheduledJobResponse>;

export type DeleteVideosJobDtoModelResponseTransformer = (
  data: any,
) => DeleteVideosJobDto;

export type DeleteVideosJobDeviceDtoModelResponseTransformer = (
  data: any,
) => DeleteVideosJobDeviceDto;

export type DeleteVideosJobDeviceParticipationDtoModelResponseTransformer = (
  data: any,
) => DeleteVideosJobDeviceParticipationDto;

export type DeleteVideosDeviceResultDtoModelResponseTransformer = (
  data: any,
) => DeleteVideosDeviceResultDto;

export const DeleteVideosDeviceResultDtoModelResponseTransformer: DeleteVideosDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.updateTime) {
      data.updateTime = new Date(data.updateTime);
    }
    return data;
  };

export const DeleteVideosJobDeviceParticipationDtoModelResponseTransformer: DeleteVideosJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      DeleteVideosDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const DeleteVideosJobDeviceDtoModelResponseTransformer: DeleteVideosJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      DeleteVideosJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const DeleteVideosJobDtoModelResponseTransformer: DeleteVideosJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      DeleteVideosJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(DeleteVideosJobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const DeleteVideosJobControllerStartScheduledJobResponseTransformer: DeleteVideosJobControllerStartScheduledJobResponseTransformer =
  async (data) => {
    DeleteVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteVideosJobControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeleteVideosJobControllerResumeScheduledJobResponse>;

export const DeleteVideosJobControllerResumeScheduledJobResponseTransformer: DeleteVideosJobControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    DeleteVideosScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteVideosJobControllerStartJobResponseTransformer = (
  data: any,
) => Promise<DeleteVideosJobControllerStartJobResponse>;

export const DeleteVideosJobControllerStartJobResponseTransformer: DeleteVideosJobControllerStartJobResponseTransformer =
  async (data) => {
    DeleteVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteVideosJobControllerGetJobResponseTransformer = (
  data: any,
) => Promise<DeleteVideosJobControllerGetJobResponse>;

export const DeleteVideosJobControllerGetJobResponseTransformer: DeleteVideosJobControllerGetJobResponseTransformer =
  async (data) => {
    DeleteVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeleteVideosJobControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<DeleteVideosJobControllerUpdateJobResponse>;

export const DeleteVideosJobControllerUpdateJobResponseTransformer: DeleteVideosJobControllerUpdateJobResponseTransformer =
  async (data) => {
    DeleteVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeployComponentsControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<DeployComponentsControllerCreateScheduleResponse>;

export type DeployComponentsScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => DeployComponentsScheduledJobSummaryDto;

export type DeployComponentsJobDataDtoModelResponseTransformer = (
  data: any,
) => DeployComponentsJobDataDto;

export type BulkDevicesQueryDtoModelResponseTransformer = (
  data: any,
) => BulkDevicesQueryDto;

export const BulkDevicesQueryDtoModelResponseTransformer: BulkDevicesQueryDtoModelResponseTransformer =
  (data) => {
    if (data?.lastPing) {
      data.lastPing = new Date(data.lastPing);
    }
    return data;
  };

export const DeployComponentsJobDataDtoModelResponseTransformer: DeployComponentsJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.devicesQuery) {
      BulkDevicesQueryDtoModelResponseTransformer(data.devicesQuery);
    }
    return data;
  };

export const DeployComponentsScheduledJobSummaryDtoModelResponseTransformer: DeployComponentsScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      DeployComponentsJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const DeployComponentsControllerCreateScheduleResponseTransformer: DeployComponentsControllerCreateScheduleResponseTransformer =
  async (data) => {
    DeployComponentsScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type DeployComponentsControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeployComponentsControllerGetScheduledJobResponse>;

export type DeployComponentsScheduledJobDtoModelResponseTransformer = (
  data: any,
) => DeployComponentsScheduledJobDto;

export const DeployComponentsScheduledJobDtoModelResponseTransformer: DeployComponentsScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      DeployComponentsJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const DeployComponentsControllerGetScheduledJobResponseTransformer: DeployComponentsControllerGetScheduledJobResponseTransformer =
  async (data) => {
    DeployComponentsScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeployComponentsControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeployComponentsControllerUpdateScheduledJobResponse>;

export const DeployComponentsControllerUpdateScheduledJobResponseTransformer: DeployComponentsControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    DeployComponentsScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeployComponentsControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeployComponentsControllerStartScheduledJobResponse>;

export type DeployComponentsJobDtoModelResponseTransformer = (
  data: any,
) => DeployComponentsJobDto;

export type DeployComponentsJobDeviceDtoModelResponseTransformer = (
  data: any,
) => DeployComponentsJobDeviceDto;

export type DeployComponentsJobDeviceParticipationDtoModelResponseTransformer =
  (data: any) => DeployComponentsJobDeviceParticipationDto;

export type DeployComponentsDeviceResultDtoModelResponseTransformer = (
  data: any,
) => DeployComponentsDeviceResultDto;

export const DeployComponentsDeviceResultDtoModelResponseTransformer: DeployComponentsDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.updateTime) {
      data.updateTime = new Date(data.updateTime);
    }
    return data;
  };

export const DeployComponentsJobDeviceParticipationDtoModelResponseTransformer: DeployComponentsJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      DeployComponentsDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const DeployComponentsJobDeviceDtoModelResponseTransformer: DeployComponentsJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      DeployComponentsJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const DeployComponentsJobDtoModelResponseTransformer: DeployComponentsJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      DeployComponentsJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(
        DeployComponentsJobDeviceDtoModelResponseTransformer,
      );
    }
    return data;
  };

export const DeployComponentsControllerStartScheduledJobResponseTransformer: DeployComponentsControllerStartScheduledJobResponseTransformer =
  async (data) => {
    DeployComponentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeployComponentsControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeployComponentsControllerResumeScheduledJobResponse>;

export const DeployComponentsControllerResumeScheduledJobResponseTransformer: DeployComponentsControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    DeployComponentsScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type DeployComponentsControllerStartJobResponseTransformer = (
  data: any,
) => Promise<DeployComponentsControllerStartJobResponse>;

export const DeployComponentsControllerStartJobResponseTransformer: DeployComponentsControllerStartJobResponseTransformer =
  async (data) => {
    DeployComponentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeployComponentsControllerGetJobResponseTransformer = (
  data: any,
) => Promise<DeployComponentsControllerGetJobResponse>;

export const DeployComponentsControllerGetJobResponseTransformer: DeployComponentsControllerGetJobResponseTransformer =
  async (data) => {
    DeployComponentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeployComponentsControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<DeployComponentsControllerUpdateJobResponse>;

export const DeployComponentsControllerUpdateJobResponseTransformer: DeployComponentsControllerUpdateJobResponseTransformer =
  async (data) => {
    DeployComponentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeviceRestartControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<DeviceRestartControllerCreateScheduleResponse>;

export type DeviceRestartScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => DeviceRestartScheduledJobSummaryDto;

export type DeviceRestartJobDataDtoModelResponseTransformer = (
  data: any,
) => DeviceRestartJobDataDto;

export const DeviceRestartJobDataDtoModelResponseTransformer: DeviceRestartJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.devicesQuery) {
      BulkDevicesQueryDtoModelResponseTransformer(data.devicesQuery);
    }
    return data;
  };

export const DeviceRestartScheduledJobSummaryDtoModelResponseTransformer: DeviceRestartScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      DeviceRestartJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const DeviceRestartControllerCreateScheduleResponseTransformer: DeviceRestartControllerCreateScheduleResponseTransformer =
  async (data) => {
    DeviceRestartScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type DeviceRestartControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeviceRestartControllerGetScheduledJobResponse>;

export type DeviceRestartScheduledJobDtoModelResponseTransformer = (
  data: any,
) => DeviceRestartScheduledJobDto;

export const DeviceRestartScheduledJobDtoModelResponseTransformer: DeviceRestartScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      DeviceRestartJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const DeviceRestartControllerGetScheduledJobResponseTransformer: DeviceRestartControllerGetScheduledJobResponseTransformer =
  async (data) => {
    DeviceRestartScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeviceRestartControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeviceRestartControllerUpdateScheduledJobResponse>;

export const DeviceRestartControllerUpdateScheduledJobResponseTransformer: DeviceRestartControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    DeviceRestartScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeviceRestartControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeviceRestartControllerStartScheduledJobResponse>;

export type DeviceRestartJobDtoModelResponseTransformer = (
  data: any,
) => DeviceRestartJobDto;

export type DeviceRestartJobDeviceDtoModelResponseTransformer = (
  data: any,
) => DeviceRestartJobDeviceDto;

export type DeviceRestartJobDeviceParticipationDtoModelResponseTransformer = (
  data: any,
) => DeviceRestartJobDeviceParticipationDto;

export const DeviceRestartJobDeviceParticipationDtoModelResponseTransformer: DeviceRestartJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      DeployComponentsDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const DeviceRestartJobDeviceDtoModelResponseTransformer: DeviceRestartJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      DeviceRestartJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const DeviceRestartJobDtoModelResponseTransformer: DeviceRestartJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      DeviceRestartJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(DeviceRestartJobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const DeviceRestartControllerStartScheduledJobResponseTransformer: DeviceRestartControllerStartScheduledJobResponseTransformer =
  async (data) => {
    DeviceRestartJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeviceRestartControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<DeviceRestartControllerResumeScheduledJobResponse>;

export const DeviceRestartControllerResumeScheduledJobResponseTransformer: DeviceRestartControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    DeviceRestartScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type DeviceRestartControllerStartJobResponseTransformer = (
  data: any,
) => Promise<DeviceRestartControllerStartJobResponse>;

export const DeviceRestartControllerStartJobResponseTransformer: DeviceRestartControllerStartJobResponseTransformer =
  async (data) => {
    DeviceRestartJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeviceRestartControllerGetJobResponseTransformer = (
  data: any,
) => Promise<DeviceRestartControllerGetJobResponse>;

export const DeviceRestartControllerGetJobResponseTransformer: DeviceRestartControllerGetJobResponseTransformer =
  async (data) => {
    DeviceRestartJobDtoModelResponseTransformer(data);
    return data;
  };

export type DeviceRestartControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<DeviceRestartControllerUpdateJobResponse>;

export const DeviceRestartControllerUpdateJobResponseTransformer: DeviceRestartControllerUpdateJobResponseTransformer =
  async (data) => {
    DeviceRestartJobDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerUploadResponseTransformer = (
  data: any,
) => Promise<DevicesControllerUploadResponse>;

export type DeviceUploadResponseDtoModelResponseTransformer = (
  data: any,
) => DeviceUploadResponseDto;

export type DeviceUploadPreviewRowDtoModelResponseTransformer = (
  data: any,
) => DeviceUploadPreviewRowDto;

export const DeviceUploadPreviewRowDtoModelResponseTransformer: DeviceUploadPreviewRowDtoModelResponseTransformer =
  (data) => {
    if (data?.activationTime) {
      data.activationTime = new Date(data.activationTime);
    }
    return data;
  };

export const DeviceUploadResponseDtoModelResponseTransformer: DeviceUploadResponseDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(DeviceUploadPreviewRowDtoModelResponseTransformer);
    }
    return data;
  };

export const DevicesControllerUploadResponseTransformer: DevicesControllerUploadResponseTransformer =
  async (data) => {
    DeviceUploadResponseDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetDetailsResponse>;

export type DeviceDetailsDtoModelResponseTransformer = (
  data: any,
) => DeviceDetailsDto;

export type DeviceDetailsDeployedModelDtoModelResponseTransformer = (
  data: any,
) => DeviceDetailsDeployedModelDto;

export const DeviceDetailsDeployedModelDtoModelResponseTransformer: DeviceDetailsDeployedModelDtoModelResponseTransformer =
  (data) => {
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const DeviceDetailsDtoModelResponseTransformer: DeviceDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.lastPing) {
      data.lastPing = new Date(data.lastPing);
    }
    if (Array.isArray(data?.modelDeployments)) {
      data.modelDeployments.forEach(
        DeviceDetailsDeployedModelDtoModelResponseTransformer,
      );
    }
    if (data?.lastPredictionTime) {
      data.lastPredictionTime = new Date(data.lastPredictionTime);
    }
    if (data?.activationTime) {
      data.activationTime = new Date(data.activationTime);
    }
    if (data?.firstConnectedAt) {
      data.firstConnectedAt = new Date(data.firstConnectedAt);
    }
    if (data?.connectedSince) {
      data.connectedSince = new Date(data.connectedSince);
    }
    if (data?.agentDeploymentTime) {
      data.agentDeploymentTime = new Date(data.agentDeploymentTime);
    }
    if (data?.lastCameraPing) {
      data.lastCameraPing = new Date(data.lastCameraPing);
    }
    return data;
  };

export const DevicesControllerGetDetailsResponseTransformer: DevicesControllerGetDetailsResponseTransformer =
  async (data) => {
    DeviceDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetSamplesResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetSamplesResponse>;

export type GetSamplesQueryResponseDtoModelResponseTransformer = (
  data: any,
) => GetSamplesQueryResponseDto;

export type DeviceSampleDtoModelResponseTransformer = (
  data: any,
) => DeviceSampleDto;

export const DeviceSampleDtoModelResponseTransformer: DeviceSampleDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.capturedAt) {
      data.capturedAt = new Date(data.capturedAt);
    }
    if (data?.predictedAt) {
      data.predictedAt = new Date(data.predictedAt);
    }
    if (data?.addedAt) {
      data.addedAt = new Date(data.addedAt);
    }
    return data;
  };

export const GetSamplesQueryResponseDtoModelResponseTransformer: GetSamplesQueryResponseDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(DeviceSampleDtoModelResponseTransformer);
    }
    return data;
  };

export const DevicesControllerGetSamplesResponseTransformer: DevicesControllerGetSamplesResponseTransformer =
  async (data) => {
    GetSamplesQueryResponseDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerStartRecordingResponseTransformer = (
  data: any,
) => Promise<DevicesControllerStartRecordingResponse>;

export type StartRecordingResponseDtoModelResponseTransformer = (
  data: any,
) => StartRecordingResponseDto;

export const StartRecordingResponseDtoModelResponseTransformer: StartRecordingResponseDtoModelResponseTransformer =
  (data) => {
    if (data?.start_time) {
      data.start_time = new Date(data.start_time);
    }
    if (data?.end_time) {
      data.end_time = new Date(data.end_time);
    }
    return data;
  };

export const DevicesControllerStartRecordingResponseTransformer: DevicesControllerStartRecordingResponseTransformer =
  async (data) => {
    StartRecordingResponseDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerStopRecordingResponseTransformer = (
  data: any,
) => Promise<DevicesControllerStopRecordingResponse>;

export type StopRecordingResponseDtoModelResponseTransformer = (
  data: any,
) => StopRecordingResponseDto;

export type VideoFileDtoModelResponseTransformer = (data: any) => VideoFileDto;

export const VideoFileDtoModelResponseTransformer: VideoFileDtoModelResponseTransformer =
  (data) => {
    if (data?.start_time) {
      data.start_time = new Date(data.start_time);
    }
    if (data?.end_time) {
      data.end_time = new Date(data.end_time);
    }
    return data;
  };

export const StopRecordingResponseDtoModelResponseTransformer: StopRecordingResponseDtoModelResponseTransformer =
  (data) => {
    if (data?.recording) {
      VideoFileDtoModelResponseTransformer(data.recording);
    }
    return data;
  };

export const DevicesControllerStopRecordingResponseTransformer: DevicesControllerStopRecordingResponseTransformer =
  async (data) => {
    StopRecordingResponseDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetVideoUploadStateResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetVideoUploadStateResponse>;

export type VideoUploadProgressDtoModelResponseTransformer = (
  data: any,
) => VideoUploadProgressDto;

export type MultipartProgressDtoModelResponseTransformer = (
  data: any,
) => MultipartProgressDto;

export const MultipartProgressDtoModelResponseTransformer: MultipartProgressDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const VideoUploadProgressDtoModelResponseTransformer: VideoUploadProgressDtoModelResponseTransformer =
  (data) => {
    if (data?.progress) {
      MultipartProgressDtoModelResponseTransformer(data.progress);
    }
    return data;
  };

export const DevicesControllerGetVideoUploadStateResponseTransformer: DevicesControllerGetVideoUploadStateResponseTransformer =
  async (data) => {
    VideoUploadProgressDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetSamplesUploadStateResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetSamplesUploadStateResponse>;

export type SampleUploadProgressDtoModelResponseTransformer = (
  data: any,
) => SampleUploadProgressDto;

export const SampleUploadProgressDtoModelResponseTransformer: SampleUploadProgressDtoModelResponseTransformer =
  (data) => {
    if (data?.progress) {
      MultipartProgressDtoModelResponseTransformer(data.progress);
    }
    return data;
  };

export const DevicesControllerGetSamplesUploadStateResponseTransformer: DevicesControllerGetSamplesUploadStateResponseTransformer =
  async (data) => {
    SampleUploadProgressDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerListSamplesUploadsResponseTransformer = (
  data: any,
) => Promise<DevicesControllerListSamplesUploadsResponse>;

export type ListSamplesUploadsResponseDtoModelResponseTransformer = (
  data: any,
) => ListSamplesUploadsResponseDto;

export const ListSamplesUploadsResponseDtoModelResponseTransformer: ListSamplesUploadsResponseDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(SampleUploadProgressDtoModelResponseTransformer);
    }
    return data;
  };

export const DevicesControllerListSamplesUploadsResponseTransformer: DevicesControllerListSamplesUploadsResponseTransformer =
  async (data) => {
    ListSamplesUploadsResponseDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetSamplesUploadStateByNameResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetSamplesUploadStateByNameResponse>;

export const DevicesControllerGetSamplesUploadStateByNameResponseTransformer: DevicesControllerGetSamplesUploadStateByNameResponseTransformer =
  async (data) => {
    SampleUploadProgressDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerListVideoUploadsResponseTransformer = (
  data: any,
) => Promise<DevicesControllerListVideoUploadsResponse>;

export type ListVideoUploadsResponseDtoModelResponseTransformer = (
  data: any,
) => ListVideoUploadsResponseDto;

export const ListVideoUploadsResponseDtoModelResponseTransformer: ListVideoUploadsResponseDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(VideoUploadProgressDtoModelResponseTransformer);
    }
    return data;
  };

export const DevicesControllerListVideoUploadsResponseTransformer: DevicesControllerListVideoUploadsResponseTransformer =
  async (data) => {
    ListVideoUploadsResponseDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetVideoUploadStateByNameResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetVideoUploadStateByNameResponse>;

export const DevicesControllerGetVideoUploadStateByNameResponseTransformer: DevicesControllerGetVideoUploadStateByNameResponseTransformer =
  async (data) => {
    VideoUploadProgressDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetHeadBlurVideosStateResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetHeadBlurVideosStateResponse>;

export type HeadBlurVideosStateDtoModelResponseTransformer = (
  data: any,
) => HeadBlurVideosStateDto;

export type HeadBlurVideosArgsDtoModelResponseTransformer = (
  data: any,
) => HeadBlurVideosArgsDto;

export const HeadBlurVideosArgsDtoModelResponseTransformer: HeadBlurVideosArgsDtoModelResponseTransformer =
  (data) => {
    if (data?.query) {
      GetSessionsRequestDtoModelResponseTransformer(data.query);
    }
    return data;
  };

export type BlurProgressDtoModelResponseTransformer = (
  data: any,
) => BlurProgressDto;

export const BlurProgressDtoModelResponseTransformer: BlurProgressDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const HeadBlurVideosStateDtoModelResponseTransformer: HeadBlurVideosStateDtoModelResponseTransformer =
  (data) => {
    if (data?.args) {
      HeadBlurVideosArgsDtoModelResponseTransformer(data.args);
    }
    if (data?.progress) {
      BlurProgressDtoModelResponseTransformer(data.progress);
    }
    return data;
  };

export const DevicesControllerGetHeadBlurVideosStateResponseTransformer: DevicesControllerGetHeadBlurVideosStateResponseTransformer =
  async (data) => {
    HeadBlurVideosStateDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetHeadBlurVideoStateResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetHeadBlurVideoStateResponse>;

export const DevicesControllerGetHeadBlurVideoStateResponseTransformer: DevicesControllerGetHeadBlurVideoStateResponseTransformer =
  async (data) => {
    BlurProgressDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerListHeadBlurVideosResponseTransformer = (
  data: any,
) => Promise<DevicesControllerListHeadBlurVideosResponse>;

export type ListHeadBlurVideosResponseDtoModelResponseTransformer = (
  data: any,
) => ListHeadBlurVideosResponseDto;

export const ListHeadBlurVideosResponseDtoModelResponseTransformer: ListHeadBlurVideosResponseDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(HeadBlurVideosStateDtoModelResponseTransformer);
    }
    return data;
  };

export const DevicesControllerListHeadBlurVideosResponseTransformer: DevicesControllerListHeadBlurVideosResponseTransformer =
  async (data) => {
    ListHeadBlurVideosResponseDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetHeadBlurVideosStateByNameResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetHeadBlurVideosStateByNameResponse>;

export const DevicesControllerGetHeadBlurVideosStateByNameResponseTransformer: DevicesControllerGetHeadBlurVideosStateByNameResponseTransformer =
  async (data) => {
    HeadBlurVideosStateDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetHeadBlurImagesStateResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetHeadBlurImagesStateResponse>;

export type HeadBlurImagesStateDtoModelResponseTransformer = (
  data: any,
) => HeadBlurImagesStateDto;

export type HeadBlurImagesArgsDtoModelResponseTransformer = (
  data: any,
) => HeadBlurImagesArgsDto;

export const HeadBlurImagesArgsDtoModelResponseTransformer: HeadBlurImagesArgsDtoModelResponseTransformer =
  (data) => {
    if (data?.query) {
      GetSamplesQueryRequestDtoModelResponseTransformer(data.query);
    }
    return data;
  };

export const HeadBlurImagesStateDtoModelResponseTransformer: HeadBlurImagesStateDtoModelResponseTransformer =
  (data) => {
    if (data?.args) {
      HeadBlurImagesArgsDtoModelResponseTransformer(data.args);
    }
    if (data?.progress) {
      BlurProgressDtoModelResponseTransformer(data.progress);
    }
    return data;
  };

export const DevicesControllerGetHeadBlurImagesStateResponseTransformer: DevicesControllerGetHeadBlurImagesStateResponseTransformer =
  async (data) => {
    HeadBlurImagesStateDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerListHeadBlurImagesResponseTransformer = (
  data: any,
) => Promise<DevicesControllerListHeadBlurImagesResponse>;

export type ListHeadBlurImagesResponseDtoModelResponseTransformer = (
  data: any,
) => ListHeadBlurImagesResponseDto;

export const ListHeadBlurImagesResponseDtoModelResponseTransformer: ListHeadBlurImagesResponseDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(HeadBlurImagesStateDtoModelResponseTransformer);
    }
    return data;
  };

export const DevicesControllerListHeadBlurImagesResponseTransformer: DevicesControllerListHeadBlurImagesResponseTransformer =
  async (data) => {
    ListHeadBlurImagesResponseDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetHeadBlurImagesStateByNameResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetHeadBlurImagesStateByNameResponse>;

export const DevicesControllerGetHeadBlurImagesStateByNameResponseTransformer: DevicesControllerGetHeadBlurImagesStateByNameResponseTransformer =
  async (data) => {
    HeadBlurImagesStateDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerCaptureAndPredictResponseTransformer = (
  data: any,
) => Promise<DevicesControllerCaptureAndPredictResponse>;

export type CaptureAndPredictResponseTranslatedDtoModelResponseTransformer = (
  data: any,
) => CaptureAndPredictResponseTranslatedDto;

export const CaptureAndPredictResponseTranslatedDtoModelResponseTransformer: CaptureAndPredictResponseTranslatedDtoModelResponseTransformer =
  (data) => {
    if (data?.predictedAt) {
      data.predictedAt = new Date(data.predictedAt);
    }
    if (data?.capturedAt) {
      data.capturedAt = new Date(data.capturedAt);
    }
    return data;
  };

export const DevicesControllerCaptureAndPredictResponseTransformer: DevicesControllerCaptureAndPredictResponseTransformer =
  async (data) => {
    CaptureAndPredictResponseTranslatedDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerPredictResponseTransformer = (
  data: any,
) => Promise<DevicesControllerPredictResponse>;

export type PredictResponseTranslatedDtoModelResponseTransformer = (
  data: any,
) => PredictResponseTranslatedDto;

export const PredictResponseTranslatedDtoModelResponseTransformer: PredictResponseTranslatedDtoModelResponseTransformer =
  (data) => {
    if (data?.predictedAt) {
      data.predictedAt = new Date(data.predictedAt);
    }
    return data;
  };

export const DevicesControllerPredictResponseTransformer: DevicesControllerPredictResponseTransformer =
  async (data) => {
    PredictResponseTranslatedDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesControllerGetSessionsResponseTransformer = (
  data: any,
) => Promise<DevicesControllerGetSessionsResponse>;

export type GetSessionsResponseDtoModelResponseTransformer = (
  data: any,
) => GetSessionsResponseDto;

export type DeviceSessionDtoModelResponseTransformer = (
  data: any,
) => DeviceSessionDto;

export const DeviceSessionDtoModelResponseTransformer: DeviceSessionDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const GetSessionsResponseDtoModelResponseTransformer: GetSessionsResponseDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(DeviceSessionDtoModelResponseTransformer);
    }
    return data;
  };

export const DevicesControllerGetSessionsResponseTransformer: DevicesControllerGetSessionsResponseTransformer =
  async (data) => {
    GetSessionsResponseDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesTaggingControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<DevicesTaggingControllerGetDetailsResponse>;

export const DevicesTaggingControllerGetDetailsResponseTransformer: DevicesTaggingControllerGetDetailsResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type DevicesTaggingControllerUpdateTagResponseTransformer = (
  data: any,
) => Promise<DevicesTaggingControllerUpdateTagResponse>;

export const DevicesTaggingControllerUpdateTagResponseTransformer: DevicesTaggingControllerUpdateTagResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type EmailReportsControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<EmailReportsControllerCreateScheduleResponse>;

export type EmailReportsScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => EmailReportsScheduledJobSummaryDto;

export const EmailReportsScheduledJobSummaryDtoModelResponseTransformer: EmailReportsScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const EmailReportsControllerCreateScheduleResponseTransformer: EmailReportsControllerCreateScheduleResponseTransformer =
  async (data) => {
    EmailReportsScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type EmailReportsControllerGetSubscriptionDetailResponseTransformer = (
  data: any,
) => Promise<EmailReportsControllerGetSubscriptionDetailResponse>;

export type ReportSubscriptionDetailDtoModelResponseTransformer = (
  data: any,
) => ReportSubscriptionDetailDto;

export const ReportSubscriptionDetailDtoModelResponseTransformer: ReportSubscriptionDetailDtoModelResponseTransformer =
  (data) => {
    if (data?.lastSent) {
      data.lastSent = new Date(data.lastSent);
    }
    if (data?.nextSend) {
      data.nextSend = new Date(data.nextSend);
    }
    if (data?.generatedDate) {
      data.generatedDate = new Date(data.generatedDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export const EmailReportsControllerGetSubscriptionDetailResponseTransformer: EmailReportsControllerGetSubscriptionDetailResponseTransformer =
  async (data) => {
    ReportSubscriptionDetailDtoModelResponseTransformer(data);
    return data;
  };

export type EmailReportsControllerGetReportSendLogResponseTransformer = (
  data: any,
) => Promise<EmailReportsControllerGetReportSendLogResponse>;

export type ReportSendLogResponseDtoModelResponseTransformer = (
  data: any,
) => ReportSendLogResponseDto;

export type ReportSendLogAttentionItemDtoModelResponseTransformer = (
  data: any,
) => ReportSendLogAttentionItemDto;

export const ReportSendLogAttentionItemDtoModelResponseTransformer: ReportSendLogAttentionItemDtoModelResponseTransformer =
  (data) => {
    if (data?.since) {
      data.since = new Date(data.since);
    }
    return data;
  };

export type ReportSendLogUpcomingItemDtoModelResponseTransformer = (
  data: any,
) => ReportSendLogUpcomingItemDto;

export const ReportSendLogUpcomingItemDtoModelResponseTransformer: ReportSendLogUpcomingItemDtoModelResponseTransformer =
  (data) => {
    if (data?.nextSend) {
      data.nextSend = new Date(data.nextSend);
    }
    return data;
  };

export type ReportSendLogRecentItemDtoModelResponseTransformer = (
  data: any,
) => ReportSendLogRecentItemDto;

export const ReportSendLogRecentItemDtoModelResponseTransformer: ReportSendLogRecentItemDtoModelResponseTransformer =
  (data) => {
    if (data?.sentAt) {
      data.sentAt = new Date(data.sentAt);
    }
    if (data?.approvedAt) {
      data.approvedAt = new Date(data.approvedAt);
    }
    return data;
  };

export const ReportSendLogResponseDtoModelResponseTransformer: ReportSendLogResponseDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.needsAttention)) {
      data.needsAttention.forEach(
        ReportSendLogAttentionItemDtoModelResponseTransformer,
      );
    }
    if (Array.isArray(data?.upcoming)) {
      data.upcoming.forEach(
        ReportSendLogUpcomingItemDtoModelResponseTransformer,
      );
    }
    if (Array.isArray(data?.recent)) {
      data.recent.forEach(ReportSendLogRecentItemDtoModelResponseTransformer);
    }
    return data;
  };

export const EmailReportsControllerGetReportSendLogResponseTransformer: EmailReportsControllerGetReportSendLogResponseTransformer =
  async (data) => {
    ReportSendLogResponseDtoModelResponseTransformer(data);
    return data;
  };

export type EmailReportsControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<EmailReportsControllerUpdateScheduledJobResponse>;

export type EmailReportsScheduledJobDtoModelResponseTransformer = (
  data: any,
) => EmailReportsScheduledJobDto;

export const EmailReportsScheduledJobDtoModelResponseTransformer: EmailReportsScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const EmailReportsControllerUpdateScheduledJobResponseTransformer: EmailReportsControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    EmailReportsScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type EmailReportsControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<EmailReportsControllerGetScheduledJobResponse>;

export const EmailReportsControllerGetScheduledJobResponseTransformer: EmailReportsControllerGetScheduledJobResponseTransformer =
  async (data) => {
    EmailReportsScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type EmailReportsControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<EmailReportsControllerResumeScheduledJobResponse>;

export const EmailReportsControllerResumeScheduledJobResponseTransformer: EmailReportsControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    EmailReportsScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type EmailReportsControllerStartJobResponseTransformer = (
  data: any,
) => Promise<EmailReportsControllerStartJobResponse>;

export type EmailReportsJobDtoModelResponseTransformer = (
  data: any,
) => EmailReportsJobDto;

export const EmailReportsJobDtoModelResponseTransformer: EmailReportsJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(JobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const EmailReportsControllerStartJobResponseTransformer: EmailReportsControllerStartJobResponseTransformer =
  async (data) => {
    EmailReportsJobDtoModelResponseTransformer(data);
    return data;
  };

export type EmailReportsControllerGetJobResponseTransformer = (
  data: any,
) => Promise<EmailReportsControllerGetJobResponse>;

export const EmailReportsControllerGetJobResponseTransformer: EmailReportsControllerGetJobResponseTransformer =
  async (data) => {
    EmailReportsJobDtoModelResponseTransformer(data);
    return data;
  };

export type EmailReportsControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<EmailReportsControllerUpdateJobResponse>;

export const EmailReportsControllerUpdateJobResponseTransformer: EmailReportsControllerUpdateJobResponseTransformer =
  async (data) => {
    EmailReportsJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurImagesControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<HeadBlurImagesControllerCreateScheduleResponse>;

export type HeadBlurImagesScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => HeadBlurImagesScheduledJobSummaryDto;

export type HeadBlurImagesJobDataDtoModelResponseTransformer = (
  data: any,
) => HeadBlurImagesJobDataDto;

export const HeadBlurImagesJobDataDtoModelResponseTransformer: HeadBlurImagesJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.query) {
      GetSamplesQueryRequestDtoModelResponseTransformer(data.query);
    }
    return data;
  };

export const HeadBlurImagesScheduledJobSummaryDtoModelResponseTransformer: HeadBlurImagesScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      HeadBlurImagesJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const HeadBlurImagesControllerCreateScheduleResponseTransformer: HeadBlurImagesControllerCreateScheduleResponseTransformer =
  async (data) => {
    HeadBlurImagesScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurImagesControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurImagesControllerGetScheduledJobResponse>;

export type HeadBlurImagesScheduledJobDtoModelResponseTransformer = (
  data: any,
) => HeadBlurImagesScheduledJobDto;

export const HeadBlurImagesScheduledJobDtoModelResponseTransformer: HeadBlurImagesScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      HeadBlurImagesJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const HeadBlurImagesControllerGetScheduledJobResponseTransformer: HeadBlurImagesControllerGetScheduledJobResponseTransformer =
  async (data) => {
    HeadBlurImagesScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurImagesControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurImagesControllerUpdateScheduledJobResponse>;

export const HeadBlurImagesControllerUpdateScheduledJobResponseTransformer: HeadBlurImagesControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    HeadBlurImagesScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurImagesControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurImagesControllerStartScheduledJobResponse>;

export type HeadBlurImagesJobDtoModelResponseTransformer = (
  data: any,
) => HeadBlurImagesJobDto;

export type HeadBlurImagesJobDeviceDtoModelResponseTransformer = (
  data: any,
) => HeadBlurImagesJobDeviceDto;

export type HeadBlurImagesJobDeviceParticipationDtoModelResponseTransformer = (
  data: any,
) => HeadBlurImagesJobDeviceParticipationDto;

export type HeadBlurImagesDeviceResultDtoModelResponseTransformer = (
  data: any,
) => HeadBlurImagesDeviceResultDto;

export const HeadBlurImagesDeviceResultDtoModelResponseTransformer: HeadBlurImagesDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.lastStart) {
      data.lastStart = new Date(data.lastStart);
    }
    if (data?.lastProgress) {
      data.lastProgress = new Date(data.lastProgress);
    }
    if (data?._meta) {
      HeadBlurImagesStateDtoModelResponseTransformer(data._meta);
    }
    return data;
  };

export const HeadBlurImagesJobDeviceParticipationDtoModelResponseTransformer: HeadBlurImagesJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      HeadBlurImagesDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const HeadBlurImagesJobDeviceDtoModelResponseTransformer: HeadBlurImagesJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      HeadBlurImagesJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const HeadBlurImagesJobDtoModelResponseTransformer: HeadBlurImagesJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      HeadBlurImagesJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(HeadBlurImagesJobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const HeadBlurImagesControllerStartScheduledJobResponseTransformer: HeadBlurImagesControllerStartScheduledJobResponseTransformer =
  async (data) => {
    HeadBlurImagesJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurImagesControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurImagesControllerResumeScheduledJobResponse>;

export const HeadBlurImagesControllerResumeScheduledJobResponseTransformer: HeadBlurImagesControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    HeadBlurImagesScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurImagesControllerStartJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurImagesControllerStartJobResponse>;

export const HeadBlurImagesControllerStartJobResponseTransformer: HeadBlurImagesControllerStartJobResponseTransformer =
  async (data) => {
    HeadBlurImagesJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurImagesControllerGetJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurImagesControllerGetJobResponse>;

export const HeadBlurImagesControllerGetJobResponseTransformer: HeadBlurImagesControllerGetJobResponseTransformer =
  async (data) => {
    HeadBlurImagesJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurImagesControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurImagesControllerUpdateJobResponse>;

export const HeadBlurImagesControllerUpdateJobResponseTransformer: HeadBlurImagesControllerUpdateJobResponseTransformer =
  async (data) => {
    HeadBlurImagesJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurVideosControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<HeadBlurVideosControllerCreateScheduleResponse>;

export type HeadBlurVideosScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => HeadBlurVideosScheduledJobSummaryDto;

export type HeadBlurVideosJobDataDtoModelResponseTransformer = (
  data: any,
) => HeadBlurVideosJobDataDto;

export const HeadBlurVideosJobDataDtoModelResponseTransformer: HeadBlurVideosJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.query) {
      GetSessionsRequestDtoModelResponseTransformer(data.query);
    }
    return data;
  };

export const HeadBlurVideosScheduledJobSummaryDtoModelResponseTransformer: HeadBlurVideosScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      HeadBlurVideosJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const HeadBlurVideosControllerCreateScheduleResponseTransformer: HeadBlurVideosControllerCreateScheduleResponseTransformer =
  async (data) => {
    HeadBlurVideosScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurVideosControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurVideosControllerGetScheduledJobResponse>;

export type HeadBlurVideosScheduledJobDtoModelResponseTransformer = (
  data: any,
) => HeadBlurVideosScheduledJobDto;

export const HeadBlurVideosScheduledJobDtoModelResponseTransformer: HeadBlurVideosScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      HeadBlurVideosJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const HeadBlurVideosControllerGetScheduledJobResponseTransformer: HeadBlurVideosControllerGetScheduledJobResponseTransformer =
  async (data) => {
    HeadBlurVideosScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurVideosControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurVideosControllerUpdateScheduledJobResponse>;

export const HeadBlurVideosControllerUpdateScheduledJobResponseTransformer: HeadBlurVideosControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    HeadBlurVideosScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurVideosControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurVideosControllerStartScheduledJobResponse>;

export type HeadBlurVideosJobDtoModelResponseTransformer = (
  data: any,
) => HeadBlurVideosJobDto;

export type HeadBlurVideosJobDeviceDtoModelResponseTransformer = (
  data: any,
) => HeadBlurVideosJobDeviceDto;

export type HeadBlurVideosJobDeviceParticipationDtoModelResponseTransformer = (
  data: any,
) => HeadBlurVideosJobDeviceParticipationDto;

export type HeadBlurVideosDeviceResultDtoModelResponseTransformer = (
  data: any,
) => HeadBlurVideosDeviceResultDto;

export const HeadBlurVideosDeviceResultDtoModelResponseTransformer: HeadBlurVideosDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.lastStart) {
      data.lastStart = new Date(data.lastStart);
    }
    if (data?.lastProgress) {
      data.lastProgress = new Date(data.lastProgress);
    }
    if (data?._meta) {
      HeadBlurVideosStateDtoModelResponseTransformer(data._meta);
    }
    return data;
  };

export const HeadBlurVideosJobDeviceParticipationDtoModelResponseTransformer: HeadBlurVideosJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      HeadBlurVideosDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const HeadBlurVideosJobDeviceDtoModelResponseTransformer: HeadBlurVideosJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      HeadBlurVideosJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const HeadBlurVideosJobDtoModelResponseTransformer: HeadBlurVideosJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      HeadBlurVideosJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(HeadBlurVideosJobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const HeadBlurVideosControllerStartScheduledJobResponseTransformer: HeadBlurVideosControllerStartScheduledJobResponseTransformer =
  async (data) => {
    HeadBlurVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurVideosControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurVideosControllerResumeScheduledJobResponse>;

export const HeadBlurVideosControllerResumeScheduledJobResponseTransformer: HeadBlurVideosControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    HeadBlurVideosScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurVideosControllerStartJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurVideosControllerStartJobResponse>;

export const HeadBlurVideosControllerStartJobResponseTransformer: HeadBlurVideosControllerStartJobResponseTransformer =
  async (data) => {
    HeadBlurVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurVideosControllerGetJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurVideosControllerGetJobResponse>;

export const HeadBlurVideosControllerGetJobResponseTransformer: HeadBlurVideosControllerGetJobResponseTransformer =
  async (data) => {
    HeadBlurVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type HeadBlurVideosControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<HeadBlurVideosControllerUpdateJobResponse>;

export const HeadBlurVideosControllerUpdateJobResponseTransformer: HeadBlurVideosControllerUpdateJobResponseTransformer =
  async (data) => {
    HeadBlurVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type MetricAlertsControllerCreateResponseTransformer = (
  data: any,
) => Promise<MetricAlertsControllerCreateResponse>;

export type MetricAlertResponseDtoModelResponseTransformer = (
  data: any,
) => MetricAlertResponseDto;

export type MetricAlertRunDtoModelResponseTransformer = (
  data: any,
) => MetricAlertRunDto;

export const MetricAlertRunDtoModelResponseTransformer: MetricAlertRunDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const MetricAlertResponseDtoModelResponseTransformer: MetricAlertResponseDtoModelResponseTransformer =
  (data) => {
    if (data?.lastEvaluatedAt) {
      data.lastEvaluatedAt = new Date(data.lastEvaluatedAt);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (Array.isArray(data?.runs)) {
      data.runs.forEach(MetricAlertRunDtoModelResponseTransformer);
    }
    return data;
  };

export const MetricAlertsControllerCreateResponseTransformer: MetricAlertsControllerCreateResponseTransformer =
  async (data) => {
    MetricAlertResponseDtoModelResponseTransformer(data);
    return data;
  };

export type MetricAlertsControllerGetByIdResponseTransformer = (
  data: any,
) => Promise<MetricAlertsControllerGetByIdResponse>;

export const MetricAlertsControllerGetByIdResponseTransformer: MetricAlertsControllerGetByIdResponseTransformer =
  async (data) => {
    MetricAlertResponseDtoModelResponseTransformer(data);
    return data;
  };

export type MetricAlertsControllerUpdateResponseTransformer = (
  data: any,
) => Promise<MetricAlertsControllerUpdateResponse>;

export const MetricAlertsControllerUpdateResponseTransformer: MetricAlertsControllerUpdateResponseTransformer =
  async (data) => {
    MetricAlertResponseDtoModelResponseTransformer(data);
    return data;
  };

export type ModelsControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<ModelsControllerGetDetailsResponse>;

export type ModelDetailsDtoModelResponseTransformer = (
  data: any,
) => ModelDetailsDto;

export const ModelDetailsDtoModelResponseTransformer: ModelDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export const ModelsControllerGetDetailsResponseTransformer: ModelsControllerGetDetailsResponseTransformer =
  async (data) => {
    ModelDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type NotificationsControllerGetActiveResponseTransformer = (
  data: any,
) => Promise<NotificationsControllerGetActiveResponse>;

export type NotificationResponseDtoModelResponseTransformer = (
  data: any,
) => NotificationResponseDto;

export const NotificationResponseDtoModelResponseTransformer: NotificationResponseDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const NotificationsControllerGetActiveResponseTransformer: NotificationsControllerGetActiveResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(NotificationResponseDtoModelResponseTransformer);
    }
    return data;
  };

export type NotificationsControllerCreateResponseTransformer = (
  data: any,
) => Promise<NotificationsControllerCreateResponse>;

export const NotificationsControllerCreateResponseTransformer: NotificationsControllerCreateResponseTransformer =
  async (data) => {
    NotificationResponseDtoModelResponseTransformer(data);
    return data;
  };

export type NotificationsControllerFindOneResponseTransformer = (
  data: any,
) => Promise<NotificationsControllerFindOneResponse>;

export const NotificationsControllerFindOneResponseTransformer: NotificationsControllerFindOneResponseTransformer =
  async (data) => {
    NotificationResponseDtoModelResponseTransformer(data);
    return data;
  };

export type NotificationsControllerUpdateResponseTransformer = (
  data: any,
) => Promise<NotificationsControllerUpdateResponse>;

export const NotificationsControllerUpdateResponseTransformer: NotificationsControllerUpdateResponseTransformer =
  async (data) => {
    NotificationResponseDtoModelResponseTransformer(data);
    return data;
  };

export type RecoveryEstimatesControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<RecoveryEstimatesControllerCreateScheduleResponse>;

export type RecoveryEstimatesScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => RecoveryEstimatesScheduledJobSummaryDto;

export const RecoveryEstimatesScheduledJobSummaryDtoModelResponseTransformer: RecoveryEstimatesScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const RecoveryEstimatesControllerCreateScheduleResponseTransformer: RecoveryEstimatesControllerCreateScheduleResponseTransformer =
  async (data) => {
    RecoveryEstimatesScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type RecoveryEstimatesControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<RecoveryEstimatesControllerGetScheduledJobResponse>;

export type RecoveryEstimatesScheduledJobDtoModelResponseTransformer = (
  data: any,
) => RecoveryEstimatesScheduledJobDto;

export const RecoveryEstimatesScheduledJobDtoModelResponseTransformer: RecoveryEstimatesScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const RecoveryEstimatesControllerGetScheduledJobResponseTransformer: RecoveryEstimatesControllerGetScheduledJobResponseTransformer =
  async (data) => {
    RecoveryEstimatesScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type RecoveryEstimatesControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<RecoveryEstimatesControllerUpdateScheduledJobResponse>;

export const RecoveryEstimatesControllerUpdateScheduledJobResponseTransformer: RecoveryEstimatesControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    RecoveryEstimatesScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type RecoveryEstimatesControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<RecoveryEstimatesControllerStartScheduledJobResponse>;

export type RecoveryEstimatesJobDtoModelResponseTransformer = (
  data: any,
) => RecoveryEstimatesJobDto;

export const RecoveryEstimatesJobDtoModelResponseTransformer: RecoveryEstimatesJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(JobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const RecoveryEstimatesControllerStartScheduledJobResponseTransformer: RecoveryEstimatesControllerStartScheduledJobResponseTransformer =
  async (data) => {
    RecoveryEstimatesJobDtoModelResponseTransformer(data);
    return data;
  };

export type RecoveryEstimatesControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<RecoveryEstimatesControllerResumeScheduledJobResponse>;

export const RecoveryEstimatesControllerResumeScheduledJobResponseTransformer: RecoveryEstimatesControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    RecoveryEstimatesScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type RecoveryEstimatesControllerStartJobResponseTransformer = (
  data: any,
) => Promise<RecoveryEstimatesControllerStartJobResponse>;

export const RecoveryEstimatesControllerStartJobResponseTransformer: RecoveryEstimatesControllerStartJobResponseTransformer =
  async (data) => {
    RecoveryEstimatesJobDtoModelResponseTransformer(data);
    return data;
  };

export type RecoveryEstimatesControllerGetJobResponseTransformer = (
  data: any,
) => Promise<RecoveryEstimatesControllerGetJobResponse>;

export const RecoveryEstimatesControllerGetJobResponseTransformer: RecoveryEstimatesControllerGetJobResponseTransformer =
  async (data) => {
    RecoveryEstimatesJobDtoModelResponseTransformer(data);
    return data;
  };

export type RecoveryEstimatesControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<RecoveryEstimatesControllerUpdateJobResponse>;

export const RecoveryEstimatesControllerUpdateJobResponseTransformer: RecoveryEstimatesControllerUpdateJobResponseTransformer =
  async (data) => {
    RecoveryEstimatesJobDtoModelResponseTransformer(data);
    return data;
  };

export type MetabaseControllerGetReportDetailsResponseTransformer = (
  data: any,
) => Promise<MetabaseControllerGetReportDetailsResponse>;

export type DetailedReportDtoModelResponseTransformer = (
  data: any,
) => DetailedReportDto;

export type ReportSubscriptionDtoModelResponseTransformer = (
  data: any,
) => ReportSubscriptionDto;

export const ReportSubscriptionDtoModelResponseTransformer: ReportSubscriptionDtoModelResponseTransformer =
  (data) => {
    if (data?.lastSent) {
      data.lastSent = new Date(data.lastSent);
    }
    return data;
  };

export const DetailedReportDtoModelResponseTransformer: DetailedReportDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (Array.isArray(data?.subscriptions)) {
      data.subscriptions.forEach(ReportSubscriptionDtoModelResponseTransformer);
    }
    return data;
  };

export const MetabaseControllerGetReportDetailsResponseTransformer: MetabaseControllerGetReportDetailsResponseTransformer =
  async (data) => {
    DetailedReportDtoModelResponseTransformer(data);
    return data;
  };

export type ReportsCompanionControllerGetChatConversationResponseTransformer = (
  data: any,
) => Promise<ReportsCompanionControllerGetChatConversationResponse>;

export type ChatTurnResponseDtoModelResponseTransformer = (
  data: any,
) => ChatTurnResponseDto;

export const ChatTurnResponseDtoModelResponseTransformer: ChatTurnResponseDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export const ReportsCompanionControllerGetChatConversationResponseTransformer: ReportsCompanionControllerGetChatConversationResponseTransformer =
  async (data) => {
    if (Array.isArray(data)) {
      data.forEach(ChatTurnResponseDtoModelResponseTransformer);
    }
    return data;
  };

export type SamplesControllerGetSampleDetailsAndImageResponseTransformer = (
  data: any,
) => Promise<SamplesControllerGetSampleDetailsAndImageResponse>;

export type SampleWithImageDtoModelResponseTransformer = (
  data: any,
) => SampleWithImageDto;

export type DeviceWithActivationModelResponseTransformer = (
  data: any,
) => DeviceWithActivation;

export const DeviceWithActivationModelResponseTransformer: DeviceWithActivationModelResponseTransformer =
  (data) => {
    if (data?.activationTime) {
      data.activationTime = new Date(data.activationTime);
    }
    return data;
  };

export type GroundTruthPredictionDtoModelResponseTransformer = (
  data: any,
) => GroundTruthPredictionDto;

export const GroundTruthPredictionDtoModelResponseTransformer: GroundTruthPredictionDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.predictedAt) {
      data.predictedAt = new Date(data.predictedAt);
    }
    if (data?.capturedAt) {
      data.capturedAt = new Date(data.capturedAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.interactionStartTime) {
      data.interactionStartTime = new Date(data.interactionStartTime);
    }
    return data;
  };

export const SampleWithImageDtoModelResponseTransformer: SampleWithImageDtoModelResponseTransformer =
  (data) => {
    if (data?.addedAt) {
      data.addedAt = new Date(data.addedAt);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.device) {
      DeviceWithActivationModelResponseTransformer(data.device);
    }
    if (Array.isArray(data?.predictions)) {
      data.predictions.forEach(
        GroundTruthPredictionDtoModelResponseTransformer,
      );
    }
    if (data?.videoStartTime) {
      data.videoStartTime = new Date(data.videoStartTime);
    }
    return data;
  };

export const SamplesControllerGetSampleDetailsAndImageResponseTransformer: SamplesControllerGetSampleDetailsAndImageResponseTransformer =
  async (data) => {
    SampleWithImageDtoModelResponseTransformer(data);
    return data;
  };

export type SamplesControllerGetSampleDetailsResponseTransformer = (
  data: any,
) => Promise<SamplesControllerGetSampleDetailsResponse>;

export type SampleDtoModelResponseTransformer = (data: any) => SampleDto;

export const SampleDtoModelResponseTransformer: SampleDtoModelResponseTransformer =
  (data) => {
    if (data?.addedAt) {
      data.addedAt = new Date(data.addedAt);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.device) {
      DeviceWithActivationModelResponseTransformer(data.device);
    }
    if (Array.isArray(data?.predictions)) {
      data.predictions.forEach(
        GroundTruthPredictionDtoModelResponseTransformer,
      );
    }
    if (data?.videoStartTime) {
      data.videoStartTime = new Date(data.videoStartTime);
    }
    return data;
  };

export const SamplesControllerGetSampleDetailsResponseTransformer: SamplesControllerGetSampleDetailsResponseTransformer =
  async (data) => {
    SampleDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleConfigDeploymentsControllerCreateScheduleResponseTransformer =
  (
    data: any,
  ) => Promise<ScheduleConfigDeploymentsControllerCreateScheduleResponse>;

export type ScheduleConfigDeploymentsScheduledJobSummaryDtoModelResponseTransformer =
  (data: any) => ScheduleConfigDeploymentsScheduledJobSummaryDto;

export type ScheduleConfigDeploymentsJobDataDtoModelResponseTransformer = (
  data: any,
) => ScheduleConfigDeploymentsJobDataDto;

export const ScheduleConfigDeploymentsJobDataDtoModelResponseTransformer: ScheduleConfigDeploymentsJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.devicesQuery) {
      BulkDevicesQueryDtoModelResponseTransformer(data.devicesQuery);
    }
    return data;
  };

export const ScheduleConfigDeploymentsScheduledJobSummaryDtoModelResponseTransformer: ScheduleConfigDeploymentsScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      ScheduleConfigDeploymentsJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const ScheduleConfigDeploymentsControllerCreateScheduleResponseTransformer: ScheduleConfigDeploymentsControllerCreateScheduleResponseTransformer =
  async (data) => {
    ScheduleConfigDeploymentsScheduledJobSummaryDtoModelResponseTransformer(
      data,
    );
    return data;
  };

export type ScheduleConfigDeploymentsControllerGetScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ScheduleConfigDeploymentsControllerGetScheduledJobResponse>;

export type ScheduleConfigDeploymentsScheduledJobDtoModelResponseTransformer = (
  data: any,
) => ScheduleConfigDeploymentsScheduledJobDto;

export const ScheduleConfigDeploymentsScheduledJobDtoModelResponseTransformer: ScheduleConfigDeploymentsScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      ScheduleConfigDeploymentsJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const ScheduleConfigDeploymentsControllerGetScheduledJobResponseTransformer: ScheduleConfigDeploymentsControllerGetScheduledJobResponseTransformer =
  async (data) => {
    ScheduleConfigDeploymentsScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleConfigDeploymentsControllerUpdateScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ScheduleConfigDeploymentsControllerUpdateScheduledJobResponse>;

export const ScheduleConfigDeploymentsControllerUpdateScheduledJobResponseTransformer: ScheduleConfigDeploymentsControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    ScheduleConfigDeploymentsScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleConfigDeploymentsControllerStartScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ScheduleConfigDeploymentsControllerStartScheduledJobResponse>;

export type ScheduleConfigDeploymentsJobDtoModelResponseTransformer = (
  data: any,
) => ScheduleConfigDeploymentsJobDto;

export type ScheduleConfigDeploymentsJobDeviceDtoModelResponseTransformer = (
  data: any,
) => ScheduleConfigDeploymentsJobDeviceDto;

export type ScheduleConfigDeploymentsJobDeviceParticipationDtoModelResponseTransformer =
  (data: any) => ScheduleConfigDeploymentsJobDeviceParticipationDto;

export const ScheduleConfigDeploymentsJobDeviceParticipationDtoModelResponseTransformer: ScheduleConfigDeploymentsJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      DeployComponentsDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const ScheduleConfigDeploymentsJobDeviceDtoModelResponseTransformer: ScheduleConfigDeploymentsJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      ScheduleConfigDeploymentsJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const ScheduleConfigDeploymentsJobDtoModelResponseTransformer: ScheduleConfigDeploymentsJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      ScheduleConfigDeploymentsJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(
        ScheduleConfigDeploymentsJobDeviceDtoModelResponseTransformer,
      );
    }
    return data;
  };

export const ScheduleConfigDeploymentsControllerStartScheduledJobResponseTransformer: ScheduleConfigDeploymentsControllerStartScheduledJobResponseTransformer =
  async (data) => {
    ScheduleConfigDeploymentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleConfigDeploymentsControllerResumeScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ScheduleConfigDeploymentsControllerResumeScheduledJobResponse>;

export const ScheduleConfigDeploymentsControllerResumeScheduledJobResponseTransformer: ScheduleConfigDeploymentsControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    ScheduleConfigDeploymentsScheduledJobSummaryDtoModelResponseTransformer(
      data,
    );
    return data;
  };

export type ScheduleConfigDeploymentsControllerStartJobResponseTransformer = (
  data: any,
) => Promise<ScheduleConfigDeploymentsControllerStartJobResponse>;

export const ScheduleConfigDeploymentsControllerStartJobResponseTransformer: ScheduleConfigDeploymentsControllerStartJobResponseTransformer =
  async (data) => {
    ScheduleConfigDeploymentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleConfigDeploymentsControllerGetJobResponseTransformer = (
  data: any,
) => Promise<ScheduleConfigDeploymentsControllerGetJobResponse>;

export const ScheduleConfigDeploymentsControllerGetJobResponseTransformer: ScheduleConfigDeploymentsControllerGetJobResponseTransformer =
  async (data) => {
    ScheduleConfigDeploymentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleConfigDeploymentsControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<ScheduleConfigDeploymentsControllerUpdateJobResponse>;

export const ScheduleConfigDeploymentsControllerUpdateJobResponseTransformer: ScheduleConfigDeploymentsControllerUpdateJobResponseTransformer =
  async (data) => {
    ScheduleConfigDeploymentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduledTrainingsControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<ScheduledTrainingsControllerGetDetailsResponse>;

export type ScheduledTrainingDetailsDtoModelResponseTransformer = (
  data: any,
) => ScheduledTrainingDetailsDto;

export const ScheduledTrainingDetailsDtoModelResponseTransformer: ScheduledTrainingDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.scheduledFor) {
      data.scheduledFor = new Date(data.scheduledFor);
    }
    if (data?.windowEnd) {
      data.windowEnd = new Date(data.windowEnd);
    }
    if (data?.windowStart) {
      data.windowStart = new Date(data.windowStart);
    }
    return data;
  };

export const ScheduledTrainingsControllerGetDetailsResponseTransformer: ScheduledTrainingsControllerGetDetailsResponseTransformer =
  async (data) => {
    ScheduledTrainingDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleModelDeploymentsControllerCreateScheduleResponseTransformer =
  (
    data: any,
  ) => Promise<ScheduleModelDeploymentsControllerCreateScheduleResponse>;

export type ScheduleModelDeploymentsScheduledJobSummaryDtoModelResponseTransformer =
  (data: any) => ScheduleModelDeploymentsScheduledJobSummaryDto;

export type ScheduleModelDeploymentsJobDataDtoModelResponseTransformer = (
  data: any,
) => ScheduleModelDeploymentsJobDataDto;

export const ScheduleModelDeploymentsJobDataDtoModelResponseTransformer: ScheduleModelDeploymentsJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.devicesQuery) {
      BulkDevicesQueryDtoModelResponseTransformer(data.devicesQuery);
    }
    return data;
  };

export const ScheduleModelDeploymentsScheduledJobSummaryDtoModelResponseTransformer: ScheduleModelDeploymentsScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      ScheduleModelDeploymentsJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const ScheduleModelDeploymentsControllerCreateScheduleResponseTransformer: ScheduleModelDeploymentsControllerCreateScheduleResponseTransformer =
  async (data) => {
    ScheduleModelDeploymentsScheduledJobSummaryDtoModelResponseTransformer(
      data,
    );
    return data;
  };

export type ScheduleModelDeploymentsControllerGetScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ScheduleModelDeploymentsControllerGetScheduledJobResponse>;

export type ScheduleModelDeploymentsScheduledJobDtoModelResponseTransformer = (
  data: any,
) => ScheduleModelDeploymentsScheduledJobDto;

export const ScheduleModelDeploymentsScheduledJobDtoModelResponseTransformer: ScheduleModelDeploymentsScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      ScheduleModelDeploymentsJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const ScheduleModelDeploymentsControllerGetScheduledJobResponseTransformer: ScheduleModelDeploymentsControllerGetScheduledJobResponseTransformer =
  async (data) => {
    ScheduleModelDeploymentsScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleModelDeploymentsControllerUpdateScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ScheduleModelDeploymentsControllerUpdateScheduledJobResponse>;

export const ScheduleModelDeploymentsControllerUpdateScheduledJobResponseTransformer: ScheduleModelDeploymentsControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    ScheduleModelDeploymentsScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleModelDeploymentsControllerStartScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ScheduleModelDeploymentsControllerStartScheduledJobResponse>;

export type ScheduleModelDeploymentsJobDtoModelResponseTransformer = (
  data: any,
) => ScheduleModelDeploymentsJobDto;

export type ScheduleModelDeploymentsJobDeviceDtoModelResponseTransformer = (
  data: any,
) => ScheduleModelDeploymentsJobDeviceDto;

export type ScheduleModelDeploymentsJobDeviceParticipationDtoModelResponseTransformer =
  (data: any) => ScheduleModelDeploymentsJobDeviceParticipationDto;

export const ScheduleModelDeploymentsJobDeviceParticipationDtoModelResponseTransformer: ScheduleModelDeploymentsJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      DeployComponentsDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const ScheduleModelDeploymentsJobDeviceDtoModelResponseTransformer: ScheduleModelDeploymentsJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      ScheduleModelDeploymentsJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const ScheduleModelDeploymentsJobDtoModelResponseTransformer: ScheduleModelDeploymentsJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      ScheduleModelDeploymentsJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(
        ScheduleModelDeploymentsJobDeviceDtoModelResponseTransformer,
      );
    }
    return data;
  };

export const ScheduleModelDeploymentsControllerStartScheduledJobResponseTransformer: ScheduleModelDeploymentsControllerStartScheduledJobResponseTransformer =
  async (data) => {
    ScheduleModelDeploymentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleModelDeploymentsControllerResumeScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ScheduleModelDeploymentsControllerResumeScheduledJobResponse>;

export const ScheduleModelDeploymentsControllerResumeScheduledJobResponseTransformer: ScheduleModelDeploymentsControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    ScheduleModelDeploymentsScheduledJobSummaryDtoModelResponseTransformer(
      data,
    );
    return data;
  };

export type ScheduleModelDeploymentsControllerStartJobResponseTransformer = (
  data: any,
) => Promise<ScheduleModelDeploymentsControllerStartJobResponse>;

export const ScheduleModelDeploymentsControllerStartJobResponseTransformer: ScheduleModelDeploymentsControllerStartJobResponseTransformer =
  async (data) => {
    ScheduleModelDeploymentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleModelDeploymentsControllerGetJobResponseTransformer = (
  data: any,
) => Promise<ScheduleModelDeploymentsControllerGetJobResponse>;

export const ScheduleModelDeploymentsControllerGetJobResponseTransformer: ScheduleModelDeploymentsControllerGetJobResponseTransformer =
  async (data) => {
    ScheduleModelDeploymentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type ScheduleModelDeploymentsControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<ScheduleModelDeploymentsControllerUpdateJobResponse>;

export const ScheduleModelDeploymentsControllerUpdateJobResponseTransformer: ScheduleModelDeploymentsControllerUpdateJobResponseTransformer =
  async (data) => {
    ScheduleModelDeploymentsJobDtoModelResponseTransformer(data);
    return data;
  };

export type ServiceHealthChecksControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<ServiceHealthChecksControllerCreateScheduleResponse>;

export type ServiceHealthChecksScheduledJobSummaryDtoModelResponseTransformer =
  (data: any) => ServiceHealthChecksScheduledJobSummaryDto;

export const ServiceHealthChecksScheduledJobSummaryDtoModelResponseTransformer: ServiceHealthChecksScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const ServiceHealthChecksControllerCreateScheduleResponseTransformer: ServiceHealthChecksControllerCreateScheduleResponseTransformer =
  async (data) => {
    ServiceHealthChecksScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type ServiceHealthChecksControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<ServiceHealthChecksControllerGetScheduledJobResponse>;

export type ServiceHealthChecksScheduledJobDtoModelResponseTransformer = (
  data: any,
) => ServiceHealthChecksScheduledJobDto;

export const ServiceHealthChecksScheduledJobDtoModelResponseTransformer: ServiceHealthChecksScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const ServiceHealthChecksControllerGetScheduledJobResponseTransformer: ServiceHealthChecksControllerGetScheduledJobResponseTransformer =
  async (data) => {
    ServiceHealthChecksScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type ServiceHealthChecksControllerUpdateScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ServiceHealthChecksControllerUpdateScheduledJobResponse>;

export const ServiceHealthChecksControllerUpdateScheduledJobResponseTransformer: ServiceHealthChecksControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    ServiceHealthChecksScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type ServiceHealthChecksControllerStartScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ServiceHealthChecksControllerStartScheduledJobResponse>;

export type ServiceHealthChecksJobDtoModelResponseTransformer = (
  data: any,
) => ServiceHealthChecksJobDto;

export const ServiceHealthChecksJobDtoModelResponseTransformer: ServiceHealthChecksJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(JobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const ServiceHealthChecksControllerStartScheduledJobResponseTransformer: ServiceHealthChecksControllerStartScheduledJobResponseTransformer =
  async (data) => {
    ServiceHealthChecksJobDtoModelResponseTransformer(data);
    return data;
  };

export type ServiceHealthChecksControllerResumeScheduledJobResponseTransformer =
  (
    data: any,
  ) => Promise<ServiceHealthChecksControllerResumeScheduledJobResponse>;

export const ServiceHealthChecksControllerResumeScheduledJobResponseTransformer: ServiceHealthChecksControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    ServiceHealthChecksScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type ServiceHealthChecksControllerStartJobResponseTransformer = (
  data: any,
) => Promise<ServiceHealthChecksControllerStartJobResponse>;

export const ServiceHealthChecksControllerStartJobResponseTransformer: ServiceHealthChecksControllerStartJobResponseTransformer =
  async (data) => {
    ServiceHealthChecksJobDtoModelResponseTransformer(data);
    return data;
  };

export type ServiceHealthChecksControllerGetJobResponseTransformer = (
  data: any,
) => Promise<ServiceHealthChecksControllerGetJobResponse>;

export const ServiceHealthChecksControllerGetJobResponseTransformer: ServiceHealthChecksControllerGetJobResponseTransformer =
  async (data) => {
    ServiceHealthChecksJobDtoModelResponseTransformer(data);
    return data;
  };

export type ServiceHealthChecksControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<ServiceHealthChecksControllerUpdateJobResponse>;

export const ServiceHealthChecksControllerUpdateJobResponseTransformer: ServiceHealthChecksControllerUpdateJobResponseTransformer =
  async (data) => {
    ServiceHealthChecksJobDtoModelResponseTransformer(data);
    return data;
  };

export type SessionsControllerGetSessionResponseTransformer = (
  data: any,
) => Promise<SessionsControllerGetSessionResponse>;

export type SessionDtoModelResponseTransformer = (data: any) => SessionDto;

export type TransactionDtoModelResponseTransformer = (
  data: any,
) => TransactionDto;

export type TransactionPredictionDtoModelResponseTransformer = (
  data: any,
) => TransactionPredictionDto;

export const TransactionPredictionDtoModelResponseTransformer: TransactionPredictionDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.predictedAt) {
      data.predictedAt = new Date(data.predictedAt);
    }
    if (data?.capturedAt) {
      data.capturedAt = new Date(data.capturedAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.interactionStartTime) {
      data.interactionStartTime = new Date(data.interactionStartTime);
    }
    return data;
  };

export type TransactionGroundTruthDtoModelResponseTransformer = (
  data: any,
) => TransactionGroundTruthDto;

export const TransactionGroundTruthDtoModelResponseTransformer: TransactionGroundTruthDtoModelResponseTransformer =
  (data) => {
    if (data?.addedAt) {
      data.addedAt = new Date(data.addedAt);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.device) {
      DeviceWithActivationModelResponseTransformer(data.device);
    }
    return data;
  };

export const TransactionDtoModelResponseTransformer: TransactionDtoModelResponseTransformer =
  (data) => {
    if (data?.prediction) {
      TransactionPredictionDtoModelResponseTransformer(data.prediction);
    }
    if (data?.groundTruth) {
      TransactionGroundTruthDtoModelResponseTransformer(data.groundTruth);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.addedAt) {
      data.addedAt = new Date(data.addedAt);
    }
    if (data?.predictedAt) {
      data.predictedAt = new Date(data.predictedAt);
    }
    if (data?.capturedAt) {
      data.capturedAt = new Date(data.capturedAt);
    }
    return data;
  };

export const SessionDtoModelResponseTransformer: SessionDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.transactions)) {
      data.transactions.forEach(TransactionDtoModelResponseTransformer);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.calculatedStartTime) {
      data.calculatedStartTime = new Date(data.calculatedStartTime);
    }
    if (data?.calculatedEndTime) {
      data.calculatedEndTime = new Date(data.calculatedEndTime);
    }
    return data;
  };

export const SessionsControllerGetSessionResponseTransformer: SessionsControllerGetSessionResponseTransformer =
  async (data) => {
    SessionDtoModelResponseTransformer(data);
    return data;
  };

export type SessionsTaggingControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<SessionsTaggingControllerGetDetailsResponse>;

export const SessionsTaggingControllerGetDetailsResponseTransformer: SessionsTaggingControllerGetDetailsResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type SessionsTaggingControllerUpdateTagResponseTransformer = (
  data: any,
) => Promise<SessionsTaggingControllerUpdateTagResponse>;

export const SessionsTaggingControllerUpdateTagResponseTransformer: SessionsTaggingControllerUpdateTagResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type SiteGroupsControllerDetailsResponseTransformer = (
  data: any,
) => Promise<SiteGroupsControllerDetailsResponse>;

export type SiteGroupDetailsDtoModelResponseTransformer = (
  data: any,
) => SiteGroupDetailsDto;

export const SiteGroupDetailsDtoModelResponseTransformer: SiteGroupDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const SiteGroupsControllerDetailsResponseTransformer: SiteGroupsControllerDetailsResponseTransformer =
  async (data) => {
    SiteGroupDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type SiteGroupsControllerGetLabelsResponseTransformer = (
  data: any,
) => Promise<SiteGroupsControllerGetLabelsResponse>;

export type SiteGroupLabelsResponseDtoModelResponseTransformer = (
  data: any,
) => SiteGroupLabelsResponseDto;

export type CatalogItemLabelDtoModelResponseTransformer = (
  data: any,
) => CatalogItemLabelDto;

export const CatalogItemLabelDtoModelResponseTransformer: CatalogItemLabelDtoModelResponseTransformer =
  (data) => {
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const SiteGroupLabelsResponseDtoModelResponseTransformer: SiteGroupLabelsResponseDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(CatalogItemLabelDtoModelResponseTransformer);
    }
    return data;
  };

export const SiteGroupsControllerGetLabelsResponseTransformer: SiteGroupsControllerGetLabelsResponseTransformer =
  async (data) => {
    SiteGroupLabelsResponseDtoModelResponseTransformer(data);
    return data;
  };

export type SitesControllerUploadResponseTransformer = (
  data: any,
) => Promise<SitesControllerUploadResponse>;

export type SiteUploadResponseDtoModelResponseTransformer = (
  data: any,
) => SiteUploadResponseDto;

export type SiteUploadPreviewRowDtoModelResponseTransformer = (
  data: any,
) => SiteUploadPreviewRowDto;

export const SiteUploadPreviewRowDtoModelResponseTransformer: SiteUploadPreviewRowDtoModelResponseTransformer =
  (data) => {
    if (data?.activationTime) {
      data.activationTime = new Date(data.activationTime);
    }
    return data;
  };

export const SiteUploadResponseDtoModelResponseTransformer: SiteUploadResponseDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.results)) {
      data.results.forEach(SiteUploadPreviewRowDtoModelResponseTransformer);
    }
    return data;
  };

export const SitesControllerUploadResponseTransformer: SitesControllerUploadResponseTransformer =
  async (data) => {
    SiteUploadResponseDtoModelResponseTransformer(data);
    return data;
  };

export type SitesControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<SitesControllerGetDetailsResponse>;

export type SiteDetailsDtoModelResponseTransformer = (
  data: any,
) => SiteDetailsDto;

export const SiteDetailsDtoModelResponseTransformer: SiteDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.activationTime) {
      data.activationTime = new Date(data.activationTime);
    }
    return data;
  };

export const SitesControllerGetDetailsResponseTransformer: SitesControllerGetDetailsResponseTransformer =
  async (data) => {
    SiteDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type SitesTaggingControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<SitesTaggingControllerGetDetailsResponse>;

export const SitesTaggingControllerGetDetailsResponseTransformer: SitesTaggingControllerGetDetailsResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type SitesTaggingControllerUpdateTagResponseTransformer = (
  data: any,
) => Promise<SitesTaggingControllerUpdateTagResponse>;

export const SitesTaggingControllerUpdateTagResponseTransformer: SitesTaggingControllerUpdateTagResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type StaticDatasetsControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<StaticDatasetsControllerGetDetailsResponse>;

export type StaticDatasetDetailsDtoModelResponseTransformer = (
  data: any,
) => StaticDatasetDetailsDto;

export type DatasetJobStatusDtoModelResponseTransformer = (
  data: any,
) => DatasetJobStatusDto;

export const DatasetJobStatusDtoModelResponseTransformer: DatasetJobStatusDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export type DatasetJobHistoryEntryDtoModelResponseTransformer = (
  data: any,
) => DatasetJobHistoryEntryDto;

export const DatasetJobHistoryEntryDtoModelResponseTransformer: DatasetJobHistoryEntryDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const StaticDatasetDetailsDtoModelResponseTransformer: StaticDatasetDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.jobStatus) {
      DatasetJobStatusDtoModelResponseTransformer(data.jobStatus);
    }
    if (data?.samplesJobStatus) {
      DatasetJobStatusDtoModelResponseTransformer(data.samplesJobStatus);
    }
    if (data?.fromSamplesJobStatus) {
      DatasetJobStatusDtoModelResponseTransformer(data.fromSamplesJobStatus);
    }
    if (data?.retryJobStatus) {
      DatasetJobStatusDtoModelResponseTransformer(data.retryJobStatus);
    }
    if (data?.fromSessionsJobStatus) {
      DatasetJobStatusDtoModelResponseTransformer(data.fromSessionsJobStatus);
    }
    if (data?.retrySessionsJobStatus) {
      DatasetJobStatusDtoModelResponseTransformer(data.retrySessionsJobStatus);
    }
    if (Array.isArray(data?.jobHistory)) {
      data.jobHistory.forEach(
        DatasetJobHistoryEntryDtoModelResponseTransformer,
      );
    }
    if (data?.analyticsJobStatus) {
      DatasetJobStatusDtoModelResponseTransformer(data.analyticsJobStatus);
    }
    if (data?.deleteJobStatus) {
      DatasetJobStatusDtoModelResponseTransformer(data.deleteJobStatus);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const StaticDatasetsControllerGetDetailsResponseTransformer: StaticDatasetsControllerGetDetailsResponseTransformer =
  async (data) => {
    StaticDatasetDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type SyncGroundTruthsControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<SyncGroundTruthsControllerCreateScheduleResponse>;

export type SyncGroundTruthsScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => SyncGroundTruthsScheduledJobSummaryDto;

export const SyncGroundTruthsScheduledJobSummaryDtoModelResponseTransformer: SyncGroundTruthsScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const SyncGroundTruthsControllerCreateScheduleResponseTransformer: SyncGroundTruthsControllerCreateScheduleResponseTransformer =
  async (data) => {
    SyncGroundTruthsScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type SyncGroundTruthsControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<SyncGroundTruthsControllerGetScheduledJobResponse>;

export type SyncGroundTruthsScheduledJobDtoModelResponseTransformer = (
  data: any,
) => SyncGroundTruthsScheduledJobDto;

export const SyncGroundTruthsScheduledJobDtoModelResponseTransformer: SyncGroundTruthsScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const SyncGroundTruthsControllerGetScheduledJobResponseTransformer: SyncGroundTruthsControllerGetScheduledJobResponseTransformer =
  async (data) => {
    SyncGroundTruthsScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type SyncGroundTruthsControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<SyncGroundTruthsControllerUpdateScheduledJobResponse>;

export const SyncGroundTruthsControllerUpdateScheduledJobResponseTransformer: SyncGroundTruthsControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    SyncGroundTruthsScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type SyncGroundTruthsControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<SyncGroundTruthsControllerStartScheduledJobResponse>;

export type SyncGroundTruthsJobDtoModelResponseTransformer = (
  data: any,
) => SyncGroundTruthsJobDto;

export type SyncGroundTruthsJobDeviceDtoModelResponseTransformer = (
  data: any,
) => SyncGroundTruthsJobDeviceDto;

export type SyncGroundTruthsJobDeviceParticipationDtoModelResponseTransformer =
  (data: any) => SyncGroundTruthsJobDeviceParticipationDto;

export type SyncGroundTruthsDeviceResultDtoModelResponseTransformer = (
  data: any,
) => SyncGroundTruthsDeviceResultDto;

export const SyncGroundTruthsDeviceResultDtoModelResponseTransformer: SyncGroundTruthsDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.updateTime) {
      data.updateTime = new Date(data.updateTime);
    }
    return data;
  };

export const SyncGroundTruthsJobDeviceParticipationDtoModelResponseTransformer: SyncGroundTruthsJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      SyncGroundTruthsDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const SyncGroundTruthsJobDeviceDtoModelResponseTransformer: SyncGroundTruthsJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      SyncGroundTruthsJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const SyncGroundTruthsJobDtoModelResponseTransformer: SyncGroundTruthsJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(
        SyncGroundTruthsJobDeviceDtoModelResponseTransformer,
      );
    }
    return data;
  };

export const SyncGroundTruthsControllerStartScheduledJobResponseTransformer: SyncGroundTruthsControllerStartScheduledJobResponseTransformer =
  async (data) => {
    SyncGroundTruthsJobDtoModelResponseTransformer(data);
    return data;
  };

export type SyncGroundTruthsControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<SyncGroundTruthsControllerResumeScheduledJobResponse>;

export const SyncGroundTruthsControllerResumeScheduledJobResponseTransformer: SyncGroundTruthsControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    SyncGroundTruthsScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type SyncGroundTruthsControllerStartJobResponseTransformer = (
  data: any,
) => Promise<SyncGroundTruthsControllerStartJobResponse>;

export const SyncGroundTruthsControllerStartJobResponseTransformer: SyncGroundTruthsControllerStartJobResponseTransformer =
  async (data) => {
    SyncGroundTruthsJobDtoModelResponseTransformer(data);
    return data;
  };

export type SyncGroundTruthsControllerGetJobResponseTransformer = (
  data: any,
) => Promise<SyncGroundTruthsControllerGetJobResponse>;

export const SyncGroundTruthsControllerGetJobResponseTransformer: SyncGroundTruthsControllerGetJobResponseTransformer =
  async (data) => {
    SyncGroundTruthsJobDtoModelResponseTransformer(data);
    return data;
  };

export type SyncGroundTruthsControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<SyncGroundTruthsControllerUpdateJobResponse>;

export const SyncGroundTruthsControllerUpdateJobResponseTransformer: SyncGroundTruthsControllerUpdateJobResponseTransformer =
  async (data) => {
    SyncGroundTruthsJobDtoModelResponseTransformer(data);
    return data;
  };

export type TagsControllerUpdateResponseTransformer = (
  data: any,
) => Promise<TagsControllerUpdateResponse>;

export const TagsControllerUpdateResponseTransformer: TagsControllerUpdateResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type TagsControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<TagsControllerGetDetailsResponse>;

export const TagsControllerGetDetailsResponseTransformer: TagsControllerGetDetailsResponseTransformer =
  async (data) => {
    TagDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type TrainingsControllerGetDefaultsResponseTransformer = (
  data: any,
) => Promise<TrainingsControllerGetDefaultsResponse>;

export type TrainingDefaultsDtoModelResponseTransformer = (
  data: any,
) => TrainingDefaultsDto;

export const TrainingDefaultsDtoModelResponseTransformer: TrainingDefaultsDtoModelResponseTransformer =
  (data) => {
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const TrainingsControllerGetDefaultsResponseTransformer: TrainingsControllerGetDefaultsResponseTransformer =
  async (data) => {
    TrainingDefaultsDtoModelResponseTransformer(data);
    return data;
  };

export type TrainingsControllerUpdateDefaultsResponseTransformer = (
  data: any,
) => Promise<TrainingsControllerUpdateDefaultsResponse>;

export const TrainingsControllerUpdateDefaultsResponseTransformer: TrainingsControllerUpdateDefaultsResponseTransformer =
  async (data) => {
    TrainingDefaultsDtoModelResponseTransformer(data);
    return data;
  };

export type TrainingsControllerClearDefaultsResponseTransformer = (
  data: any,
) => Promise<TrainingsControllerClearDefaultsResponse>;

export const TrainingsControllerClearDefaultsResponseTransformer: TrainingsControllerClearDefaultsResponseTransformer =
  async (data) => {
    TrainingDefaultsDtoModelResponseTransformer(data);
    return data;
  };

export type TrainingsControllerGetDetailsResponseTransformer = (
  data: any,
) => Promise<TrainingsControllerGetDetailsResponse>;

export type TrainingDetailsDtoModelResponseTransformer = (
  data: any,
) => TrainingDetailsDto;

export const TrainingDetailsDtoModelResponseTransformer: TrainingDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.windowEnd) {
      data.windowEnd = new Date(data.windowEnd);
    }
    if (data?.windowStart) {
      data.windowStart = new Date(data.windowStart);
    }
    return data;
  };

export const TrainingsControllerGetDetailsResponseTransformer: TrainingsControllerGetDetailsResponseTransformer =
  async (data) => {
    TrainingDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type TrainingsControllerGetTrainingExecutionDetailsResponseTransformer =
  (
    data: any,
  ) => Promise<TrainingsControllerGetTrainingExecutionDetailsResponse>;

export type TrainingExecutionDetailsDtoModelResponseTransformer = (
  data: any,
) => TrainingExecutionDetailsDto;

export type EpochDetailsDtoModelResponseTransformer = (
  data: any,
) => EpochDetailsDto;

export const EpochDetailsDtoModelResponseTransformer: EpochDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export const TrainingExecutionDetailsDtoModelResponseTransformer: TrainingExecutionDetailsDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.epochMetrics)) {
      data.epochMetrics.forEach(EpochDetailsDtoModelResponseTransformer);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const TrainingsControllerGetTrainingExecutionDetailsResponseTransformer: TrainingsControllerGetTrainingExecutionDetailsResponseTransformer =
  async (data) => {
    TrainingExecutionDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type TrainingsControllerGetSampleStatsResponseTransformer = (
  data: any,
) => Promise<TrainingsControllerGetSampleStatsResponse>;

export type TrainingSampleStatsDtoModelResponseTransformer = (
  data: any,
) => TrainingSampleStatsDto;

export type EpochMetricsMetricDtoModelResponseTransformer = (
  data: any,
) => EpochMetricsMetricDto;

export const EpochMetricsMetricDtoModelResponseTransformer: EpochMetricsMetricDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export type DataReportMetricDtoModelResponseTransformer = (
  data: any,
) => DataReportMetricDto;

export const DataReportMetricDtoModelResponseTransformer: DataReportMetricDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export type ConfusionMatrixMetricDtoModelResponseTransformer = (
  data: any,
) => ConfusionMatrixMetricDto;

export const ConfusionMatrixMetricDtoModelResponseTransformer: ConfusionMatrixMetricDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export type ConfidenceStatsMetricDtoModelResponseTransformer = (
  data: any,
) => ConfidenceStatsMetricDto;

export const ConfidenceStatsMetricDtoModelResponseTransformer: ConfidenceStatsMetricDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    return data;
  };

export const TrainingSampleStatsDtoModelResponseTransformer: TrainingSampleStatsDtoModelResponseTransformer =
  (data) => {
    if (Array.isArray(data?.epochMetrics)) {
      data.epochMetrics.forEach(EpochMetricsMetricDtoModelResponseTransformer);
    }
    if (Array.isArray(data?.dataReport)) {
      data.dataReport.forEach(DataReportMetricDtoModelResponseTransformer);
    }
    if (Array.isArray(data?.confusionMatrix)) {
      data.confusionMatrix.forEach(
        ConfusionMatrixMetricDtoModelResponseTransformer,
      );
    }
    if (Array.isArray(data?.confidenceStats)) {
      data.confidenceStats.forEach(
        ConfidenceStatsMetricDtoModelResponseTransformer,
      );
    }
    return data;
  };

export const TrainingsControllerGetSampleStatsResponseTransformer: TrainingsControllerGetSampleStatsResponseTransformer =
  async (data) => {
    TrainingSampleStatsDtoModelResponseTransformer(data);
    return data;
  };

export type UploadSamplesControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<UploadSamplesControllerCreateScheduleResponse>;

export type UploadSamplesScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => UploadSamplesScheduledJobSummaryDto;

export type UploadSamplesJobDataDtoModelResponseTransformer = (
  data: any,
) => UploadSamplesJobDataDto;

export const UploadSamplesJobDataDtoModelResponseTransformer: UploadSamplesJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.query) {
      GetSamplesQueryRequestDtoModelResponseTransformer(data.query);
    }
    return data;
  };

export const UploadSamplesScheduledJobSummaryDtoModelResponseTransformer: UploadSamplesScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      UploadSamplesJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const UploadSamplesControllerCreateScheduleResponseTransformer: UploadSamplesControllerCreateScheduleResponseTransformer =
  async (data) => {
    UploadSamplesScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type UploadSamplesControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<UploadSamplesControllerGetScheduledJobResponse>;

export type UploadSamplesScheduledJobDtoModelResponseTransformer = (
  data: any,
) => UploadSamplesScheduledJobDto;

export const UploadSamplesScheduledJobDtoModelResponseTransformer: UploadSamplesScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      UploadSamplesJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const UploadSamplesControllerGetScheduledJobResponseTransformer: UploadSamplesControllerGetScheduledJobResponseTransformer =
  async (data) => {
    UploadSamplesScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadSamplesControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<UploadSamplesControllerUpdateScheduledJobResponse>;

export const UploadSamplesControllerUpdateScheduledJobResponseTransformer: UploadSamplesControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    UploadSamplesScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadSamplesControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<UploadSamplesControllerStartScheduledJobResponse>;

export type UploadSamplesJobDtoModelResponseTransformer = (
  data: any,
) => UploadSamplesJobDto;

export type UploadSamplesJobDeviceDtoModelResponseTransformer = (
  data: any,
) => UploadSamplesJobDeviceDto;

export type UploadSamplesJobDeviceParticipationDtoModelResponseTransformer = (
  data: any,
) => UploadSamplesJobDeviceParticipationDto;

export type UploadSamplesDeviceResultDtoModelResponseTransformer = (
  data: any,
) => UploadSamplesDeviceResultDto;

export const UploadSamplesDeviceResultDtoModelResponseTransformer: UploadSamplesDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.lastStart) {
      data.lastStart = new Date(data.lastStart);
    }
    if (data?.lastProgress) {
      data.lastProgress = new Date(data.lastProgress);
    }
    if (data?._meta) {
      SampleUploadProgressDtoModelResponseTransformer(data._meta);
    }
    return data;
  };

export const UploadSamplesJobDeviceParticipationDtoModelResponseTransformer: UploadSamplesJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      UploadSamplesDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const UploadSamplesJobDeviceDtoModelResponseTransformer: UploadSamplesJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      UploadSamplesJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const UploadSamplesJobDtoModelResponseTransformer: UploadSamplesJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      UploadSamplesJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(UploadSamplesJobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const UploadSamplesControllerStartScheduledJobResponseTransformer: UploadSamplesControllerStartScheduledJobResponseTransformer =
  async (data) => {
    UploadSamplesJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadSamplesControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<UploadSamplesControllerResumeScheduledJobResponse>;

export const UploadSamplesControllerResumeScheduledJobResponseTransformer: UploadSamplesControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    UploadSamplesScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type UploadSamplesControllerStartJobResponseTransformer = (
  data: any,
) => Promise<UploadSamplesControllerStartJobResponse>;

export const UploadSamplesControllerStartJobResponseTransformer: UploadSamplesControllerStartJobResponseTransformer =
  async (data) => {
    UploadSamplesJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadSamplesControllerGetJobResponseTransformer = (
  data: any,
) => Promise<UploadSamplesControllerGetJobResponse>;

export const UploadSamplesControllerGetJobResponseTransformer: UploadSamplesControllerGetJobResponseTransformer =
  async (data) => {
    UploadSamplesJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadSamplesControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<UploadSamplesControllerUpdateJobResponse>;

export const UploadSamplesControllerUpdateJobResponseTransformer: UploadSamplesControllerUpdateJobResponseTransformer =
  async (data) => {
    UploadSamplesJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadVideosControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<UploadVideosControllerCreateScheduleResponse>;

export type UploadVideosScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => UploadVideosScheduledJobSummaryDto;

export type UploadVideosJobDataDtoModelResponseTransformer = (
  data: any,
) => UploadVideosJobDataDto;

export const UploadVideosJobDataDtoModelResponseTransformer: UploadVideosJobDataDtoModelResponseTransformer =
  (data) => {
    if (data?.query) {
      GetSessionsRequestDtoModelResponseTransformer(data.query);
    }
    return data;
  };

export const UploadVideosScheduledJobSummaryDtoModelResponseTransformer: UploadVideosScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      UploadVideosJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const UploadVideosControllerCreateScheduleResponseTransformer: UploadVideosControllerCreateScheduleResponseTransformer =
  async (data) => {
    UploadVideosScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type UploadVideosControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<UploadVideosControllerGetScheduledJobResponse>;

export type UploadVideosScheduledJobDtoModelResponseTransformer = (
  data: any,
) => UploadVideosScheduledJobDto;

export const UploadVideosScheduledJobDtoModelResponseTransformer: UploadVideosScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.data) {
      UploadVideosJobDataDtoModelResponseTransformer(data.data);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const UploadVideosControllerGetScheduledJobResponseTransformer: UploadVideosControllerGetScheduledJobResponseTransformer =
  async (data) => {
    UploadVideosScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadVideosControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<UploadVideosControllerUpdateScheduledJobResponse>;

export const UploadVideosControllerUpdateScheduledJobResponseTransformer: UploadVideosControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    UploadVideosScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadVideosControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<UploadVideosControllerStartScheduledJobResponse>;

export type UploadVideosJobDtoModelResponseTransformer = (
  data: any,
) => UploadVideosJobDto;

export type UploadVideosJobDeviceDtoModelResponseTransformer = (
  data: any,
) => UploadVideosJobDeviceDto;

export type UploadVideosJobDeviceParticipationDtoModelResponseTransformer = (
  data: any,
) => UploadVideosJobDeviceParticipationDto;

export type UploadVideosDeviceResultDtoModelResponseTransformer = (
  data: any,
) => UploadVideosDeviceResultDto;

export const UploadVideosDeviceResultDtoModelResponseTransformer: UploadVideosDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.lastStart) {
      data.lastStart = new Date(data.lastStart);
    }
    if (data?.lastProgress) {
      data.lastProgress = new Date(data.lastProgress);
    }
    if (data?._meta) {
      VideoUploadProgressDtoModelResponseTransformer(data._meta);
    }
    return data;
  };

export const UploadVideosJobDeviceParticipationDtoModelResponseTransformer: UploadVideosJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      UploadVideosDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const UploadVideosJobDeviceDtoModelResponseTransformer: UploadVideosJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      UploadVideosJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const UploadVideosJobDtoModelResponseTransformer: UploadVideosJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (data?.data) {
      UploadVideosJobDataDtoModelResponseTransformer(data.data);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(UploadVideosJobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const UploadVideosControllerStartScheduledJobResponseTransformer: UploadVideosControllerStartScheduledJobResponseTransformer =
  async (data) => {
    UploadVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadVideosControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<UploadVideosControllerResumeScheduledJobResponse>;

export const UploadVideosControllerResumeScheduledJobResponseTransformer: UploadVideosControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    UploadVideosScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type UploadVideosControllerStartJobResponseTransformer = (
  data: any,
) => Promise<UploadVideosControllerStartJobResponse>;

export const UploadVideosControllerStartJobResponseTransformer: UploadVideosControllerStartJobResponseTransformer =
  async (data) => {
    UploadVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadVideosControllerGetJobResponseTransformer = (
  data: any,
) => Promise<UploadVideosControllerGetJobResponse>;

export const UploadVideosControllerGetJobResponseTransformer: UploadVideosControllerGetJobResponseTransformer =
  async (data) => {
    UploadVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type UploadVideosControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<UploadVideosControllerUpdateJobResponse>;

export const UploadVideosControllerUpdateJobResponseTransformer: UploadVideosControllerUpdateJobResponseTransformer =
  async (data) => {
    UploadVideosJobDtoModelResponseTransformer(data);
    return data;
  };

export type UsersControllerMeResponseTransformer = (
  data: any,
) => Promise<UsersControllerMeResponse>;

export type UserDetailsDtoModelResponseTransformer = (
  data: any,
) => UserDetailsDto;

export const UserDetailsDtoModelResponseTransformer: UserDetailsDtoModelResponseTransformer =
  (data) => {
    if (data?.lastConnected) {
      data.lastConnected = new Date(data.lastConnected);
    }
    return data;
  };

export const UsersControllerMeResponseTransformer: UsersControllerMeResponseTransformer =
  async (data) => {
    UserDetailsDtoModelResponseTransformer(data);
    return data;
  };

export type WorkerJobControllerCreateScheduleResponseTransformer = (
  data: any,
) => Promise<WorkerJobControllerCreateScheduleResponse>;

export type WorkerJobScheduledJobSummaryDtoModelResponseTransformer = (
  data: any,
) => WorkerJobScheduledJobSummaryDto;

export const WorkerJobScheduledJobSummaryDtoModelResponseTransformer: WorkerJobScheduledJobSummaryDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const WorkerJobControllerCreateScheduleResponseTransformer: WorkerJobControllerCreateScheduleResponseTransformer =
  async (data) => {
    WorkerJobScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type WorkerJobControllerGetScheduledJobResponseTransformer = (
  data: any,
) => Promise<WorkerJobControllerGetScheduledJobResponse>;

export type WorkerJobScheduledJobDtoModelResponseTransformer = (
  data: any,
) => WorkerJobScheduledJobDto;

export const WorkerJobScheduledJobDtoModelResponseTransformer: WorkerJobScheduledJobDtoModelResponseTransformer =
  (data) => {
    if (data?.startDate) {
      data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
      data.endDate = new Date(data.endDate);
    }
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    return data;
  };

export const WorkerJobControllerGetScheduledJobResponseTransformer: WorkerJobControllerGetScheduledJobResponseTransformer =
  async (data) => {
    WorkerJobScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type WorkerJobControllerUpdateScheduledJobResponseTransformer = (
  data: any,
) => Promise<WorkerJobControllerUpdateScheduledJobResponse>;

export const WorkerJobControllerUpdateScheduledJobResponseTransformer: WorkerJobControllerUpdateScheduledJobResponseTransformer =
  async (data) => {
    WorkerJobScheduledJobDtoModelResponseTransformer(data);
    return data;
  };

export type WorkerJobControllerStartScheduledJobResponseTransformer = (
  data: any,
) => Promise<WorkerJobControllerStartScheduledJobResponse>;

export type WorkerJobJobDtoModelResponseTransformer = (
  data: any,
) => WorkerJobJobDto;

export type WorkerJobJobDeviceDtoModelResponseTransformer = (
  data: any,
) => WorkerJobJobDeviceDto;

export type WorkerJobJobDeviceParticipationDtoModelResponseTransformer = (
  data: any,
) => WorkerJobJobDeviceParticipationDto;

export type WorkerJobDeviceResultDtoModelResponseTransformer = (
  data: any,
) => WorkerJobDeviceResultDto;

export const WorkerJobDeviceResultDtoModelResponseTransformer: WorkerJobDeviceResultDtoModelResponseTransformer =
  (data) => {
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.updateTime) {
      data.updateTime = new Date(data.updateTime);
    }
    return data;
  };

export const WorkerJobJobDeviceParticipationDtoModelResponseTransformer: WorkerJobJobDeviceParticipationDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.result) {
      WorkerJobDeviceResultDtoModelResponseTransformer(data.result);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    return data;
  };

export const WorkerJobJobDeviceDtoModelResponseTransformer: WorkerJobJobDeviceDtoModelResponseTransformer =
  (data) => {
    if (data?.participation) {
      WorkerJobJobDeviceParticipationDtoModelResponseTransformer(
        data.participation,
      );
    }
    return data;
  };

export const WorkerJobJobDtoModelResponseTransformer: WorkerJobJobDtoModelResponseTransformer =
  (data) => {
    if (data?.createdAt) {
      data.createdAt = new Date(data.createdAt);
    }
    if (data?.updatedAt) {
      data.updatedAt = new Date(data.updatedAt);
    }
    if (data?.startTime) {
      data.startTime = new Date(data.startTime);
    }
    if (data?.endTime) {
      data.endTime = new Date(data.endTime);
    }
    if (Array.isArray(data?.devices)) {
      data.devices.forEach(WorkerJobJobDeviceDtoModelResponseTransformer);
    }
    return data;
  };

export const WorkerJobControllerStartScheduledJobResponseTransformer: WorkerJobControllerStartScheduledJobResponseTransformer =
  async (data) => {
    WorkerJobJobDtoModelResponseTransformer(data);
    return data;
  };

export type WorkerJobControllerResumeScheduledJobResponseTransformer = (
  data: any,
) => Promise<WorkerJobControllerResumeScheduledJobResponse>;

export const WorkerJobControllerResumeScheduledJobResponseTransformer: WorkerJobControllerResumeScheduledJobResponseTransformer =
  async (data) => {
    WorkerJobScheduledJobSummaryDtoModelResponseTransformer(data);
    return data;
  };

export type WorkerJobControllerStartJobResponseTransformer = (
  data: any,
) => Promise<WorkerJobControllerStartJobResponse>;

export const WorkerJobControllerStartJobResponseTransformer: WorkerJobControllerStartJobResponseTransformer =
  async (data) => {
    WorkerJobJobDtoModelResponseTransformer(data);
    return data;
  };

export type WorkerJobControllerGetJobResponseTransformer = (
  data: any,
) => Promise<WorkerJobControllerGetJobResponse>;

export const WorkerJobControllerGetJobResponseTransformer: WorkerJobControllerGetJobResponseTransformer =
  async (data) => {
    WorkerJobJobDtoModelResponseTransformer(data);
    return data;
  };

export type WorkerJobControllerUpdateJobResponseTransformer = (
  data: any,
) => Promise<WorkerJobControllerUpdateJobResponse>;

export const WorkerJobControllerUpdateJobResponseTransformer: WorkerJobControllerUpdateJobResponseTransformer =
  async (data) => {
    WorkerJobJobDtoModelResponseTransformer(data);
    return data;
  };
